import React, { useState, useEffect, useRef, useCallback } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// Alles wat de browser zelf tekent en inpakt voor de uitvoer.
import { svgNaarPng, stadskaartSvg, wijkkaartSvg, dekkingskaartSvg, grafiekSvg, balkSvg, omslagSvg,
  geojsonVan, kmlVan, maakZip, bewaarAls, bestandsnaam as exportNaam, EK } from './exportbestanden';
import { LineChart, Line, BarChart, Bar, ComposedChart, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { calcWijk, YEARS, SOCKET_KW_SLIM, berekenPubliekSemiSplitV5, verdeelHeel,
  WIJKTYPE_MIX,
  DOELGROEP_LAADTYPE,
  acUtilisatieMwhJaarV5,
  acNormKwh,
  acNormBasis,
  MOW_DREMPEL_BIJPLAATSING_KWH,
  NORM_JAREN,
  bezettingsgraadGemeente,
  evAandeelGemeente,
  acUtilisatieMwhMaand,
  dcUtilisatieMwhMaand,
  hpcUtilisatieMwhMaand,
  REDUNDANTIE_MARGE_AC,
  REDUNDANTIE_MARGE_DC,
  REDUNDANTIE_MARGE_HPC,
  JAARKM,
  VERBRUIK_PER_KM,
  STADSFACTOR,
  FLUVIUS_KAPPA} from './gemeenteData';
import Parameters from './Parameters';
import WijkImpact from './components/WijkImpact';
import { bouwRaster, bepaalDekking, telDekking, maakDekkingBeeld,
         plaatsPalen } from './rasterdekking';
import GemeenteOnboarding from './components/GemeenteOnboarding';
import GemeenteEditor from './components/GemeenteEditor';
import { getIngelogdeGebruiker, getAlleGemeenten, getGemeente, slaGemeenteOp, updateGemeente, verwijderGemeente, checkHealth, onboardGemeenteGeo, getSectoren, syncWijkenVanStatbel, getLaadpalen, getFluviusPrive, getLaadpleinTerreinen, haalLaadpleinTerreinenOp, getLaadpleinOordelen, zetLaadpleinOordeel, downloadRapport,
  getExportHistorie, bewaarExport, downloadHistorie,
  getTeaserStatus, downloadTeaser,
  getAdressen, haalAdressenOp,
  bewaarNetcapaciteit, getInwonersSectoren, getMowBestelwagens, getStraten, haalStratenOp,
  getInstellingen, bewaarInstellingen, getInstellingenHerkomst,
  downloadFichePdf, getBezettingZichtbaar, getHuishoudgroei, laadGisnet,
  getGisnet, berekenNetAfstanden } from './api';
import { maakNetPanes, tekenStroomnet, STANDAARD_ZICHT, StroomnetUitklap, netKlasse, NET_KLASSE,
         NET_OK, NetLabel, KAND_PANE, paalSleutel, netRegelPlein, netRegelPaal, alleen230, peildatumLang,
         netBereik, NetStraat, NET_OPMERKING, dichtsteNetpunten, meterTussen, AANSLUIT_SOORTEN,
         AANSLUIT_KLEUR, AansluitTeken, BESTAAND_KLEUR, BestaandTeken, planSignalen, PlanBlok, planVoet } from './stroomnet';
import Dashboard from './Dashboard';
import Uitleg from './components/Uitleg';
import Bezetting from './Bezetting';
import DataBronnen from './DataBronnen';

// Leaflet zet standaard een vlaggetje voor zijn naam onderaan elke kaart. Hier
// alleen de naam, met de link naar de eigen website. Geldt voor elke kaart in
// de app, want ze gebruiken allemaal deze ene Leaflet. De vermelding van de
// kaartbronnen (OpenStreetMap, CARTO, Digitaal Vlaanderen) blijft staan.
if (L?.Control?.Attribution?.prototype?.options) {
  L.Control.Attribution.prototype.options.prefix =
    '<a href="https://leafletjs.com" target="_blank" rel="noreferrer">Leaflet</a>';
}

// ── Provincies in Cijfers API ─────────────────────────────────────────────
// API-key voor browser-side fetch naar provincies.incijfers.be.
// Intern tool met login — key in frontend is acceptabel.
const PIC_API_KEY  = '4d245c4f-ca7c-4e6a-a18c-246cb549415c';
const PIC_BASE     = 'https://provincies.incijfers.be/viewerservices/odata';
const PIC_BRANDST  = [
  'v2101_personenwagens_elektriciteit',
  'v2101_personenwagens_benzine',
  'v2101_personenwagens_diesel',
  'v2101_personenwagens_lpg',
  'v2101_personenwagens_hybride',
  'v2101_personenwagens_andere',
];
// Statische NIS-code tabel — alle 581 Belgische gemeenten (Statbel 2024).
// Gegenereerd uit nis-lookup.js (backend). Sleutel = naam lowercase.
const PIC_NIS = {
  "aalst":"41002","aalter":"44084","aarlen":"81001","aarschot":"24001","aartselaar":"11001","aat":"51004",
  "affligem":"23105","aiseau-presles":"52074","alken":"73001","alveringem":"38002","amay":"61003","amel":"63001",
  "andenne":"92003","anderlecht":"21001","anderlues":"56001","anhée":"91005","ans":"62003","anthisnes":"61079",
  "antoing":"57003","antwerpen":"11002","anzegem":"34002","ardooie":"37020","arendonk":"13001","as":"71002",
  "asse":"23002","assenede":"43002","assesse":"92006","attert":"81003","aubange":"81004","aubel":"63003",
  "avelgem":"34003","awans":"62006","aywaille":"62009","baarle-hertog":"13002","baelen":"63004","balen":"13003",
  "bastenaken":"82003","beaumont":"56005","beauraing":"91013","beernem":"31003","beerse":"13004","beersel":"23003",
  "begijnendijk":"24007","bekkevoort":"24008","beloeil":"51008","bergen":"53053","beringen":"71004","berlaar":"12002",
  "berlare":"42003","berloz":"64008","bernissart":"51009","bertem":"24009","bertogne":"82005","bertrix":"84009",
  "bevekom":"25005","bever":"23009","beveren":"46003","beyne-heusay":"62015","bierbeek":"24011","bilzen":"73006",
  "binche":"58002","bitsingen":"62011","bièvre":"91015","blankenberge":"31004","blégny":"62119","bocholt":"72003",
  "boechout":"11004","bonheiden":"12005","boom":"11005","boortmeerbeek":"24014","borgloon":"73009","borgworm":"64074",
  "bornem":"12007","borsbeek":"11007","bouillon":"84010","boussu":"53014","boutersem":"24016","braives":"64015",
  "brakel":"45059","brasschaat":"11008","brecht":"11009","bredene":"35002","bree":"72004","brugelette":"51012",
  "brugge":"31005","brunehaut":"57093","brussel":"21004","buggenhout":"42004","burdinne":"61010","burg-reuland":"63087",
  "büllingen":"63012","bütgenbach":"63013","celles":"57018","cerfontaine":"93010","chapelle-lez-herlaimont":"52010","charleroi":"52011",
  "chastre":"25117","chaudfontaine":"62022","chaumont-gistoux":"25018","chimay":"56016","chiny":"85007","chièvres":"51014",
  "châtelet":"52012","ciney":"91030","clavier":"61012","colfontaine":"53082","comblain-au-pont":"62026","courcelles":"52015",
  "court-saint-etienne":"25023","couvin":"93014","crisnée":"64021","dalhem":"62027","damme":"31006","daverdisse":"84016",
  "de haan":"35029","de panne":"38008","de pinte":"44012","deerlijk":"34009","deinze":"44083","denderleeuw":"41011",
  "dendermonde":"42006","dentergem":"37002","dessel":"13006","destelbergen":"44013","diepenbeek":"71011","diest":"24020",
  "diksmuide":"32003","dilbeek":"23016","dilsen-stokkem":"72041","dinant":"91034","dison":"63020","doische":"93018",
  "donceel":"64023","doornik":"57081","dour":"53020","drogenbos":"23098","duffel":"12009","durbuy":"83012",
  "ecaussinnes":"55050","edegem":"11013","edingen":"51067","eeklo":"43005","eghezée":"92035","eigenbrakel":"25014",
  "elsene":"21009","elzele":"51017","engis":"61080","erezée":"83013","erpe-mere":"41082","erquelinnes":"56022",
  "esneux":"62032","essen":"11016","estaimpuis":"57027","estinnes":"58003","etalle":"85009","etterbeek":"21005",
  "eupen":"63023","evere":"21006","evergem":"44019","faimes":"64076","farciennes":"52018","fauvillers":"82009",
  "fernelmont":"92138","ferrières":"61019","fexhe-le-haut-clocher":"64025","fleurus":"52021","floreffe":"92045","florennes":"93022",
  "florenville":"85011","flémalle":"62120","fléron":"62038","fontaine-l’evêque":"52022","fosses-la-ville":"92048","frameries":"53028",
  "frasnes-lez-anvaing":"51065","froidchapelle":"56029","galmaarden":"23023","ganshoren":"21008","gavere":"44020","gedinne":"91054",
  "geel":"13008","geer":"64029","geetbets":"24028","geldenaken":"25048","gembloux":"92142","genepien":"25031",
  "genk":"71016","gent":"44021","geraardsbergen":"41018","gerpinnes":"52025","gesves":"92054","gingelom":"71017",
  "gistel":"35005","glabbeek":"24137","gooik":"23024","gouvy":"82037","graven":"25037","grimbergen":"23025",
  "grobbendonk":"13010","grâce-hollogne":"62118","haacht":"24033","haaltert":"41024","habay":"85046","halen":"71020",
  "halle":"23027","ham":"71069","ham-sur-heure-nalinnes":"56086","hamme":"42008","hamoir":"61024","hamois":"91059",
  "hamont-achel":"72037","hannuit":"64034","harelbeke":"34013","hasselt":"71022","hastière":"91142","havelange":"91064",
  "hechtel-eksel":"72038","heers":"73022","heist-op-den-berg":"12014","hemiksem":"11018","hensies":"53039","herbeumont":"84029",
  "herent":"24038","herentals":"13011","herenthout":"13012","herk-de-stad":"71024","herne":"23032","herselt":"13013",
  "herstal":"62051","herstappe":"73028","herve":"63035","herzele":"41027","heusden-zolder":"71070","heuvelland":"33039",
  "hoegaarden":"24041","hoei":"61031","hoeilaart":"23033","hoeselt":"73032","holsbeek":"24043","honnelles":"53083",
  "hooglede":"36006","hoogstraten":"13014","horebeke":"45062","hotton":"83028","houffalize":"82014","houthalen-helchteren":"72039",
  "houthulst":"32006","houyet":"91072","hove":"11021","huldenberg":"24045","hulshout":"13016","hélécine":"25118",
  "héron":"61028","ichtegem":"35006","ieper":"33011","incourt":"25043","ingelmunster":"36007","itter":"25044",
  "izegem":"36008","jabbeke":"31012","jalhay":"63038","jemeppe-sur-sambre":"92140","jette":"21010","juprelle":"62060",
  "jurbeke":"53044","kalmthout":"11022","kampenhout":"23038","kapelle-op-den-bos":"23039","kapellen":"11023","kaprijke":"43007",
  "kasteelbrakel":"25015","kasterlee":"13017","keerbergen":"24048","kelmis":"63040","kinrooi":"72018","kluisbergen":"45060",
  "knokke-heist":"31043","koekelare":"32010","koekelberg":"21011","koksijde":"38014","komen-waasten":"57097","kontich":"11024",
  "kortemark":"32011","kortenaken":"24054","kortenberg":"24055","kortessem":"73040","kortrijk":"34022","kraainem":"23099",
  "kruibeke":"46013","kruisem":"45068","kuurne":"34023","la bruyère":"92141","la louvière":"58001","la roche-en-ardenne":"83031",
  "laakdal":"13053","laarne":"42010","lanaken":"73042","landen":"24059","langemark-poelkapelle":"33040","lasne":"25119",
  "le roeulx":"55035","lebbeke":"42011","lede":"41034","ledegem":"36010","lendelede":"34025","lennik":"23104",
  "lens":"53046","leopoldsburg":"71034","les bons villers":"52075","lessen":"51069","leuven":"24062","leuze-en-hainaut":"57094",
  "libin":"84035","libramont-chevigny":"84077","lichtervelde":"36011","liedekerke":"23044","lier":"12021","lierde":"45063",
  "lierneux":"63045","lievegem":"44085","lijsem":"64047","lille":"13019","limburg":"63046","linkebeek":"23100",
  "lint":"11025","linter":"24133","lo-reninge":"32030","lobbes":"56044","lochristi":"44034","lokeren":"46014",
  "lommel":"72020","londerzeel":"23045","lontzen":"63048","lubbeek":"24066","luik":"62063","lummen":"71037",
  "léglise":"84033","maarkedal":"45064","maaseik":"72021","maasmechelen":"73107","machelen":"23047","maldegem":"43010",
  "malle":"11057","malmedy":"63049","manage":"55086","manhay":"83055","marche-en-famenne":"83034","marchin":"61039",
  "martelange":"81013","mechelen":"12025","meerhout":"13021","meise":"23050","meix-devant-virton":"85024","melle":"44040",
  "menen":"34027","merbes-le-château":"56049","merchtem":"23052","merelbeke":"44043","merksplas":"13023","mesen":"33016",
  "messancy":"81015","mettet":"92087","meulebeke":"37007","middelkerke":"35011","modave":"61041","moerbeke":"44045",
  "moeskroen":"57096","mol":"13025","momignies":"56051","mont-de-l’enclus":"57095","mont-saint-guibert":"25068","montigny-le-tilleul":"52048",
  "moorslede":"36012","morlanwelz":"58004","mortsel":"11029","musson":"85026","namen":"92094","nandrin":"61043",
  "nassogne":"83040","nazareth":"44048","neufchâteau":"84043","neupré":"62121","niel":"11030","nieuwerkerken":"71045",
  "nieuwpoort":"38016","nijlen":"12026","nijvel":"25072","ninove":"41048","oerle":"64056","ohey":"92097",
  "olen":"13029","olne":"63057","onhaye":"91103","oostende":"35013","oosterzele":"44052","oostkamp":"31022",
  "oostrozebeke":"37010","opwijk":"23060","opzullik":"51068","orp-jauche":"25120","ottignies-louvain-la-neuve":"25121","oud-heverlee":"24086",
  "oud-turnhout":"13031","oudenaarde":"45035","oudenburg":"35014","oudergem":"21002","oudsbergen":"72042","ouffet":"61048",
  "oupeye":"62079","overijse":"23062","paliseul":"84050","pecq":"57062","peer":"72030","pelt":"72043",
  "pepingen":"23064","pepinster":"63058","perwijs":"25084","philippeville":"93056","pittem":"37011","plombières":"63088",
  "pont-à-celles":"52055","poperinge":"33021","profondeville":"92101","putte":"12029","puurs-sint-amands":"12041","péruwelz":"57064",
  "quaregnon":"53065","quiévrain":"53068","quévy":"53084","raeren":"63061","ramillies":"25122","ranst":"11035",
  "ravels":"13035","rebecq":"25123","remicourt":"64063","rendeux":"83044","retie":"13036","riemst":"73066",
  "rijkevorsel":"13037","rixensart":"25091","rochefort":"91114","roeselare":"36015","ronse":"45041","roosdaal":"23097",
  "rotselaar":"24094","rouvroy":"85047","ruiselede":"37012","rumes":"57072","rumst":"11037","saint-georges-sur-meuse":"64065",
  "saint-ghislain":"53070","saint-hubert":"84059","saint-léger":"85034","saint-nicolas":"62093","sainte-ode":"82038","sambreville":"92137",
  "sankt vith":"63067","schaarbeek":"21015","schelle":"11038","scherpenheuvel-zichem":"24134","schilde":"11039","schoten":"11040",
  "seneffe":"55085","seraing":"62096","sint-agatha-berchem":"21003","sint-genesius-rode":"23101","sint-gillis":"21013","sint-gillis-waas":"46020",
  "sint-jans-molenbeek":"21012","sint-joost-ten-node":"21014","sint-katelijne-waver":"12035","sint-lambrechts-woluwe":"21018","sint-laureins":"43014","sint-lievens-houtem":"41063",
  "sint-martens-latem":"44064","sint-niklaas":"46021","sint-pieters-leeuw":"23077","sint-pieters-woluwe":"21019","sint-truiden":"71053","sivry-rance":"56088",
  "sombreffe":"92114","somme-leuze":"91120","soumagne":"62099","spa":"63072","spiere-helkijn":"34043","sprimont":"62100",
  "stabroek":"11044","staden":"36019","stavelot":"63073","steenokkerzeel":"23081","stekene":"46024","stoumont":"63075",
  "tellin":"84068","temse":"46025","tenneville":"83049","terhulpen":"25050","ternat":"23086","tervuren":"24104",
  "tessenderlo":"71057","theux":"63076","thimister-clermont":"63089","thuin":"56078","tielt":"37015","tielt-winge":"24135",
  "tienen":"24107","tinlot":"61081","tintigny":"85039","tongeren":"73083","torhout":"31033","tremelo":"24109",
  "trois-ponts":"63086","trooz":"62122","tubeke":"25105","turnhout":"13040","ukkel":"21016","vaux-sur-sûre":"82036",
  "verlaine":"61063","verviers":"63079","veurne":"38025","vielsalm":"82032","villers-la-ville":"25107","villers-le-bouillet":"61068",
  "vilvoorde":"23088","viroinval":"93090","virton":"85045","vleteren":"33041","vloesberg":"51019","voeren":"73109",
  "vorselaar":"13044","vorst":"21007","vosselaar":"13046","vresse-sur-semois":"91143","waasmunster":"42023","wachtebeke":"44073",
  "walcourt":"93088","walhain":"25124","wanze":"61072","waregem":"34040","wasseiges":"64075","waterloo":"25110",
  "watermaal-bosvoorde":"21017","waver":"25112","weismes":"63080","welkenraedt":"63084","wellen":"73098","wellin":"84075",
  "wemmel":"23102","wervik":"33029","westerlo":"13049","wetteren":"42025","wevelgem":"34041","wezembeek-oppem":"23103",
  "wezet":"62108","wichelen":"42026","wielsbeke":"37017","wijnegem":"11050","willebroek":"12040","wingene":"37018",
  "wommelgem":"11052","wortegem-petegem":"45061","wuustwezel":"11053","yvoir":"91141","zandhoven":"11054","zaventem":"23094",
  "zedelgem":"31040","zele":"42028","zelzate":"43018","zemst":"23096","zinnik":"55040","zoersel":"11055",
  "zonhoven":"71066","zonnebeke":"33037","zottegem":"41081","zoutleeuw":"24130","zuienkerke":"31042","zulte":"44081",
  "zutendaal":"71067","zwalm":"45065","zwevegem":"34042","zwijndrecht":"11056","’s gravenbrakel":"55004"
};

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl:'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl:'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

const C = {
  darkBg:'#0F1117', panelBg:'#1A1F2E', surface2:'#222839',
  border:'rgba(255,255,255,0.08)', borderStrong:'rgba(255,255,255,0.15)',
  teal:'#4ECDC4', tealDark:'#2B5F6E', green:'#4ECDC4',
  darkGreen:'#2B5F6E', gold:'#E8963A', warn:'#E8963A',
  text:'#FFFFFF', textMid:'rgba(255,255,255,0.92)', textDim:'rgba(255,255,255,0.55)',
  red:'#E05C5C',
};

// Palet van het nieuwe ontwerp, gelijk aan Dashboard.js. Staat op moduleniveau
// naast C zodat het stijlobject st erin de component erbij kan; als const
// binnen de component zou het in de temporal dead zone vallen en crashen.
const N = {
  ink:'#12161C', ink2:'#3D4652', ink3:'#6B7684', ink4:'#9AA4B1',
  paper:'#FFFFFF', paper2:'#FBFAF7', canvas:'#ECEAE5',
  line:'#D9D5CD', line2:'#C4BFB5', head:'#F6F4F0',
  accent:'#1F5C6B', accent2:'#2D7F92',
  ok:'#3F7D4E', warn:'#9C6420', red:'#B4442F',
};

// ── Tabblad Laadpleinen: filteren ─────────────────────────────────────
// Buiten de component gezet zodat het los te toetsen is. De kaart, de lijst en
// de tellers gebruiken allemaal deze ene functie; anders kan de kaart iets
// anders tonen dan het getal erboven, en dat is precies de fout die dit
// dashboard eerder al eens maakte.
// Tot welke afstand een voorziening in de Excel van Laadpleinen wordt genoemd.
export const VZ_TOON_M = 750;

// De vier beoordelingen, in deze volgorde links op tabblad Laadpleinen.
export const PLEIN_STATUSSEN = [
  ['open', 'nog te beoordelen'], ['geschikt', 'geschikt'], ['later', 'later beslissen'], ['niet', 'afgevallen'],
];

export const PLEIN_SOORTEN = [
  ['winkel','Winkel','vzWinkel'], ['sport','Sport','vzSport'],
  ['onderwijs','Onderwijs','vzOnderwijs'], ['ov','Station','vzOv'],
  ['zorg','Zorg','vzZorg'], ['publiek','Publiek','vzPubliek'],
];

// De soort parking zoals de server hem meegeeft: terrein, garage of strook.
// Gebruikt als naam wanneer een parking in OpenStreetMap geen naam heeft.
export const PLEIN_SOORTNAAM = {
  terrein: 'Parkeerterrein', garage: 'Parkeergarage', strook: 'Parkeerstrook langs de straat',
};
export const pleinSoortNaam = (r) => PLEIN_SOORTNAAM[r?.soort] || PLEIN_SOORTNAAM.terrein;
// Bij een garage zonder geteld aantal is het aantal vakken onbekend.
export const pleinVakkenTekst = (r) => r?.vakken == null ? 'aantal vakken onbekend' : `${r.vakken} vakken`;

export function filterPleinen(rijen, oordelen, o) {
  const statusVan = (r) => oordelen[r.id]?.status || 'open';
  return (rijen || []).filter(r => {
    // Een onbekend aantal (garage) valt niet weg op de ondergrens.
    if (r.vakken != null && r.vakken < o.minVak) return false;
    if (o.toegang.length && !o.toegang.includes(r.groep)) return false;
    if (o.alleenMetLaadpunt && !((r.laadpunten ?? 0) > 0)) return false;
    if (o.status !== 'alle' && statusVan(r) !== o.status) return false;
    if (o.soorten.length) {
      // Eén treffer is genoeg: de gekozen soorten zijn een OF, geen EN.
      const raak = o.soorten.some(k => {
        const veld = PLEIN_SOORTEN.find(v => v[0] === k)?.[2];
        const m = veld ? r[veld] : null;
        return m != null && m <= o.nabij;
      });
      if (!raak) return false;
    }
    return true;
  }).sort((a, b) => (b.vakken ?? 0) - (a.vakken ?? 0));
}

// Aantal benodigde laadpleinen: het deel van de bij te plaatsen laadpunten dat
// geclusterd wordt, gedeeld door de omvang van één plein.
export function pleinenNodig(bijkomend, aandeelPct, puntenPerPlein) {
  return Math.ceil((Math.max(0, bijkomend) * (aandeelPct / 100)) / Math.max(1, puntenPerPlein));
}

// ── Het technisch fiche: rekenen aan een ingetekende rij parkeervakken ──
// Een rij is vier hoekpunten in de volgorde linksboven, rechtsboven,
// rechtsonder, linksonder, plus het aantal vakken dat erin ligt. Over de korte
// afstand van een parkeerterrein mag met een plat vlak gerekend worden: op
// 51 graden noorderbreedte is de fout over honderd meter minder dan een
// centimeter, en de luchtfoto zelf is grover dan dat.
const M_PER_GRAAD_LAT = 111320;
export function meterPerGraad(lat) {
  return { lat: M_PER_GRAAD_LAT, lng: M_PER_GRAAD_LAT * Math.cos(lat * Math.PI / 180) };
}

// Een punt [lat,lng] omgezet naar meters ten opzichte van een middelpunt, en
// terug. x loopt naar het oosten, y naar het noorden.
export function naarMeter(punt, midden) {
  const m = meterPerGraad(midden[0]);
  return [(punt[1] - midden[1]) * m.lng, (punt[0] - midden[0]) * m.lat];
}
export function naarGraden(xy, midden) {
  const m = meterPerGraad(midden[0]);
  return [midden[0] + xy[1] / m.lat, midden[1] + xy[0] / m.lng];
}

export function afstandMeter(a, b) {
  const xy = naarMeter(b, a);
  return Math.hypot(xy[0], xy[1]);
}

// Het middelpunt van de vier hoekpunten.
export function middenVanRij(rij) {
  const p = rij?.punten || [];
  if (p.length !== 4) return null;
  return [(p[0][0] + p[1][0] + p[2][0] + p[3][0]) / 4,
          (p[0][1] + p[1][1] + p[2][1] + p[3][1]) / 4];
}

// De richting van de bovenrand, in radialen, gemeten vanaf het oosten.
export function richtingVanRij(rij) {
  const p = rij?.punten || [];
  if (p.length !== 4) return 0;
  const xy = naarMeter(p[1], p[0]);
  return Math.atan2(xy[1], xy[0]);
}

// De schuinte van de vakken binnen de rij, in graden. Nul is haaks parkeren.
// Een schuine rij is langer dan een haakse met evenveel vakken: de vakken
// schuiven over elkaar heen en dat kost aan elk uiteinde diepte maal tangens.
export function verschuiving(diepte, schuinteGraden) {
  return diepte * Math.tan((schuinteGraden || 0) * Math.PI / 180);
}
export function lengteVanRij(aantal, breedte, diepte, schuinte) {
  const s = (schuinte || 0) * Math.PI / 180;
  return aantal * breedte / Math.cos(s) + Math.abs(verschuiving(diepte, schuinte));
}

// Wat er werkelijk is ingetekend, in meters. De breedte is die van ÉÉN vak,
// gemeten HAAKS OP HET VAK, dus zoals een parkeervak wordt uitgezet. De diepte
// is het gemiddelde van de twee zijranden.
export function maatVanRij(rij) {
  const p = rij?.punten || [];
  if (p.length !== 4) return { breedte: 0, diepte: 0, lengte: 0 };
  const lengte = (afstandMeter(p[0], p[1]) + afstandMeter(p[3], p[2])) / 2;
  const diepte = (afstandMeter(p[0], p[3]) + afstandMeter(p[1], p[2])) / 2;
  const aantal = Math.max(1, rij.aantal || 1);
  const s = (rij.schuinte || 0) * Math.PI / 180;
  const bruikbaar = Math.max(0, lengte - Math.abs(verschuiving(diepte, rij.schuinte)));
  return { breedte: bruikbaar / aantal * Math.cos(s), diepte, lengte };
}

// Een rechthoek van een gegeven lengte bij diepte, om een middelpunt heen en
// gedraaid volgens richting. De hoekpunten staan in de volgorde linksboven,
// rechtsboven, rechtsonder, linksonder van de rij zelf.
export function rechthoekVan(midden, richting, lengte, diepte) {
  const halveL = lengte / 2, halveD = diepte / 2;
  const c = Math.cos(richting), s = Math.sin(richting);
  const u = [halveL * c, halveL * s];
  const v = [-halveD * s, halveD * c];
  const hoek = (sx, sy) => naarGraden([sx * u[0] + sy * v[0], sx * u[1] + sy * v[1]], midden);
  return [hoek(-1, 1), hoek(1, 1), hoek(1, -1), hoek(-1, -1)];
}

export function rechthoekRij(midden, richting, aantal, breedte, diepte, schuinte = 0) {
  return rechthoekVan(midden, richting, lengteVanRij(aantal, breedte, diepte, schuinte), diepte);
}

// Een rij opnieuw opbouwen uit zijn maten. Dit is de enige plek waar
// hoekpunten ontstaan, zodat de rij altijd een rechthoek blijft.
export function bouwRij({ midden, richting, aantal, breedte, diepte, schuinte = 0 }) {
  const a = Math.max(1, Math.round(aantal || 1));
  const b = Math.max(0.1, breedte), d = Math.max(0.1, diepte);
  return { punten: rechthoekRij(midden, richting, a, b, d, schuinte),
           aantal: a, breedte: Math.round(b * 10) / 10,
           diepte: Math.round(d * 10) / 10, schuinte: Math.round(schuinte || 0) };
}

// Dezelfde rij, maar opgebouwd uit een gemeten lengte in plaats van uit de
// breedte per vak. Gebruikt bij het slepen aan een rand.
export function aantalVoorLengte(lengte, breedte, diepte, schuinte = 0) {
  const s = (schuinte || 0) * Math.PI / 180;
  const bruikbaar = lengte - Math.abs(verschuiving(diepte, schuinte));
  return Math.max(1, Math.round(bruikbaar * Math.cos(s) / Math.max(0.1, breedte)));
}

// Een rij die langer of korter wordt gesleept. De breedte van een vak staat
// vast, want dat is een maat uit de werkelijkheid; het AANTAL vakken is de
// uitkomst. De rij klikt daardoor vast op hele vakken, en dat hoort: een half
// parkeervak bestaat niet. Het vaste punt is de zijde die blijft liggen.
export function rijUitLengte({ vast, richting, breedte, lengte, diepte, schuinte = 0,
                               kantLangs = 1, kantHaaks = 0 }) {
  const aantal = aantalVoorLengte(lengte, breedte, diepte, schuinte);
  const nieuweLengte = lengteVanRij(aantal, breedte, diepte, schuinte);
  const u = [Math.cos(richting), Math.sin(richting)];
  const v = [-Math.sin(richting), Math.cos(richting)];
  const a = kantLangs * nieuweLengte / 2, b = kantHaaks * diepte / 2;
  const midden = naarGraden([a * u[0] + b * v[0], a * u[1] + b * v[1]], vast);
  return bouwRij({ midden, richting, aantal, breedte, diepte, schuinte });
}

// De losse vakken binnen de rij, elk als vier punten. Bij schuinte lopen de
// scheidingslijnen mee, zodat elk vak een gelijk parallellogram is en de rij
// precies wordt opgevuld.
export function vakkenVanRij(rij) {
  const p = rij?.punten || [];
  const aantal = Math.max(1, Math.min(500, rij?.aantal || 1));
  if (p.length !== 4) return [];
  const maat = maatVanRij(rij);
  const verschuif = verschuiving(maat.diepte, rij?.schuinte);
  const lengte = maat.lengte || 1;
  // Fracties langs de bovenrand en langs de onderrand. Bij een positieve
  // schuinte begint de bovenrand ingesprongen, bij een negatieve de onderrand.
  const stap = (lengte - Math.abs(verschuif)) / aantal / lengte;
  const startBoven = verschuif >= 0 ? Math.abs(verschuif) / lengte : 0;
  const startOnder = verschuif >= 0 ? 0 : Math.abs(verschuif) / lengte;
  const tussen = (a, b, f) => [a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f];
  const vakken = [];
  for (let i = 0; i < aantal; i++) {
    const b1 = startBoven + i * stap, b2 = startBoven + (i + 1) * stap;
    const o1 = startOnder + i * stap, o2 = startOnder + (i + 1) * stap;
    vakken.push([tussen(p[0], p[1], b1), tussen(p[0], p[1], b2),
                 tussen(p[3], p[2], o2), tussen(p[3], p[2], o1)]);
  }
  return vakken;
}

// Een nieuwe rij, midden op de locatie en met de vakken naar het noorden
// gericht. De gemeente sleept hem daarna op zijn plek.
export function nieuweRij(lat, lng, aantal = 10, breedte = 2.5, diepte = 5.0) {
  return bouwRij({ midden: [lat, lng], richting: 0, aantal, breedte, diepte, schuinte: 0 });
}

// De grepen waarmee de rij wordt versteld, in vaste volgorde. De vier hoeken
// verstellen lengte en diepte tegelijk, de vier randen elk één van de twee, en
// de laatste draait de rij om zijn middelpunt.
export const FICHE_GREPEN = ['hoek0','hoek1','hoek2','hoek3','boven','rechts','onder','links','draai'];

// Waar elke greep ligt. De draaigreep steekt twaalf meter boven de rij uit.
export function greepPunten(rij) {
  const p = rij?.punten || [];
  if (p.length !== 4) return [];
  const midden = middenVanRij(rij), richting = richtingVanRij(rij);
  const maat = maatVanRij(rij);
  const mid = (a, b) => [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2];
  const buiten = naarGraden([-(maat.diepte / 2 + 12) * Math.sin(richting),
                              (maat.diepte / 2 + 12) * Math.cos(richting)], midden);
  return [p[0], p[1], p[2], p[3],
          mid(p[0], p[1]), mid(p[1], p[2]), mid(p[3], p[2]), mid(p[0], p[3]), buiten];
}

// Een greep verzetten naar een nieuw punt. De rij blijft altijd een rechthoek:
// bij een hoek of een rand blijft de tegenoverliggende zijde liggen waar hij
// lag, en bij de draaigreep blijven alle maten gelijk.
export function verzetGreep(rij, greep, punt) {
  const p = rij.punten;
  const richting = richtingVanRij(rij);
  const maat = maatVanRij(rij);
  const u = [Math.cos(richting), Math.sin(richting)];
  const v = [-Math.sin(richting), Math.cos(richting)];
  const mid = (a, b) => [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2];
  const langs = (vanaf, as) => { const d = naarMeter(punt, vanaf); return d[0] * as[0] + d[1] * as[1]; };
  const teken = (x) => (x < 0 ? -1 : 1);
  const gemeen = { richting, breedte: maat.breedte, schuinte: rij.schuinte || 0 };

  if (greep === 'draai') {
    const d = naarMeter(punt, middenVanRij(rij));
    return bouwRij({ midden: middenVanRij(rij), aantal: rij.aantal,
      richting: Math.atan2(d[1], d[0]) - Math.PI / 2,
      breedte: maat.breedte, diepte: maat.diepte, schuinte: rij.schuinte || 0 });
  }
  if (greep.startsWith('hoek')) {
    const i = Number(greep.slice(4));
    const tegenover = p[(i + 2) % 4];
    const a = langs(tegenover, u), b = langs(tegenover, v);
    return rijUitLengte({ ...gemeen, vast: tegenover,
      lengte: Math.abs(a), diepte: Math.max(0.5, Math.abs(b)),
      kantLangs: teken(a), kantHaaks: teken(b) });
  }
  if (greep === 'boven' || greep === 'onder') {
    const tegenover = greep === 'boven' ? mid(p[3], p[2]) : mid(p[0], p[1]);
    const b = langs(tegenover, v);
    return rijUitLengte({ ...gemeen, vast: tegenover,
      lengte: maat.lengte, diepte: Math.max(0.5, Math.abs(b)),
      kantLangs: 0, kantHaaks: teken(b) });
  }
  const tegenover = greep === 'rechts' ? mid(p[0], p[3]) : mid(p[1], p[2]);
  const a = langs(tegenover, u);
  return rijUitLengte({ ...gemeen, vast: tegenover,
    lengte: Math.abs(a), diepte: maat.diepte,
    kantLangs: teken(a), kantHaaks: 0 });
}

// De grenzen die de server bewaakt bij het bewaren van een fiche. Staan hier
// zodat het scherm ze noemt vóór het opsturen in plaats van een foutmelding
// van de server op te vangen.
export const FICHE_GRENS = { breedteMin:1.5, breedteMax:6, diepteMin:2, diepteMax:12 };
export function meterTekst(n) {
  return (Math.round(n * 10) / 10).toLocaleString('nl-NL',
    { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}
export function ficheBezwaar(rij) {
  // Op een tiende afronden vóór de vergelijking, en precies zoals het bij het
  // bewaren ook gebeurt. Anders keurt het scherm een rij van 2,0 meter diep af
  // omdat er in werkelijkheid 1,9999999 staat, met een melding die zegt dat
  // 2,0 wel mag.
  const ruw = maatVanRij(rij);
  const m = { breedte: Math.round(ruw.breedte * 10) / 10,
              diepte:  Math.round(ruw.diepte  * 10) / 10 };
  if (m.breedte < FICHE_GRENS.breedteMin || m.breedte > FICHE_GRENS.breedteMax)
    return `Een vak is ${meterTekst(m.breedte)} meter breed. Toegestaan is ${meterTekst(FICHE_GRENS.breedteMin)} tot ${meterTekst(FICHE_GRENS.breedteMax)} meter.`;
  if (m.diepte < FICHE_GRENS.diepteMin || m.diepte > FICHE_GRENS.diepteMax)
    return `De rij is ${meterTekst(m.diepte)} meter diep. Toegestaan is ${meterTekst(FICHE_GRENS.diepteMin)} tot ${meterTekst(FICHE_GRENS.diepteMax)} meter.`;
  return null;
}

// Het bezwaar over alle rijen samen, met het rijnummer erbij zodat duidelijk is
// welke rij niet deugt.
export function ficheBezwaarAlle(rijen) {
  for (let i = 0; i < (rijen || []).length; i++) {
    const b = ficheBezwaar(rijen[i]);
    if (b) return `Rij ${i + 1}: ${b}`;
  }
  return null;
}

// ── Aangewezen vakken en palen ─────────────────────────────────────────
// Een aangewezen vak heet "rij:vak", allebei geteld vanaf nul. Die vorm ligt
// vast in de invoercontrole van de server en mag hier niet van afwijken.
export const vakSleutel = (rijNr, vakNr) => `${rijNr}:${vakNr}`;

// Waarvoor een aangewezen vak is voorbehouden. Een vak zonder vermelding in de
// doelen is gewoon voorbehouden aan laden. Dezelfde kleuren op de kaart en in
// de PDF van het fiche.
export const VAK_DOELEN = [['laden', 'Laden'], ['deel', 'Deelwagen'], ['bestel', 'Bestelwagen']];
export const VAK_KLEUR  = { laden: '#1F5C6B', deel: '#6B4C9A', bestel: '#9C6420' };
export const VAK_LETTER = { deel: 'D', bestel: 'B' };

// Het laadvermogen dat één laadpunt voor bestelwagens telt bij de vergelijking
// met het minimum van MOW. AC heeft per laadpunt een eigen maximum van 11 kW.
// Een snellader van 50 kW verdeelt zijn vermogen over twee laadpunten, dus
// telt elk laadpunt voor 25 kW. Besluit van 8 oktober 2026.
export const BESTEL_KW_PER_PUNT = { ac: 11, dc: 25 };

// Laadvermogen voor bestelwagens op de gekozen locaties die uiterlijk in het
// gegeven jaar gerealiseerd zijn. Een locatie zonder jaartal telt mee vanaf het
// eerste planjaar. Geeft het aantal laadpunten en het vermogen in kW.
export function bestelVermogenTot(locaties, jaar, eersteJaar) {
  let punten = 0, kw = 0;
  for (const l of (locaties || [])) {
    const b = l.bestelwagens || {};
    const ac = Math.max(0, Math.floor(Number(b.ac) || 0));
    const dc = Math.max(0, Math.floor(Number(b.dc) || 0));
    if (!ac && !dc) continue;
    const vanaf = Number.isFinite(l.jaar) ? l.jaar : eersteJaar;
    if (vanaf > jaar) continue;
    punten += ac + dc;
    kw += ac * BESTEL_KW_PER_PUNT.ac + dc * BESTEL_KW_PER_PUNT.dc;
  }
  return { punten, kw };
}

// Korte regel voor de lijst en de kaart op tabblad Laadpleinen, met enkelvoud
// bij één laadpunt. Leeg als er niets is ingevuld.
export function deelwagensTekst(aantal) {
  const n = Math.max(0, Math.floor(Number(aantal) || 0));
  return n ? `${n} ${n === 1 ? 'laadpunt' : 'laadpunten'} deelwagens` : '';
}
export function bestelwagensTekst(bestelwagens) {
  const b = bestelPuntenVan(bestelwagens);
  const n = b.ac + b.dc;
  if (!n) return '';
  const delen = [b.ac ? `${b.ac} AC` : null, b.dc ? `${b.dc} DC` : null].filter(Boolean).join(', ');
  return `${n} ${n === 1 ? 'laadpunt' : 'laadpunten'} bestelwagens (${delen})`;
}

// Laadpunten voor bestelwagens op een locatie, AC en DC, als gehele getallen.
export function bestelPuntenVan(bestelwagens) {
  const b = bestelwagens || {};
  return { ac: Math.max(0, Math.floor(Number(b.ac) || 0)),
           dc: Math.max(0, Math.floor(Number(b.dc) || 0)) };
}

// Laadpunten op een locatie die de vraag van PERSONENWAGENS dienen: de
// opstelling min de laadpunten voor bestelwagens, per soort en nooit onder nul.
// Deelwagens blijven meetellen, want een deelwagen is een personenwagen.
// Besluit van 9 oktober 2026: een laadpunt voor bestelwagens staat er echt,
// maar is geen plek voor het tekort aan personenwagens.
export function puntenVoorPersonenwagens(opstelling, bestelwagens) {
  const o = opstelling || {};
  const b = bestelPuntenVan(bestelwagens);
  const per = (soort) => Math.max(0, Math.floor(Number(o[soort]) || 0) * PUNTEN_PER_PAAL - (b[soort] || 0));
  return { ac: per('ac'), dc: per('dc'), hpc: per('hpc') };
}

// Hetzelfde in hele palen, voor de netcapaciteit. Naar beneden afgerond: een
// paal waarvan een laadpunt voor bestelwagens is, haalt niets af van wat het
// model vraagt. Dat is de voorzichtige kant.
export function palenVoorPersonenwagens(opstelling, bestelwagens) {
  const p = puntenVoorPersonenwagens(opstelling, bestelwagens);
  return { ac:  Math.floor(p.ac  / PUNTEN_PER_PAAL),
           dc:  Math.floor(p.dc  / PUNTEN_PER_PAAL),
           hpc: Math.floor(p.hpc / PUNTEN_PER_PAAL) };
}

// ── Deelgemeenten ──────────────────────────────────────────────────────
// Ligt een punt binnen een vorm? De vorm komt van de server als lijst van
// veelhoeken, elk een lijst ringen van [lengte, breedte]; de eerste ring is de
// buitenrand, de volgende zijn gaten. Even-oneven regel over alle ringen.
export function puntInVorm(lat, lng, vorm) {
  for (const veelhoek of (vorm || [])) {
    let binnen = false;
    for (const ring of (veelhoek || [])) {
      for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const [xi, yi] = ring[i], [xj, yj] = ring[j];
        if (((yi > lat) !== (yj > lat)) && (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi)) binnen = !binnen;
      }
    }
    if (binnen) return true;
  }
  return false;
}

// De deelgemeente waarin een punt ligt. Valt het punt door een kleine
// onnauwkeurigheid op een grens net buiten alle vormen, dan telt de
// deelgemeente met het dichtstbijzijnde hoekpunt.
export function deelgemeenteVan(lat, lng, deelgemeenten) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || !(deelgemeenten || []).length) return null;
  const binnen = deelgemeenten.find(d => puntInVorm(lat, lng, d.vorm));
  if (binnen) return binnen.code;
  let beste = null, besteAfstand = Infinity;
  for (const d of deelgemeenten) {
    for (const veelhoek of (d.vorm || [])) for (const ring of veelhoek) for (const [x, y] of ring) {
      const afstand = (x - lng) * (x - lng) + (y - lat) * (y - lat);
      if (afstand < besteAfstand) { besteAfstand = afstand; beste = d.code; }
    }
  }
  return beste;
}

// Het laadvermogen voor bestelwagens per deelgemeente, voor één jaar. Zelfde
// regels als bestelVermogenTot, maar dan per deelgemeente opgeteld.
export function bestelPerDeelgemeente(locaties, deelgemeenten, jaar, eersteJaar) {
  const uit = new Map((deelgemeenten || []).map(d => [d.code, 0]));
  for (const l of (locaties || [])) {
    const code = deelgemeenteVan(l.lat, l.lng, deelgemeenten);
    if (code == null) continue;
    const kw = bestelVermogenTot([l], jaar, eersteJaar).kw;
    if (kw) uit.set(code, (uit.get(code) || 0) + kw);
  }
  return uit;
}

// Zelfde opschuiven als bij de vakken, maar dan voor de doelen per vak.
export function doelenNaVerwijderen(doelen, weg) {
  const uit = {};
  for (const [sleutel, doel] of Object.entries(doelen || {})) {
    const [r, v] = sleutel.split(':').map(Number);
    if (r === weg) continue;
    uit[vakSleutel(r > weg ? r - 1 : r, v)] = doel;
  }
  return uit;
}

// Bij het verwijderen van een rij schuiven de nummers van de rijen erna één op,
// dus de aangewezen vakken moeten mee opschuiven. Anders wijzen ze na het
// verwijderen naar de verkeerde rij.
export function vakkenNaVerwijderen(vakken, weg) {
  return (vakken || []).reduce((uit, sleutel) => {
    const [r, v] = sleutel.split(':').map(Number);
    if (r === weg) return uit;
    uit.push(vakSleutel(r > weg ? r - 1 : r, v));
    return uit;
  }, []);
}

// Alle plekken waar een paal kan staan: op elke scheiding tussen twee vakken,
// en op de twee uiteinden van een rij. Elke scheiding levert twee plekken op,
// vooraan en achteraan de rij, want welke kant de auto's inrijden weten wij
// niet. De gemeente kiest zelf welke van de twee.
export function scheidingPunten(rijen) {
  const uit = [];
  (rijen || []).forEach((rij, rijNr) => {
    const vakken = vakkenVanRij(rij);
    vakken.forEach((vak, i) => {
      uit.push({ rijNr, scheiding: i, lat: vak[0][0], lng: vak[0][1], kant: 'boven' });
      uit.push({ rijNr, scheiding: i, lat: vak[3][0], lng: vak[3][1], kant: 'onder' });
      if (i === vakken.length - 1) {
        uit.push({ rijNr, scheiding: i + 1, lat: vak[1][0], lng: vak[1][1], kant: 'boven' });
        uit.push({ rijNr, scheiding: i + 1, lat: vak[2][0], lng: vak[2][1], kant: 'onder' });
      }
    });
  });
  return uit;
}

// De dichtstbijzijnde plek uit een lijst. Geeft null terug bij een lege lijst.
export function dichtstePunt(punt, lijst) {
  let beste = null, besteAfstand = Infinity;
  for (const p of lijst || []) {
    const d = afstandMeter(punt, [p.lat, p.lng]);
    if (d < besteAfstand) { besteAfstand = d; beste = p; }
  }
  return beste ? { ...beste, afstand: besteAfstand } : null;
}

// Wat er aan palen is ingetekend, in dezelfde vorm als de opstelling van een
// locatie, zodat de twee naast elkaar te leggen zijn.
export const PAAL_SOORTEN = [['ac','AC 22 kW'], ['dc','DC 50 kW'], ['hpc','HPC 150 kW']];
// Kleur van een laadpaal in het technisch fiche, op het scherm en in de PDF.
// Oker en rood zoals op tabblad Laadinfra-mix. AC is hier helder blauw en niet
// het petrol van dat tabblad, want petrol valt weg tegen de vakken voor laden.
// Tot 9 oktober 2026 was DC groen, en dat was naast AC slecht te zien.
export const PAAL_KLEUR = { ac: '#2E7BE6', dc: '#D9A02B', hpc: '#B4442F' };
// ── Cabine en kabels ───────────────────────────────────────────────────
// De cabine hoort bij de snelladers, want die vragen het meeste vermogen. Zijn
// er geen snelladers, dan valt hij op het midden van alle palen. Zijn er
// helemaal geen palen, dan op de eerste rij.
export function cabinePlek(palen, rijen) {
  const zwaar = (palen || []).filter(p => p.soort === 'dc' || p.soort === 'hpc');
  const lijst = zwaar.length ? zwaar : (palen || []);
  if (lijst.length) {
    return { lat: lijst.reduce((n, p) => n + p.lat, 0) / lijst.length,
             lng: lijst.reduce((n, p) => n + p.lng, 0) / lijst.length };
  }
  const midden = (rijen || []).length ? middenVanRij(rijen[0]) : null;
  return midden ? { lat: midden[0], lng: midden[1] } : null;
}

// Bij welke rij en welke kant een paal hoort. Nodig om de kabels langs de rij
// te laten lopen in plaats van er dwars doorheen.
export function paalBijRij(paal, rijen) {
  const plek = dichtstePunt([paal.lat, paal.lng], scheidingPunten(rijen));
  return plek ? { rijNr: plek.rijNr, kant: plek.kant } : null;
}

// Het kabeltracé: per rij en per kant lopen de palen aan één streng, en die
// streng loopt vanaf het uiteinde dat het dichtst bij de cabine ligt naar de
// cabine toe. Dat is realistischer dan van elke paal een eigen lijn.
export function kabelTraces(palen, rijen, cabine) {
  if (!cabine || !(palen || []).length) return [];
  const groepen = new Map();
  const los = [];
  (palen || []).forEach(paal => {
    const bij = paalBijRij(paal, rijen);
    if (!bij) { los.push(paal); return; }
    const sleutel = `${bij.rijNr}:${bij.kant}`;
    if (!groepen.has(sleutel)) groepen.set(sleutel, { rijNr: bij.rijNr, palen: [] });
    groepen.get(sleutel).palen.push(paal);
  });
  const traces = [];
  for (const groep of groepen.values()) {
    const rij = rijen[groep.rijNr];
    const richting = rij ? richtingVanRij(rij) : 0;
    const as = [Math.cos(richting), Math.sin(richting)];
    const eerste = groep.palen[0];
    const langs = (paal) => {
      const d = naarMeter([paal.lat, paal.lng], [eerste.lat, eerste.lng]);
      return d[0] * as[0] + d[1] * as[1];
    };
    const op = [...groep.palen].sort((a, b) => langs(a) - langs(b));
    const streng = op.map(p => [p.lat, p.lng]);
    if (streng.length > 1) traces.push(streng);
    // Het uiteinde dat het dichtst bij de cabine ligt, gaat naar de cabine.
    const kop = streng[0], staart = streng[streng.length - 1];
    const dichtst = afstandMeter(kop, [cabine.lat, cabine.lng])
                  <= afstandMeter(staart, [cabine.lat, cabine.lng]) ? kop : staart;
    traces.push([dichtst, [cabine.lat, cabine.lng]]);
  }
  los.forEach(p => traces.push([[p.lat, p.lng], [cabine.lat, cabine.lng]]));
  return traces;
}

export function telPalen(palen) {
  const uit = { ac:0, dc:0, hpc:0 };
  (palen || []).forEach(p => { if (uit[p.soort] != null) uit[p.soort] += 1; });
  return uit;
}
export function palenTekst(telling) {
  const delen = PAAL_SOORTEN
    .filter(([k]) => (telling[k] || 0) > 0)
    .map(([k]) => `${telling[k]} ${k.toUpperCase()}`);
  return delen.length ? delen.join(', ') : 'nog geen palen';
}

// ── Plausibiliteitsgrens op het EV-aandeel ─────────────────────────────
// Sinds 19 augustus 2026 volgt het model de Vlaamse reeks zonder opslag per
// gemeente, dus alles boven die reeks komt uit het veld waarmee het aandeel
// handmatig wordt overschreven. Ter onderbouwing van de grens: gemeten op de
// 289 Vlaamse gemeenten zonder leasevloot ligt het EV-aandeel van wagens bij
// gezinnen in de helft van de gevallen tussen 1,0 en 2,6 procent, met 1,64
// procent in het midden. Een gemeente die daar meer dan de helft boven zit,
// heeft vrijwel zeker een cijfer uit de inschrijvingsstatistiek ingevuld, en
// dat telt de wagens van leasemaatschappijen mee.
export const EV_AANDEEL_GRENS = 1.5;

// Geeft null als er niets aan de hand is, anders het aantal keer dat het
// aandeel boven het Vlaams gemiddelde van datzelfde jaar ligt.
export function evAandeelTeHoog(jaar, evPct, grens = EV_AANDEEL_GRENS) {
  const vlaams = evAandeelGemeente(jaar);
  if (!(vlaams > 0) || !(evPct > 0)) return null;
  const factor = evPct / vlaams;
  // Kleine marge, anders slaat een waarde die precies op de grens ligt toch
  // aan door afrondingsruis in de deling.
  return factor > grens + 1e-9 ? factor : null;
}

// ── Wijk bepalen uit de wijkgrenzen ────────────────────────────────────
// Ligt een punt binnen een ring? Standaard stralenmethode: tel hoe vaak een
// denkbeeldige lijn naar rechts de rand kruist. Oneven is binnen.
export function puntInRing(lng, lat, ring) {
  let binnen = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i], [xj, yj] = ring[j];
    if (((yi > lat) !== (yj > lat)) &&
        (lng < ((xj - xi) * (lat - yi)) / ((yj - yi) || 1e-12) + xi)) binnen = !binnen;
  }
  return binnen;
}

// Zoekt de wijk waarbinnen een locatie ligt, op basis van de statistische
// sectoren die de app toch al ophaalt. Nauwkeuriger dan de dichtstbijzijnde
// wijk, want een parking op een wijkgrens viel daarmee de verkeerde kant op.
// Geeft null als er geen grenzen zijn geladen; de aanroeper valt dan terug.
export function wijkVanPunt(sectorenGeo, lat, lng) {
  const kenmerken = sectorenGeo?.features;
  if (!kenmerken?.length || lat == null || lng == null) return null;
  for (const f of kenmerken) {
    const g = f.geometry;
    if (!g) continue;
    const vlakken = g.type === 'Polygon' ? [g.coordinates]
                  : g.type === 'MultiPolygon' ? g.coordinates : [];
    for (const vlak of vlakken) {
      if (!vlak.length || !puntInRing(lng, lat, vlak[0])) continue;
      // Gaten in het vlak tellen niet mee als binnen.
      let inGat = false;
      for (let i = 1; i < vlak.length; i++) if (puntInRing(lng, lat, vlak[i])) inGat = true;
      if (!inGat) return f.properties?.WIJK_ID ?? null;
    }
  }
  return null;
}

// ── Vermogensvertaling ─────────────────────────────────────────────────
// De netbeheerder rekent niet in laadpunten maar in aansluitwaarde, en die
// hangt aan de PAAL en niet aan het laadpunt: één paal met twee punten deelt
// binnen die ene aansluiting. Per punt rekenen verdubbelt de capaciteitsvraag.
//
// AC en DC volgen rechtstreeks uit de aansluiting, wortel(3) × 400 V × stroom:
// 3×35A geeft 24,2 kVA en 3×80A geeft 55,4 kVA. Voor HPC bestaat geen vaste
// waarde maar een bandbreedte die van de kast afhangt; daarom min en max.
// Peildatum van deze waarden staat in VERMOGEN_PEILDATUM en hoort in elk
// rapport mee, want een plan dat over een half jaar wordt gelezen moet
// zichzelf kunnen verklaren.
export const PAAL_VERMOGEN = {
  ac:  { naam: 'AC 22 kW',   aansluiting: '3×35A',         kvaMin: 24.2, kvaMax: 24.2 },
  dc:  { naam: 'DC 50 kW',   aansluiting: '3×80A',         kvaMin: 55.4, kvaMax: 55.4 },
  hpc: { naam: 'HPC 150 kW', aansluiting: 'middenspanning', kvaMin: 150,  kvaMax: 250  },
};
export const PUNTEN_PER_PAAL = 2;

/**
 * Snel en ultrasnel afronden op HELE PALEN voor de hele gemeente, en het
 * resultaat teruggeven per wijk.
 *
 * Een lader heeft altijd twee laadpunten, dus een halve paal bestaat niet.
 * Tot 20 augustus 2026 werd er per wijk afgerond: elke wijk met een fractie
 * kreeg een hele paal, en bij 24 wijken telde dat op. Een behoefte van 30,5
 * snellaadpunten werd zo 20 palen oftewel 40 laadpunten, terwijl 16 palen
 * volstaan. Dat werkte door in de investering en het aansluitvermogen.
 *
 * Het aantal palen wordt eerst voor de gemeente bepaald en daarna over de
 * wijken verdeeld naar rato van hun eigen behoefte, met de grootste-restmethode
 * zodat de wijken samen exact op dat aantal uitkomen.
 *
 * @param {number[]} behoefte - de ruwe behoefte per wijk, in laadpunten
 * @returns {number[]} hele laadpunten per wijk, samen een veelvoud van twee
 */
export function stadsPalen(behoefte) {
  const som = behoefte.reduce((a, b) => a + b, 0);
  if (som <= 0) return behoefte.map(() => 0);
  const sockets = Math.ceil(som / PUNTEN_PER_PAAL) * PUNTEN_PER_PAAL;
  const ideaal = behoefte.map(b => b / som * sockets);
  const heel   = ideaal.map(x => Math.floor(x));
  const over   = sockets - heel.reduce((a, b) => a + b, 0);
  const volgorde = ideaal
    .map((x, i) => ({ i, rest: x - Math.floor(x) }))
    .sort((a, b) => b.rest - a.rest);
  for (let k = 0; k < over; k++) heel[volgorde[k % volgorde.length].i] += 1;
  return heel;
}
// Boven deze waarde moet Fluvius eerst een studie doen.
export const KVA_STUDIE = 25;
// Daarboven past het niet meer op een laagspanningsaansluiting en is een eigen
// cabine nodig.
export const KVA_CABINE = 250;
export const VERMOGEN_PEILDATUM = 'augustus 2026';

// Rekent een opstelling {ac, dc, hpc} in palen om naar punten en kVA. De vlag
// wordt op de BOVENkant van de bandbreedte gezet: wie capaciteit reserveert bij
// een netbeheerder reserveert de bovenkant, niet het gunstigste geval.
export function vermogenVanOpstelling(opstelling) {
  const o = opstelling || {};
  let palen = 0, punten = 0, kvaMin = 0, kvaMax = 0;
  for (const [type, gegeven] of Object.entries(PAAL_VERMOGEN)) {
    const n = Math.max(0, Math.floor(Number(o[type]) || 0));
    if (!n) continue;
    palen  += n;
    punten += n * PUNTEN_PER_PAAL;
    kvaMin += n * gegeven.kvaMin;
    kvaMax += n * gegeven.kvaMax;
  }
  const min = Math.round(kvaMin), max = Math.round(kvaMax);
  return {
    palen, punten, kvaMin: min, kvaMax: max,
    bandbreedte: min !== max,
    vlag: !palen ? 'leeg' : max > KVA_CABINE ? 'cabine' : max > KVA_STUDIE ? 'studie' : 'geen',
  };
}

// Leesbare samenstelling voor lijst en rapport, bijvoorbeeld "8 AC, 2 DC".
export function samenstellingTekst(opstelling) {
  const o = opstelling || {};
  const delen = Object.keys(PAAL_VERMOGEN)
    .filter(t => (Number(o[t]) || 0) > 0)
    .map(t => `${Math.floor(Number(o[t]))} ${t.toUpperCase()}`);
  return delen.join(', ');
}

// ── Dekking van de gekozen locaties ────────────────────────────────────
// Vergelijkt wat er op de laadpleinen is ingevuld met wat het model vraagt.
// Twee toetsen, want ze beantwoorden verschillende vragen. De eerste is of de
// laadvraag gedekt is; daar is de mix vrij, omdat energie over alle soorten
// optelt. De tweede is of er genoeg AC staat voor de bewoners; die laden 's
// nachts en kunnen dus niet naar een snellader, waardoor dat deel niet
// uitwisselbaar is. Er wordt bewust NIET geoordeeld dat er ergens te veel van
// een soort staat: het model geeft één werkbare verdeling, niet de enige.
export function dekkingVanLocaties({ wijken = [], locaties = [], pleinAandeelPct = 45, util, bewAcAandeel = 0.95 }) {
  const deel = Math.max(0, Math.min(1, pleinAandeelPct / 100));
  const perWijk = new Map();
  for (const l of locaties) {
    const v = vermogenVanOpstelling(l.opstelling);
    if (!v.palen) continue;
    // Zonder de laadpunten voor bestelwagens: die dienen niet de vraag van
    // personenwagens. Zonder bestelwagens is dit gelijk aan de opstelling.
    const p = puntenVoorPersonenwagens(l.opstelling, l.bestelwagens);
    const r = perWijk.get(l.wijkId) || { ac:0, dc:0, hpc:0 };
    r.ac  += p.ac;
    r.dc  += p.dc;
    r.hpc += p.hpc;
    perWijk.set(l.wijkId, r);
  }

  const nodigRuw = { ac:0, dc:0, hpc:0 };
  const ingevuld = { ac:0, dc:0, hpc:0 };
  let energieNodig = 0, energieIngevuld = 0;
  let bewNodig = 0, bewIngevuld = 0;
  const tekortWijken = [];

  for (const w of wijken) {
    const d = w.delta || {};
    const dAC = Math.max(0, d.AC || 0), dDC = Math.max(0, d.DC || 0), dHPC = Math.max(0, d.HPC || 0);
    nodigRuw.ac += dAC * deel; nodigRuw.dc += dDC * deel; nodigRuw.hpc += dHPC * deel;
    energieNodig += deel * (dAC * util.ac + dDC * util.dc + dHPC * util.hpc);

    const v = perWijk.get(w.wijkId) || { ac:0, dc:0, hpc:0 };
    ingevuld.ac += v.ac; ingevuld.dc += v.dc; ingevuld.hpc += v.hpc;
    energieIngevuld += v.ac * util.ac + v.dc * util.dc + v.hpc * util.hpc;

    // Welk deel van de AC-vraag in deze wijk komt van bewoners? Het werkladen
    // telt hier BEWUST NIET mee. In de rekenkern is dat als bewonersgedrag
    // behandeld omdat forenzen net zo lang stilstaan, maar op een zuiver
    // bedrijventerrein wonen geen bewoners en dan hoort er ook geen
    // bewonerstekort gemeld te worden. De laadbehoefte van die forenzen blijft
    // volledig in het model en dus in de kolom Volgens het model; alleen deze
    // controleregel kijkt er niet naar. Bij een gemengde wijk werkt dit
    // vanzelf goed: het bewonersaandeel is daar het gemiddelde van de
    // aangevinkte wijktypes en dus kleiner, maar niet nul.
    const acTotaal = w.mwhAC || 0;
    const aandeel = acTotaal > 0
      ? Math.min(1, (w.mwhBew || 0) * bewAcAandeel / acTotaal)
      : 0;
    const bewW = deel * dAC * util.ac * aandeel;
    const ingW = v.ac * util.ac;
    // Alleen tellen wat in DEZE wijk nodig is. Zonder deze begrenzing zou een
    // overschot in de ene wijk een tekort in de andere wegpoetsen, terwijl een
    // laadplein in Kessel-Lo de bewoners van Wijgmaal niet helpt.
    bewNodig += bewW; bewIngevuld += Math.min(ingW, bewW);
    if (bewW > 0 && ingW < bewW) tekortWijken.push(w.naam || 'onbekende wijk');
  }

  // Locaties die in geen enkele wijk vallen tellen wel mee in het stadstotaal,
  // want de palen staan er echt. Ze doen niet mee aan de bewonerstoets, omdat
  // niet vast te stellen is welke bewoners ze bedienen.
  const bekend = new Set(wijken.map(w => w.wijkId));
  for (const [wijkId, v] of perWijk) {
    if (bekend.has(wijkId)) continue;
    ingevuld.ac += v.ac; ingevuld.dc += v.dc; ingevuld.hpc += v.hpc;
    energieIngevuld += v.ac * util.ac + v.dc * util.dc + v.hpc * util.hpc;
  }

  const afgerond = deelAfronding([nodigRuw.ac, nodigRuw.dc, nodigRuw.hpc]).delen;
  const pct = (a, b2) => b2 > 0 ? Math.round((a / b2) * 100) : (a > 0 ? 100 : 0);
  return {
    nodig: { ac: afgerond[0], dc: afgerond[1], hpc: afgerond[2] },
    ingevuld,
    energie:  { nodig: Math.round(energieNodig), ingevuld: Math.round(energieIngevuld), pct: pct(energieIngevuld, energieNodig) },
    bewoners: { nodig: Math.round(bewNodig), ingevuld: Math.round(bewIngevuld), pct: pct(bewIngevuld, bewNodig), tekortWijken },
  };
}

// Korte omschrijving bij een vlag, voor scherm en rapport. Volgens de regel
// van Fluvius in de aansluitingstarieven (VREG): onder 25 kVA steeds
// laagspanning, van 25 tot 250 kVA beslist de netbeheerder, boven 250 kVA
// steeds middenspanning. Tot 26 oktober 2026 stond hier dat boven 25 kVA
// alleen een studie nodig was; dat zei niets over wat de studie beslist.
export function vermogenMelding(vlag) {
  if (vlag === 'cabine') return `Boven ${KVA_CABINE} kVA: een eigen cabine op middenspanning is nodig.`;
  if (vlag === 'studie') return `Tussen ${KVA_STUDIE} en ${KVA_CABINE} kVA beslist Fluvius na een studie of de aansluiting op laagspanning of op middenspanning komt. Een eigen cabine is dus mogelijk, maar niet zeker.`;
  if (vlag === 'geen')   return `Onder ${KVA_STUDIE} kVA: aansluiting op laagspanning, zonder studie en zonder eigen cabine.`;
  return 'Nog geen palen ingevuld.';
}

// Drie delen afronden zodat ze precies optellen tot het afgeronde totaal.
// Zonder dit wordt elk laadtype apart naar boven afgerond en telt de rij niet
// op: 452 plus 19 plus 3 is 474 terwijl er 473 staat. Werkwijze: eerst naar
// beneden afronden, dan de rest verdelen over de delen met de grootste
// achterstand. Zo klopt de som altijd en blijft het totaal onaangeroerd.
export function deelAfronding(delen) {
  const som = delen.reduce((a, b) => a + (b || 0), 0);
  const totaal = Math.ceil(som);
  const onder = delen.map(d => Math.floor(d || 0));
  let rest = totaal - onder.reduce((a, b) => a + b, 0);
  // Volgorde op grootste achterstand; bij gelijke stand telt de grootste eerst,
  // zodat de uitkomst niet afhangt van de volgorde in de lijst.
  const volgorde = delen
    .map((d, i) => ({ i, over: (d || 0) - Math.floor(d || 0), groot: d || 0 }))
    .sort((a, b) => (b.over - a.over) || (b.groot - a.groot));
  for (let k = 0; k < volgorde.length && rest > 0; k++) { onder[volgorde[k].i]++; rest--; }
  // Blijft er na één ronde nog iets over (kan bij veel nullen), dan bij het
  // grootste deel erbij, want daar valt het het minst op.
  while (rest > 0) { onder[volgorde[0].i]++; rest--; }
  return { totaal, delen: onder };
}

// Kleuren voor tabblad Laadinfra-mix. Bewust twee families die ver uit elkaar
// liggen, ook in grijswaarde, want de eerdere drie tinten waren op het scherm
// nauwelijks te onderscheiden en op papier helemaal niet.
// Laadtypes: blauw, oker, rood.
const MIX_AC  = '#2D7F92';
const MIX_DC  = '#D9A02B';
const MIX_HPC = '#B4442F';
// Doelgroepen: drie tinten petrol en grijs, zodat de twee balken op dezelfde
// regel nooit met elkaar te verwarren zijn.
const MIX_BEW = '#1F5C6B';
const MIX_BEZ = '#9CC2CC';
const MIX_LOG = '#3D4652';

// Lichtblauwgrijs voor het deel van de bestaande laadpunten dat NIET meetelt
// voor de behoefte van het gekozen jaar. Bewust geen tweede tint petrol: die
// viel op het scherm samen met de gevulde helft van het balkje.
const KERN_LICHT = '#CBD5D9';

// Kleuren van tabblad Dekking, ook gebruikt voor de dekkingskaart in het
// Word-document, zodat scherm en papier dezelfde kleuren tonen. Besluiten van HL
// van 17 oktober 2026: het plan paars (petrol was naast de bestaande laadpalen
// niet te onderscheiden), de snellader goudgeel in plaats van groen (geen groen
// naast petrol), en het laadplein helder roze in plaats van donkerbruin.
export const DEK_KLEUR = {
  publiek:'#2D7F92', snel:'#D9A02B', semi:'#9AA4B1', plein:'#D6338A',
  plan:'#6B4C9A', rood:'#A32A16',
};
export const KLEUR_PLAN = DEK_KLEUR.plan;

// Kleur relatief tov de laagste/hoogste waarde binnen de huidige gemeente,
// zodat er altijd zichtbare spreiding is, ongeacht gemeentegrootte of
// scenario (zie overleg over Gent die overal rood kleurde bij een vaste
// drempel van 30).
// Kleur van een wijk op de kaart, naar de hoeveelheid laadpunten die er nog
// nodig is. Eén kleurfamilie in vijf sterktes uit de huisstijl: hoe donkerder,
// hoe meer er moet gebeuren. Dat leest van afstand beter dan losse kleuren.
// Kleurschaal van de kaart: van licht naar donker, van petrol naar oker.
// Hoe donkerder, hoe meer laadpunten er nog bij moeten. De helderheid daalt
// bij elke stap, dus de kleur volgt de aantallen ook in grijstinten en bij
// kleurenblindheid.
const KAART_SCHAAL = ['#EDF4F5', '#A9C9D1', '#C8BDA0', '#B78838', '#7E4E12'];

// Bepaalt de grenzen tussen de vijf kleuren door de wijken in vijf even grote
// groepen te verdelen. Dat is anders dan verhoudingsgewijs verdelen: heeft
// één wijk er 412 nodig en de rest tussen 9 en 96, dan zou die ene wijk alle
// andere in de lichtste tint duwen en zie je geen verschil meer. Met even
// grote groepen blijft er altijd onderscheid.
//
// De grenzen worden één keer per weergave berekend en meegegeven, zodat de
// kaart en de legenda gegarandeerd dezelfde indeling gebruiken.
function bepaalKlassegrenzen(alleWaarden) {
  const relevant = alleWaarden.filter(v => Number.isFinite(v)).sort((a, b) => a - b);
  if (relevant.length < 2) return null;
  const min = relevant[0], max = relevant[relevant.length - 1];
  if (max === min) return null;   // alles gelijk: geen kunstmatig onderscheid maken

  const grenzen = [1, 2, 3, 4].map(i => relevant[Math.floor(relevant.length * i / 5)]);
  // Bij weinig wijken kunnen grenzen samenvallen; die dubbelen eruit halen,
  // anders blijft een kleur ongebruikt terwijl de legenda hem wel toont.
  return grenzen;
}

// Geeft de kleur voor één waarde, op basis van de eerder bepaalde grenzen.
function kaartKleur(waarde, grenzen) {
  if (!Number.isFinite(waarde)) return KAART_SCHAAL[0];
  if (!grenzen) return KAART_SCHAAL[2];
  return KAART_SCHAAL[grenzen.filter(g => waarde >= g).length];
}

// Verzamelt per kleur welke waarden erin vallen, voor de legenda. Zo staat er
// het werkelijke bereik en het aantal wijken bij in plaats van 'weinig' en 'veel'.
function legendaKlassen(alleWaarden, grenzen) {
  const relevant = alleWaarden.filter(v => Number.isFinite(v));
  return KAART_SCHAAL.map((kleur, i) => {
    const inKlasse = relevant.filter(w => {
      const k = grenzen ? grenzen.filter(g => w >= g).length : 2;
      return k === i;
    });
    return {
      kleur,
      aantal: inKlasse.length,
      laag: inKlasse.length ? Math.min(...inKlasse) : null,
      hoog: inKlasse.length ? Math.max(...inKlasse) : null,
    };
  });
}

function makeIcon(color, size=12) {
  return L.divIcon({
    className:'',
    html:`<div style="width:${size}px;height:${size}px;border-radius:50%;background:${color};border:2px solid white;box-shadow:0 0 0 1px ${color},0 2px 4px rgba(0,0,0,0.35)"></div>`,
    iconSize:[size,size], iconAnchor:[size/2,size/2],
  });
}

function makeBestaandIcon(type, count = 1) {
  const configs = {
    ac:      { color:'#1a6e30', bg:'#27ae60', size:16 },
    dc:      { color:'#922b21', bg:'#e74c3c', size:18 },
    hpc:     { color:'#6c3483', bg:'#9b59b6', size:20 },
    default: { color:'#1a5276', bg:'#2980b9', size:16 },
  };
  const cfg = configs[type] || configs.default;
  const badge = count > 1
    ? `<div style="
        position:absolute; top:-6px; right:-6px;
        min-width:15px; height:15px; padding:0 3px; border-radius:8px;
        background:#1a2830; border:1.5px solid white;
        color:#fff; font-size:9px; font-weight:800; line-height:12px; text-align:center;
      ">${count}</div>`
    : '';
  return L.divIcon({
    className:'',
    html:`<div style="position:relative;width:${cfg.size}px;height:${cfg.size}px;">
      <div style="
        width:${cfg.size}px;height:${cfg.size}px;border-radius:50%;
        background:${cfg.bg};
        border:3px solid white;
        outline:2px solid ${cfg.color};
        box-shadow:0 2px 6px rgba(0,0,0,0.5);
      "></div>${badge}</div>`,
    iconSize:[cfg.size,cfg.size],
    iconAnchor:[cfg.size/2,cfg.size/2],
  });
}

// Kleuren van de netbeheerder voor de ruimte op het net. Staan hier op
// moduleniveau omdat zowel de kaart als de tabel ze gebruiken.
const NET_RUIMTE_KLEUR = { krap:'#E08A2E', beperkt:'#E8DE2A', ruim:'#8CC63F' };

// Het midden van de grootste ring van een vorm, om er een opschrift op te
// zetten. Het gemiddelde van alle randpunten van die ring, wat voor de
// gebruikelijke sectorvormen dicht genoeg bij het midden ligt.
// ── De rekenregel achter 'bij te plaatsen' ────────────────────────────
// Per wijk het tekort per laadsoort, nooit negatief, opgeteld en naar boven
// afgerond. Het stadstotaal is de som daarvan. De planning van de
// laadpaalexploitant gaat er daarna een keer af, verdeeld over de wijken naar
// hun aandeel in het tekort aan gewone laadpunten, en nooit meer dan er aan
// dat tekort is. Staat hier los zodat de regel apart te toetsen is.
// @param tekorten  [{ id, ac, dc, hpc }] per wijk, onafgerond
// @param gepland   'Gepland te installeren, AC'
export function bijTePlaatsenPerWijk(tekorten, gepland = 0) {
  const heel = {}, acDeel = {};
  for (const t of tekorten) {
    heel[t.id]   = Math.ceil(Math.max(0, t.ac) + Math.max(0, t.dc) + Math.max(0, t.hpc));
    acDeel[t.id] = Math.max(0, t.ac);
  }
  const acTotaal = Object.values(acDeel).reduce((a, b) => a + b, 0);
  const aangerekend = Math.max(0, Math.min(Number(gepland) || 0, Math.floor(acTotaal)));
  const aftrek = verdeelHeel(aangerekend, acDeel);
  const perWijk = new Map();
  let totaal = 0;
  for (const t of tekorten) {
    const n = Math.max(0, heel[t.id] - (aftrek[t.id] || 0));
    perWijk.set(t.id, n);
    totaal += n;
  }
  return { perWijk, totaal, aangerekend };
}


function middelpuntVanVorm(geom) {
  if (!geom) return null;
  const vlakken = geom.type === 'Polygon' ? [geom.coordinates]
    : geom.type === 'MultiPolygon' ? geom.coordinates : [];
  let grootste = null;
  for (const vlak of vlakken) {
    const ring = vlak[0] || [];
    if (!grootste || ring.length > grootste.length) grootste = ring;
  }
  if (!grootste || !grootste.length) return null;
  let sx = 0, sy = 0, n = 0;
  for (const [lon, lat] of grootste) {
    if (!Number.isFinite(lon) || !Number.isFinite(lat)) continue;
    sx += lon; sy += lat; n++;
  }
  return n ? { lng: sx / n, lat: sy / n } : null;
}

// Waarmerk van deze versie, zodat te controleren is welke versie er draait.
// Bij elke oplevering bijwerken.
// De instellingen die BIJ DE GEMEENTE horen, met hun standaardwaarde. Alles wat
// hier staat wordt per gemeente bewaard en weer ingelezen. Wat er NIET in staat
// is een kijkinstelling: de schakelaars op Dekking, het gekozen gebied op
// Plaatsing en de drie filters op de kandidatenlijst. Die zeggen hoe iemand op
// dat moment kijkt, niet wat de gemeente heeft besloten.
// Het adres van de achtergrondkaart. De sleutel komt uit een instelling bij
// Railway (REACT_APP_CARTO_KEY) en staat bewust niet in de code, zodat hij is
// te vervangen zonder dit bestand aan te passen. Ontbreekt de instelling, dan
// werkt de kaart gewoon door, maar met een watermerk erover.
export const KAART_ADRES = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png'
  + (process.env.REACT_APP_CARTO_KEY ? `?key=${process.env.REACT_APP_CARTO_KEY}` : '');

export const STANDAARD_INSTELLINGEN = {
  priveStart: null, redundantieMarge: 0.10, huidigLP: 0,
  netcapSlim: 0, netcapSlimWijk: {}, netcapSlimHand: {},
  netcapBegin: 2027, netcapEind: 2030,
  pleinMinVak: 12, pleinOmvang: 12, pleinAandeel: 45,
  pleinToegang: ['openbaar'], pleinNabij: 200, pleinSoorten: [],
  // Loopafstand naar een laadplein: binnen deze afstand neemt een plein losse
  // laadpunten over in een andere wijk. Besluit HL 27 oktober 2026: 250 m,
  // dezelfde maat als tabblad Dekking.
  pleinLoop: 250,
  plaatsVoorrang: 150,
  capex: { AC: 4500, DC: 29000, HPC: 82000 },
  // Maximale afstand van een losse laadpaal tot de straatkabel, voor het
  // filter Nabij het net op tabblad Plaatsing. Besluit HL 23 oktober 2026:
  // 25 meter, en niet voor laadpleinen.
  netGrens: 25,
};

export const APP_VERSIE = '17 oktober 2026, korte uitleg dekking';

export default function AppWithOnboarding({ onHoofdmenu = null } = {}) {
  // ── API / DB state ─────────────────────────────────────────────────
  // Begint leeg. Stond hier eerder de ingebouwde voorbeeldset, dan zag een
  // gebruiker zonder toegang die set in beeld staan alsof het zijn gemeenten
  // waren. De lijst komt nu uitsluitend van de server.
  const [gemeenten,       setGemeenten]      = useState({});
  const [dbStatus,        setDbStatus]       = useState('laden'); // laden | online | offline
  const [apiError,        setApiError]       = useState('');
  // Waar als de server een lege lijst teruggaf: het account heeft nergens
  // toegang. Dat is iets anders dan een storing en krijgt een eigen melding.
  const [geenToegang,     setGeenToegang]    = useState(false);
  // Wat de server had toen dit scherm openging, en wie welk uitgangspunt als
  // laatste wijzigde. De eerste dient om een botsing te herkennen, de tweede om
  // onder een uitgangspunt te tonen waar het vandaan komt.
  const gezienRef = useRef({});
  const [herkomst, setHerkomst] = useState({});
  const [botsing,  setBotsing]  = useState(null);
  // Het wijzigingslogboek staat sinds 17 oktober 2026 alleen nog in de
  // beheeromgeving, niet meer in LaadAtlas zelf (HL: het leidt af).
  const [saving,          setSaving]         = useState(false);

  // ── UI state ───────────────────────────────────────────────────────
  const [gemId,           setGemId]          = useState(null);
  const [showDashboard,   setShowDashboard]  = useState(true);
  // Beheerpagina voor de gegevensbestanden. Alleen bereikbaar vanaf het
  // gemeentenoverzicht, niet vanuit een gemeente.
  const [showBronnen,     setShowBronnen]    = useState(false);
  const [mapReady,        setMapReady]       = useState(false);
  // Actief tabblad. Alle panelen blijven in de DOM staan (display:none),
  // want de Leaflet-kaart mag nooit uit de DOM verdwijnen. showWijken is
  // vervangen door tab === 'wijken'.
  const [tab,             setTab]            = useState('dashboard');
  // Het tabblad Bezetting staat alleen in beeld als de server dat toestaat:
  // voor de rol beheerder, of voor iedereen zodra BEZETTING_VOOR_IEDEREEN op 1 staat.
  const [bezettingZichtbaar, setBezettingZichtbaar] = useState(false);
  useEffect(() => {
    let weg = false;
    getBezettingZichtbaar()
      .then(r => { if (!weg) setBezettingZichtbaar(!!r?.zichtbaar); })
      .catch(e => {
        console.warn('Zichtbaarheid van het tabblad Bezetting niet opgehaald:', e.message);
        if (!weg) setBezettingZichtbaar(false);
      });
    return () => { weg = true; };
  }, [gemId]);
  const [showOnboarding,  setShowOnboarding] = useState(false);
  // Als de gebruiker vanuit het dashboard een gemeente selecteert (naam+nis+provincie),
  // wordt dat object hier bewaard zodat de wizard direct met die naam kan starten.
  const [onboardingInit,  setOnboardingInit] = useState(null);
  const [showDelete,      setShowDelete]     = useState(false);
  const [showEditor,      setShowEditor]     = useState(false);
  const sectorenRef      = useRef(null);
  // Zelfde inhoud als sectorenRef, maar als state zodat de SVG-wijkkaartjes
  // hertekenen wanneer de sectoren geladen zijn.
  const [sectorenGeo,     setSectorenGeo]    = useState(null);
  const [sectorenGeladen, setSectorenGeladen] = useState(0);
  // Inwoners per statistische sector, uit de ingelezen Statbel-gegevens.
  // Nodig om het aantal bij te plaatsen laadpunten van een wijk over zijn
  // sectoren te verdelen naar inwonertal.
  const [sectorInwoners, setSectorInwoners] = useState({});
  // Auto's per sector, de betere verdeelsleutel. Leeg als de bron ontbreekt.
  const [sectorWagens, setSectorWagens] = useState({});
  // De klassen van de legenda zodra de kaart per sector is ingekleurd. Blijft
  // leeg als er geen sectorvormen zijn; dan tellen de wijken, zoals voorheen.
  const [sectorKlassen, setSectorKlassen] = useState(null);
  // De naam van een sector. Die komt uit de ingelezen bevolkingsbron en NIET
  // uit de kaartvormen: bij het omzetten van het kaartbestand is de naamkolom
  // gemist, waardoor daar overal de code staat. Zo hoeven die elf bestanden
  // niet opnieuw gemaakt te worden.
  const [sectorNamen, setSectorNamen] = useState({});
  // Het minimaal beschikbare laadvermogen voor bestelwagens volgens MOW, in kW, voor 2028 en 2030.
  // Alleen om te tonen, niet om mee te rekenen. null zolang er niets is.
  const [mowBestel, setMowBestel] = useState(null);
  // De groei van het aantal auto's per jaar uit de huishoudens van de gemeente,
  // zoals de server die berekent. null zolang er niets is; dan rekent het model
  // zonder groei, zoals voorheen.
  const [autoGroei, setAutoGroei] = useState(null);
  // Staat de verdeling per deelgemeente op tabblad Dashboard open?
  const [bestelDgOpen, setBestelDgOpen] = useState(false);

  // Het gewicht waarmee de uitkomst van een wijk over haar sectoren wordt
  // verdeeld: het aantal auto's als dat bekend is, anders het inwonertal.
  // De naam van een sector, met de code als terugval.
  const sectorNaam = React.useCallback(
    (code) => sectorNamen[code] || code, [sectorNamen]);

  // De naam van een sector zoals een ambtenaar hem noemt. Eerste keus is de
  // omschrijving uit het Statbel-bestand met inwoners per sector; dat zijn de
  // namen van de deelwijken. Staat die er niet, dan de naam uit het
  // vormenbestand, en anders de code. Zonder deze volgorde staat er in de
  // tabellen en in het Word-document een code waar de kaart een naam toont.
  const sectorNaamVan = React.useCallback(
    (code, uitVorm) => sectorNamen[code] || uitVorm || code || '', [sectorNamen]);

  const sectorGewicht = React.useCallback(
    (code) => (sectorWagens[code] != null ? sectorWagens[code] : (sectorInwoners[code] || 0)),
    [sectorWagens, sectorInwoners]);
  const [ongematcht,      setOngematcht]     = useState(0);
  const [showOverzicht,   setShowOverzicht]  = useState(false);
  // Welke kaartlaag zichtbaar is: 'behoefte' toont de wijkvlakken gekleurd naar
  // het aantal benodigde laadpunten, 'bestaand' toont de bestaande laadpunten
  // als markers met de Streetview-link. Beide lagen blijven bestaan; ze worden
  // alleen aan de kaart toegevoegd of eraf gehaald.
  const [kaartLaag,       setKaartLaag]      = useState('bestaand');
  // Aantal wijken dat niet aan een statistische sector gekoppeld kon worden.
  // Die staan als cirkel op de kaart; de legenda vermeldt dat apart.
  const [aantalZonderVorm, setAantalZonderVorm] = useState(0);

  // ── Simulator state ────────────────────────────────────────────────
  // Geselecteerde peiljaren. De rekenkern werkt met één jaar; dat is altijd het
  // laatst gekozen jaar. De overige selectie dient om jaren naast elkaar te
  // vergelijken in de tabel op het Dashboard.
  const JAREN_DEFAULT = [2027, 2030];
  const [jaren,           setJaren]             = useState(JAREN_DEFAULT);
  const year = jaren[jaren.length - 1];
  // Zet de selectie op precies één jaar.
  const setYear = (y) => setJaren([y]);
  // Op het Dashboard mogen meerdere jaren aan staan, want daar dient de
  // vergelijkingstabel voor. Op de andere tabbladen kan er maar één jaar tegelijk
  // gelden: de parameters, de kaart en de wijkcijfers horen bij precies één jaar.
  const meerdereJarenToegestaan = tab === 'dashboard';
  const wisselJaar = (y) => {
    if (!meerdereJarenToegestaan) { setJaren([y]); return; }
    setJaren(hs => hs.includes(y)
      ? (hs.length > 1 ? hs.filter(x => x !== y) : hs)
      : [...hs, y].sort((a, b) => a - b));
  };
  // Handmatig startpunt voor het privé-aandeel, als fractie 0 tot 1.
  // null betekent: gebruik het startpunt dat het model zelf berekent.
  // Belangrijk: dit is het startpunt in 2026, niet de waarde in het gekozen
  // jaar. Het model trekt er per jaar PRIVE_DALING_PER_JAAR vanaf, en die
  // daling blijft dus intact als hier iets wordt ingesteld.
  const [capexPlan, setCapexPlan] = useState(STANDAARD_INSTELLINGEN.capex);
  // Welke gemeente er is ingelezen. Zolang die niet gelijk is aan de gekozen
  // gemeente wordt er NIETS bewaard, anders zouden de waarden van de vorige
  // gemeente over de nieuwe heen worden geschreven.
  const instellingenVan = useRef(null);
  const [priveStart,      setPriveStart]     = useState(null);
  const [redundantieMarge,setRedundantieMarge]   = useState(0.10);
  const [huidigLP,        setHuidigLP]       = useState(0);
  // De schakelaar Slim laden stond hier tot 9 september 2026. Hij veranderde
  // geen enkel getal op dit tabblad: de energiecorrectie is op 9 augustus 2026
  // uit calcWijk gehaald. Slim laden werkt alleen op het aansluitvermogen en
  // staat daarom op tabblad Netcapaciteit, als percentage per wijk.
  const [selectedWijk,    setSelectedWijk]   = useState(null);
  const [existingPalen,   setExistingPalen]  = useState([]);

  // ── Tabblad Laadinfra-mix ──────────────────────────────────────────
  // Eén wijk tegelijk uitgeklapt, en de volledige rekensom apart daarvan,
  // zodat het scherm niet volloopt met getallen die niemand vroeg.
  const [mixOpen,   setMixOpen]   = useState(null);   // wijk-id of null
  const [mixReken,  setMixReken]  = useState(null);   // wijk-id of null
  const [mixParams, setMixParams] = useState(true);   // de twee tabellen tonen

  // ── Tabblad Laadpleinen ────────────────────────────────────────────
  // De parkeerterreinen komen uit de ingelezen bron, niet live: OpenStreetMap
  // wordt buiten de app om bevraagd met het analysescript en het resultaat
  // wordt geïmporteerd. De beoordeling per locatie staat in een eigen tabel,
  // zodat een nieuwe import de oordelen niet wist.
  const [pleinRijen,   setPleinRijen]   = useState(null);   // null = nog niet geladen
  const [pleinFout,    setPleinFout]    = useState(null);

  // ── Netcapaciteit ──────────────────────────────────────────────────
  // Begin- en eindjaar van de periode die de gemeente laat uitwerken. Los van
  // het peiljaar bovenin, want een gemeente kan in 2027 opdracht geven voor een
  // plan dat pas in 2028 begint.
  const [netcapBegin,  setNetcapBegin]  = useState(2027);
  const [netcapEind,   setNetcapEind]   = useState(2030);
  const [netcapUit,    setNetcapUit]    = useState(null);
  const [netcapBezig,  setNetcapBezig]  = useState(false);
  const [netcapFout,   setNetcapFout]   = useState(null);
  // Welk jaar de wijktabel toont. Leeg betekent de hele gekozen periode.
  // Deel van de AC-palen waarop slim laden structureel wordt toegepast, in
  // procenten. Standaard 0: er verandert niets tenzij iemand er bewust aan
  // draait, zodat de uitkomst zonder slim laden de uitkomst blijft.
  // De pop-up met alle parameters, vanaf elk tabblad op te roepen.
  const [showParams, setShowParams] = useState(false);
  const [dekPubliek, setDekPubliek] = useState(true);
  const [dekSemi,    setDekSemi]    = useState(false);
  const [dekSnel,    setDekSnel]    = useState(true);
  const [dekPleinen, setDekPleinen] = useState(true);
  const [dekCirkels, setDekCirkels] = useState(true);
  // Standaard UIT: de kaart begint blank en kleurt pas als je er zelf om vraagt.
  const [dekVlekken, setDekVlekken] = useState(false);
  // De palen die het tabblad Plaatsing tot en met het gekozen jaar neerzet.
  // Zonder deze schakelaar toont Dekking alleen de stand van vandaag en komt
  // het percentage nooit hoger, hoeveel het plan ook toevoegt.
  const [dekPlaatsing, setDekPlaatsing] = useState(true);
  const [dekAlleSectoren, setDekAlleSectoren] = useState(false);
  const [netcapSlim, setNetcapSlim] = useState(0);
  // Per wijk een eigen percentage. Een wijk die met de hand is ingevuld, blijft
  // staan als het stadspercentage daarna verandert; anders raakt iemand zijn
  // eigen invoer kwijt zonder het te zien.
  const [netcapSlimWijk, setNetcapSlimWijk] = useState({});   // wijkId -> percentage
  const [netcapSlimHand, setNetcapSlimHand] = useState({});   // wijkId -> true
  const [netcapWijkJaar, setNetcapWijkJaar] = useState('');
  const [pleinOphaal,  setPleinOphaal]  = useState(null);   // wanneer voor het laatst opgehaald
  const [pleinBezig,   setPleinBezig]   = useState(false);
  const [pleinOordeel, setPleinOordeel] = useState({});     // locatieId -> {status, notitie}
  const [pleinGekozen, setPleinGekozen] = useState(null);   // locatieId
  const [pleinMinVak,  setPleinMinVak]  = useState(12);
  const [pleinOmvang,  setPleinOmvang]  = useState(12);
  const [pleinAandeel, setPleinAandeel] = useState(45);

  // Tabblad Plaatsing. Het deel Paal volgt Paal komt sinds 19 augustus 2026 uit
  // het gemeentedossier: het aandeel bestaande laadpunten dat volgens de
  // concessiehouder in aanmerking komt om er een paal bij te zetten. Dat cijfer
  // levert de gemeente aan; is het er niet, dan blijft het op nul en krijgt elk
  // nieuw laadpunt een eigen aansluiting. Daarvoor stond hier een schuif zonder
  // bron. De voorrang staat in honderdsten omdat een schuif met hele stappen
  // prettiger werkt: 150 is 1,5 keer zo zwaar.
  const [plaatsGebied,   setPlaatsGebied]   = useState('alle');
  const [plaatsVoorrang, setPlaatsVoorrang] = useState(150);
  // De straatpunten van de gemeente, om een geplotte paal naar een echte straat
  // te trekken. Ontbreken ze, dan blijft een paal op het middelpunt van zijn
  // rastervakje staan en zegt het scherm dat erbij.
  const [straten, setStraten] = useState([]);
  // De adressen van de gemeente uit het Adressenregister van Vlaanderen. Nog
  // niet in de berekening; ze worden eerst opgehaald en geteld, zodat te zien
  // is of de aantallen kloppen.
  const [adressen, setAdressen] = useState([]);
  const [adressenMelding, setAdressenMelding] = useState(null);
  const [adressenBezig, setAdressenBezig] = useState(false);
  const [stratenMelding, setStratenMelding] = useState(null);
  const [stratenBezig, setStratenBezig] = useState(false);
  const [pleinToegang, setPleinToegang] = useState(['openbaar']);
  const [pleinNabij,   setPleinNabij]   = useState(200);
  const [pleinLoop,    setPleinLoop]    = useState(250);
  const [wijkImpactOpen, setWijkImpactOpen] = useState(false);
  const [pleinSoorten, setPleinSoorten] = useState([]);     // leeg = geen eis
  // Welke beoordelingen op de kaart en in de lijst staan. Elk apart aan of
  // uit, via de knoppen links die ook de legenda zijn (mockup V7).
  const [pleinZicht,   setPleinZicht]   = useState({ open:true, geschikt:true, later:true, niet:true });
  // De kolom rechts: 'loc', 'flt', 'lag' of null (dicht).
  const [pleinRechts,  setPleinRechts]  = useState(null);
  // Op Laadpleinen staan alle lagen van het stroomnet standaard aan (HL, 23 oktober 2026).
  const [pleinNetZicht, setPleinNetZicht] = useState({ v400:true, v230:true, vonb:true, ms:true, dc:true, vk:true, kc:true,
    vst:false, tr:false, zz:false, prjR:false, prjP:false, prjC:false });
  const [pleinMetLp,   setPleinMetLp]   = useState(false);
  const [pleinLucht,   setPleinLucht]   = useState(false);
  const [pleinPunten,  setPleinPunten]  = useState(true);
  // ── GIS netbeheerder ────────────────────────────────────────────────
  // De netgegevens van Fluvius voor deze gemeente, met de lagen voor de kaart.
  // null zolang er niets geladen is; { aanwezig:false } als er geen bestand is.
  const [gisNet,       setGisNet]       = useState(null);
  const [gisVersie,    setGisVersie]    = useState(0);   // na inlezen of verwijderen in Bewerken
  const [netZicht,     setNetZicht]     = useState(STANDAARD_ZICHT);
  const [netGrens,     setNetGrens]     = useState(25);
  // Afstanden tot het net per locatie, uit de server. Ook na het verwijderen
  // van het bestand blijven ze bestaan: dat is het resultaat van het plan.
  const [netAfstPlein, setNetAfstPlein] = useState({});
  const [netAfstPaal,  setNetAfstPaal]  = useState({});
  const [plaatsNetFilter, setPlaatsNetFilter] = useState('alle');
  const pleinMapRef  = useRef(null);
  const pleinMap     = useRef(null);
  const pleinLaag    = useRef(null);
  const pleinPuntLaag= useRef(null);
  const pleinLuchtLaag = useRef(null);
  const pleinGrensLaag = useRef(null);   // gemeente- en sectorgrenzen onder de kandidaten

  // ── Technisch fiche per locatie ──────────────────────────────────────
  // ficheOpen is het nummer van de locatie waarvan het venster openstaat, of
  // null. ficheWerk is de schets waaraan gewerkt wordt; die staat los van
  // pleinOordeel zodat sluiten zonder bewaren niets achterlaat.
  // ficheWerk is de hele schets: de rijen, de aangewezen vakken en de palen.
  // ficheRijNr zegt welke rij wordt bewerkt en ficheModus wat een klik op de
  // kaart doet, want vormgeven, aanwijzen en palen plaatsen vragen alle drie
  // dezelfde muisknop.
  const [ficheOpen,  setFicheOpen]  = useState(null);
  // Het stroomnet op de luchtfoto van het technisch fiche: alle lagen aan.
  // De lagen van het plan van Fluvius staan standaard uit (mockup Plan van Fluvius V1).
  const [ficheNetZicht, setFicheNetZicht] = useState({ v400:true, v230:true, vonb:true, ms:true, dc:true, vk:true, kc:true, best:true,
    vst:false, tr:false, zz:false, prjR:false, prjP:false, prjC:false });
  // Het fiche heeft twee delen (mockup Technisch fiche V2, 26 oktober 2026):
  // A. Inrichting, ingezoomd op de luchtfoto; B. Aansluiting op het net,
  // uitgezoomd op de gewone kaart met het stroomnet.
  const [ficheDeel, setFicheDeel] = useState('A');
  const [ficheWerk,  setFicheWerk]  = useState(null);
  const [ficheRijNr, setFicheRijNr] = useState(0);
  const [ficheModus, setFicheModus] = useState('rijen');
  const [fichePaal,  setFichePaal]  = useState('ac');
  // Waarvoor een aangeklikt vak wordt voorbehouden: laden, deelwagen of bestelwagen.
  const [ficheDoel,  setFicheDoel]  = useState('laden');
  const [ficheBezig, setFicheBezig] = useState(false);
  // Na bewaren blijft het fiche open; de knop meldt kort dat het gelukt is.
  const [ficheBewaard, setFicheBewaard] = useState(false);
  const [ficheFout,  setFicheFout]  = useState(null);
  const ficheMapRef = useRef(null);
  const ficheMap    = useRef(null);
  const ficheLaag   = useRef(null);   // de rijen en hun vakken
  const ficheHoekLaag = useRef(null); // de grepen van de gekozen rij
  const fichePaalLaag = useRef(null); // de ingetekende palen en de cabine
  const ficheKabelLaag = useRef(null); // de kabels, apart zodat het verslepen
                                       // van de cabine de cabine niet wist
  const ficheLucht    = useRef(null); // de luchtfoto, alleen in deel A
  const ficheBestLaag = useRef(null); // de bestaande laadpunten, in beide delen
  const ficheAansLaag = useRef(null); // de lijn naar het aansluitpunt, deel B
  const ficheWerkRef  = useRef(null); // laatste schets, voor de sleepafhandeling
  const ficheHoekPunten = useRef([]); // de vier bolletjes, om ze mee te verschuiven

  // ── Tabblad Dekking ──────────────────────────────────────────────────
  // Eigen kaartinstantie, om dezelfde reden als bij Laadpleinen: een kaart
  // verhuizen tussen twee panelen die met display:none verborgen worden geeft
  // meer problemen dan een tweede instantie.
  // Tabblad Netcapaciteit: dezelfde zoombare kaart als op de andere tabbladen,
  // maar gekleurd naar de ruimte op het net per sector.
  const netcapMapRef  = useRef(null);
  const netcapMap     = useRef(null);
  const netcapLaag    = useRef(null);
  const netcapGetoond = useRef(null);

  const dekMapRef   = useRef(null);
  const dekMap      = useRef(null);
  const dekLaag     = useRef(null);
  const dekGetoond  = useRef(null);   // welke gemeente er als laatste is ingezoomd

  // Tabblad Plaatsing: eigen kaart, zelfde opzet als die van Dekking.
  const plaatsMapRef  = useRef(null);
  const plaatsMap     = useRef(null);
  const plaatsLaag    = useRef(null);
  const plaatsGetoond = useRef(null);
  const [loadingPalen,    setLoadingPalen]   = useState(false);
  const [fluviusFp,       setFluviusFp]      = useState(null); // V5: ruwe Fluvius-telling
  const [picEvAandeel,    setPicEvAandeel]   = useState(null); // PiC: live EV-aandeel 2025
  const [chartTab,        setChartTab]       = useState('lp');

  const mapRef        = useRef(null);
  const mapInstance   = useRef(null);
  const wijkLayerRef  = useRef(null);
  const projLayerRef  = useRef(null);
  const existLayerRef = useRef(null);

  // De gemeente zoals hij in de database staat, met alle wijken. Alleen het
  // bewerkscherm krijgt deze, want daar moet een uitgeschakelde wijk zichtbaar
  // blijven om hem weer aan te kunnen zetten.
  const gemeenteVolledig = gemeenten[gemId] || Object.values(gemeenten)[0];

  // De gemeente zoals de rest van de app hem gebruikt: zonder de wijken die
  // niet meetellen. Eén plek, zodat elk tabblad, elke kaart, elke berekening en
  // elke uitvoer dezelfde wijken ziet.
  const gemeente = React.useMemo(() => {
    if (!gemeenteVolledig) return gemeenteVolledig;
    const wijken = gemeenteVolledig.wijken || [];
    const meetellend = wijken.filter(w => w.actief !== false);
    if (meetellend.length === wijken.length) return gemeenteVolledig;
    return { ...gemeenteVolledig, wijken: meetellend };
  }, [gemeenteVolledig]);

  // Deel Paal volgt Paal, uit het gemeentedossier, in procent. null betekent
  // dat de gemeente dit cijfer nog niet heeft aangeleverd; dan krijgt elk nieuw
  // laadpunt een eigen aansluiting. Moet NA de declaratie van gemeente staan.
  const plaatsPvp = gemeente?.pvpNormPct ?? 0;
  const pvpOnbekend = gemeente?.pvpNormPct == null;
  // Wat er in het invoerveld op tabblad Plaatsing staat. Los van plaatsPvp,
  // want tijdens het typen mag de berekening nog niet meelopen; pas bij het
  // verlaten van het veld gaat de waarde naar de gemeente.
  const [pvpInvoer, setPvpInvoer] = useState('');
  useEffect(() => {
    setPvpInvoer(gemeente?.pvpNormPct != null ? String(gemeente.pvpNormPct) : '');
  }, [gemeente?.id, gemeente?.pvpNormPct]);

  // Bewaart het percentage in het gemeentedossier. Gebruikt door het veld op
  // tabblad Plaatsing en door het overzicht onder Parameters, zodat beide
  // langs dezelfde weg gaan. Geeft false terug als het bewaren mislukte.
  const bewaarPvpWaarde = async (waarde) => {
    if (waarde === (gemeente?.pvpNormPct ?? null)) return true;
    try {
      await updateGemeente(gemeente.id, { ...gemeente, pvpNormPct: waarde });
      setGemeenten(g => ({ ...g, [gemeente.id]: { ...g[gemeente.id], pvpNormPct: waarde } }));
      return true;
    } catch (e) {
      setApiError('Het percentage kon niet worden bewaard: ' + e.message);
      return false;
    }
  };

  const bewaarPvpNorm = async () => {
    const schoon = pvpInvoer.trim();
    const waarde = schoon === '' ? null : Math.max(0, Math.min(100, parseFloat(schoon.replace(',', '.'))));
    if (schoon !== '' && !Number.isFinite(waarde)) { setPvpInvoer(''); return; }
    const gelukt = await bewaarPvpWaarde(waarde);
    if (!gelukt) setPvpInvoer(gemeente?.pvpNormPct != null ? String(gemeente.pvpNormPct) : '');
  };

  // ── Trendcorrectie ─────────────────────────────────────────────────
  // Car sharing, V2G en Energiedelen PV hebben nog geen onderbouwd effect
  // (zie Leeswijzer/Validatie Overzicht) en staan daarom nog zonder effect
  // op de berekening, in plaats van met een verzonnen percentage. Slim
  // laden heeft een eigen, gebronneerd mechanisme (zie calcWijk in
  // gemeenteData.js: kleine energiecorrectie + aparte "ruimte voor extra
  // laadpunten"-metric), en loopt dus niet meer via deze generieke factor.
  const trendFactor = 1.0;

  // calcParams krijgt privePctOverride altijd gevuld, met de waarde die
  // privePctVoorJaar voor dat jaar oplevert. calcWijk geeft dat veld voorrang
  // boven privePct, dus zo geldt het ingestelde startpunt inclusief de
  // jaarlijkse daling in plaats van één vast percentage voor alle jaren.
  // De definitie van calcParams volgt hieronder, na de MOW-telling, omdat V5
  // de MOW-tellingen per laadtype nodig heeft.

  // ── Bestaande laadpunten toewijzen aan dichtstbijzijnde wijk ────────
  // (zelfde dichtstbijzijnde-centroïde-methode als de sector-koppeling
  // op de backend, hier client-side omdat existingPalen live via MOW
  // wordt opgehaald en niet in de database staat)
  // Per wijk, per type (AC/DC/HPC), MOW-conform gewogen: elk publiek
  // laadpunt telt voor 100%, elk semi-publiek laadpunt voor 50% mee
  // (Bijlage 11: "aangezien ze niet permanent beschikbaar zijn").
  const leegType = () => ({ AC: 0, DC: 0, HPC: 0 });
  const leegV5 = () => ({ Qp_AC: 0, Qp_DC: 0, Qp_HPC: 0, Qs_AC: 0, Qs_DC: 0, Qs_HPC: 0 });
  const bestaandPerWijk = {};
  const bestaandV5PerWijk = {};
  (gemeente?.wijken || []).forEach(w => {
    bestaandPerWijk[w.id] = leegType();
    bestaandV5PerWijk[w.id] = leegV5();
  });
  existingPalen.forEach(el => {
    const lat = el.lat ?? el.center?.lat;
    const lng = el.lon ?? el.center?.lon;
    if (lat == null || lng == null) return;
    // In welke wijk staat deze paal? Kijk naar de KAART: in welke statistische
    // sector valt dit punt, en bij welke wijk hoort die sector. Precies dezelfde
    // regel als bij de kandidaatlocaties.
    //
    // Tot 12 augustus 2026 werd hier het dichtstbijzijnde wijkmiddelpunt
    // genomen. Dat middelpunt is een prikje op de kaart en geen grens, dus een
    // paal belandde geregeld in de buurwijk en werd daar van de behoefte
    // afgetrokken. Gemeten: bij Leuven 226 van de 1.505 palen, bij Grimbergen
    // 347 van de 687.
    const wijkId = wijkVanPunt(sectorenGeo, lat, lng);
    let beste = wijkId ? (gemeente?.wijken || []).find(w => w.id === wijkId) : null;
    // Valt de paal buiten elke sector, bijvoorbeeld net over de gemeentegrens,
    // dan alsnog de dichtstbijzijnde wijk, met de lengtegraad gecorrigeerd voor
    // de breedte.
    if (!beste) {
      let besteAfstand = Infinity;
      (gemeente?.wijken || []).forEach(w => {
        if (w.lat == null || w.lng == null) return;
        const rek = Math.cos((w.lat + lat) / 2 * Math.PI / 180);
        const d = Math.hypot(w.lat - lat, (w.lng - lng) * rek);
        if (d < besteAfstand) { besteAfstand = d; beste = w; }
      });
    }
    if (!beste) return;
    const t = el.tags || {};
    const type = t.mow_snelheid === 'ultrasnel' ? 'HPC' : t.mow_snelheid === 'snel' ? 'DC' : 'AC';
    const isSemi = t.mow_toegankelijkheid === 'semi-publiek';
    const gewicht = isSemi ? 0.5 : 1;
    bestaandPerWijk[beste.id][type] += gewicht;
    // V5: aparte tellers publiek (Qp) en semi-publiek (Qs), ONGEWOGEN.
    // De 0,5-weging op semi wordt in V5 pas in berekenPubliekSemiSplitV5
    // toegepast via SEMI_GEWICHTSFACTOR.
    if (isSemi) bestaandV5PerWijk[beste.id]['Qs_' + type] += 1;
    else        bestaandV5PerWijk[beste.id]['Qp_' + type] += 1;
  });
  // Optelling per type, voor de bestaand-tegels/labels elders in de app
  const bestaandTotaalPerType = Object.values(bestaandPerWijk).reduce((s, b) => ({
    AC: s.AC + b.AC, DC: s.DC + b.DC, HPC: s.HPC + b.HPC,
  }), leegType());
  // V5: totalen per gemeente per publiek/semi × AC/DC/HPC (voor
  // berekenPubliekSemiSplitV5). Ongewogen aantallen.
  const bestaandV5Totaal = Object.values(bestaandV5PerWijk).reduce((s, b) => ({
    Qp_AC:  s.Qp_AC  + b.Qp_AC,  Qp_DC:  s.Qp_DC  + b.Qp_DC,  Qp_HPC: s.Qp_HPC + b.Qp_HPC,
    Qs_AC:  s.Qs_AC  + b.Qs_AC,  Qs_DC:  s.Qs_DC  + b.Qs_DC,  Qs_HPC: s.Qs_HPC + b.Qs_HPC,
  }), leegV5());

  // ── V5: bereken privePct_j voor huidige jaar via Fluvius + MOW ─────
  // Formule: P = Fluvius Fp × κ (κ = 1/(1-onderregistratie), zie gemeenteData.js).
  //          Q = MOW publiek + 0,5 × MOW semi (per laadtype opgeteld).
  //          privePct_0 = P/(P+Q), daalt per jaar met PRIVE_DALING_PER_JAAR.
  // Valt terug op gemeente?.privePctBerekend als Fluvius Fp of MOW-tellingen
  // ontbreken (bijv. geen postcodes ingesteld, geen MOW-data live).
  const v5Gemeente = {
    fluvius: fluviusFp,
    mow_qp_ac:  bestaandV5Totaal.Qp_AC,
    mow_qp_dc:  bestaandV5Totaal.Qp_DC,
    mow_qp_hpc: bestaandV5Totaal.Qp_HPC,
    mow_qs_ac:  bestaandV5Totaal.Qs_AC,
    mow_qs_dc:  bestaandV5Totaal.Qs_DC,
    mow_qs_hpc: bestaandV5Totaal.Qs_HPC,
  };
  const heeftV5Data = fluviusFp != null && fluviusFp > 0 &&
    (bestaandV5Totaal.Qp_AC + bestaandV5Totaal.Qp_DC + bestaandV5Totaal.Qp_HPC +
     bestaandV5Totaal.Qs_AC + bestaandV5Totaal.Qs_DC + bestaandV5Totaal.Qs_HPC) > 0;
  const v5Split = heeftV5Data ? berekenPubliekSemiSplitV5(v5Gemeente, year) : null;
  const v5PrivePctJ = v5Split?.privePct_j;

  // ── Privé-aandeel per jaar ─────────────────────────────────────────
  // Het model rekent met een startpunt in 2026 dat elk jaar met
  // PRIVE_DALING_PER_JAAR daalt, omdat het publieke deel sneller groeit.
  // De schuifbalk op het tabblad Gemeente verzet dat startpunt; de daling
  // blijft daarna gewoon doorlopen. Zonder handmatig startpunt wordt het
  // startpunt van het model gebruikt.
  const PRIVE_STARTJAAR = 2026;
  const PRIVE_DALING = 0.02;
  const priveStartBerekend = v5Split?.privePct_0
    ?? gemeente?.privePctBerekend
    ?? 0.5;
  const priveStartActief = priveStart ?? priveStartBerekend;
  const privePctVoorJaar = (jr) =>
    Math.max(0, Math.min(1, priveStartActief - PRIVE_DALING * Math.max(0, jr - PRIVE_STARTJAAR)));

  // ── Handmatig ingevuld EV-aandeel ──────────────────────────────────
  // Het percentage staat meestal maar op een paar jaren ingevuld. Vielen de
  // tussenliggende jaren terug op de eigen schatting van het model, dan zakte
  // de berekende behoefte daar in, en dan daalde de prognose halverwege. Dat
  // is naar een gemeente toe niet uit te leggen, want er worden geen palen
  // weggehaald. Daarom worden de ingevulde jaren als ankerpunten gebruikt en
  // wordt er tussen twee ankers rechtevenredig verdeeld.
  //
  // Vóór het eerste anker en ná het laatste blijft het model zijn eigen curve
  // rijden; daar valt niets te verdelen en een aanname zou verzonnen zijn.
  const evAnkers = Object.entries(gemeente?.evAandeelOverride || {})
    .map(([jr, waarde]) => [Number(jr), Number(waarde)])
    .filter(([jr, waarde]) => Number.isFinite(jr) && Number.isFinite(waarde))
    .sort((a, b) => a[0] - b[0]);

  const evOverrideVoorJaar = (jr) => {
    if (!evAnkers.length) return null;
    const exact = evAnkers.find(([j]) => j === jr);
    if (exact) return exact[1];
    if (jr < evAnkers[0][0] || jr > evAnkers[evAnkers.length - 1][0]) return null;
    for (let i = 0; i < evAnkers.length - 1; i++) {
      const [j1, w1] = evAnkers[i], [j2, w2] = evAnkers[i + 1];
      if (jr > j1 && jr < j2) return w1 + (w2 - w1) * ((jr - j1) / (j2 - j1));
    }
    return null;
  };

  // De afzetnorm per jaar die deze gemeente heeft ingesteld: hoeveel kWh er per
  // gewoon laadpunt per jaar doorheen gaat. Het model deelt de publieke
  // laadvraag hierdoor. Leeg betekent de basiswaarde van 6.000 kWh.
  const normPerJaar = gemeente?.normPerJaar || null;

  // De gemeten bezettingsgraad van deze gemeente. Sinds 21 augustus 2026 GEEN
  // invoer meer voor de afzet: bezetting meet tijd en de norm meet energie, en
  // die twee bewegen los van elkaar. Blijft staan als tweede toets naast de norm.
  const bezetting = bezettingsgraadGemeente(gemeente?.naam, gemeente?.inwoners);

  const calcParams = {
    year,
    normPerJaar,
    evAandeelOverride: evOverrideVoorJaar(year),
    // V5: gebruik jaar-afhankelijke privePct_j als beschikbaar; anders val
    // terug op de statische privePctBerekend uit de database.
    privePct: v5PrivePctJ != null ? v5PrivePctJ : gemeente?.privePctBerekend,
    // Altijd gevuld, want calcWijk geeft deze waarde voorrang. Zo geldt het
    // ingestelde startpunt inclusief de jaarlijkse daling, en niet één vast
    // percentage voor alle jaren.
    privePctOverride: privePctVoorJaar(year),
    redundantieMarge,
    trendFactor,
    // Het aantal auto's groeit mee met het aantal huishoudens. Leeg betekent
    // geen groei. Zie huishoudens.js op de server.
    autoGroei: autoGroei?.factoren || null,
  };

  // CAPEX per laadtype. Let op de eenheid, deze verschilt:
  // - AC: €4.500 per SOCKET. Reële kost ca. €8.000/paal (2 sockets), model
  //   gebruikt €9.000/paal (€4.500/socket) als bewuste marge voor prijsinflatie.
  // - DC en HPC: bedragen zijn per LAADPAAL (2 sockets per paal). Nog niet
  //   apart gevalideerd, moet nog getoetst tegen actuele markt.
  // Methodiek DC/HPC: per wijk wordt het aantal palen bepaald met
  //   Math.ceil(sockets/2). Een wijk met behoefte 0,5 / 1 / 1,5 sockets
  //   krijgt dus 1 hele laadpaal (2 sockets), 2,5 / 3 / 3,5 sockets → 2
  //   palen, enzovoort. Je kunt namelijk geen halve laadpaal plaatsen, en
  //   palen worden per wijk gepland (niet gedeeld tussen wijken).
  // De bedragen staan in de instellingen van de gemeente, zie STANDAARD_INSTELLINGEN.
  const CAPEX_V2 = capexPlan;

  // ── Snel en ultrasnel per gemeente, per jaar ───────────────────────
  // De functies hieronder rekenen per wijk, maar snel en ultrasnel worden voor
  // de HELE gemeente afgerond op hele palen. Daarom wordt de uitkomst hier
  // eenmalig per jaar bepaald en per wijk-id opgezocht. Zonder deze stap zou
  // de wijkreeks en de export per wijk afronden en dus andere aantallen tonen
  // dan de wijkkaarten.
  const stadsCache = React.useMemo(() => new Map(), [gemId, calcParams, priveStartActief]);
  const stadsVoorJaar = (jr) => {
    if (stadsCache.has(jr)) return stadsCache.get(jr);
    const v5SplitJaar = heeftV5Data ? berekenPubliekSemiSplitV5(v5Gemeente, jr) : null;
    const privePctJaar = v5SplitJaar?.privePct_j != null ? v5SplitJaar.privePct_j : gemeente?.privePctBerekend;
    const p = { ...calcParams, year: jr, evAandeelOverride: evOverrideVoorJaar(jr),
                privePct: privePctJaar, privePctOverride: privePctVoorJaar(jr) };
    const wijken = gemeente?.wijken || [];
    const ruw = wijken.map(w => calcWijk(w, p));
    const dc  = stadsPalen(ruw.map(d => d.totDC));
    const hpc = stadsPalen(ruw.map(d => d.totHPC));
    const uit = new Map();
    wijken.forEach((w, i) => uit.set(w.id, { dc: dc[i], hpc: hpc[i] }));
    stadsCache.set(jr, uit);
    return uit;
  };

  // ── EEN BRON voor het aantal bij te plaatsen laadpunten ────────────
  // Afgesproken op 17 augustus 2026. Het getal PER WIJK is de bron: het tekort
  // van dat jaar, per laadsoort nooit negatief, opgeteld en naar boven
  // afgerond, want een halve laadpaal bestaat niet. Het stadstotaal is de som
  // daarvan. Daarna gaat de planning van de laadpaalexploitant er een keer af,
  // verdeeld over de wijken naar hun aandeel in het tekort aan gewone
  // laadpunten. Elke plek in de app die dit getal toont leest hier, zodat de
  // som van de wijken altijd gelijk is aan wat er in de tegel staat.
  const bronCache = React.useMemo(() => new Map(),
    [gemId, calcParams, priveStartActief, huidigLP]);
  const bronVoorJaar = (jr) => {
    if (bronCache.has(jr)) return bronCache.get(jr);
    const wijken = gemeente?.wijken || [];
    const v5SplitJaar = heeftV5Data ? berekenPubliekSemiSplitV5(v5Gemeente, jr) : null;
    const privePctJaar = v5SplitJaar?.privePct_j != null ? v5SplitJaar.privePct_j : gemeente?.privePctBerekend;
    const p = { ...calcParams, year: jr, evAandeelOverride: evOverrideVoorJaar(jr),
                privePct: privePctJaar, privePctOverride: privePctVoorJaar(jr) };
    const stads = stadsVoorJaar(jr);
    const tekorten = wijken.map(w => {
      const ruwD = calcWijk(w, p);
      const sd = stads.get(w.id) || { dc: ruwD.totDC, hpc: ruwD.totHPC };
      const b = bestaandPerWijk[w.id] || leegType();
      return { id: w.id,
               ac:  ruwD.totAC - b.AC,
               dc:  sd.dc  - b.DC,
               hpc: sd.hpc - b.HPC };
    });
    const uit = bijTePlaatsenPerWijk(tekorten, huidigLP);
    bronCache.set(jr, uit);
    return uit;
  };

  // Het aantal bij te plaatsen laadpunten van een wijk in een jaar.
  const bijTePlaatsenWijk = (wijkId, jr) => bronVoorJaar(jr).perWijk.get(wijkId) ?? 0;

  // ── Jaardeel per wijk ──────────────────────────────────────────────
  // De kaart en de legenda tonen wat er IN het gekozen jaar bij moet komen,
  // niet het cumulatieve tekort vanaf vandaag. Het cumulatieve getal staat in
  // de kerncijferbalk bovenaan.
  // Deze twee helpers rekenen exact zoals wijkTijdreeks(PerJaar) verderop in
  // dit bestand, maar staan hier los uitgeschreven omdat die functies pas ná
  // de kaart worden gedeclareerd terwijl de kaart het getal al tijdens de
  // render nodig heeft.
  const EERSTE_PLANJAAR = 2027;

  const bijkomendVoorJaar = (wijk, jr) => bijTePlaatsenWijk(wijk.id, jr);

  // Het eerste planjaar krijgt de volle achterstand, want dan wordt die
  // ingelopen. Elk volgend jaar alleen de groei ten opzichte van het jaar
  // ervoor, en nooit negatief, want palen worden niet weggehaald.
  const jaardeelWijk = (wijk) => {
    const nu = bijkomendVoorJaar(wijk, year);
    if (year <= EERSTE_PLANJAAR) return nu;
    return Math.max(0, nu - bijkomendVoorJaar(wijk, year - 1));
  };

  // Hetzelfde als bijkomendVoorJaar, maar uitgesplitst naar laadsoort. Nodig
  // omdat een DC-paal een heel ander aansluitvermogen vraagt dan een AC-paal.
  const bijkomendPerSoortVoorJaar = (wijk, jr) => {
    const v5SplitJaar  = heeftV5Data ? berekenPubliekSemiSplitV5(v5Gemeente, jr) : null;
    const privePctJaar = v5SplitJaar?.privePct_j != null ? v5SplitJaar.privePct_j : gemeente?.privePctBerekend;
    const d = calcWijk(wijk, {
      ...calcParams, year: jr,
      evAandeelOverride: evOverrideVoorJaar(jr),
      privePct: privePctJaar,
      privePctOverride: privePctVoorJaar(jr),
    });
    const b = bestaandPerWijk[wijk.id] || leegType();
    return { ac:  Math.max(0, d.totAC  - b.AC),
             dc:  Math.max(0, d.totDC  - b.DC),
             hpc: Math.max(0, d.totHPC - b.HPC) };
  };

  // Het deel dat in dit jaar bijkomt. Het eerste planjaar krijgt de volle
  // achterstand, elk volgend jaar alleen de groei, en nooit negatief want
  // palen worden niet weggehaald.
  // Het lopende totaal aan bij te plaatsen laadpunten tot en met een jaar. Het
  // eerste planjaar bevat de volle achterstand; daarna groeit het mee.
  const totaalPunten = (wijk, jr) => bijkomendPerSoortVoorJaar(wijk, Math.max(jr, EERSTE_PLANJAAR));

  const jaardeelPerSoort = (wijk, jr) => {
    const nu = bijkomendPerSoortVoorJaar(wijk, jr);
    if (jr <= EERSTE_PLANJAAR) return nu;
    const vorig = bijkomendPerSoortVoorJaar(wijk, jr - 1);
    return { ac:  Math.max(0, nu.ac  - vorig.ac),
             dc:  Math.max(0, nu.dc  - vorig.dc),
             hpc: Math.max(0, nu.hpc - vorig.hpc) };
  };

  // Bij het wisselen van gemeente eerst de oude doorrekening weggooien, anders
  // blijven de cijfers en de kaart van de vorige stad in beeld tot het antwoord
  // van de server binnen is, of voorgoed als dat antwoord uitblijft.
  useEffect(() => {
    setNetcapUit(null);
    setNetcapFout(null);
  }, [gemId]);

  // ── Netcapaciteit doorrekenen ──────────────────────────────────────
  // De aansluitwaarden en het rekenwerk staan in de backend, zodat een latere
  // toepassing voor netbeheerders dezelfde bron gebruikt en de getallen niet
  // uit elkaar kunnen lopen. Het scherm levert alleen de laadpunten per wijk
  // per jaar en de opstellingen per laadplein aan.
  const netcapLaatsteJaar = 2035;

  useEffect(() => {
    // Ook op het tabblad Export, want het rapport gebruikt dezelfde kaart met
    // de kleuren van de netbeheerder.
    if ((tab !== 'netcapaciteit' && tab !== 'export') || !gemId || !(gemeente?.wijken || []).length) return;
    let afgebroken = false;
    const begin = Math.min(netcapBegin, netcapEind);
    const eind  = Math.max(netcapBegin, netcapEind);

    // Laadpleinen hebben geen jaartal, dus ze worden in het eerste jaar van de
    // periode gerekend. Staat er niets ingevuld, dan telt er ook niets mee.
    // Per locatie het jaar waarvoor hij is vastgelegd. Zonder jaar valt hij in
    // het eerste jaar van de gekozen periode; een jaar buiten de periode valt
    // op de dichtstbijzijnde rand, want anders zou hij nergens meetellen.
    const locatiesPerWijk = {};
    for (const r of pleinGeschikt) {
      const palen = pleinOordeel[r.id]?.opstelling;
      if (!vermogenVanOpstelling(palen).palen) continue;
      const gekozenJaar = pleinOordeel[r.id]?.jaar;
      const jaarVanLocatie = gekozenJaar == null ? begin
        : Math.min(netcapLaatsteJaar, Math.max(begin, Number(gekozenJaar)));
      const wid = wijkVanPunt(sectorenGeo, r.lat, r.lng)
        ?? (wijkResults.find(w => w.wijk.lat != null &&
             Math.hypot(w.wijk.lat - r.lat, w.wijk.lng - r.lng) < 0.05)?.wijk?.id ?? null);
      (locatiesPerWijk[wid] ||= []).push({ locatieId: r.id, naam: r.naam || null, palen,
        jaar: jaarVanLocatie });
    }

    // Per wijk over de jaren heen. De laadpunten uit het model worden HIER
    // eenmalig omgezet naar palen; daarna rekent alles in palen, want de
    // aansluitwaarde hangt aan de paal en niet aan het laadpunt.
    // Van laadpunten naar hele palen. Dat afronden gebeurt ÉÉN KEER per soort
    // voor de hele gemeente, op het lopende totaal over de jaren. Rondden we af
    // per wijk, per jaar en per soort, dan telt dat bij kleine aantallen flink
    // op: een wijk die 0,6 snellaadpunt nodig heeft zou een hele paal met twee
    // punten krijgen, en dat maal het aantal wijken maal het aantal jaren.
    // Zo blijft het overschot hooguit één paal per soort voor de hele gemeente.
    const SOORTEN = ['ac', 'dc', 'hpc'];
    const wijkenLijst = gemeente?.wijken || [];
    const jaarLijstAlles = [];
    for (let jr = begin; jr <= netcapLaatsteJaar; jr++) jaarLijstAlles.push(jr);
    // Begint de periode later dan het eerste planjaar, dan hoort wat er in de
    // jaren daarvóór al bij moest komen NIET in het eerste jaar van de periode.
    // Het jaar ervoor dient dan als nullijn.
    const basisJaar = begin > EERSTE_PLANJAAR ? begin - 1 : null;

    // Stap 1: de gevraagde laadpunten per wijk per jaar per soort.
    const punten = new Map();   // sleutel `${jr}|${wijkId}|${soort}`
    const gemeenteTot = {};     // lopend totaal per soort per jaar
    for (const jr of (basisJaar ? [basisJaar, ...jaarLijstAlles] : jaarLijstAlles)) {
      for (const soort of SOORTEN) gemeenteTot[`${jr}|${soort}`] = 0;
      for (const w of wijkenLijst) {
        const tot = totaalPunten(w, jr);
        for (const soort of SOORTEN) {
          const v = Math.max(0, tot[soort] || 0);
          punten.set(`${jr}|${w.id}|${soort}`, v);
          gemeenteTot[`${jr}|${soort}`] += v;
        }
      }
    }

    // Stap 2: per soort het aantal palen voor de hele gemeente, één keer
    // afgerond op het lopende totaal, en daarvan het jaarverschil.
    const palenPerJaar = {};
    for (const soort of SOORTEN) {
      let vorig = basisJaar ? Math.ceil(gemeenteTot[`${basisJaar}|${soort}`] / 2) : 0;
      for (const jr of jaarLijstAlles) {
        const totNu = Math.ceil(gemeenteTot[`${jr}|${soort}`] / 2);
        palenPerJaar[`${jr}|${soort}`] = Math.max(0, totNu - vorig);
        vorig = totNu;
      }
    }

    // Stap 3: die hele palen over de wijken verdelen naar hun aandeel in de
    // gevraagde laadpunten, met de grootste-restmethode zodat de som klopt.
    const palenVanWijk = new Map();  // sleutel `${jr}|${wijkId}|${soort}`
    for (const jr of jaarLijstAlles) {
      for (const soort of SOORTEN) {
        const teVerdelen = palenPerJaar[`${jr}|${soort}`];
        const delen = wijkenLijst.map(w => ({
          id: w.id,
          // Het gewicht is wat er in dít jaar bijkomt. Voor het eerste jaar van
          // de periode is dat het verschil met de nullijn, of het volle bedrag
          // als de periode bij het eerste planjaar begint.
          gewicht: (jr === begin && !basisJaar) ? punten.get(`${jr}|${w.id}|${soort}`)
            : Math.max(0, punten.get(`${jr}|${w.id}|${soort}`) -
                          (punten.get(`${jr - 1}|${w.id}|${soort}`) ?? 0)),
        }));
        const somGewicht = delen.reduce((a, d) => a + d.gewicht, 0);
        if (!teVerdelen || somGewicht <= 0) {
          for (const d of delen) palenVanWijk.set(`${jr}|${d.id}|${soort}`, 0);
          continue;
        }
        const ruw = delen.map(d => ({ id: d.id, waarde: teVerdelen * d.gewicht / somGewicht }));
        const heel = ruw.map(r => ({ id: r.id, n: Math.floor(r.waarde), rest: r.waarde - Math.floor(r.waarde) }));
        let over = teVerdelen - heel.reduce((a, h) => a + h.n, 0);
        heel.sort((a, b) => b.rest - a.rest);
        for (let i = 0; i < over; i++) heel[i % heel.length].n += 1;
        for (const h of heel) palenVanWijk.set(`${jr}|${h.id}|${soort}`, h.n);
      }
    }

    // Stap 4: per wijk de palen die al op een gekozen locatie staan eraf halen.
    // Wat er dit jaar niet af kan, gaat mee naar het volgende jaar.
    const perJaar = new Map();
    for (const w of wijkenLijst) {
      // Wat er in een jaar op een vastgelegde locatie komt, gaat af van de
      // palen die het model voor dat jaar vraagt. Per jaar apart, want een
      // locatie hoort nu bij het jaar waarvoor hij is vastgelegd.
      const rest = { ac: 0, dc: 0, hpc: 0 };
      for (const jr of jaarLijstAlles) {
        for (const loc of (locatiesPerWijk[w.id] || []).filter(l => l.jaar === jr)) {
          // Alleen de palen voor personenwagens gaan af van wat het model
          // vraagt. De palen voor bestelwagens komen erbovenop; de locatie
          // zelf houdt haar volle opstelling en dus haar volle aansluitvermogen.
          const voorPersonen = palenVoorPersonenwagens(loc.palen, pleinOordeel[loc.locatieId]?.bestelwagens);
          for (const soort of SOORTEN) {
            rest[soort] += voorPersonen[soort];
          }
        }
        const zonder = {};
        for (const soort of SOORTEN) {
          const palen = palenVanWijk.get(`${jr}|${w.id}|${soort}`) || 0;
          const af = Math.min(palen, rest[soort]);
          rest[soort] -= af;
          zonder[soort] = palen - af;
        }
        if (!perJaar.has(jr)) perJaar.set(jr, []);
        perJaar.get(jr).push({
          wijkId: w.id, naam: w.naam,
          slimAandeel: netcapSlimHand[w.id] ? (netcapSlimWijk[w.id] ?? 0) : netcapSlim,
          palenZonderLocatie: zonder,
          locaties: (locatiesPerWijk[w.id] || []).filter(l => l.jaar === jr),
        });
      }
    }
    const jaren = [...perJaar.keys()].sort((a, b) => a - b)
      .map(jr => ({ jaar: jr, binnenPeriode: jr <= eind, wijken: perJaar.get(jr) }));

    setNetcapBezig(true); setNetcapFout(null);
    // Kort wachten voordat er wordt doorgerekend. Zonder deze pauze vuurt elke
    // toetsaanslag in het percentageveld een eigen doorrekening af, en die
    // overlappen elkaar in de database.
    const wacht = setTimeout(() => {
    bewaarNetcapaciteit(gemId, {
      jaren,
      slimAandeel: netcapSlim,
      // De NIS-code wordt door de server zelf opgezocht; het scherm heeft hem niet.
      // De gebruikte uitgangspunten. Zonder deze zijn gemeenten later wel op te
      // tellen maar niet te vergelijken.
      grondslag: {
        peiljaar: year, pleinAandeel, pleinOmvang,
        evAandeel: wijkResults[0]?.data.evPct ?? null,
        privePct: gemeente?.privePctBerekend ?? null,
        periodeVan: begin, periodeTot: eind,
        slimAandeel: netcapSlim,
      },
    })
      .then(r => { if (!afgebroken) setNetcapUit(r); })
      .catch(e => { if (!afgebroken) setNetcapFout(e.message); })
      .finally(() => { if (!afgebroken) setNetcapBezig(false); });
    }, 400);

    return () => { afgebroken = true; clearTimeout(wacht); };
  }, [tab, gemId, netcapBegin, netcapEind, pleinAandeel, year, pleinOordeel,
      netcapSlim, netcapSlimWijk, netcapSlimHand]);

  // ── Bereken wijken ─────────────────────────────────────────────────
  //
  // Snel en ultrasnel worden voor de HELE STAD opgeteld en dan pas naar hele
  // palen afgerond; daarna gaat het resultaat terug naar de wijken naar rato
  // van hun eigen behoefte.
  //
  // Tot 20 augustus 2026 gebeurde dat per wijk. Elke wijk met een fractie
  // kreeg een hele paal van twee laadpunten, en bij 24 wijken telt dat op:
  // een behoefte van 30,5 snellaadpunten werd 20 palen oftewel 40 laadpunten,
  // terwijl 16 palen volstaan. Bij ultrasnel was het effect nog groter. Dat
  // werkte door in de investering en in het aansluitvermogen.
  //
  // Gewone laadpunten blijven per wijk: die staan los in de straat en een
  // halve paal komt daar niet voor, want het aantal is per wijk al groot.
  const ruweResults = (gemeente?.wijken || []).map(w => ({ wijk:w, data: calcWijk(w, calcParams) }));

  const dcPerWijk  = stadsPalen(ruweResults.map(r => r.data.totDC));
  const hpcPerWijk = stadsPalen(ruweResults.map(r => r.data.totHPC));

  const wijkResults = ruweResults.map(({ wijk: w, data: ruw }, i) => {
    // totLP is de som van de drie soorten en moet dat blijven, anders staat er
    // op het ene tabblad een ander totaal dan op het andere. Sinds snel en
    // ultrasnel op stadsniveau worden afgerond, wijkt de ruwe totLP daarvan af.
    const data = { ...ruw, totDC: dcPerWijk[i], totHPC: hpcPerWijk[i],
                   totLP: ruw.totAC + dcPerWijk[i] + hpcPerWijk[i] };
    const bestaand = bestaandPerWijk[w.id] || leegType();
    const delta = {
      AC:  Math.max(0, data.totAC  - bestaand.AC),
      DC:  Math.max(0, data.totDC  - bestaand.DC),
      HPC: Math.max(0, data.totHPC - bestaand.HPC),
    };
    const capex = delta.AC*CAPEX_V2.AC + Math.ceil(delta.DC/2)*CAPEX_V2.DC + Math.ceil(delta.HPC/2)*CAPEX_V2.HPC;
    return { wijk:w, data:{ ...data, bestaand, delta, capex,
      deltaTotaal: delta.AC + delta.DC + delta.HPC,
      // Het getal dat op het scherm komt, uit de ene bron, inclusief de
      // planning van de laadpaalexploitant.
      bijTePlaatsen: bijTePlaatsenWijk(w.id, year),
      jaardeel: jaardeelWijk(w) } };
  });
  // Hier stond tot 9 september 2026 een tabel met alle wijkwaarden en twee
  // regels met de rekenparameters, weggeschreven naar de browserconsole. Die
  // zijn weg: wie bij een demonstratie de console opent hoort geen rekenwerk
  // te zien. Meldingen bij een echte fout blijven wel staan.
  const alleJaardelen = wijkResults.map(r => r.data.jaardeel);
  // Eén keer per weergave berekend, zodat de kaart en de legenda gegarandeerd
  // dezelfde indeling gebruiken. Gebaseerd op het jaardeel, dus de legenda
  // schaalt mee met het gekozen jaar en de kop "bij te plaatsen in <jaar>"
  // klopt met wat de kleuren tonen.
  const klassegrenzen = bepaalKlassegrenzen(alleJaardelen);
  const kaartKlassen = legendaKlassen(alleJaardelen, klassegrenzen);

  const totLP       = wijkResults.reduce((s,r)=>s+r.data.totLP,0);
  const totMwh      = wijkResults.reduce((s,r)=>s+r.data.totMwh,0);
  // De PUBLIEKE laadvraag, dus na aftrek van het deel dat thuis of op het werk
  // laadt. Dat is wat het plan moet opvangen. Uitgangspunt 10 van 3 augustus
  // 2026: MWh betekent op elk tabblad hetzelfde, namelijk de publieke vraag.
  // De tegel Laadvolume toonde tot 20 augustus 2026 het TOTALE verbruik, dus
  // inclusief thuisladen, terwijl elke wijkkaart de publieke vraag toonde.
  const totMwhPubliek = wijkResults.reduce((s,r)=>s+r.data.mwhPubliek,0);
  const totMwhPrive   = Math.max(0, totMwh - totMwhPubliek);
  const totBestaand = wijkResults.reduce((s,r)=>s+r.data.bestaand.AC+r.data.bestaand.DC+r.data.bestaand.HPC,0);
  // Bijkomend (stadsbreed) = optelling van wat elke wijk zelf al, per type,
  // nooit-negatief aangeeft nodig te hebben (dezelfde .delta als hieronder
  // voor de kaartkleur/tooltips/wijktabel). Bewust GEEN aparte, stadsbrede
  // netto-berekening (totLP - totBestaand), want dan kan een overschot in
  // de ene wijk een tekort in een andere wijk verbergen, terwijl bestaande
  // infrastructuur in wijk A een tekort in wijk B niet kan oplossen.
  // "Gepland te installeren" is specifiek AC (zie invoerveld), dus mag ook
  // alleen het AC-deel van bijkomend/CAPEX verminderen, niet DC/HPC.
  const geplandAangerekend = bronVoorJaar(year).aangerekend;
  // Het stadstotaal is de som van de wijkgetallen uit bronVoorJaar, dus niet
  // een eigen optelling van onafgeronde tekorten. Anders staat er in de tegel
  // een ander getal dan op de tabbladen Wijken en Plaatsing.
  const bijkomend = bronVoorJaar(year).totaal;
  // CAPEX-tegel: rechtstreekse optelling van de bouwkost van precies het
  // bijkomende deel, per wijk en per laadtype (delta.AC/DC/HPC), niet een
  // ratio-schatting op basis van bruto-totalen. Die ratio-aanpak gaf een
  // sterk vertekend (te laag) beeld zodra bijkomend << totLP (bijvoorbeeld
  // omdat een deel van de stad al ruim voldoende infrastructuur heeft),
  // want dan schaalde hij de hele stadsbrede bouwkost mee naar beneden,
  // ook voor wijken die wel degelijk een fors tekort hebben. De AC-kost van
  // "gepland te installeren" wordt er hier ook echt vanaf getrokken, zodat
  // deze tegel meebeweegt met de Bijkomend-tegel hierboven.
  // Stadstotaal-CAPEX: som van de per-wijk CAPEX. Elke wijk heeft eigen
  // laadpalen (0,5 socket-behoefte in een wijk = 1 hele laadpaal daar),
  // dus we tellen per-wijk-ceils op, geen stadstotaal-ceil.
  // ── Welk deel van de bestaande laadpunten telt mee ─────────────────
  // Inhoudelijk is dit per wijk en per type het minimum van behoefte en
  // aanwezig: een wijk die voor dit jaar al genoeg heeft, lost met haar
  // overschot geen tekort in een andere wijk op.
  // Het wordt hier bewust afgeleid uit de twee getallen die ERNAAST op het
  // scherm staan, 'laadpunten nodig' min 'bij te plaatsen'. Rekenkundig is dat
  // hetzelfde, maar het garandeert dat de aftreksom die een lezer zelf maakt
  // exact uitkomt, ook na afronding en ook als er iets gepland te installeren
  // staat. Dat was precies de bron van de verwarring.
  const aanwezigTotaal = Math.round(bestaandTotaalPerType.AC + bestaandTotaalPerType.DC + bestaandTotaalPerType.HPC);
  // Ongewogen aantallen voor de tegel Nu aanwezig: publiek telt helemaal,
  // semi-publiek voor de helft. Samen geven ze aanwezigTotaal.
  const aanwezigPubliek = Math.round(bestaandV5Totaal.Qp_AC + bestaandV5Totaal.Qp_DC + bestaandV5Totaal.Qp_HPC);
  const aanwezigSemi = Math.round(bestaandV5Totaal.Qs_AC + bestaandV5Totaal.Qs_DC + bestaandV5Totaal.Qs_HPC);

  // Elektrische auto's die op een publiek laadpunt zijn aangewezen: alle
  // elektrische auto's min die met een eigen laadpunt.
  //
  // Dit is een TELLING tegenover een TELLING. Het privé-aandeel dat elders in
  // het model staat verdeelt ENERGIE en is daarom geen maat voor het aantal
  // auto's: een privé laadpunt bedient één auto, een publiek laadpunt meerdere.
  //
  // Het aantal privé laadpunten komt uit de Fluvius-telling, opgehoogd voor de
  // eigenaars die hun thuislader niet aanmelden. Dat is P uit de V5-splitsing.
  // Elk privé laadpunt hoort bij één auto, dus P is het aantal auto's dat thuis
  // kan laden.
  const evsTotaal = wijkResults.reduce((s,r) => s + (r.data.evs || 0), 0);
  const privePunten = v5Split?.P ?? 0;
  const evsZonderEigen = Math.max(0, evsTotaal - privePunten);

  // ── De afzetnorm per jaar: staat, omrekening en opslag ──────────────
  //
  // De twee invoervelden zijn hetzelfde getal in een andere gedaante. De
  // omrekening loopt via de publieke laadvraag van dat jaar:
  //
  //   laadpunten      = publieke vraag / norm
  //   EV per laadpunt = EV's zonder eigen laadpunt / laadpunten
  //
  // Dus: norm = publieke vraag x EV per laadpunt / EV's zonder eigen laadpunt.
  const [normInvoer, setNormInvoer] = useState({});
  const [evInvoer,   setEvInvoer]   = useState({});
  useEffect(() => { setNormInvoer({}); setEvInvoer({}); }, [gemId]);

  // Per jaar de publieke vraag en het aantal auto's zonder eigen laadpunt,
  // zodat de tabel elke regel kan invullen zonder per rij te herrekenen.
  const normReeks = React.useMemo(() => {
    const uit = {};
    for (const jr of NORM_JAREN) {
      const v5SplitJaar = heeftV5Data ? berekenPubliekSemiSplitV5(v5Gemeente, jr) : null;
      const privePctJaar = v5SplitJaar?.privePct_j != null ? v5SplitJaar.privePct_j : gemeente?.privePctBerekend;
      const p = { ...calcParams, year: jr, evAandeelOverride: evOverrideVoorJaar(jr),
                  privePct: privePctJaar, privePctOverride: privePctVoorJaar(jr) };
      // Snel en ultrasnel blijven hier ONafgerond: de stadsafronding daarvan
      // gebeurt verderop en kan hier nog niet worden aangeroepen. Het verschil
      // is klein, want die twee soorten zijn maar enkele procenten van het
      // totaal, en de kolom dient om de norm te vertalen naar EV per laadpunt.
      let pub = 0, evs = 0, lp = 0;
      for (const w of (gemeente?.wijken || [])) {
        const d = calcWijk(w, p);
        pub += d.mwhPubliek; evs += d.evs || 0; lp += d.totLP;
      }
      const zonderEigen = Math.max(0, evs - (v5SplitJaar?.P ?? 0));
      uit[jr] = { pub, evs, zonderEigen, lp,
                  evPerPunt: lp > 0 ? zonderEigen / lp : null };
    }
    return uit;
  }, [gemId, calcParams, priveStartActief, normPerJaar]);

  // Wat er gebeurde toen iemand een norm boven de drempel invulde. Blijft
  // staan tot de volgende invoer, zodat het niet wegflitst.
  const [normMelding, setNormMelding] = useState('');
  const [normOpen, setNormOpen] = useState(false);

  const bewaarNormWaarde = async (jr, waarde) => {
    const nieuw = { ...(gemeente?.normPerJaar || {}) };
    if (waarde == null) delete nieuw[jr]; else nieuw[jr] = waarde;
    try {
      await updateGemeente(gemeente.id, { ...gemeente, normPerJaar: Object.keys(nieuw).length ? nieuw : null });
      setGemeenten(g => ({ ...g, [gemeente.id]: { ...g[gemeente.id], normPerJaar: Object.keys(nieuw).length ? nieuw : null } }));
    } catch (e) {
      setApiError('De norm kon niet worden bewaard: ' + e.message);
    }
  };

  // De norm mag niet boven de drempel uitkomen waarbij de concessie bijplaatst.
  // Daarboven bestaat de situatie niet: er komt een paal bij en de afzet per
  // laadpunt zakt weer. Een hogere norm zou het model een tekort laten
  // wegrekenen dat er wel is. Zie actie 12 van actielijst_rekenmodel.docx.
  const NORM_MIN_KWH = 1000;
  const begrensNorm = (w, jr) => {
    if (w > MOW_DREMPEL_BIJPLAATSING_KWH) {
      setNormMelding(`${fmtN(w)} kWh voor ${jr} is teruggezet naar `
        + `${fmtN(MOW_DREMPEL_BIJPLAATSING_KWH)} kWh. Daarboven plaatst de concessiehouder `
        + `een laadpunt bij, waarna de afzet per laadpunt weer zakt.`);
      return MOW_DREMPEL_BIJPLAATSING_KWH;
    }
    if (w < NORM_MIN_KWH) {
      setNormMelding(`${fmtN(w)} kWh voor ${jr} is opgehoogd naar ${fmtN(NORM_MIN_KWH)} kWh, `
        + `de laagste waarde waarmee gerekend kan worden.`);
      return NORM_MIN_KWH;
    }
    setNormMelding('');
    return w;
  };

  const bewaarNorm = (jr) => {
    const ruw = (normInvoer[jr] ?? '').toString().trim();
    setNormInvoer(v => { const n = { ...v }; delete n[jr]; return n; });
    if (ruw === '') return;                       // niets getypt, niets bewaren
    const w = Math.round(parseFloat(ruw.replace(',', '.')));
    if (!Number.isFinite(w) || w <= 0) return;
    bewaarNormWaarde(jr, begrensNorm(w, jr));
  };

  // Invoer in EV's per laadpunt terugrekenen naar kWh per laadpunt.
  const bewaarNormViaEv = (jr) => {
    const ruw = (evInvoer[jr] ?? '').toString().trim();
    setEvInvoer(v => { const n = { ...v }; delete n[jr]; return n; });
    if (ruw === '') return;
    const ev = parseFloat(ruw.replace(',', '.'));
    const r = normReeks[jr];
    if (!Number.isFinite(ev) || ev <= 0 || !r || !r.zonderEigen) return;
    const w = Math.round(r.pub * 1000 * ev / r.zonderEigen);
    bewaarNormWaarde(jr, begrensNorm(w, jr));
  };

  // Alles terug naar de standaardreeks: de ingestelde waarden wissen.
  const resetNorm = async () => {
    setNormInvoer({}); setEvInvoer({});
    try {
      await updateGemeente(gemeente.id, { ...gemeente, normPerJaar: null });
      setGemeenten(g => ({ ...g, [gemeente.id]: { ...g[gemeente.id], normPerJaar: null } }));
    } catch (e) {
      setApiError('De norm kon niet worden teruggezet: ' + e.message);
    }
  };

  const trekNormDoor = async (vanafJaar) => {
    const w = acNormKwh(vanafJaar, normPerJaar);
    const nieuw = { ...(gemeente?.normPerJaar || {}) };
    for (const jr of NORM_JAREN) if (jr >= vanafJaar) nieuw[jr] = w;
    try {
      await updateGemeente(gemeente.id, { ...gemeente, normPerJaar: nieuw });
      setGemeenten(g => ({ ...g, [gemeente.id]: { ...g[gemeente.id], normPerJaar: nieuw } }));
    } catch (e) {
      setApiError('De norm kon niet worden doorgetrokken: ' + e.message);
    }
  };

  const capexBijkomendRuw = wijkResults.reduce((s,r) => s + r.data.capex, 0);
  const capexBijkomend = Math.max(0, capexBijkomendRuw - geplandAangerekend*CAPEX_V2.AC);

  // Vanaf 2027, gelijk aan de jaarknoppen en aan de wijkreeks. YEARS begint bij
  // 2025 omdat het model daar zijn startpunt heeft, maar die twee jaren horen
  // niet in de grafiek: er valt niets meer te plannen voor een jaar dat al bezig is.
  const tijdreeks = YEARS.filter(y => y >= 2027).map(yr => {
    // V5: herbereken privePct_j per jaar (daalt lineair per PRIVE_DALING_PER_JAAR).
    const v5SplitJaar = heeftV5Data ? berekenPubliekSemiSplitV5(v5Gemeente, yr) : null;
    const privePctJaar = v5SplitJaar?.privePct_j != null ? v5SplitJaar.privePct_j : gemeente?.privePctBerekend;
    const p = {
      ...calcParams,
      year: yr,
      evAandeelOverride: evOverrideVoorJaar(yr),
      privePct: privePctJaar,
      // Per jaar het bijbehorende privé-aandeel, dus met de daling erin.
      privePctOverride: privePctVoorJaar(yr),
    };
    // Snel en ultrasnel per gemeente afronden, net als bij de wijkkaarten.
    // Anders staat er in de grafiek een ander aantal dan op het scherm.
    const ruw = (gemeente?.wijken||[]).map(w => calcWijk(w, p));
    const dcJr  = stadsPalen(ruw.map(d => d.totDC));
    const hpcJr = stadsPalen(ruw.map(d => d.totHPC));
    const res = (gemeente?.wijken||[]).map((w, i) => {
      const rd = ruw[i];
      const d = { ...rd, totDC: dcJr[i], totHPC: hpcJr[i],
                  totLP: rd.totAC + dcJr[i] + hpcJr[i] };
      const bestaand = bestaandPerWijk[w.id] || leegType();
      const delta = {
        AC:  Math.max(0, d.totAC  - bestaand.AC),
        DC:  Math.max(0, d.totDC  - bestaand.DC),
        HPC: Math.max(0, d.totHPC - bestaand.HPC),
      };
      const capex = delta.AC*CAPEX_V2.AC + Math.ceil(delta.DC/2)*CAPEX_V2.DC + Math.ceil(delta.HPC/2)*CAPEX_V2.HPC;
      return { ...d, bestaand, delta, deltaTotaal: delta.AC+delta.DC+delta.HPC, capex };
    });
    const totLPJaar      = res.reduce((s,r)=>s+r.totLP,0);
    const geplandAangerekendJaar = bronVoorJaar(yr).aangerekend;
    const bijkomendJaar = bronVoorJaar(yr).totaal;
    const capexNuRuw = res.reduce((s,r) => s + r.capex, 0);
    const capexNu = Math.max(0, capexNuRuw - geplandAangerekendJaar*CAPEX_V2.AC);
    return {
      jaar:yr,
      'Laadpunten nodig':  totLPJaar,
      // Cumulatief: alles wat er tussen vandaag en dit jaar bij moet.
      'Bijkomend': bijkomendJaar,
      'MWh':       Math.round(res.reduce((s,r)=>s+r.mwhPubliek,0)),
      // Cumulatief: totale investering tussen vandaag en dit jaar.
      'CAPEX €K':  Math.round(capexNu/1000),
    };
  });

  // ── Per jaar in plaats van cumulatief ────────────────────────────────
  // 'Bijkomend' en 'CAPEX €K' uit tijdreeks zijn cumulatief vanaf vandaag.
  // Voor de grafiek is het jaardeel nodig: het verschil met het vorige jaar.
  // Het eerste jaar houdt de volle waarde, want dan wordt de achterstand
  // ingelopen. Nooit negatief: laadpunten worden niet weggehaald.
  const tijdreeksPerJaar = tijdreeks.map((t, i) => {
    const vorige = i > 0 ? tijdreeks[i-1] : null;
    const nieuwDitJaar   = vorige ? Math.max(0, t['Bijkomend'] - vorige['Bijkomend']) : t['Bijkomend'];
    const capexDitJaar   = vorige ? Math.max(0, t['CAPEX €K'] - vorige['CAPEX €K'])   : t['CAPEX €K'];
    return {
      jaar: t.jaar,
      'Nieuw dit jaar':   Math.round(nieuwDitJaar),
      // Loopt op met de staven en eindigt in het gekozen jaar precies op het
      // kerncijfer 'Bij te plaatsen'. Zo sluit de grafiek aan op de balk.
      'Tot en met dat jaar': Math.round(t['Bijkomend']),
      'Totaal nodig':     Math.round(t['Laadpunten nodig']),
      'MWh':              t['MWh'],
      'CAPEX dit jaar':   Math.round(capexDitJaar),
      'CAPEX cumulatief': Math.round(t['CAPEX €K']),
    };
  });

  // ══════════════════════════════════════════════════════════════════
  // API: gemeenten laden bij startup
  // ══════════════════════════════════════════════════════════════════
  useEffect(() => {
    async function laadGemeenten() {
      // Health check
      const health = await checkHealth();
      if (health.status !== 'ok') {
        setDbStatus('offline');
        setGemeenten({});
        setApiError('De server is niet bereikbaar. Probeer het later opnieuw.');
        return;
      }
      setDbStatus('online');

      try {
        // De lijst bevat alleen de gemeenten waarvoor dit account toegang heeft.
        const lijst = await getAlleGemeenten();
        const gemObj = {};
        for (const g of lijst) {
          gemObj[g.id] = g; // wijken nog niet geladen
        }
        if (!lijst.length) {
          // Geen enkele gemeente gekoppeld. Niet terugvallen op iets anders.
          setGemeenten({});
          setGeenToegang(true);
          return;
        }
        setGeenToegang(false);
        // De eerste gemeente uit de lijst volledig laden, inclusief wijken.
        // Stond hier eerder een vaste naam, dan werd die ook opgehaald voor een
        // account dat er geen toegang toe had, en dat liet de app afketsen.
        const eersteId = lijst[0].id;
        const eerste = await getGemeente(eersteId);
        gemObj[eersteId] = eerste;
        setGemeenten(gemObj);
        setGemId(eersteId);
      } catch(e) {
        setApiError(e.message);
        setDbStatus('offline');
      }
    }
    laadGemeenten();
  }, []);

  // ══════════════════════════════════════════════════════════════════
  // API: gemeente laden bij switch (lazy — wijken pas ophalen als nodig)
  // ══════════════════════════════════════════════════════════════════
  const laadGemeenteDetails = useCallback(async (id) => {
    // Bij het opstarten staat er nog geen gemeente gekozen. Zonder deze regel
    // werd er een gemeente zonder naam opgevraagd, en dat gaf boven in beeld de
    // melding dat de gemeente niet gevonden was.
    if (!id) return;
    if (gemeenten[id]?.wijken?.length) return; // al geladen
    if (dbStatus === 'offline') return;
    try {
      const g = await getGemeente(id);
      setGemeenten(prev => ({ ...prev, [id]: g }));
    } catch(e) {
      setApiError(e.message);
    }
  }, [gemeenten, dbStatus]);

  const loadSectoren = useCallback(async (id) => {
    try {
      const fc = await getSectoren(id);
      sectorenRef.current = fc?.features?.length > 0 ? fc : null;
      // Ook in state, zodat de wijkkaartjes op het tabblad Wijken opnieuw
      // tekenen zodra de sectoren binnen zijn.
      setSectorenGeo(sectorenRef.current);
      setSectorenGeladen(Date.now());
    } catch(e) {
      console.warn('Sectoren laden fout:', e.message);
      sectorenRef.current = null;
      setSectorenGeo(null);
    }
  }, []);

  useEffect(() => {
    laadGemeenteDetails(gemId);
    setSelectedWijk(null);
    sectorenRef.current = null;
    setSectorenGeo(null);
    setSectorenGeladen(0);
    // loadBestaandePalen en setView pas uitvoeren als kaart bestaat.
    // Bij eerste render vanuit dashboard bestaat de kaart nog niet;
    // de mapReady-trigger vanuit kaart-init zorgt dan voor de laadpalen.
    if (mapInstance.current) {
      loadBestaandePalen();
      if (gemeente) {
        mapInstance.current.setView(gemeente.center, gemeente.zoom, { animate:true });
      }
    }
  }, [gemId]);

  // ══════════════════════════════════════════════════════════════════
  // Gemeente toevoegen via onboarding → opslaan in DB
  // ══════════════════════════════════════════════════════════════════
  const slaEditorOp = useCallback((bijgewerkt) => {
    setGemeenten(prev => ({ ...prev, [bijgewerkt.id]: bijgewerkt }));
  }, []);

  const voegGemeenteToe = useCallback(async (nieuw, extra = {}) => {
    setSaving(true);
    setApiError('');
    let gId = nieuw.id;
    try {
      if (dbStatus === 'online') {
        // Opslaan in database
        const opgeslagen = await slaGemeenteOp(nieuw);
        setGemeenten(prev => ({ ...prev, [opgeslagen.id]: opgeslagen }));
        setGemId(opgeslagen.id);
        gId = opgeslagen.id;
      } else {
        // Offline fallback: alleen in sessie
        setGemeenten(prev => ({ ...prev, [nieuw.id]: nieuw }));
        setGemId(nieuw.id);
      }
      setHuidigLP(0);
      setShowOnboarding(false);
      // Geo onboarding + sector-koppeling op achtergrond
      // (wizard-wijken blijven ongewijzigd; dit koppelt alleen Statbel-
      // polygonen aan die wijken voor de kaartweergave)
      try {
        await onboardGemeenteGeo(gId);
        await syncWijkenVanStatbel(gId);
        await loadSectoren(gId);
      } catch(e) { console.warn('Geo sync:', e.message); }
      // Het GIS-bestand van de netbeheerder, als dat bij de onboarding is
      // gekozen. Kan pas nu, want de server bewaart het per gemeente. Lukt het
      // niet, dan staat de gemeente er wel en kan het later via Bewerken.
      if (extra?.gisBestand && dbStatus === 'online') {
        try {
          await laadGisnet(gId, extra.gisBestand);
          setGisVersie(v => v + 1);
        } catch (e) {
          console.error('GIS-bestand niet ingelezen:', e.message);
          setApiError(`Het GIS-bestand kon niet worden ingelezen: ${e.message} Het kan later alsnog via Bewerken.`);
        }
      }
    } catch(e) {
      setApiError(`Opslaan mislukt: ${e.message}`);
    }
    setSaving(false);
  }, [dbStatus, loadSectoren]);

  // ══════════════════════════════════════════════════════════════════
  // Gemeente verwijderen
  // ══════════════════════════════════════════════════════════════════
  const verwijder = useCallback(async (id) => {
    try {
      if (dbStatus === 'online') await verwijderGemeente(id);
      setGemeenten(prev => {
        const rest = { ...prev };
        delete rest[id];
        return rest;
      });
      setGemId(Object.keys(gemeenten).find(k => k !== id) || 'leuven');
    } catch(e) {
      setApiError(e.message);
    }
    setShowDelete(false);
  }, [gemeenten, dbStatus]);

  // ── invalidateSize zodra dashboard verdwijnt ──────────────────────
  // De kaart-div was verborgen (display:none); Leaflet kent de grootte
  // niet meer. invalidateSize met een korte delay lost dit op.
  // Draait ook bij het wisselen van tabblad: de kaart zit op het tabblad
  // Gemeente en is verborgen zolang een ander tabblad open staat.
  // requestAnimationFrame in plaats van setTimeout(50): het herstel valt in
  // hetzelfde beeldframe waarin het paneel zichtbaar wordt, dus er is geen
  // zichtbare vertraging of grijze kaart.
  useEffect(() => {
    if (showDashboard || tab !== 'gemeente' || !mapInstance.current) return;
    requestAnimationFrame(() => {
      if (!mapInstance.current) return;
      mapInstance.current.invalidateSize();
      if (gemeente?.center) {
        mapInstance.current.setView(gemeente.center, gemeente.zoom || 13, { animate: false });
      }
    });
  }, [showDashboard, tab]);

  // ── Sectoren laden (apart, na gemeente-switch) ─────────────────────
  useEffect(() => {
    if (!mapInstance.current) return;
    sectorenRef.current = null;
    setSectorenGeo(null);
    loadSectoren(gemId);
  }, [gemId, mapReady]);

  // ── Kaart init ─────────────────────────────────────────────────────
  // De analyseview (inclusief kaart-div) blijft altijd in de DOM.
  // Dashboard wordt als overlay getoond via display:none op de analyseview.
  // Daardoor initialiseert de kaart gewoon bij mount, één keer.
  useEffect(() => {
    if (!mapRef.current || mapInstance.current) return;
    mapInstance.current = L.map(mapRef.current, {
      center: [50.8798, 4.7005],
      zoom: 13,
      zoomControl: false,
    });
    L.control.zoom({ position:'topleft' }).addTo(mapInstance.current);
    L.tileLayer(KAART_ADRES, {
      attribution:'© OpenStreetMap © CARTO', maxZoom:19,
    }).addTo(mapInstance.current);
    // Leaflet-logo klikbaarheid uitschakelen — voorkomt politieke popup.
    // De tekstattributie (© OpenStreetMap © CARTO) blijft zichtbaar (licentievereiste).
    // Alle verwijzingen naar leafletjs.com onklikbaar maken. Eerder werd alleen
    // het vlaglogo afgevangen, maar het woord Leaflet ernaast is ook een link en
    // die opende hun website in hetzelfde venster.
    setTimeout(() => {
      mapRef.current?.querySelectorAll('.leaflet-control-attribution a').forEach(a => {
        if ((a.getAttribute('href') || '').includes('leafletjs')) {
          a.removeAttribute('href');
          a.style.pointerEvents = 'none';
          a.style.cursor = 'default';
          a.style.textDecoration = 'none';
          a.style.color = 'inherit';
        }
      });
    }, 500);
    setMapReady(true);
  }, []);

  // ── Tabblad Laadpleinen: gegevens en afgeleiden ────────────────────
  const PLEIN_KLEUR = { geschikt:N.ok, niet:N.ink4, later:N.warn, open:N.accent2 };

  // Eén keer laden zodra er een gemeente open staat. Faalt het, dan zegt het
  // scherm wat er moet gebeuren in plaats van leeg te blijven.
  useEffect(() => {
    // Laden zodra er een gemeente open staat, ongeacht het tabblad. De gekozen
    // locaties worden namelijk op vier plekken gebruikt: het tabblad
    // Laadpleinen, de kaarten op Dekking en Netcapaciteit, en de export.
    // Stond dit op een lijstje tabbladen, dan telde een export zonder eerst
    // Laadpleinen te openen nul geschikte locaties.
    if (pleinRijen !== null || !gemeente?.naam || !gemId) return;
    let afgebroken = false;
    (async () => {
      try {
        const [terreinen, oordelen] = await Promise.all([
          getLaadpleinTerreinen(gemId),
          getLaadpleinOordelen(gemId).catch(() => ({ oordelen: [] })),
        ]);
        if (afgebroken) return;
        setPleinRijen(terreinen.terreinen || []);
        setPleinOphaal(terreinen.laatstOpgehaald || null);
        setPleinFout(null);
        const kaart = {};
        (oordelen.oordelen || []).forEach(o => {
          kaart[o.locatie_id] = { status:o.status, notitie:o.notitie,
            opstelling:o.opstelling || {}, jaar:o.jaar ?? null,
            deelwagens:o.deelwagens ?? null, bestelwagens:o.bestelwagens ?? null,
            fiche:o.fiche ?? null };
        });
        setPleinOordeel(kaart);
      } catch (e) {
        if (!afgebroken) { setPleinRijen([]); setPleinFout(e.message); }
      }
    })();
    return () => { afgebroken = true; };
  }, [pleinRijen, gemeente, gemId]);

  // Opnieuw laten ophalen bij de kaartdienst. Nodig als het bij het onboarden
  // niet lukte, of om na een jaar te verversen.
  const opnieuwOphalen = useCallback(async () => {
    if (!gemId || !gemeente?.naam) return;
    setPleinBezig(true);
    setPleinFout(null);
    try {
      const uit = await haalLaadpleinTerreinenOp(gemId, gemeente.naam);
      if (!uit.gelukt) setPleinFout(uit.melding || 'Ophalen mislukt.');
      setPleinRijen(null);   // laat het laden opnieuw lopen
    } catch (e) {
      setPleinFout(e.message);
    } finally {
      setPleinBezig(false);
    }
  }, [gemId, gemeente]);

  // Bij het wisselen van gemeente moet alles opnieuw geladen worden. Het laden
  // gebeurt maar één keer per gemeente, dus zonder deze reset zouden de
  // kandidaten van de vorige gemeente blijven staan.
  useEffect(() => {
    setPleinRijen(null);
    setPleinOordeel({});
    setPleinGekozen(null);
    setPleinFout(null);
    if (pleinMap.current) { pleinMap.current._pleinGepast = false; pleinMap.current._zelf = false; pleinMap.current._stadGrens = null; }
  }, [gemId]);

  // ── GIS netbeheerder: de netgegevens van deze gemeente ophalen ─────────
  // Opnieuw na inlezen of verwijderen in Bewerken (gisVersie). Geen bestand:
  // { aanwezig:false }, en dan tonen de kaarten en lijsten niets extra.
  useEffect(() => {
    setGisNet(null); setNetAfstPlein({}); setNetAfstPaal({});
    setPlaatsNetFilter('alle');
    if (!gemId || dbStatus !== 'online') return;
    let weg = false;
    getGisnet(gemId, true)
      .then(r => { if (!weg) setGisNet(r); })
      .catch(e => {
        if (weg) return;
        console.error('Netgegevens niet opgehaald:', e.message);
        setGisNet({ aanwezig: false });
      });
    return () => { weg = true; };
  }, [gemId, gisVersie, dbStatus]);

  // De afstanden van de kandidaatlocaties. Met een bestand rekent de server ze
  // uit en bewaart ze; zonder bestand komt terug wat eerder bewaard is.
  useEffect(() => {
    if (!gemId || !gisNet || !(pleinRijen || []).length) return;
    let weg = false;
    const punten = pleinRijen.filter(r => r.lat != null && r.lng != null)
      .map(r => ({ sleutel: String(r.id), lat: r.lat, lng: r.lng }));
    berekenNetAfstanden(gemId, 'plein', punten)
      .then(r => {
        if (weg) return;
        const m = {};
        for (const a of r.afstanden || []) m[a.sleutel] = a;
        setNetAfstPlein(m);
      })
      .catch(e => console.error('Afstanden van de kandidaten niet berekend:', e.message));
    return () => { weg = true; };
  }, [gemId, gisNet, pleinRijen]);

  // Filteren gebeurt hier, zodat de kaart, de lijst en de tellers gegarandeerd
  // dezelfde verzameling gebruiken. Eén bron van waarheid voorkomt dat de kaart
  // iets anders laat zien dan de teller erboven.
  const pleinAlles = pleinRijen || [];
  const oordeelVan = (r) => pleinOordeel[r.id]?.status || 'open';
  // Op dit tabblad geen filter en geen oordeel op het net: een laadplein krijgt
  // een eigen aansluiting en mag verder van het net liggen dan een losse paal.
  // Alleen de afstanden worden getoond. Besluit HL 23 oktober 2026.
  // Eerst de filters, dan de beoordelingen die aan staan. De aantallen per
  // beoordeling links tellen over de lijst vóór die laatste stap.
  const pleinVoorStatus = React.useMemo(
    () => filterPleinen(pleinAlles, pleinOordeel, {
      minVak: pleinMinVak, toegang: pleinToegang, alleenMetLaadpunt: pleinMetLp,
      status: 'alle', soorten: pleinSoorten, nabij: pleinNabij,
    }),
    [pleinAlles, pleinOordeel, pleinMinVak, pleinToegang, pleinMetLp, pleinSoorten, pleinNabij]);
  const pleinGefilterd = React.useMemo(
    () => pleinVoorStatus.filter(r => pleinZicht[pleinOordeel[r.id]?.status || 'open']),
    [pleinVoorStatus, pleinZicht, pleinOordeel]);
  // Boven 250 kVA is een eigen cabine nodig; dan telt ook de afstand tot de
  // middenspanningskabel.
  const pleinEigenCabine = React.useCallback(
    (r) => vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling).vlag === 'cabine', [pleinOordeel]);
  const pleinHeeftNet = pleinGefilterd.some(r => netAfstPlein[String(r.id)]);
  // Is er een planbestand van Fluvius, dan krijgt de Excel vier kolommen erbij.
  const pleinHeeftPlan = !!(gisNet?.aanwezig && gisNet?.samenvatting?.plan && gisNet?.lagen);
  const planVoetTekst = () => planVoet(gisNet?.samenvatting?.plan);
  // Staat er ergens een HPC-lader, dan krijgt de Excel een kolom voor de
  // onderkant van de bandbreedte.
  const pleinKvaBand = pleinGefilterd.some(r => {
    const v = vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling);
    return v.palen && v.bandbreedte;
  });
  // Een naam voor een parking zonder naam in OpenStreetMap: de soort en de
  // dichtstbijzijnde straat binnen 150 m, bijvoorbeeld "parkeerterrein aan
  // Heuvelkouter". Zonder straat de coördinaten, zoals voorheen.
  const pleinLocatieNaam = React.useCallback((r) => {
    if (r.naam) return r.naam;
    let beste = null, besteD = 150;
    for (const p of straten) {
      if (!p.naam || Math.abs(p.lat - r.lat) > 0.002 || Math.abs(p.lng - r.lng) > 0.003) continue;
      const d = afstandMeter([r.lat, r.lng], [p.lat, p.lng]);
      if (d < besteD) { besteD = d; beste = p; }
    }
    return beste ? `${pleinSoortNaam(r).toLowerCase()} aan ${beste.naam}`
      : `${r.lat?.toFixed(5)}, ${r.lng?.toFixed(5)}`;
  }, [straten]);
  // Dezelfde naam voor op het scherm: met een hoofdletter, en zonder straat de
  // soort in plaats van coördinaten.
  const pleinNaamKort = React.useCallback((r) => {
    if (r.naam) return r.naam;
    const n = pleinLocatieNaam(r);
    return /^\d/.test(n) ? pleinSoortNaam(r) : n.charAt(0).toUpperCase() + n.slice(1);
  }, [pleinLocatieNaam]);

  const pleinVakkenTotaal = pleinGefilterd.reduce((s, r) => s + (r.vakken ?? 0), 0);
  // Hoeveel laadpleinen er nodig zijn: het deel van de bij te plaatsen punten
  // dat geclusterd wordt, gedeeld door de omvang van één plein.
  const pleinNodig = pleinenNodig(bijkomend, pleinAandeel, pleinOmvang);
  // Locaties die zijn vastgelegd voor het gekozen peiljaar of eerder staan er
  // dan al, en tellen dus mee tegen wat er voor dat jaar nodig is. Een locatie
  // zonder jaar telt mee zodra hij op geschikt staat.
  const pleinVastgelegd = pleinAlles.filter(r => {
    const o = pleinOordeel[r.id];
    if (o?.status !== 'geschikt') return false;
    return o.jaar == null || Number(o.jaar) <= year;
  }).length;
  const pleinTeKiezen = Math.max(0, pleinNodig - pleinVastgelegd);

  // ── Kerninzichten voor het Dashboard ────────────────────────────────
  // Van de laadpunten die er tot het gekozen jaar bij moeten gaat een deel naar
  // een plein en de rest wordt een losse paal. Van het pleindeel heeft alleen
  // dát stuk een concrete plek waarvoor al een terrein is goedgekeurd.
  // Tellen over de KANDIDATEN, niet over alle opgehaalde parkeerterreinen.
  // Dat laatste is het hele bestand inclusief winkelparkings, afgesloten
  // terreinen en alles wat te klein is voor een plein; daar hoeft niemand een
  // oordeel over te geven. Stond er eerst wel, waardoor de voortgangsbalk
  // "2 van 685" toonde terwijl er 63 kandidaten waren.
  // Over de kandidaten na de filters, los van welke beoordelingen links aan
  // of uit staan: dat is een kijkkeuze en mag het plan niet veranderen.
  const pleinGeschikt = pleinVoorStatus.filter(r => pleinOordeel[r.id]?.status === 'geschikt');
  // Elk goedgekeurd terrein biedt plaats aan één plein, tenzij er minder vakken
  // zijn dan een plein groot is.
  // Ruimte op de goedgekeurde terreinen. Waar een opstelling is ingevuld telt
  // die, anders de standaardomvang uit de schuifknop. Zo verandert de
  // verdeelbalk mee zodra de gemeente locaties concreet invult.
  // Laadpunten voor bestelwagens gaan eraf: ze staan er wel, maar zijn geen
  // plek voor het tekort aan personenwagens. pleinRuimteBruto is wat er
  // fysiek past, pleinRuimte wat daarvan voor personenwagens is.
  const pleinRuimteBruto = pleinGeschikt.reduce((s2, r) => {
    const v = vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling);
    return s2 + (v.palen ? v.punten : Math.min(pleinOmvang, r.vakken ?? pleinOmvang));
  }, 0);
  const pleinRuimte = pleinGeschikt.reduce((s2, r) => {
    const opst = pleinOordeel[r.id]?.opstelling;
    const v = vermogenVanOpstelling(opst);
    const best = pleinOordeel[r.id]?.bestelwagens;
    if (v.palen) {
      const p = puntenVoorPersonenwagens(opst, best);
      return s2 + p.ac + p.dc + p.hpc;
    }
    const b = bestelPuntenVan(best);
    return s2 + Math.max(0, Math.min(pleinOmvang, r.vakken ?? pleinOmvang) - b.ac - b.dc);
  }, 0);
  const pleinRuimteBestel = pleinRuimteBruto - pleinRuimte;
  // Wat er concreet is ingevuld, los van wat er theoretisch past. Dit is het
  // afstemmingsbeeld: de prognose vraagt puntenOpPlein, de ingevulde locaties
  // leveren puntenIngevuld, en het verschil moet ergens anders vandaan komen.
  const pleinIngevuldeLocaties = pleinGeschikt.filter(
    r => vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling).palen > 0);
  // Laadpunten voor deelwagens, opgeteld over de geschikt bevonden locaties.
  // Eis 5 van de leidraad van MOW. De eenheid is LAADPUNTEN, niet palen.
  const pleinDeelLocaties = pleinGeschikt.filter(r => (pleinOordeel[r.id]?.deelwagens ?? 0) > 0);
  const pleinDeelTotaal = pleinDeelLocaties.reduce(
    (s2, r) => s2 + (pleinOordeel[r.id]?.deelwagens ?? 0), 0);

  // Dekking van de gekozen locaties: wat het model vraagt tegenover wat er is
  // ingevuld, in aantallen per soort en in laadvraag. De wijk van een locatie
  // wordt bepaald met de wijkgrenzen; is er geen grens geladen, dan valt hij
  // terug op de dichtstbijzijnde wijk zoals voorheen.
  const pleinDekking = React.useMemo(() => {
    const util = {
      ac:  acUtilisatieMwhJaarV5(year, normPerJaar),
      dc:  dcUtilisatieMwhMaand(year)  * 12,
      hpc: hpcUtilisatieMwhMaand(year) * 12,
    };
    const wijkVan = (r) => wijkVanPunt(sectorenGeo, r.lat, r.lng)
      ?? (wijkResults.find(w => w.wijk.lat != null &&
           Math.hypot(w.wijk.lat - r.lat, w.wijk.lng - r.lng) < 0.05)?.wijk?.id ?? null);
    return dekkingVanLocaties({
      wijken: wijkResults.map(({ wijk, data }) => ({
        wijkId: wijk.id, naam: wijk.naam,
        delta: data.delta, mwhAC: data.mwhAC, mwhBew: data.mwhBew, mwhWerk: data.mwhWerk,
      })),
      locaties: pleinGeschikt.map(r => ({
        wijkId: wijkVan(r), opstelling: pleinOordeel[r.id]?.opstelling,
        bestelwagens: pleinOordeel[r.id]?.bestelwagens,
      })),
      pleinAandeelPct: pleinAandeel,
      util,
      bewAcAandeel: DOELGROEP_LAADTYPE.bew.ac,
    });
  }, [wijkResults, pleinGeschikt, pleinOordeel, pleinAandeel, year, sectorenGeo]);
  const puntenOpPlein   = Math.round(bijkomend * (pleinAandeel / 100));
  const puntenLossePaal = Math.max(0, Math.round(bijkomend) - puntenOpPlein);
  const puntenMetPlek   = Math.min(pleinRuimte, puntenOpPlein);
  const puntenZonderPlek = Math.max(0, puntenOpPlein - puntenMetPlek);
  // Vergelijken met 'open' en niet op aanwezigheid toetsen: sinds een locatie
  // met een ingevulde opstelling bewaard blijft met status 'open', zou een
  // waarheidstoets die locatie als beoordeeld tellen.
  const pleinBeoordeeldTotaal = pleinVoorStatus.filter(r => oordeelVan(r) !== 'open').length;
  const pleinAfgevallen = pleinVoorStatus.filter(r => pleinOordeel[r.id]?.status === 'niet').length;

  // Oordeel opslaan. De schermtoestand gaat meteen mee zodat het klikken vlot
  // aanvoelt; mislukt het opslaan, dan draait hij terug en verschijnt de fout.
  const zetOordeel = useCallback(async (locatieId, status, notitie) => {
    if (!locatieId || !gemId) return;
    const vorige = pleinOordeel[locatieId];
    setPleinOordeel(h => {
      const n = { ...h };
      // Bij 'open' gaat alleen de beoordeling terug. Staat er een opstelling of
      // een aantal laadpunten voor deelwagens, dan blijft de rij bestaan;
      // anders verdwijnt de locatie uit de lijst zoals voorheen, zodat een
      // verkeerde klik spoorloos terug te draaien is. Zelfde regel als op de
      // server, anders lopen scherm en opslag uiteen.
      const opstelling = h[locatieId]?.opstelling || {};
      const deelwagens = h[locatieId]?.deelwagens ?? null;
      const bestel = h[locatieId]?.bestelwagens || null;
      const heeftBestel = !!(bestel && ((bestel.ac || 0) > 0 || (bestel.dc || 0) > 0));
      if (status === 'open' && !Object.keys(opstelling).length && !(deelwagens > 0)
          && !heeftBestel && !h[locatieId]?.fiche) delete n[locatieId];
      else n[locatieId] = { ...(h[locatieId] || {}), status,
                            notitie: notitie ?? h[locatieId]?.notitie ?? null,
                            opstelling, deelwagens, jaar: h[locatieId]?.jaar ?? null };
      return n;
    });
    try {
      await zetLaadpleinOordeel(gemId, locatieId, status, notitie ?? vorige?.notitie ?? null);
    } catch (e) {
      setPleinOordeel(h => {
        const n = { ...h };
        if (vorige) n[locatieId] = vorige; else delete n[locatieId];
        return n;
      });
      setPleinFout(`Opslaan mislukt: ${e.message}`);
    }
  }, [gemId, pleinOordeel]);

  // De opstelling opslaan. Een locatie die nog geen beoordeling heeft, krijgt
  // 'later': hetzelfde wat er gebeurt als je alleen een notitie achterlaat.
  const zetOpstelling = useCallback(async (locatieId, opstelling) => {
    if (!locatieId || !gemId) return;
    const vorige = pleinOordeel[locatieId];
    const status = vorige?.status || 'later';
    setPleinOordeel(h => ({ ...h,
      [locatieId]: { ...(h[locatieId] || {}), status, notitie: vorige?.notitie ?? null, opstelling } }));
    try {
      await zetLaadpleinOordeel(gemId, locatieId, status, vorige?.notitie ?? null, opstelling);
    } catch (e) {
      setPleinOordeel(h => {
        const n = { ...h };
        if (vorige) n[locatieId] = vorige; else delete n[locatieId];
        return n;
      });
      setPleinFout(`Opslaan mislukt: ${e.message}`);
    }
  }, [gemId, pleinOordeel]);

  // Het aantal LAADPUNTEN dat op deze locatie voor deelwagens wordt
  // voorbehouden. Let op het verschil met de opstelling hierboven: die telt
  // PALEN. De twee tellen niet bij elkaar op; een laadpunt voor deelwagens zit
  // binnen de opstelling. Zelfde opzet als zetOpstelling: een locatie zonder
  // beoordeling krijgt 'later'.
  const zetDeelwagens = useCallback(async (locatieId, aantal) => {
    if (!locatieId || !gemId) return;
    const vorige = pleinOordeel[locatieId];
    const status = vorige?.status || 'later';
    setPleinOordeel(h => ({ ...h,
      [locatieId]: { ...(h[locatieId] || {}), status, notitie: vorige?.notitie ?? null,
                     deelwagens: aantal } }));
    try {
      await zetLaadpleinOordeel(gemId, locatieId, status, vorige?.notitie ?? null,
        undefined, undefined, aantal);
    } catch (e) {
      setPleinOordeel(h => {
        const n = { ...h };
        if (vorige) n[locatieId] = vorige; else delete n[locatieId];
        return n;
      });
      setPleinFout(`Opslaan mislukt: ${e.message}`);
    }
  }, [gemId, pleinOordeel]);

  // De laadpunten voor bestelwagens op deze locatie, AC en DC apart. Telt net
  // als deelwagens LAADPUNTEN binnen de opstelling. Zelfde opzet als
  // zetDeelwagens.
  const zetBestelwagens = useCallback(async (locatieId, soort, aantal) => {
    if (!locatieId || !gemId) return;
    const vorige = pleinOordeel[locatieId];
    const status = vorige?.status || 'later';
    const nu = { ac: vorige?.bestelwagens?.ac || 0, dc: vorige?.bestelwagens?.dc || 0, [soort]: aantal };
    const waarde = (nu.ac || nu.dc) ? nu : null;
    setPleinOordeel(h => ({ ...h,
      [locatieId]: { ...(h[locatieId] || {}), status, notitie: vorige?.notitie ?? null,
                     bestelwagens: waarde } }));
    try {
      await zetLaadpleinOordeel(gemId, locatieId, status, vorige?.notitie ?? null,
        undefined, undefined, undefined, undefined, waarde);
    } catch (e) {
      setPleinOordeel(h => {
        const n2 = { ...h };
        if (vorige) n2[locatieId] = vorige; else delete n2[locatieId];
        return n2;
      });
      setPleinFout(`Opslaan mislukt: ${e.message}`);
    }
  }, [gemId, pleinOordeel]);

  // Het technisch fiche van een locatie. Zelfde opzet als zetOpstelling: het
  // scherm loopt vooruit, en mislukt het bewaren dan komt de vorige toestand
  // terug met een melding erbij. Een locatie zonder beoordeling zou hier niet
  // moeten voorkomen, want de ingang staat alleen onder een geschikte locatie;
  // valt hij er toch, dan blijft dezelfde regel gelden als bij de opstelling.
  const zetPleinFiche = useCallback(async (locatieId, fiche) => {
    if (!locatieId || !gemId) return false;
    const vorige = pleinOordeel[locatieId];
    const status = vorige?.status || 'geschikt';
    setPleinOordeel(h => ({ ...h,
      [locatieId]: { ...(h[locatieId] || {}), status, fiche } }));
    try {
      await zetLaadpleinOordeel(gemId, locatieId, status, vorige?.notitie ?? null,
        undefined, undefined, undefined, fiche);
      return true;
    } catch (e) {
      setPleinOordeel(h => {
        const n = { ...h };
        if (vorige) n[locatieId] = vorige; else delete n[locatieId];
        return n;
      });
      setFicheFout(`Bewaren mislukt: ${e.message}`);
      return false;
    }
  }, [gemId, pleinOordeel]);

  // De dichtstbijzijnde straatnaam bij een punt. De straatpunten liggen om de
  // 25 meter, dus binnen 300 meter is er bij een gekarteerde gemeente altijd
  // een treffer. Zijn de straatnamen niet opgehaald, dan komt er niets terug en
  // valt de kop van het venster terug op de naam van de locatie zelf.
  const straatBij = useCallback((lat, lng) => {
    if (!Number.isFinite(lat) || !Number.isFinite(lng) || !straten.length) return '';
    let beste = null, besteAfstand = Infinity;
    for (const s of straten) {
      if (!s.naam) continue;
      const dLat = (s.lat - lat) * 111320;
      const dLng = (s.lng - lng) * 111320 * Math.cos(lat * Math.PI / 180);
      const d = dLat * dLat + dLng * dLng;
      if (d < besteAfstand) { besteAfstand = d; beste = s.naam; }
    }
    return besteAfstand <= 300 * 300 ? beste : '';
  }, [straten]);

  // Het venster openen op een locatie. Staat er al een schets, dan komt die
  // terug zoals hij bewaard is; anders begint het venster leeg.
  const openFiche = useCallback((locatie) => {
    if (!locatie) return;
    setFicheOpen(locatie.id);
    const bewaard = pleinOordeel[locatie.id]?.fiche;
    const rijen = (bewaard?.rijen || [])
      .filter(r => r?.punten?.length === 4)
      .map(r => ({ punten: r.punten, aantal: r.aantal || 1,
                   breedte: r.breedte ?? 2.5, diepte: r.diepte ?? 5.0,
                   schuinte: r.schuinte ?? 0 }));
    setFicheWerk({ rijen, vakken: bewaard?.vakken || [], doelen: bewaard?.doelen || {},
                   palen: bewaard?.palen || [], cabine: bewaard?.cabine || null,
                   aansluiting: bewaard?.aansluiting || null });
    setFicheRijNr(rijen.length ? 0 : -1);
    setFicheModus('rijen');
    setFicheDeel('A');
    setFicheFout(null);
  }, [pleinOordeel]);

  const sluitFiche = useCallback(() => {
    setFicheOpen(null);
    setFicheWerk(null);
    setFicheRijNr(-1);
    setFicheFout(null);
  }, []);

  // Een rij erbij, tien vakken van 2,5 bij 5,0 meter. De eerste komt midden op
  // de locatie, elke volgende acht meter eronder zodat hij niet op de vorige
  // valt en meteen aan te pakken is.
  const rijToevoegen = useCallback(() => {
    const locatie = (pleinAlles || []).find(r => r.id === ficheOpen);
    if (!locatie || !Number.isFinite(locatie.lat)) return;
    setFicheWerk(huidig => {
      const rijen = huidig?.rijen || [];
      const naarBeneden = rijen.length * 8;
      const midden = naarGraden([0, -naarBeneden], [locatie.lat, locatie.lng]);
      const nieuweR = bouwRij({ midden, richting: 0, aantal: 10,
                                breedte: 2.5, diepte: 5.0, schuinte: 0 });
      return { ...(huidig || { vakken: [], doelen: {}, palen: [], cabine: null }),
               rijen: [...rijen, nieuweR] };
    });
    // De nieuwe rij is meteen de rij die bewerkt wordt.
    setFicheRijNr(ficheWerk?.rijen?.length ?? 0);
    setFicheModus('rijen');
    setFicheFout(null);
  }, [pleinAlles, ficheOpen, ficheWerk]);

  // Een rij weghalen. De aangewezen vakken van die rij vervallen en die van de
  // rijen erna schuiven één nummer op. De palen blijven staan waar ze staan.
  const rijVerwijderen = useCallback((nr) => {
    setFicheWerk(huidig => {
      if (!huidig || !huidig.rijen[nr]) return huidig;
      return { ...huidig,
        rijen: huidig.rijen.filter((_, i) => i !== nr),
        vakken: vakkenNaVerwijderen(huidig.vakken, nr),
        doelen: doelenNaVerwijderen(huidig.doelen, nr) };
    });
    setFicheRijNr(oud2 => Math.max(-1, oud2 > nr ? oud2 - 1 : Math.min(oud2, nr - 1)));
    setFicheFout(null);
  }, []);

  // Het aantal vakken verdeelt de rij alleen opnieuw. Breedte, diepte en
  // schuinte maken er een nette rechthoek van, om hetzelfde middelpunt en in
  // dezelfde richting. Wordt een rij korter, dan vervallen de aangewezen
  // vakken die er niet meer zijn.
  const zetFicheVeld = useCallback((veld, waarde) => {
    setFicheWerk(huidig => {
      const rij = huidig?.rijen?.[ficheRijNr];
      if (!rij) return huidig;
      const maat = maatVanRij(rij);
      const nu = {
        midden: middenVanRij(rij), richting: richtingVanRij(rij),
        aantal: rij.aantal, breedte: maat.breedte, diepte: maat.diepte,
        schuinte: rij.schuinte || 0,
      };
      if (veld === 'aantal') nu.aantal = Math.max(1, Math.min(200, Math.round(waarde) || 1));
      else if (veld === 'schuinte') nu.schuinte = Math.max(-60, Math.min(60, Math.round(waarde) || 0));
      else nu[veld] = waarde;
      if (!(nu.breedte > 0) || !(nu.diepte > 0)) return huidig;
      const nieuweR = bouwRij(nu);
      return { ...huidig,
        rijen: huidig.rijen.map((r, i) => i === ficheRijNr ? nieuweR : r),
        vakken: huidig.vakken.filter(sleutel => {
          const [r, v] = sleutel.split(':').map(Number);
          return r !== ficheRijNr || v < nieuweR.aantal;
        }),
        doelen: Object.fromEntries(Object.entries(huidig.doelen || {}).filter(([sleutel]) => {
          const [r, v] = sleutel.split(':').map(Number);
          return r !== ficheRijNr || v < nieuweR.aantal;
        })) };
    });
  }, [ficheRijNr]);

  // Een vak voorbehouden aan laden, een deelwagen of een bestelwagen, of die
  // keuze weer terugnemen. Een klik met hetzelfde doel als het vak al heeft
  // maakt het vrij; een klik met een ander doel zet het om.
  const wisselVak = useCallback((rijNr, vakNr) => {
    setFicheWerk(huidig => {
      if (!huidig) return huidig;
      const sleutel = vakSleutel(rijNr, vakNr);
      const erin = huidig.vakken.includes(sleutel);
      const doelen = { ...(huidig.doelen || {}) };
      const nu = erin ? (doelen[sleutel] || 'laden') : null;
      if (nu === ficheDoel) {
        delete doelen[sleutel];
        return { ...huidig, vakken: huidig.vakken.filter(x => x !== sleutel), doelen };
      }
      if (ficheDoel === 'laden') delete doelen[sleutel]; else doelen[sleutel] = ficheDoel;
      return { ...huidig, vakken: erin ? huidig.vakken : [...huidig.vakken, sleutel], doelen };
    });
  }, [ficheDoel]);

  // Een paal op de dichtstbijzijnde scheiding tussen twee vakken. Staat daar al
  // een paal, dan haalt de klik hem juist weg.
  const zetPaal = useCallback((punt) => {
    setFicheWerk(huidig => {
      if (!huidig) return huidig;
      const bestaand = huidig.palen.findIndex(
        p => afstandMeter(punt, [p.lat, p.lng]) < 2.5);
      if (bestaand >= 0) {
        return { ...huidig, palen: huidig.palen.filter((_, i) => i !== bestaand) };
      }
      const plek = dichtstePunt(punt, scheidingPunten(huidig.rijen));
      if (!plek) return huidig;
      return { ...huidig,
        palen: [...huidig.palen, { soort: fichePaal, lat: plek.lat, lng: plek.lng }] };
    });
  }, [fichePaal]);

  // De cabine erbij of eraf. Hij komt bij de snelladers te staan en is daarna
  // met de muis te verzetten.
  const wisselCabine = useCallback(() => {
    setFicheWerk(huidig => {
      if (!huidig) return huidig;
      if (huidig.cabine) return { ...huidig, cabine: null };
      // Onder 25 kVA komt de aansluiting altijd op laagspanning; een eigen
      // cabine is daar niet aan de orde (fiche V2).
      const vlag = vermogenVanOpstelling(telPalen(huidig.palen)).vlag;
      if (vlag !== 'studie' && vlag !== 'cabine') return huidig;
      const plek = cabinePlek(huidig.palen, huidig.rijen);
      return plek ? { ...huidig, cabine: plek } : huidig;
    });
  }, []);

  // De soort aansluitpunt kiezen, of bij een zelf aangewezen punt het punt.
  const kiesAansluiting = useCallback((soort, punt = null) => {
    setFicheWerk(huidig => {
      if (!huidig) return huidig;
      const vorige = huidig.aansluiting;
      if (soort === 'vrij') {
        // Terug naar het eigen punt: het eerder aangeklikte punt blijft bewaard.
        const p = punt || (vorige?.soort === 'vrij' && vorige.lat != null ? [vorige.lat, vorige.lng]
                           : huidig._vrij || null);
        return { ...huidig, aansluiting: p ? { soort, lat: p[0], lng: p[1] } : { soort },
                 _vrij: p || huidig._vrij || null };
      }
      return { ...huidig, aansluiting: { soort },
               _vrij: vorige?.soort === 'vrij' && vorige.lat != null ? [vorige.lat, vorige.lng] : huidig._vrij || null };
    });
  }, []);

  const verzetCabine = useCallback((punt) => {
    setFicheWerk(huidig => huidig
      ? { ...huidig, cabine: { lat: punt[0], lng: punt[1] } } : huidig);
  }, []);

  // ── Aansluiting op het net (fiche V2, deel B) ──────────────────────────
  // Het beginpunt van de lijn: het midden van de ingetekende rijen, anders het
  // midden van het parkeerterrein. Ook de netgegevens op het fiche worden van
  // hier gemeten, zodat de afstanden in deel A en deel B gelijk zijn.
  const ficheStart = React.useMemo(() => {
    if (!ficheOpen) return null;
    const punten = (ficheWerk?.rijen || []).flatMap(r => r.punten || []);
    if (punten.length) {
      return [punten.reduce((a, p) => a + p[0], 0) / punten.length,
              punten.reduce((a, p) => a + p[1], 0) / punten.length];
    }
    const loc = pleinAlles.find(r => r.id === ficheOpen);
    return loc && Number.isFinite(loc.lat) ? [loc.lat, loc.lng] : null;
  }, [ficheOpen, ficheWerk?.rijen, pleinAlles]);
  const ficheNetPunten = React.useMemo(
    () => (gisNet?.aanwezig ? dichtsteNetpunten(ficheStart, gisNet.lagen) : {}),
    [ficheStart, gisNet]);
  // Wat het plan van Fluvius zegt over deze plek, vanaf hetzelfde punt.
  const fichePlan = React.useMemo(
    () => (gisNet?.aanwezig && gisNet?.samenvatting?.plan ? planSignalen(ficheStart, gisNet.lagen) : null),
    [ficheStart, gisNet]);
  const ficheVlag = vermogenVanOpstelling(telPalen(ficheWerk?.palen)).vlag;
  // De middenspanningskabel en een eigen cabine alleen vanaf 25 kVA.
  const ficheMsMag = ficheVlag === 'studie' || ficheVlag === 'cabine';
  // De soort die geldt: de gekozen soort, of anders een voor de hand liggende.
  // Zonder netbestand kan alleen een zelf aangewezen punt.
  const ficheAansluiting = React.useMemo(() => {
    if (!ficheOpen) return null;
    const metNet = !!gisNet?.aanwezig;
    const standaard = metNet ? (ficheMsMag ? 'dc' : 'v400') : 'vrij';
    const gekozen = ficheWerk?.aansluiting;
    let soort = gekozen?.soort || standaard;
    if (!metNet && soort !== 'vrij') soort = 'vrij';
    if (soort === 'ms' && !ficheMsMag) soort = standaard;
    const naam = (AANSLUIT_SOORTEN.find(([k]) => k === soort) || [])[1] || '';
    if (soort === 'vrij') {
      if (gekozen?.soort === 'vrij' && gekozen.lat != null && ficheStart) {
        return { soort, naam, lat: gekozen.lat, lng: gekozen.lng,
                 d: Math.round(meterTussen(ficheStart, [gekozen.lat, gekozen.lng])) };
      }
      return { soort, naam, leeg: true };
    }
    const p = ficheNetPunten[soort];
    return p ? { soort, naam, ...p } : { soort, naam, leeg: true };
  }, [ficheOpen, gisNet, ficheMsMag, ficheWerk?.aansluiting, ficheStart, ficheNetPunten]);

  // Het fiche als PDF. De schets gaat mee zoals hij in beeld staat, samen met
  // de kengetallen die het scherm al heeft uitgerekend. De server tekent alleen
  // en rekent niets, zodat bestand en scherm nooit uiteen kunnen lopen.
  const [fichePdfBezig, setFichePdfBezig] = useState(false);
  const ficheAlsPdf = useCallback(async () => {
    const locatie = (pleinAlles || []).find(r => r.id === ficheOpen);
    if (!locatie || !ficheWerk) return;
    const oordeel = pleinOordeel[ficheOpen] || {};
    // Het vermogen volgt de TEKENING, niet de opstelling in het venster. Er
    // staat maar één bron op het fiche, anders kan er een aansluitvermogen op
    // komen te staan dat bij een ander aantal palen hoort dan er getekend is.
    const paalTelling2 = telPalen(ficheWerk.palen);
    const vermogen = vermogenVanOpstelling(paalTelling2);
    const straat = straatBij(locatie.lat, locatie.lng);
    const vakkenPerRij = (ficheWerk.rijen || []).map(r => vakkenVanRij(r));
    const vakkenTotaal2 = (ficheWerk.rijen || []).reduce((n, r) => n + (r.aantal || 0), 0);
    const paalT = paalTelling2;
    const aangewezen2 = new Set(ficheWerk.vakken || []);
    const telDoel = (doel) => Object.entries(ficheWerk.doelen || {})
      .filter(([sleutel, d]) => d === doel && aangewezen2.has(sleutel)).length;
    const netregel = vermogen.vlag === 'cabine' ? 'eigen cabine op middenspanning nodig'
      : vermogen.vlag === 'studie' ? 'Fluvius beslist na een studie: laagspanning of middenspanning'
      : vermogen.vlag === 'geen' ? 'laagspanning, zonder studie' : null;
    // De bestaande laadpunten binnen een straal rond het plein, als [lat, lng].
    function bestaandBij(straal) {
      if (!ficheStart) return [];
      return existingPalen
        .map(el => [el.lat ?? el.center?.lat, el.lon ?? el.center?.lon])
        .filter(p => p[0] != null && p[1] != null && meterTussen(ficheStart, p) <= straal);
    }
    // Wat bladzijde 2 nodig heeft. Het net wordt bijgesneden tot de omgeving
    // van het plein en de aansluiting, anders gaat het hele net van de gemeente
    // mee in het verzoek.
    function netVoorPdf() {
      if (!ficheStart) return null;
      const metNet = !!gisNet?.aanwezig;
      const np = ficheNetPunten;
      const kader = ['dc', 'vk', 'v400'].map(k => np[k]).filter(Boolean).map(p => [p.lat, p.lng]);
      const a = ficheAansluiting && !ficheAansluiting.leeg ? ficheAansluiting : null;
      const alle = [ficheStart, ...kader, ...(a ? [[a.lat, a.lng]] : [])];
      // Ruim om alles heen: de kaart op de bladzijde wordt breder dan hoog.
      const lats = alle.map(p => p[0]), lngs = alle.map(p => p[1]);
      const mLat = 0.004 + (Math.max(...lats) - Math.min(...lats)) * 0.6;
      const mLng = 0.007 + (Math.max(...lngs) - Math.min(...lngs)) * 0.9;
      const binnen = (p) => p[0] >= Math.min(...lats) - mLat && p[0] <= Math.max(...lats) + mLat
                          && p[1] >= Math.min(...lngs) - mLng && p[1] <= Math.max(...lngs) + mLng;
      const lagen = {};
      if (metNet) {
        for (const k of ['v400', 'v230', 'vonb', 'ms']) {
          if (ficheNetZicht[k] === false) continue;
          lagen[k] = (gisNet.lagen?.[k] || []).filter(l => l.some(binnen));
        }
        for (const k of ['dc', 'kc', 'vk']) {
          if (ficheNetZicht[k] === false) continue;
          lagen[k] = (gisNet.lagen?.[k] || []).filter(binnen);
        }
      }
      const afst = (k) => (np[k] ? `${fmtN(np[k].d)} m` : null);
      const peil = peildatumLang(gisNet?.peildatum);
      return {
        titel: `${gemeente?.naam || ''}, Technisch fiche ${straat || locatie.naam || 'parkeerterrein'}, aansluiting op het net`,
        regels: [
          ['Locatie', [straat || locatie.naam, gemeente?.naam].filter(Boolean).join(', ')],
          ['Laadpalen', (ficheWerk.palen || []).length ? palenTekst(paalT) : 'nog geen palen'],
          ['Aansluitvermogen', vermogen.palen
            ? (vermogen.bandbreedte ? `${fmtN(vermogen.kvaMin)} tot ${fmtN(vermogen.kvaMax)} kVA` : `${fmtN(vermogen.kvaMax)} kVA`)
            : null],
          ['Netaansluiting', netregel],
          ['Aangesloten op', a ? a.naam : 'nog niet aangewezen'],
          ['Afstand, hemelsbreed', a ? `${fmtN(a.d)} m` : null],
        ].filter(r => r[1] != null && r[1] !== ''),
        netgegevens: metNet ? [
          ['Straatkabel 400 V', afst('v400')], ['MS-cabine Fluvius', afst('dc')],
          ['Verdeelkast', afst('vk')], ...(ficheMsMag ? [['Middenspanningskabel', afst('ms')]] : []),
        ].filter(r => r[1]) : [],
        metNet,
        lagen,
        bestaand: ficheNetZicht.best === false ? [] : bestaandBij(2500).filter(binnen),
        start: ficheStart,
        kader,
        aansluiting: a ? { soort: a.soort, lat: a.lat, lng: a.lng, afstand: a.d } : null,
        opmerking: metNet ? NET_OPMERKING : null,
        // De regels van het plan van Fluvius, onder de netgegevens. De lagen
        // zelf niet, om de kaart leesbaar te houden (mockup Plan van Fluvius V1).
        plan: fichePlan && fichePlan.regels.length
          ? { regels: fichePlan.regels.map(([soort, , tekst]) => [soort, tekst]), voet: planVoet(gisNet?.samenvatting?.plan) } : null,
        voet: [metNet ? `Netgegevens: Fluvius${gisNet?.bestandsnaam ? `, ${gisNet.bestandsnaam}` : ''}${peil ? `, peildatum ${peil}` : ''}.` : '',
               gisNet?.samenvatting?.plan ? `Plan: Fluvius, planbestand, aangemaakt op ${peildatumLang(gisNet.samenvatting.plan.peildatum)}.` : '',
               'Bestaande laadpunten: MOW.'].filter(Boolean).join(' '),
      };
    }
    setFichePdfBezig(true);
    setFicheFout(null);
    try {
      await downloadFichePdf({
        gemeenteId: gemId, gemeente: gemeente?.naam, onderwerp: 'technisch-fiche',
        titel: `${gemeente?.naam || ''}, Technisch fiche ${straat || locatie.naam || 'parkeerterrein'}`,
        lat: locatie.lat, lng: locatie.lng,
        regels: [
          ['Locatie', [straat || locatie.naam, gemeente?.naam].filter(Boolean).join(', ')],
          ['Vastgelegd voor', oordeel.jaar ? String(oordeel.jaar) : 'nog niet vastgelegd'],
          ['Parkeervakken op het terrein', locatie.vakken != null ? fmtN(locatie.vakken) : null],
          ['Ingetekend', `${fmtN(ficheWerk.rijen.length)} ${ficheWerk.rijen.length === 1 ? 'rij' : 'rijen'}, ${fmtN(vakkenTotaal2)} ${vakkenTotaal2 === 1 ? 'vak' : 'vakken'}`],
          ['Voorbehouden aan laden', `${fmtN(ficheWerk.vakken.length)} ${ficheWerk.vakken.length === 1 ? 'vak' : 'vakken'}`],
          ['Waarvan voor deelwagens', telDoel('deel') ? `${fmtN(telDoel('deel'))} ${telDoel('deel') === 1 ? 'vak' : 'vakken'}` : null],
          ['Waarvan voor bestelwagens', telDoel('bestel') ? `${fmtN(telDoel('bestel'))} ${telDoel('bestel') === 1 ? 'vak' : 'vakken'}` : null],
          ['Laadpalen', (ficheWerk.palen || []).length ? palenTekst(paalT) : 'nog geen palen'],
          ['Laadpunten', vermogen.palen
            ? `${fmtN(vermogen.punten)}${(oordeel.deelwagens ?? 0) > 0 ? `, waarvan ${fmtN(oordeel.deelwagens)} voor deelwagens` : ''}`
            : null],
          ['Aansluitvermogen', vermogen.palen
            ? (vermogen.bandbreedte ? `${fmtN(vermogen.kvaMin)} tot ${fmtN(vermogen.kvaMax)} kVA` : `${fmtN(vermogen.kvaMax)} kVA`)
            : null],
          ['Netaansluiting', netregel],
        ].filter(r => r[1] != null && r[1] !== ''),
        // De aansluitwaarden waarmee het aansluitvermogen hierboven is berekend,
        // uit dezelfde plek als de berekening zelf. Vervangt de losse regel
        // Peildatum, die las als de datum van het hele fiche.
        aansluitwaarden: {
          regels: [
            ...Object.entries(PAAL_VERMOGEN).map(([soort, p]) => [
              `Laadpaal ${soort.toUpperCase()}, ${p.aansluiting}`,
              p.kvaMin === p.kvaMax
                ? `${String(p.kvaMax).replace('.', ',')} kVA`
                : `${String(p.kvaMin).replace('.', ',')} tot ${String(p.kvaMax).replace('.', ',')} kVA`,
            ]),
            ['Fluvius beslist na een studie', `${KVA_STUDIE} tot ${KVA_CABINE} kVA`],
            ['Eigen cabine nodig', `boven ${KVA_CABINE} kVA`],
          ],
          voet: `Vastgesteld in ${VERMOGEN_PEILDATUM}.`,
        },
        schets: {
          rijen: ficheWerk.rijen, vakken: ficheWerk.vakken, doelen: ficheWerk.doelen || {},
          vakkenPerRij, palen: ficheWerk.palen, cabine: ficheWerk.cabine,
          kabels: kabelTraces(ficheWerk.palen, ficheWerk.rijen, ficheWerk.cabine),
          // De bestaande laadpunten dichtbij; de rest valt toch buiten beeld.
          bestaand: bestaandBij(400),
        },
        // Bladzijde 2: de aansluiting op het net (fiche V2).
        net: netVoorPdf(),
        meta2: { locatie: locatie.id, rijen: ficheWerk.rijen.length, vakken: vakkenTotaal2 },
      });
    } catch (e) {
      setFicheFout(`De PDF kon niet worden gemaakt: ${e.message}`);
    } finally {
      setFichePdfBezig(false);
    }
  }, [pleinAlles, ficheOpen, ficheWerk, pleinOordeel, gemId, gemeente, straatBij,
      ficheStart, ficheNetPunten, ficheAansluiting, ficheMsMag, gisNet, ficheNetZicht, existingPalen, fichePlan]);

  const bewaarFiche = useCallback(async () => {
    if (!ficheOpen) return;
    const rijen = ficheWerk?.rijen || [];
    const bezwaar = ficheBezwaarAlle(rijen);
    if (bezwaar) { setFicheFout(bezwaar); return; }
    setFicheBezig(true);
    setFicheFout(null);
    // De aansluiting alleen als er bewust een is gekozen, met het punt erbij
    // zoals het nu op de kaart staat.
    const aansl = ficheWerk?.aansluiting && ficheAansluiting
      ? (ficheAansluiting.leeg ? { soort: ficheAansluiting.soort }
         : { soort: ficheAansluiting.soort, lat: ficheAansluiting.lat, lng: ficheAansluiting.lng })
      : null;
    const fiche = rijen.length || (ficheWerk?.palen || []).length || ficheWerk?.cabine || aansl ? {
      rijen: rijen.map(r => {
        const maat = maatVanRij(r);
        return { punten: r.punten, aantal: r.aantal,
                 breedte: Math.round(maat.breedte * 10) / 10,
                 diepte:  Math.round(maat.diepte * 10) / 10,
                 schuinte: Math.round(r.schuinte || 0) };
      }),
      vakken: ficheWerk.vakken || [],
      doelen: ficheWerk.doelen || {},
      palen: ficheWerk.palen || [],
      cabine: ficheWerk.cabine || null,
      aansluiting: aansl,
      bewerkt: new Date().toISOString(),
    } : null;
    const gelukt = await zetPleinFiche(ficheOpen, fiche);
    setFicheBezig(false);
    // Besluit HL 26 oktober 2026: na Bewaren blijft het fiche open, zodat
    // verder getekend kan worden. Sluiten gaat met de knop Sluiten.
    if (gelukt) {
      setFicheBewaard(true);
      setTimeout(() => setFicheBewaard(false), 2500);
    }
  }, [ficheOpen, ficheWerk, zetPleinFiche, ficheAansluiting]);

  // Het peiljaar waarvoor een locatie is vastgelegd. Leeg betekent nog niet
  // vastgelegd; die locatie telt dan mee in het eerste jaar van de periode.
  const zetPleinJaar = useCallback(async (locatieId, jaar) => {
    if (!locatieId || !gemId) return;
    const vorige = pleinOordeel[locatieId];
    const status = vorige?.status || 'geschikt';
    setPleinOordeel(h => ({ ...h,
      [locatieId]: { ...(h[locatieId] || {}), status, jaar } }));
    try {
      await zetLaadpleinOordeel(gemId, locatieId, status, vorige?.notitie ?? null,
        undefined, jaar);
    } catch (e) {
      setPleinOordeel(h => {
        const n = { ...h };
        if (vorige) n[locatieId] = vorige; else delete n[locatieId];
        return n;
      });
      setPleinFout(`Opslaan mislukt: ${e.message}`);
    }
  }, [gemId, pleinOordeel]);

  // De uitvoer naar Excel. Vijf bladen: het overzicht opent met dezelfde
  // getallen als het scherm, daarna de gegevens per jaar, per wijk en per
  // locatie, en tot slot de toelichting. De aansluitwaarden staan als getal in
  // het bestand, zodat er in Excel mee gerekend kan worden.
  const exporteerNetcapaciteit = async (regels, binnen, nadien, begin, eind, slimAan) => {
    setNetcapFout(null);
    // De kaart als afbeelding voor het overzichtsblad. Lukt dat niet, dan gaat
    // het bestand gewoon door zonder kaart.
    let kaartPng = null;
    try {
      const svg = stadskaartSvg(sectorenGeo, (gemeente?.wijken || []), netcapVermogenVanWijk,
        gekozenLocaties, 900, 400, netcapKaartOptiesRapport);
      if (svg) kaartPng = await svgNaarPng(svg, 1400);
    } catch (e) {
      console.error('Kaart voor de Excel overgeslagen:', e.message);
    }
    const som   = (rs, veld) => rs.reduce((a, r) => a + (r[veld] || 0), 0);
    const soort = (rs, s) => rs.reduce((a, r) => a + (r.palen[s] || 0), 0);
    const palen = rs => soort(rs,'ac') + soort(rs,'dc') + soort(rs,'hpc');
    // Van de palen het deel dat op een gekozen laadplein staat.
    const opPlein = rs => palen(rs) - som(rs,'palenZonderLocatie');
    // Het bestand mag nooit iets anders zeggen dan het scherm: staat slim laden
    // ergens aan, dan gaan ook de kolommen in de export over het scenario.
    const kvaVeld = slimAan ? 'kvaSlimMax' : 'kvaMax';
    // Het percentage van een wijk staat op elke regel van die wijk; de eerste
    // volstaat. Als getal tussen 0 en 1, dus maal honderd voor de kolom.
    const slimPct = rs => Math.round(((rs[0]?.slimAandeel) || 0) * 100);
    const slimKol = (kolommen) => slimAan ? kolommen : [];
    const rijJaar = (label, rs) => ({
      jaar: label, ac: soort(rs,'ac'), dc: soort(rs,'dc'), hpc: soort(rs,'hpc'),
      samen: palen(rs), opPlein: opPlein(rs), kva: som(rs, kvaVeld),
      ...(slimAan ? { kvaZonder: som(rs,'kvaMax') } : {}),
    });
    const jaren = [...new Set(binnen.map(r => r.jaar))].sort();
    const wijken = [...new Set(binnen.map(r => r.gebiedNaam))]
      .map(naam => ({ naam, rs: binnen.filter(r => r.gebiedNaam === naam) }))
      .sort((a, b) => som(b.rs, kvaVeld) - som(a.rs, kvaVeld));

    const kolJaar = [
      { titel:'Jaar',            veld:'jaar',  breedte:18, soort:'tekst', uitleg:'Het jaar waarin deze laadpalen bijkomen.' },
      { titel:'Gewone paal',     veld:'ac',    breedte:14, soort:'getal', uitleg:`Aantal gewone laadpalen. Elk ${String(PAAL_VERMOGEN.ac.kvaMax).replace('.', ',')} kVA.` },
      { titel:'Snellader',       veld:'dc',    breedte:12, soort:'getal', uitleg:`Aantal snelladers. Elk ${String(PAAL_VERMOGEN.dc.kvaMax).replace('.', ',')} kVA.` },
      { titel:'Ultrasnellader',  veld:'hpc',   breedte:15, soort:'getal', uitleg:`Aantal ultrasnelladers. Elk ${PAAL_VERMOGEN.hpc.kvaMin} tot ${PAAL_VERMOGEN.hpc.kvaMax} kVA.` },
      { titel:'Samen',           veld:'samen', breedte:11, soort:'getal', uitleg:'Alle laadpalen van dat jaar bij elkaar.' },
      { titel:'Op een laadplein', veld:'opPlein', breedte:17, soort:'getal', uitleg:'Van die palen het deel dat op een gekozen laadplein staat. De rest heeft nog geen locatie.' },
      { titel:'Aansluitvermogen (kVA)', veld:'kva', breedte:22, soort:'getal', balk:true, uitleg:'Optelsom van de aansluitwaarden. Elke locatie krijgt een eigen aansluiting.' },
      ...slimKol([{ titel:'Zonder slim laden (kVA)', veld:'kvaZonder', breedte:24, soort:'getal',
        uitleg:'Wat er gevraagd zou worden als er geen slim laden wordt toegepast.' }]),
    ];
    const kolWijk = [
      { titel:'Wijk',            veld:'wijk',  breedte:26, soort:'tekst', uitleg:'Wijk waarin de laadpalen komen.' },
      { titel:'Gewone paal',     veld:'ac',    breedte:14, soort:'getal', uitleg:'Aantal gewone laadpalen in deze wijk.' },
      { titel:'Snellader',       veld:'dc',    breedte:12, soort:'getal', uitleg:'Aantal snelladers in deze wijk.' },
      { titel:'Ultrasnellader',  veld:'hpc',   breedte:15, soort:'getal', uitleg:'Aantal ultrasnelladers in deze wijk.' },
      { titel:'Samen',           veld:'samen', breedte:11, soort:'getal', uitleg:'Alle laadpalen van die wijk bij elkaar.' },
      { titel:'Op een laadplein', veld:'opPlein', breedte:17, soort:'getal', uitleg:'Van die palen het deel dat op een gekozen laadplein staat. De rest heeft nog geen locatie.' },
      { titel:'Aansluitvermogen (kVA)', veld:'kva', breedte:22, soort:'getal', balk:true, uitleg:'Optelsom van de aansluitwaarden in die wijk.' },
      ...slimKol([
        { titel:'Slim laden (%)', veld:'slim', breedte:15, soort:'getal',
          uitleg:'Het deel van de laadpalen in deze wijk waarop slim laden wordt toegepast.' },
        { titel:'Zonder slim laden (kVA)', veld:'kvaZonder', breedte:24, soort:'getal',
          uitleg:'Wat er in deze wijk gevraagd zou worden zonder slim laden.' },
        { titel:'Extra laadpalen mogelijk', veld:'extra', breedte:24, soort:'getal',
          uitleg:'Het aantal laadpalen dat op dezelfde aansluitingen zou passen. Dit is de ANDERE manier om dezelfde ruimte te benutten; niet optellen bij de besparing op het vermogen.' },
      ]),
    ];

    // Een blad met de gekozen locaties per jaar. Dat is wat de netbeheerder
    // nodig heeft: welke locatie, welke laders en hoeveel vermogen, wanneer.
    const kolLocatie = [
      { titel:'Jaar',      veld:'jaar',   breedte:10, soort:'tekst', uitleg:'Het peiljaar waarvoor deze locatie is vastgelegd.' },
      { titel:'Locatie',   veld:'naam',   breedte:30, soort:'tekst', uitleg:'Naam van het parkeerterrein, of de coördinaten.' },
      { titel:'Wijk',      veld:'wijk',   breedte:24, soort:'tekst', uitleg:'Wijk waarin de locatie ligt.' },
      { titel:'Gewone paal',    veld:'ac',  breedte:14, soort:'getal', uitleg:'Aantal gewone laadpalen op deze locatie.' },
      { titel:'Snellader',      veld:'dc',  breedte:12, soort:'getal', uitleg:'Aantal snelladers op deze locatie.' },
      { titel:'Ultrasnellader', veld:'hpc', breedte:15, soort:'getal', uitleg:'Aantal ultrasnelladers op deze locatie.' },
      { titel:'Laadpunten',     veld:'punten', breedte:12, soort:'getal', uitleg:'Twee laadpunten per laadpaal.' },
      { titel:'Aansluitvermogen (kVA)', veld:'kva', breedte:22, soort:'getal', balk:true, uitleg:'Aansluitvermogen van deze ene locatie.' },
      { titel:'Aansluiting', veld:'aansluiting', breedte:18, soort:'tekst', uitleg:`Onder ${KVA_STUDIE} kVA laagspanning. Tussen ${KVA_STUDIE} en ${KVA_CABINE} kVA beslist Fluvius na een studie: laagspanning of middenspanning. Boven ${KVA_CABINE} kVA een eigen cabine op middenspanning.` },
    ];
    const locatieRijen = pleinGeschikt
      .filter(r => vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling).palen)
      .map(r => {
        const o = pleinOordeel[r.id]?.opstelling || {};
        const v = vermogenVanOpstelling(o);
        const wid = wijkVanPunt(sectorenGeo, r.lat, r.lng)
          ?? (wijkResults.find(w => w.wijk.lat != null &&
               Math.hypot(w.wijk.lat - r.lat, w.wijk.lng - r.lng) < 0.05)?.wijk?.id ?? null);
        return {
          jaar: pleinOordeel[r.id]?.jaar != null ? String(pleinOordeel[r.id].jaar) : 'nog niet vastgelegd',
          naam: r.naam || `${r.lat?.toFixed(5)}, ${r.lng?.toFixed(5)}`,
          wijk: (gemeente?.wijken || []).find(w => w.id === wid)?.naam || '',
          ac: Number(o.ac) || 0, dc: Number(o.dc) || 0, hpc: Number(o.hpc) || 0,
          punten: v.punten, kva: v.kvaMax,
          aansluiting: v.vlag === 'cabine' ? 'eigen cabine'
            : v.vlag === 'studie' ? 'Fluvius beslist' : 'laagspanning',
        };
      })
      .sort((a2, b2) => String(a2.jaar).localeCompare(String(b2.jaar)) || a2.naam.localeCompare(b2.naam));

    // Blad Per sector: het gevraagde vermogen uitgesplitst naar statistische
    // sector, gesorteerd per wijk. Het wijkgetal is naar inwonertal verdeeld,
    // dus dit is een verdeling en geen aparte berekening.
    const kolSector = [
      { titel:'Wijk',    veld:'wijk',   breedte:24, uitleg:'De wijk waar deze sector aan is toegewezen.' },
      { titel:'Sector',  veld:'sector', breedte:30, uitleg:'Naam van de statistische sector volgens Statbel.' },
      { titel:'Code',    veld:'code',   breedte:14, uitleg:'De officiële sectorcode.' },
      { titel:'Inwoners', veld:'inwoners', breedte:12, soort:'getal',
        uitleg:'Inwonertal van de sector volgens Statbel.' },
      { titel:'Auto\u2019s', veld:'wagens', breedte:12, soort:'getal',
        uitleg:'Aantal auto\u2019s in de sector volgens Statbel. Dit is de sleutel waarmee het vermogen van de wijk over haar sectoren is verdeeld. Is dit leeg, dan is er op inwonertal verdeeld.' },
      { titel:'Aansluitvermogen (kVA)', veld:'kva', breedte:22, soort:'getal', balk:true,
        uitleg:'Het gevraagde vermogen van de wijk, verdeeld over haar sectoren naar inwonertal. Geen aparte berekening per sector.' },
      { titel:'Ruimte op het net', veld:'ruimte', breedte:20,
        uitleg:'De meting van de netbeheerder voor deze sector: krap, beperkt of ruim.' },
    ];
    const sectorRijen = (sectorenRef.current?.features || [])
      .map(f => {
        const code = f.properties?.NISCODE;
        const wijk = (gemeente?.wijken || []).find(w => w.id === f.properties?.WIJK_ID);
        return {
          wijk: wijk?.naam || 'niet toegewezen',
          sector: sectorNaam(code),
          code,
          inwoners: sectorInwoners[code] ?? null,
          wagens: sectorWagens[code] ?? null,
          kva: Math.round(netcapKvaPerSector[code] || 0),
          ruimte: netcapUit?.netruimteSector?.[code] || '',
        };
      })
      .sort((a2, b2) => (a2.wijk === b2.wijk ? b2.kva - a2.kva : a2.wijk.localeCompare(b2.wijk)));

    const bladen = [
      { naam:'Per jaar', kolommen:kolJaar,
        rijen: [...jaren.map(j => rijJaar(String(j), binnen.filter(r => r.jaar === j))),
                rijJaar(`Samen ${begin}-${eind}`, binnen),
                ...(nadien.length ? [rijJaar(`${eind + 1} t/m 2035`, nadien),
                                     rijJaar('Samen tot 2035', regels)] : [])] },
      { naam:'Per wijk', kolommen:kolWijk,
        rijen: [...wijken.map(w => ({ wijk:w.naam, ac:soort(w.rs,'ac'), dc:soort(w.rs,'dc'),
                                      hpc:soort(w.rs,'hpc'), samen:palen(w.rs), opPlein:opPlein(w.rs),
                                      kva:som(w.rs, kvaVeld),
                                      ...(slimAan ? { slim: slimPct(w.rs), kvaZonder: som(w.rs,'kvaMax'),
                                                      extra: som(w.rs,'extraPalenSlim') } : {}) })),
                { wijk:'Samen', ac:soort(binnen,'ac'), dc:soort(binnen,'dc'), hpc:soort(binnen,'hpc'),
                  samen:palen(binnen), opPlein:opPlein(binnen), kva:som(binnen, kvaVeld),
                  ...(slimAan ? { kvaZonder: som(binnen,'kvaMax'),
                                  extra: som(binnen,'extraPalenSlim') } : {}) }] },
      ...(locatieRijen.length ? [{ naam:'Locaties', kolommen:kolLocatie, rijen:locatieRijen }] : []),
      ...(sectorRijen.length ? [{ naam:'Per sector', kolommen:kolSector, rijen:sectorRijen }] : []),
    ];

    try {
      await downloadRapport({
        gemeenteId: gemId, gemeente: gemeente?.naam || '', onderwerp: 'netcapaciteit',
        titel: 'Strategisch Laadplan, aan te vragen bij de netbeheerder',
        ondertitel: `${gemeente?.naam || ''} · ${begin} tot en met ${eind}`,
        meta: `Opgesteld op ${new Date().toLocaleDateString('nl-BE')} · aansluitwaarden per laadpaal, ` +
              `peildatum ${netcapUit?.peildatum || VERMOGEN_PEILDATUM}`,
        // Het overzichtsblad opent het bestand met dezelfde cijfers als het scherm.
        overzicht: {
          naam: 'Overzicht',
          kerncijfers: [
            { label:'Laadpalen', waarde: palen(binnen) },
            { label:'Aansluitvermogen (kVA)', waarde: som(binnen, kvaVeld) },
            { label:'Locaties met een eigen cabine', waarde: som(binnen,'cabines') },
            ...(slimAan ? [
              { label:'Zonder slim laden (kVA)', waarde: som(binnen,'kvaMax') },
              { label:'Extra laadpalen mogelijk', waarde: som(binnen,'extraPalenSlim') },
            ] : []),
          ],
          tip: 'Wil je een grafiek? Klik in een tabel en druk op Alt+F1.',
          zin: [
            slimAan
              ? `Slim laden is toegepast in ${wijken.filter(w => slimPct(w.rs) > 0).length} van de ` +
                `${wijken.length} wijken. Elk laadpunt houdt ${SOCKET_KW_SLIM} kW gegarandeerd in plaats ` +
                `van ${netcapUit?.slim?.kwPerPuntNominaal || 11}, een piekreductie van ${Math.round((1 - SOCKET_KW_SLIM / (netcapUit?.slim?.kwPerPuntNominaal || 11)) * 100)} procent, ` +
                `waardoor er vier laadpunten op een aansluiting passen in plaats van twee. ` +
                `Dat kan op twee manieren worden benut, en die zijn ` +
                `niet bij elkaar op te tellen: het gevraagde aansluitvermogen daalt van ` +
                `${fmtN(som(binnen,'kvaMax'))} naar ${fmtN(som(binnen,'kvaSlimMax'))} kVA, OF er kunnen ` +
                `${fmtN(som(binnen,'extraPalenSlim'))} laadpalen extra bij zonder dat er een aansluiting ` +
                `verzwaard wordt.`
              : '',
            nadien.length
              ? `Voor ${eind + 1} tot en met 2035 zijn nog geen locaties gekozen. Volgens het model ` +
                `komen er dan nog ${pleinenNodig(palen(nadien) * 2, pleinAandeel, pleinOmvang)} laadpleinen bij.`
              : '',
          ].filter(Boolean).join(' '),
          // Dezelfde twee tabellen als op het scherm, zodat het bestand opent
          // met het verhaal en niet met kolomkoppen.
          tabellen: [
            { titel: `Per jaar, ${begin} tot en met ${eind}`, kolommen: kolJaar,
              rijen: [...jaren.map(j => rijJaar(String(j), binnen.filter(r => r.jaar === j))),
                      { ...rijJaar(`Samen ${begin}-${eind}`, binnen), __vet: true }] },
            { titel: 'Per wijk', kolommen: kolWijk,
              rijen: [...wijken.map(w => ({ wijk:w.naam, ac:soort(w.rs,'ac'), dc:soort(w.rs,'dc'),
                        hpc:soort(w.rs,'hpc'), samen:palen(w.rs), opPlein:opPlein(w.rs),
                        kva:som(w.rs, kvaVeld),
                        ...(slimAan ? { slim: slimPct(w.rs), kvaZonder: som(w.rs,'kvaMax'),
                                        extra: som(w.rs,'extraPalenSlim') } : {}) })),
                      { wijk:'Samen', ac:soort(binnen,'ac'), dc:soort(binnen,'dc'),
                        hpc:soort(binnen,'hpc'), samen:palen(binnen), opPlein:opPlein(binnen),
                        kva:som(binnen, kvaVeld),
                        ...(slimAan ? { kvaZonder: som(binnen,'kvaMax'),
                                        extra: som(binnen,'extraPalenSlim') } : {}), __vet: true }] },
          ],
          kaart: kaartPng ? { png: kaartPng, breedte: 900, hoogte: 400,
            onderschrift: 'Aansluitkaart netcongestie en gevraagd aansluitvermogen' +
              (netcapUit?.netruimtePeildatum ? `, kaart van de netbeheerder van ${netcapUit.netruimtePeildatum}` : '') } : null,
        },
        toelichting: slimAan ? [
          ['Slim laden, de regel',
           `Met slim laden houdt elk laadpunt ${SOCKET_KW_SLIM} kW gegarandeerd in plaats van ` +
           `${netcapUit?.slim?.kwPerPuntNominaal || 11}, een piekreductie van ${Math.round((1 - SOCKET_KW_SLIM / (netcapUit?.slim?.kwPerPuntNominaal || 11)) * 100)} procent. ` +
           `Het E-Laad-onderzoek noemt een bandbreedte van 35 tot 49 procent. ` +
           `Op een aansluiting voor een gewone paal passen ` +
           `dan vier laadpunten in plaats van twee, dus 12 kVA per paal in plaats van ` +
           `${String(PAAL_VERMOGEN.ac.kvaMax).replace('.', ',')}.`],
          ['Twee lezingen, niet optellen',
           'Dezelfde vrijgekomen ruimte kan maar een keer worden uitgegeven: een lichtere aansluiting vragen, ' +
           'of de aansluiting houden en er een tweede laadpaal bij zetten. De kolommen Zonder slim laden en ' +
           'Extra laadpalen mogelijk horen dus naast elkaar gelezen te worden en nooit bij elkaar opgeteld.'],
          ['Alleen gewone laadpalen',
           'Slim laden werkt in dit model alleen op gewone laadpalen. Bij snelladers en ultrasnelladers zit ' +
           'geen ruimte in het aansluitschema.'],
          ['Het aantal laadpalen verandert niet',
           'Slim laden verandert de energievraag niet, en het vermogen per laadpunt is bij de gehanteerde ' +
           'doorzet niet de beperkende factor. Het aantal benodigde laadpalen blijft daarom gelijk.'],
          ['Blad Locaties, cabines en studies',
           'Op het blad Locaties staat het volledige aansluitvermogen per locatie, en het aantal cabines en ' +
           'studies is niet herrekend. Een locatie doet wel of niet aan slim laden, en met een percentage per ' +
           'wijk valt niet te bepalen welke locatie dat is.'],
        ] : [],
        bladen,
      }, 'xlsx');
    } catch (e) {
      setNetcapFout(e.message);
    }
  };

  // Sneltoetsen tijdens een sessie met de gemeente: G geschikt, N niet,
  // L later, O terug naar onbeoordeeld. Alleen actief op dit tabblad en niet
  // terwijl er in een veld getypt wordt.
  useEffect(() => {
    if (tab !== 'pleinen') return;
    const opToets = (e) => {
      if (!pleinGekozen) return;
      const el = document.activeElement;
      if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')) return;
      const k = e.key.toLowerCase();
      const naar = k === 'g' ? 'geschikt' : k === 'n' ? 'niet' : k === 'l' ? 'later' : k === 'o' ? 'open' : null;
      if (!naar) return;
      e.preventDefault();
      zetOordeel(pleinGekozen, naar);
    };
    window.addEventListener('keydown', opToets);
    return () => window.removeEventListener('keydown', opToets);
  }, [tab, pleinGekozen, zetOordeel]);

  // De kaart van Laadpleinen: de hele gemeente vult het beeld, ook als de kaart
  // pas later zijn echte maat krijgt of de kolom rechts open- of dichtgaat.
  // Zodra iemand zelf zoomt, schuift of klikt, blijft het beeld staan.
  // Besluit HL 23 oktober 2026: de stad meteen beeldvullend.
  const pasPleinKaart = useCallback(() => {
    const m = pleinMap.current;
    if (!m) return;
    m.invalidateSize();
    if (m._zelf || !m._stadGrens || !m._stadGrens.isValid()) return;
    m.fitBounds(m._stadGrens, { padding: [16, 16], animate: false });
  }, []);
  useEffect(() => {
    const el = pleinMapRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const o = new ResizeObserver(() => pasPleinKaart());
    o.observe(el);
    return () => o.disconnect();
  }, [pasPleinKaart]);
  // Een gekozen locatie opent rechts het tabblad Locatie.
  useEffect(() => { if (pleinGekozen != null) setPleinRechts('loc'); }, [pleinGekozen]);

  // De Excel van tabblad Laadpleinen. Stond eerder in de knop zelf.
  const downloadPleinen = async () => {
                    setExportBezig(true); setExportFout(null);
                    try {
                      const naamVan = { geschikt:'geschikt', niet:'afgevallen', later:'later', open:'nog te doen' };
                      await downloadRapport({
                        gemeente: gemeente?.naam || '', onderwerp: 'laadpleinen',
                        titel: 'Strategisch Laadplan, kandidaatlocaties voor laadpleinen',
                        ondertitel: `${gemeente?.naam || ''} · ${fmtN(pleinGefilterd.length)} kandidaten, ` +
                          `waarvan ${fmtN(pleinGefilterd.filter(x => (x.laadpunten ?? 0) === 0).length)} nog zonder laadpunt`,
                        meta: `Opgesteld op ${new Date().toLocaleDateString('nl-BE')} · parkeerterreinen uit ` +
                          `OpenStreetMap${pleinOphaal?.wanneer ? ', opgehaald ' + new Date(pleinOphaal.wanneer).toLocaleDateString('nl-BE') : ''}` +
                          // Welke filters gelden, zodat het aantal kandidaten te volgen is.
                          ` · Filters: minimaal ${fmtN(pleinMinVak)} parkeervakken · ` +
                          `${pleinToegang.length ? pleinToegang.join(' en ') : 'geen toegang gekozen'}` +
                          `${pleinSoorten.length ? ` · ${PLEIN_SOORTEN.filter(([id]) => pleinSoorten.includes(id))
                              .map(([, label]) => label.toLowerCase()).join(', ')} binnen ${fmtN(pleinNabij)} m` : ''}` +
                          `${pleinMetLp ? ' · alleen met laadpunt' : ''}` +
                          `${Object.values(pleinZicht).every(Boolean) ? '' : ` · beoordeling: ${PLEIN_STATUSSEN
                              .filter(([id]) => pleinZicht[id]).map(([, label]) => label).join(', ') || 'geen'}`}`,
                        tabblad: 'Kandidaatlocaties',
                        kolommen: [
                          { titel:'Locatie',     veld:'naam',        breedte:30, soort:'tekst',  uitleg:'Naam van het parkeerterrein. Zonder naam: de soort en de dichtstbijzijnde straat binnen 150 m. Is er ook geen straat bekend, dan de coördinaten.' },
                          { titel:'Soort',       veld:'soort',       breedte:16, soort:'tekst',  uitleg:'Parkeerterrein, parkeergarage of parkeerstrook langs de straat, zoals ingevuld in OpenStreetMap.' },
                          { titel:'Vakken',      veld:'vakken',      breedte:10, soort:'getal',  uitleg:'Aantal parkeervakken. Uit de kaartgegevens als die er zijn, anders geschat op 25 m² per vak.' },
                          { titel:'Vakken geteld', veld:'capBron',   breedte:14, soort:'tekst',  uitleg:'Geteld betekent dat het aantal vakken in OpenStreetMap staat. Geschat betekent berekend uit de oppervlakte, 25 m² per vak.' },
                          { titel:'Toegang',     veld:'groep',       breedte:14, soort:'tekst',  uitleg:'Openbaar betekent vrij toegankelijk volgens OpenStreetMap. Wie de eigenaar is, staat daar niet in. Semipubliek is een winkel- of bedrijfsparking.' },
                          { titel:'Bestaande laadpunten', veld:'laadpunten', breedte:12, soort:'getal', uitleg:'Laadpunten die nu al op dit terrein staan, volgens de gegevens van MOW. Niet de laadpunten die hier gepland worden; die staan in Palen per soort.' },
                          { titel:'Voorziening', veld:'voorziening', breedte:28, soort:'tekst',  uitleg:`Dichtstbijzijnde voorziening waar bezoekers voor parkeren, als die binnen ${VZ_TOON_M} m ligt. Verder weg staat er "geen binnen ${VZ_TOON_M} m".` },
                          { titel:'Afstand (m)', veld:'afstand',     breedte:12, soort:'getal',  uitleg:'Afstand tot die voorziening, hemelsbreed vanaf het middelpunt.' },
                          { titel:'Beoordeling', veld:'oordeel',     breedte:15, soort:'oordeel',uitleg:'Samen met de gemeente bepaald: geschikt, afgevallen, later of nog te doen.' },
                          { titel:'Vastgelegd voor', veld:'jaar', breedte:16, soort:'tekst', uitleg:'Het peiljaar waarvoor deze locatie is vastgelegd. Leeg betekent nog niet vastgelegd.' },
                          { titel:'Palen per soort', veld:'opstelling', breedte:18, soort:'tekst', uitleg:`Aantal palen per soort dat hier voorzien is. Twee laadpunten per paal. Leeg betekent nog niet ingevuld.` },
                          { titel:'Aansluitvermogen (kVA)', veld:'kva', breedte:14, soort:'getal', uitleg:`Aansluitvermogen van de hele locatie, peildatum ${VERMOGEN_PEILDATUM}. AC 3×35A is 24,2 kVA per paal, DC 3×80A is 55,4 kVA, HPC 150 tot 250 kVA. Bij HPC staat hier de hoogste waarde, omdat de kast bepaalt waar het uitkomt.` },
                          ...(pleinKvaBand ? [
                            { titel:'Laagste bij HPC (kVA)', veld:'kvaMin', breedte:14, soort:'getal', uitleg:'Bij een HPC-lader het aansluitvermogen aan de onderkant van de bandbreedte. Leeg als er geen HPC-lader staat.' },
                          ] : []),
                          { titel:'Studie Fluvius', veld:'netstudie', breedte:16, soort:'tekst',  uitleg:`Onder ${KVA_STUDIE} kVA laagspanning. Tussen ${KVA_STUDIE} en ${KVA_CABINE} kVA beslist Fluvius na een studie: laagspanning of middenspanning. Boven ${KVA_CABINE} kVA een eigen cabine op middenspanning.` },
                          { titel:'Laadpunten deelwagens', veld:'deelwagens', breedte:22, soort:'getal', uitleg:'Aantal laadpunten op deze locatie dat voor deelwagens wordt voorbehouden. Telt mee binnen de opstelling.' },
                          ...(pleinHeeftNet ? [
                            { titel:'Straatkabel 400 V (m)', veld:'d400', breedte:20, soort:'getal', uitleg:'Afstand hemelsbreed tot de dichtstbijzijnde straatkabel van 400 V, volgens de netgegevens van Fluvius.' },
                            { titel:'MS-cabine Fluvius (m)', veld:'dcabine', breedte:20, soort:'getal', uitleg:'Afstand hemelsbreed tot de dichtstbijzijnde cabine van Fluvius die stroom voor de straat maakt.' },
                            // Het planbestand van Fluvius heeft geen verdeelkasten en geen
                            // middenspanning; dan blijven die twee kolommen weg.
                            ...(gisNet?.samenvatting?.soort === 'plan' ? [] : [
                            { titel:'Verdeelkast (m)', veld:'dkast', breedte:16, soort:'getal', uitleg:'Afstand hemelsbreed tot de dichtstbijzijnde verdeelkast, het aftakpunt van de straatkabel.' },
                            { titel:'Middenspanningskabel (m)', veld:'dms', breedte:22, soort:'getal', uitleg:`Afstand hemelsbreed tot de dichtstbijzijnde middenspanningskabel. Alleen bij een laadplein boven ${KVA_CABINE} kVA, dat een eigen cabine nodig heeft.` },
                            ]),
                          ] : []),
                          ...(pleinHeeftPlan ? [
                            { titel:'Kabel te versterken', veld:'planKabel', breedte:16, soort:'tekst', uitleg:'Ja als de dichtstbijzijnde straatkabel van 400 V in het plan van Fluvius als te versterken op lange termijn staat. Uit het planbestand van Fluvius.' },
                            { titel:'Transformator verwacht probleem', veld:'planTransfo', breedte:20, soort:'tekst', uitleg:'Ja als in het plan van Fluvius bij de transformator van de dichtstbijzijnde MS-cabine verwacht probleem op lange termijn staat.' },
                            { titel:'In zoekzone nieuwe cabine', veld:'planZoekzone', breedte:18, soort:'tekst', uitleg:'Ja als de locatie in een zoekzone voor een nieuwe cabine van Fluvius ligt, anders de afstand tot de dichtstbijzijnde zoekzone.' },
                            { titel:'Werken van Fluvius', veld:'planWerken', breedte:30, soort:'tekst', uitleg:'De werkgebieden van Fluvius waarin de locatie ligt.' },
                          ] : []),
                          { titel:'Notitie',     veld:'notitie',     breedte:40, soort:'tekst',  uitleg:'Vrije aantekening bij de locatie.' },
                          { titel:'Kaart',       veld:'kaart',       breedte:44, soort:'link',   uitleg:'Aanklikbare verwijzing die de locatie op de kaart opent.' },
                        ],
                        rijen: pleinGefilterd.map(r => ({
                          naam: pleinLocatieNaam(r),
                          vakken: r.vakken ?? null,
                          soort: pleinSoortNaam(r).toLowerCase(),
                          capBron: r.vakken == null ? 'aantal vakken onbekend' : r.capBron === 'ja' ? 'geteld' : 'geschat',
                          groep: r.groep || '',
                          laadpunten: r.laadpunten ?? 0,
                          // Alleen een voorziening die te belopen is. Besluit HL
                          // 23 oktober 2026: tot 750 m, verder weg zegt het niets.
                          voorziening: r.voorziening && r.voorzieningM != null && r.voorzieningM <= VZ_TOON_M
                            ? r.voorziening : `geen binnen ${VZ_TOON_M} m`,
                          afstand: r.voorzieningM != null && r.voorzieningM <= VZ_TOON_M ? r.voorzieningM : null,
                          oordeel: naamVan[oordeelVan(r)] || 'nog te doen',
                          jaar: pleinOordeel[r.id]?.jaar != null ? String(pleinOordeel[r.id].jaar) : '',
                          opstelling: samenstellingTekst(pleinOordeel[r.id]?.opstelling),
                          kva: (() => {
                            const v = vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling);
                            return v.palen ? v.kvaMax : null;
                          })(),
                          kvaMin: (() => {
                            const v = vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling);
                            return v.palen && v.bandbreedte ? v.kvaMin : null;
                          })(),
                          netstudie: (() => {
                            const v = vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling);
                            return { cabine:'eigen cabine', studie:'Fluvius beslist', geen:'nee', leeg:'' }[v.vlag];
                          })(),
                          deelwagens: pleinOordeel[r.id]?.deelwagens ?? null,
                          d400: netAfstPlein[String(r.id)]?.d400 ?? null,
                          dcabine: netAfstPlein[String(r.id)]?.dcabine ?? null,
                          dkast: netAfstPlein[String(r.id)]?.dkast ?? null,
                          dms: pleinEigenCabine(r) ? (netAfstPlein[String(r.id)]?.dms ?? null) : null,
                          ...(() => {
                            if (!pleinHeeftPlan) return {};
                            const sg = planSignalen([r.lat, r.lng], gisNet.lagen) || {};
                            const jn = (b) => (b == null ? '' : b ? 'ja' : 'nee');
                            return { planKabel: jn(sg.kabelVersterken), planTransfo: jn(sg.transfoProbleem),
                              planZoekzone: sg.zoekzone == null ? '' : sg.zoekzone === 0 ? 'ja' : `nee, op ${fmtN(sg.zoekzone)} m`,
                              planWerken: (sg.werken || []).join(', ') };
                          })(),
                          notitie: pleinOordeel[r.id]?.notitie || '',
                          kaart: `https://www.google.com/maps/search/?api=1&query=${r.lat},${r.lng}`,
                        })),
                        toelichting: [
                          ['Herkomst', 'Parkeerterreinen uit OpenStreetMap, opgehaald door de app zelf.'],
                          ['Selectie', 'Alleen terreinen die groot genoeg zijn voor een laadplein en die aan de gekozen filters voldoen.'],
                          ['Laadplein', 'Minimaal drie laadpalen, dus zes laadpunten, op aaneengesloten parkeervakken.'],
                          ['Let op', 'Het aantal vakken is een schatting waar de kaartgegevens geen telling geven; ter plaatse nakijken blijft nodig.'],
                          ...(pleinHeeftNet ? [['Netgegevens', `Afstanden tot het net volgens de netgegevens van Fluvius, peildatum ${
                            peildatumLang(Object.values(netAfstPlein)[0]?.peildatum)}. `
                            + 'De netgegevens tonen waar kabels, cabines en kasten liggen. Ze zeggen niets over de vrije '
                            + 'capaciteit op het net en zijn geen toezegging van de netbeheerder.']] : []),
                          ...(pleinHeeftPlan ? [['Plan van Fluvius', planVoetTekst()]] : []),
                        ],
                      });
                    } catch (e) { setExportFout(e.message); }
                    finally { setExportBezig(false); }
                  };

  // ── Tabblad Laadpleinen: de kaart ──────────────────────────────────
  // Een eigen Leaflet-instantie, los van die op Gemeente. Reden: de kaart op
  // Gemeente zit in een ander paneel dat verborgen wordt met display:none, en
  // een Leaflet-kaart verplaatsen tussen twee panelen geeft meer problemen dan
  // een tweede instantie. Hij wordt pas gemaakt zodra het tabblad open is.
  useEffect(() => {
    if (tab !== 'pleinen' || !pleinMapRef.current) return;
    if (!pleinMap.current) {
      pleinMap.current = L.map(pleinMapRef.current, {
        center: [gemeente?.wijken?.[0]?.lat ?? 50.88, gemeente?.wijken?.[0]?.lng ?? 4.70],
        zoom: 12,
        // In stappen van een kwart, zodat de gemeente het beeld echt vult. Met
        // hele stappen bleef ze bij het openen op ongeveer de halve hoogte
        // staan (HL, 26 oktober 2026).
        zoomSnap: 0.25, zoomDelta: 0.5,
        // Zoomknoppen linksonder: linksboven staat de lijst en rechtsboven de
        // legenda. Rechtsonder blijft vrij voor de bronvermelding van de kaart,
        // want die mag nooit worden afgedekt.
        zoomControl: false,
      });
      L.control.zoom({ position: 'bottomleft' }).addTo(pleinMap.current);
      L.tileLayer(KAART_ADRES, {
        attribution: '© OpenStreetMap © CARTO', maxZoom: 19,
      }).addTo(pleinMap.current);
      pleinLaag.current = L.layerGroup().addTo(pleinMap.current);
      pleinPuntLaag.current = L.layerGroup();
      pleinGrensLaag.current = L.layerGroup().addTo(pleinMap.current);
      // Vaste lagen voor het stroomnet en voor de kandidaten erbovenop.
      maakNetPanes(pleinMap.current);
      // Wie zelf zoomt of schuift, houdt zijn eigen beeld.
      pleinMap.current.on('mousedown wheel touchstart', () => { if (pleinMap.current) pleinMap.current._zelf = true; });
    }
    // Na het tonen van een verborgen paneel weet Leaflet zijn afmetingen niet.
    const t = setTimeout(() => pleinMap.current?.invalidateSize(), 60);
    return () => clearTimeout(t);
  }, [tab, gemeente]);

  // Het stroomnet van Fluvius op de kaart van Laadpleinen. Zonder bestand
  // wordt er niets getekend.
  useEffect(() => {
    if (tab !== 'pleinen' || !pleinMap.current) return;
    tekenStroomnet(pleinMap.current, gisNet?.aanwezig ? gisNet.lagen : null, pleinNetZicht);
  }, [tab, gisNet, pleinNetZicht]);

  // ── Tabblad Dekking: de kaart ────────────────────────────────────────
  useEffect(() => {
    if (tab !== 'dekking' || !dekMapRef.current) return;
    if (!dekMap.current) {
      dekMap.current = L.map(dekMapRef.current, {
        center: [gemeente?.wijken?.[0]?.lat ?? 50.88, gemeente?.wijken?.[0]?.lng ?? 4.70],
        zoom: 12,
        zoomControl: false,
      });
      L.control.zoom({ position: 'bottomleft' }).addTo(dekMap.current);
      L.tileLayer(KAART_ADRES, {
        attribution: '© OpenStreetMap · CARTO', maxZoom: 19,
      }).addTo(dekMap.current);
      dekLaag.current = L.layerGroup().addTo(dekMap.current);
    }
    // Na het tonen van een verborgen paneel weet Leaflet zijn afmetingen niet.
    const t = setTimeout(() => dekMap.current?.invalidateSize(), 60);
    return () => clearTimeout(t);
  }, [tab, gemeente]);

  // De punten en hun cirkels. Punten die op exact dezelfde coördinaat staan
  // horen bij één paal en krijgen dus één stip en één cirkel; anders liggen er
  // twee identieke cirkels over elkaar.
  const dekPunten = React.useMemo(() => {
    const groepen = new Map();
    for (const el of existingPalen) {
      const lat = el.lat ?? el.center?.lat, lng = el.lon ?? el.center?.lng ?? el.center?.lon;
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
      const t = el.tags || {};
      // Gewone palen en snelladers tellen mee, ultrasnelladers niet. Een
      // ultrasnellader staat langs een invalsweg voor wie onderweg is, en die
      // bedient geen buurt; hem meetellen zou de dekking mooier maken dan ze is.
      if (t.mow_snelheid === 'ultrasnel') continue;
      const snel = t.mow_snelheid === 'snel';
      const semi = t.mow_toegankelijkheid === 'semi-publiek';
      // De sleutel bevat OOK de soort en de toegankelijkheid. Staat er op één
      // plek zowel een gewone paal als een snellader, dan zijn dat twee aparte
      // stippen. Anders zou zo'n plek onder één soort vallen en zou de
      // schakelaar voor snelladers daar niets doen.
      const sleutel = `${lat.toFixed(6)}_${lng.toFixed(6)}_${semi ? 's' : 'p'}_${snel ? 'd' : 'a'}`;
      if (!groepen.has(sleutel)) groepen.set(sleutel, { lat, lng, semi, snel, punten: 0 });
      groepen.get(sleutel).punten += 1;
    }
    return [...groepen.values()];
  }, [existingPalen]);


  // Gemeente- en sectorgrenzen onder de kandidaatlocaties, zodat de stippen
  // niet los op de ondergrond zweven. Zelfde opbouw als op het tabblad Dekking:
  // een dikke donkere rand voor de buitenrand van de gemeente en een dunne
  // witte lijn erbovenop voor de grenzen binnenin.
  useEffect(() => {
    if (tab !== 'pleinen' || !pleinGrensLaag.current) return;
    const laag = pleinGrensLaag.current;
    laag.clearLayers();
    const vormen = sectorenRef.current?.features || [];
    if (!vormen.length) return;
    L.geoJSON({ type:'FeatureCollection', features: vormen }, {
      style: { color:'#3D4652', weight:3, opacity:0.7, fillColor:'#FBFAF7', fillOpacity:0.35 },
      interactive: false,
    }).addTo(laag);
    const binnen = L.geoJSON({ type:'FeatureCollection', features: vormen }, {
      style: { color:'#FFFFFF', weight:1, opacity:0.8, fill:false },
      interactive: false,
    }).addTo(laag);
    laag.eachLayer(l => l.bringToBack && l.bringToBack());
    if (pleinMap.current) { pleinMap.current._stadGrens = binnen.getBounds(); pasPleinKaart(); }
  }, [tab, gemId, sectorenGeladen, pasPleinKaart]);

  // Luchtfoto als aparte laag, zodat je kunt zien of er werkelijk vakken liggen.
  useEffect(() => {
    if (!pleinMap.current) return;
    if (pleinLucht && !pleinLuchtLaag.current) {
      pleinLuchtLaag.current = L.tileLayer(
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        { attribution: 'Luchtfoto: Esri', maxZoom: 19 });
    }
    if (!pleinLuchtLaag.current) return;
    if (pleinLucht) pleinLuchtLaag.current.addTo(pleinMap.current);
    else pleinMap.current.removeLayer(pleinLuchtLaag.current);
  }, [pleinLucht, tab]);

  // Bestaande laadpunten als losse laag. Bewust alleen tonen, niet koppelen aan
  // een terrein: uit de meting bleek dat de grote locaties tientallen tot
  // honderden meters van elk gekarteerd parkeerterrein liggen.
  useEffect(() => {
    if (!pleinMap.current || !pleinPuntLaag.current) return;
    pleinPuntLaag.current.clearLayers();
    if (pleinPunten) {
      existingPalen.forEach(el => {
        const lat = el.lat ?? el.center?.lat, lng = el.lon ?? el.center?.lon;
        if (lat == null || lng == null) return;
        L.circleMarker([lat, lng], {
          radius: 3, color: N.ink2, weight: 1, fillColor: N.ink2, fillOpacity: 0.8,
        }).addTo(pleinPuntLaag.current);
      });
      pleinPuntLaag.current.addTo(pleinMap.current);
    } else {
      pleinMap.current.removeLayer(pleinPuntLaag.current);
    }
  }, [pleinPunten, existingPalen, tab]);

  // ── Het venster met het technisch fiche ──────────────────────────────
  // Eigen kaart, om dezelfde reden als bij Laadpleinen: een kaart verhuizen
  // tussen twee schermen geeft meer last dan een tweede instantie. De
  // luchtfoto van Digitaal Vlaanderen ligt over een gewone kaart heen, zodat
  // er ook iets te zien is als een tegel ontbreekt.
  useEffect(() => {
    if (!ficheOpen) {
      if (ficheMap.current) { ficheMap.current.remove(); ficheMap.current = null; }
      return;
    }
    if (!ficheMapRef.current || ficheMap.current) return;
    const rij = (pleinAlles || []).find(r => r.id === ficheOpen);
    ficheMap.current = L.map(ficheMapRef.current, {
      center: [rij?.lat ?? 50.88, rij?.lng ?? 4.70],
      zoom: 19, maxZoom: 21, zoomControl: false,
    });
    // Linksboven: linksonder staat de legenda van de vakken en palen.
    L.control.zoom({ position: 'topleft' }).addTo(ficheMap.current);
    L.tileLayer(KAART_ADRES, {
      attribution: '© OpenStreetMap © CARTO', maxZoom: 21, maxNativeZoom: 19,
    }).addTo(ficheMap.current);
    // Adres en tegelindeling afgelezen uit de dienstbeschrijving van Digitaal
    // Vlaanderen, niet geraden: het raster GoogleMapsVL is hetzelfde raster als
    // dat van de kaart eronder, dus z, y en x gaan er rechtstreeks in.
    ficheLucht.current = L.tileLayer('https://geo.api.vlaanderen.be/OMW/wmts/1.0.0/omwrgb25vl/default/GoogleMapsVL/{z}/{y}/{x}.png',
      { attribution: 'Luchtfoto: Digitaal Vlaanderen', maxZoom: 21 }).addTo(ficheMap.current);
    ficheLaag.current = L.layerGroup().addTo(ficheMap.current);
    ficheKabelLaag.current = L.layerGroup().addTo(ficheMap.current);
    fichePaalLaag.current = L.layerGroup().addTo(ficheMap.current);
    ficheHoekLaag.current = L.layerGroup().addTo(ficheMap.current);
    // Het stroomnet onder de schets, boven de luchtfoto (mockup V15, punt 4).
    maakNetPanes(ficheMap.current, 300);
    // De bestaande laadpunten in de bovenste laag van het net, onder de schets.
    ficheBestLaag.current = L.layerGroup().addTo(ficheMap.current);
    // De lijn naar het aansluitpunt boven het net en het plein (deel B).
    const aansPane = ficheMap.current.createPane('p_aans');
    aansPane.style.zIndex = '395';
    ficheAansLaag.current = L.layerGroup().addTo(ficheMap.current);
    const t = setTimeout(() => ficheMap.current?.invalidateSize(), 60);
    return () => clearTimeout(t);
  }, [ficheOpen, pleinAlles]);

  // Het stroomnet van Fluvius op het technisch fiche. Zonder bestand niets.
  useEffect(() => {
    if (!ficheOpen || !ficheMap.current) return;
    tekenStroomnet(ficheMap.current, gisNet?.aanwezig ? gisNet.lagen : null, ficheNetZicht, false);
  }, [ficheOpen, gisNet, ficheNetZicht, pleinAlles]);

  // De bestaande laadpunten op het fiche, in beide delen: donkergrijze bol met
  // witte rand (fiche V2). Ze staan onder de nieuwe palen.
  useEffect(() => {
    const laag = ficheBestLaag.current;
    if (!ficheOpen || !ficheMap.current || !laag) return;
    laag.clearLayers();
    if (ficheNetZicht.best === false) return;
    const R = ficheMap.current._netRenderer?.kand;
    existingPalen.forEach(el => {
      const lat = el.lat ?? el.center?.lat, lng = el.lon ?? el.center?.lon;
      if (lat == null || lng == null) return;
      L.circleMarker([lat, lng], {
        pane: KAND_PANE, renderer: R, radius: 5, color: '#fff', weight: 2,
        fillColor: BESTAAND_KLEUR, fillOpacity: 1, interactive: false,
      }).addTo(laag);
    });
  }, [ficheOpen, existingPalen, ficheNetZicht, pleinAlles]);

  // Wisselen tussen deel A en deel B. A: luchtfoto, ingezoomd op de schets.
  // B: gewone kaart, uitgezoomd tot het plein en de dichtstbijzijnde cabine,
  // kast en straatkabel in beeld zijn. Alleen bij het wisselen, zodat zelf
  // verschuiven of zoomen daarna niet steeds wordt teruggezet.
  const ficheDeelVorig = useRef('A');
  useEffect(() => {
    const kaart = ficheMap.current;
    if (!ficheOpen || !kaart || !ficheLucht.current) { ficheDeelVorig.current = 'A'; return; }
    // Bij het openen staat de kaart al goed; alleen een echte wissel telt.
    if (ficheDeelVorig.current === ficheDeel) return;
    ficheDeelVorig.current = ficheDeel;
    if (ficheDeel === 'B') {
      if (kaart.hasLayer(ficheLucht.current)) kaart.removeLayer(ficheLucht.current);
      const np = ficheNetPunten;
      const punten = [ficheStart, ...['dc', 'vk', 'v400'].map(k => np[k]).filter(Boolean).map(p => [p.lat, p.lng]),
        ...(ficheAansluiting && !ficheAansluiting.leeg ? [[ficheAansluiting.lat, ficheAansluiting.lng]] : [])]
        .filter(Boolean);
      if (punten.length > 1) kaart.fitBounds(L.latLngBounds(punten).pad(0.25), { maxZoom: 18 });
      else if (punten.length) kaart.setView(punten[0], 17);
    } else {
      if (!kaart.hasLayer(ficheLucht.current)) ficheLucht.current.addTo(kaart);
      const punten = (ficheWerk?.rijen || []).flatMap(r => r.punten || []);
      if (punten.length) kaart.fitBounds(L.latLngBounds(punten).pad(0.3), { maxZoom: 20 });
      else if (ficheStart) kaart.setView(ficheStart, 19);
    }
  }, [ficheDeel, ficheOpen]);

  // De aansluiting in deel B: een roze stippellijn op een witte onderlijn van
  // het plein naar het gekozen punt, met de afstand halverwege. Het plein zelf
  // krijgt een vierkantje, want uitgezoomd is een rij vakken haast onzichtbaar.
  useEffect(() => {
    const laag = ficheAansLaag.current;
    if (!ficheOpen || !ficheMap.current || !laag) return;
    laag.clearLayers();
    if (ficheDeel !== 'B' || !ficheStart) return;
    L.marker(ficheStart, { pane: 'p_aans', interactive: false, keyboard: false,
      icon: L.divIcon({ className: '', iconSize: [14, 14], iconAnchor: [7, 7],
        html: `<div style="width:14px;height:14px;box-sizing:border-box;background:${N.accent};border:2px solid #fff;`
            + `box-shadow:0 0 0 1px ${N.accent}"></div>` }) }).addTo(laag);
    const a = ficheAansluiting;
    if (!a || a.leeg) return;
    const doel = [a.lat, a.lng];
    L.polyline([ficheStart, doel], { pane: 'p_aans', color: '#fff', weight: 7, opacity: 0.9, interactive: false }).addTo(laag);
    L.polyline([ficheStart, doel], { pane: 'p_aans', color: AANSLUIT_KLEUR, weight: 4, dashArray: '8 6', interactive: false }).addTo(laag);
    L.circleMarker(doel, { pane: 'p_aans', radius: 9, color: AANSLUIT_KLEUR, weight: 3, fill: false, interactive: false }).addTo(laag);
    const mid = [(ficheStart[0] + doel[0]) / 2, (ficheStart[1] + doel[1]) / 2];
    L.marker(mid, { pane: 'p_aans', interactive: false, keyboard: false,
      icon: L.divIcon({ className: '', iconSize: null,
        html: `<span style="display:inline-block;transform:translate(-50%,-50%);white-space:nowrap;background:#fff;`
            + `border:1.5px solid ${AANSLUIT_KLEUR};color:${AANSLUIT_KLEUR};font:700 12.5px/1 system-ui,sans-serif;`
            + `padding:3px 6px;border-radius:4px">${fmtN(a.d)} m</span>` }) }).addTo(laag);
  }, [ficheOpen, ficheDeel, ficheStart, ficheAansluiting]);

  // In deel B wijst een klik op de kaart het eigen aansluitpunt aan, als die
  // keuze aanstaat.
  useEffect(() => {
    const kaart = ficheMap.current;
    if (!ficheOpen || !kaart || ficheDeel !== 'B' || ficheAansluiting?.soort !== 'vrij') return;
    const klik = (e) => kiesAansluiting('vrij', [e.latlng.lat, e.latlng.lng]);
    kaart.on('click', klik);
    kaart.getContainer().style.cursor = 'crosshair';
    return () => { kaart.off('click', klik); kaart.getContainer().style.cursor = ''; };
  }, [ficheOpen, ficheDeel, ficheAansluiting?.soort, kiesAansluiting]);

  // De schets tekenen: alle rijen met hun vakken, de grepen van de rij die
  // bewerkt wordt, en de palen. Tijdens het slepen loopt het werk via
  // ficheWerkRef, want een sleepbeweging levert tientallen stapjes per seconde
  // en die horen niet allemaal in de schermtoestand terecht te komen.
  useEffect(() => {
    ficheWerkRef.current = ficheWerk;
    if (!ficheOpen || !ficheMap.current || !ficheLaag.current) return;
    const kaart = ficheMap.current;
    // In deel B wordt er niet getekend: de schets ligt er alleen ter oriëntatie.
    const modus = ficheDeel === 'A' ? ficheModus : null;
    const rijen = ficheWerk?.rijen || [];
    const aangewezen = new Set(ficheWerk?.vakken || []);
    const doelVan = ficheWerk?.doelen || {};

    const zetGrepen = (schets) => {
      const rij = schets.rijen[ficheRijNr];
      if (!rij) return;
      const plekken = greepPunten(rij);
      ficheHoekPunten.current.forEach((m, i) => plekken[i] && m.setLatLng(plekken[i]));
    };

    const teken = (schets) => {
      ficheLaag.current.clearLayers();
      schets.rijen.forEach((rij, rijNr) => {
        const gekozen = rijNr === ficheRijNr;
        vakkenVanRij(rij).forEach((vak, vakNr) => {
          const sleutelV = vakSleutel(rijNr, vakNr);
          const vast = aangewezen.has(sleutelV);
          const doel = vast ? (doelVan[sleutelV] || 'laden') : null;
          const kleurV = vast ? VAK_KLEUR[doel] : N.accent2;
          L.polygon(vak, {
            color: kleurV,
            weight: vast ? 2 : 1.5, opacity: gekozen ? 0.95 : 0.6,
            fillColor: kleurV,
            fillOpacity: vast ? 0.65 : (gekozen ? 0.25 : 0.12),
            interactive: modus === 'vakken',
            bubblingMouseEvents: false,
          }).addTo(ficheLaag.current)
            .on('click', () => { if (modus === 'vakken') wisselVak(rijNr, vakNr); });
          // De letter midden in een vak voor een deelwagen of bestelwagen, zodat
          // het ook zonder kleurenzicht te lezen is.
          if (vast && VAK_LETTER[doel]) {
            const mid = [vak.reduce((a, q) => a + q[0], 0) / vak.length,
                         vak.reduce((a, q) => a + q[1], 0) / vak.length];
            L.marker(mid, { interactive: false, keyboard: false,
              icon: L.divIcon({ className: '', iconSize: [16, 16], iconAnchor: [8, 8],
                html: `<div style="width:16px;height:16px;line-height:16px;text-align:center;`
                    + `font:800 12px/16px sans-serif;color:#fff">${VAK_LETTER[doel]}</div>` }) })
              .addTo(ficheLaag.current);
          }
        });
        // De omtrek vangt de muis op: hierop pak je de hele rij op. Dat kan
        // alleen bij de rij die bewerkt wordt en alleen in de stand Rijen
        // tekenen, anders vecht het met het aanwijzen van vakken.
        const pakbaar = gekozen && modus === 'rijen';
        const omtrek = L.polygon(rij.punten, {
          color: N.accent, weight: gekozen ? 2.5 : 1.5,
          opacity: gekozen ? 1 : 0.5, fill: true,
          fillColor: N.accent2, fillOpacity: 0.01,
          interactive: pakbaar, bubblingMouseEvents: false,
        }).addTo(ficheLaag.current);
        if (!pakbaar) return;
        omtrek.on('mousedown', (e) => {
          const begin = ficheWerkRef.current;
          if (!begin) return;
          const vanaf = e.latlng;
          const beginPunten = begin.rijen[rijNr].punten;
          kaart.dragging.disable();
          L.DomEvent.stop(e);
          const beweeg = (ev) => {
            const dLat = ev.latlng.lat - vanaf.lat, dLng = ev.latlng.lng - vanaf.lng;
            const punten = beginPunten.map(pt => [pt[0] + dLat, pt[1] + dLng]);
            const nu = { ...ficheWerkRef.current };
            nu.rijen = nu.rijen.map((r, i) => i === rijNr ? { ...r, punten } : r);
            ficheWerkRef.current = nu;
            teken(nu);
            zetGrepen(nu);
          };
          const klaar = () => {
            kaart.off('mousemove', beweeg);
            kaart.off('mouseup', klaar);
            document.removeEventListener('mouseup', klaar);
            kaart.dragging.enable();
            setFicheWerk({ ...ficheWerkRef.current });
          };
          kaart.on('mousemove', beweeg);
          kaart.on('mouseup', klaar);
          // Laat je de muis buiten de kaart los, dan komt er geen mouseup op de
          // kaart en zou het verschuiven blijven hangen met de kaart op slot.
          document.addEventListener('mouseup', klaar);
        });
      });
    };

    // De kabels staan in hun eigen laag en worden apart bijgewerkt. Ze krijgen
    // een donkere omranding met een felle kern, want een enkele donkere lijn
    // valt weg tegen de vulling van de vakken en tegen het asfalt op de foto.
    const tekenKabels = (schets) => {
      ficheKabelLaag.current.clearLayers();
      kabelTraces(schets.palen, schets.rijen || [], schets.cabine).forEach(lijn => {
        L.polyline(lijn, { color:'#12161C', weight:7, opacity:0.55,
                           interactive:false }).addTo(ficheKabelLaag.current);
        L.polyline(lijn, { color:'#FFD400', weight:3.5, opacity:1, dashArray:'9 5',
                           interactive:false }).addTo(ficheKabelLaag.current);
      });
    };

    const tekenPalen = (schets) => {
      fichePaalLaag.current.clearLayers();
      if (schets.cabine) {
        L.marker([schets.cabine.lat, schets.cabine.lng], {
          draggable: modus === 'palen',
          zIndexOffset: 900,
          icon: L.divIcon({ className:'', iconSize:[30,22], iconAnchor:[15,11],
            html:`<div style="width:30px;height:22px;box-sizing:border-box;border-radius:4px;`
               + `background:${N.ink};border:2px solid #FFD400;box-shadow:0 1px 5px rgba(18,22,28,.55);`
               + `color:#fff;font:700 11px/18px system-ui,sans-serif;text-align:center;`
               + `cursor:${modus === 'palen' ? 'grab' : 'default'}">CAB</div>` }),
        }).addTo(fichePaalLaag.current)
          .on('drag', (e) => {
            // Alleen de kabels opnieuw tekenen. De cabine zelf staat in een
            // andere laag; die opnieuw maken zou hem onder de muis vandaan
            // halen en de sleepbeweging afbreken.
            const ll = e.target.getLatLng();
            const nu = { ...ficheWerkRef.current, cabine: { lat: ll.lat, lng: ll.lng } };
            ficheWerkRef.current = nu;
            tekenKabels(nu);
          })
          .on('dragend', (e) => {
            const ll = e.target.getLatLng();
            verzetCabine([ll.lat, ll.lng]);
          });
      }
      (schets.palen || []).forEach((paal) => {
        const kleur = PAAL_KLEUR[paal.soort] || PAAL_KLEUR.ac;
        L.marker([paal.lat, paal.lng], {
          interactive: modus === 'palen',
          zIndexOffset: 800,
          icon: L.divIcon({ className:'', iconSize:[14,14], iconAnchor:[7,7],
            html:`<div style="width:14px;height:14px;box-sizing:border-box;border-radius:3px;`
               + `background:${kleur};border:2px solid #fff;box-shadow:0 1px 4px rgba(18,22,28,.5);`
               + `cursor:${modus === 'palen' ? 'pointer' : 'default'}"></div>` }),
        }).addTo(fichePaalLaag.current)
          .on('click', () => { if (modus === 'palen') zetPaal([paal.lat, paal.lng]); });
      });
    };

    teken(ficheWerk || { rijen: [], palen: [] });
    // In deel B alleen de rijen: uitgezoomd dekken de palen het plein af.
    const leeg = { rijen: [], palen: [], cabine: null };
    tekenKabels(modus === null ? leeg : (ficheWerk || leeg));
    tekenPalen(modus === null ? leeg : (ficheWerk || leeg));

    // Een klik op de kaart zet een paal op de dichtstbijzijnde scheiding.
    const klikKaart = (e) => {
      if (modus === 'palen') zetPaal([e.latlng.lat, e.latlng.lng]);
    };
    kaart.on('click', klikKaart);

    // De grepen horen alleen bij de rij die bewerkt wordt, en alleen in de
    // stand Rijen tekenen.
    ficheHoekLaag.current.clearLayers();
    ficheHoekPunten.current = [];
    const rij = rijen[ficheRijNr];
    if (!rij || modus !== 'rijen') return () => kaart.off('click', klikKaart);

    const plek = greepPunten(rij);
    FICHE_GREPEN.forEach((greep, i) => {
      const draai = greep === 'draai';
      const rand = !draai && !greep.startsWith('hoek');
      const maat = draai ? 22 : rand ? 16 : 20;
      const m = L.marker(plek[i], {
        draggable: true,
        zIndexOffset: draai ? 1200 : 1000,
        icon: L.divIcon({ className:'', iconSize:[maat, maat], iconAnchor:[maat/2, maat/2],
          html:`<div style="width:${maat}px;height:${maat}px;box-sizing:border-box;border-radius:50%;`
             + `background:${draai ? N.accent : '#fff'};border:${rand ? 3 : 4}px solid ${N.accent};`
             + `box-shadow:0 1px 5px rgba(18,22,28,.45);cursor:${draai ? 'grab' : 'crosshair'}"></div>` }),
      }).addTo(ficheHoekLaag.current);
      ficheHoekPunten.current.push(m);
      m.on('drag', (e) => {
        const huidig = ficheWerkRef.current;
        if (!huidig?.rijen?.[ficheRijNr]) return;
        const ll = e.target.getLatLng();
        const verzet = verzetGreep(huidig.rijen[ficheRijNr], greep, [ll.lat, ll.lng]);
        const nu = { ...huidig,
          rijen: huidig.rijen.map((r, j) => j === ficheRijNr ? verzet : r) };
        ficheWerkRef.current = nu;
        teken(nu);
        // De andere grepen lopen mee, behalve die in de hand van de gebruiker.
        const nieuwePlek = greepPunten(verzet);
        ficheHoekPunten.current.forEach((h, j) => { if (j !== i) h.setLatLng(nieuwePlek[j]); });
      });
      m.on('dragend', () => {
        if (ficheWerkRef.current) setFicheWerk({ ...ficheWerkRef.current });
      });
    });
    return () => kaart.off('click', klikKaart);
  }, [ficheWerk, ficheOpen, ficheRijNr, ficheModus, ficheDeel, wisselVak, zetPaal, verzetCabine]);

  // De kandidaten zelf. Grootte volgt het aantal vakken, kleur volgt het
  // oordeel. Opnieuw tekenen bij elke wijziging van filter of oordeel.
  useEffect(() => {
    if (tab !== 'pleinen' || !pleinMap.current || !pleinLaag.current) return;
    pleinLaag.current.clearLayers();
    const punten = [];
    pleinGefilterd.forEach(r => {
      if (r.lat == null || r.lng == null) return;
      const status = oordeelVan(r);
      const straal = Math.max(6, Math.min(26, Math.sqrt(r.vakken ?? 6) * 1.4));
      const cirkel = L.circleMarker([r.lat, r.lng], {
        pane: KAND_PANE,
        radius: straal,
        // Witte rand en vollere kleur, zodat de bollen boven het stroomnet
        // uitkomen (mockup Kleuren kaart V1, variant A).
        color: r.id === pleinGekozen ? N.ink : '#fff',
        weight: r.id === pleinGekozen ? 3 : 2,
        fillColor: PLEIN_KLEUR[status], fillOpacity: 0.85,
      });
      // Hoveren geeft één regel; het volledige beeld staat in het paneel links.
      cirkel.bindTooltip(
        `<b>${r.naam || pleinSoortNaam(r)}</b><br>${pleinVakkenTekst(r)} · ` +
        `${(r.laadpunten ?? 0) > 0 ? `${r.laadpunten} laadpunten` : 'nog geen laadpunt'}` +
        `${status !== 'open' ? `<br><b>${status === 'niet' ? 'afgevallen' : status}</b>` : ''}` +
        `${deelwagensTekst(pleinOordeel[r.id]?.deelwagens)
            ? `<br>${deelwagensTekst(pleinOordeel[r.id]?.deelwagens)}` : ''}` +
        `${bestelwagensTekst(pleinOordeel[r.id]?.bestelwagens)
            ? `<br>${bestelwagensTekst(pleinOordeel[r.id]?.bestelwagens)}` : ''}` +
        `${netAfstPlein[String(r.id)] ? `<br>${netRegelPlein(netAfstPlein[String(r.id)],
            vermogenVanOpstelling(pleinOordeel[r.id]?.opstelling).vlag === 'cabine')}` : ''}`);
      cirkel.on('click', () => setPleinGekozen(r.id));
      cirkel.addTo(pleinLaag.current);
      // Locaties met laadpunten voor deelwagens krijgen een ring. De vulkleur
      // is al bezet door het oordeel, dus het onderscheid moet in de rand.
      const deel = pleinOordeel[r.id]?.deelwagens ?? 0;
      if (deel > 0) {
        L.circleMarker([r.lat, r.lng], {
          pane: KAND_PANE,
          radius: straal + 5, color: N.accent, weight: 2.5,
          fill: false, interactive: false,
        }).addTo(pleinLaag.current);
      }
      punten.push([r.lat, r.lng]);
    });
    if (punten.length) {
      const grens = L.latLngBounds(punten);
      // Alleen als de grenzen van de gemeente er (nog) niet zijn.
      if (grens.isValid() && !pleinMap.current._pleinGepast && !pleinMap.current._stadGrens && !pleinMap.current._zelf) {
        pleinMap.current.fitBounds(grens.pad(0.1));
        pleinMap.current._pleinGepast = true;
      }
    }
  }, [tab, pleinGefilterd, pleinOordeel, pleinGekozen, netAfstPlein]);

  // ── Bestaande palen ────────────────────────────────────────────────
  // Welke gemeente er nu open staat, voor de laadpalen hieronder.
  const palenVoor = useRef(null);
  palenVoor.current = gemId;
  const loadBestaandePalen = useCallback(async () => {
    if (!gemeente?.naam || !gemId) return;
    const voor = gemId;
    // Een antwoord dat binnenkomt nadat er al een andere gemeente open staat,
    // wordt weggegooid. Zonder deze toets kon het antwoord van de eerste
    // gemeente in de lijst (Antwerpen, 6.565 laadpunten) later binnenkomen dan
    // dat van de gekozen gemeente en het overschrijven. Dan stonden de
    // laadpunten van Antwerpen bij Liedekerke, niet op de kaart want buiten
    // beeld, en rekende het hele model daarmee (gevonden 26 oktober 2026).
    const nogActueel = () => palenVoor.current === voor;
    setExistingPalen([]);
    setLoadingPalen(true);
    try {
      const json = await getLaadpalen(voor);
      if (nogActueel()) setExistingPalen(json.elements || []);
    } catch(e) {
      console.warn('Laadpalen ophalen mislukt:', e.message);
      if (nogActueel()) setExistingPalen([]);
    }
    // V5: haal ook Fluvius ruwe telling op, voor de publiek/semi-splitberekening.
    // Faalt stil als postcodes ontbreken; V5 valt terug op gemeente?.privePctBerekend.
    try {
      const fj = await getFluviusPrive(voor);
      if (nogActueel()) setFluviusFp(fj?.totaalPrivePunten ?? null);
    } catch (e) {
      console.warn('Fluvius-telling ophalen mislukt:', e.message);
      if (nogActueel()) setFluviusFp(null);
    }
    if (nogActueel()) setLoadingPalen(false);
  }, [gemId, gemeente]);


  // ── Laad bestaande palen zodra kaart klaar is (eerste keer vanuit dashboard) ──
  useEffect(() => {
    if (!mapInstance.current) return;
    loadBestaandePalen();
  }, [mapReady]);

  // ── Instellingen van de gemeente: inlezen en bewaren ────────────────
  // Alles wat de gemeente zelf instelt hangt aan de gemeente, niet aan het
  // scherm. Bij het openen worden de waarden ingelezen; wat er nog niet staat
  // valt terug op de standaardwaarde.
  useEffect(() => {
    if (!gemId) return;
    let weg = false;
    instellingenVan.current = null;      // niets bewaren tot het inlezen klaar is
    getInstellingen(gemId)
      .then(r => {
        if (weg) return;
        const i = { ...STANDAARD_INSTELLINGEN, ...(r.instellingen || {}) };
        // Bewaren wat dit scherm bij het openen zag. Dat gaat bij elke opslag
        // mee, zodat de server kan zien of er intussen iemand anders is geweest.
        gezienRef.current = r.instellingen || {};
        setPriveStart(i.priveStart);
        setRedundantieMarge(i.redundantieMarge);
        setHuidigLP(i.huidigLP);
        setNetcapSlim(i.netcapSlim);
        setNetcapSlimWijk(i.netcapSlimWijk || {});
        setNetcapSlimHand(i.netcapSlimHand || {});
        setNetcapBegin(i.netcapBegin);
        setNetcapEind(i.netcapEind);
        setPleinMinVak(i.pleinMinVak);
        setPleinOmvang(i.pleinOmvang);
        setPleinAandeel(i.pleinAandeel);
        setPleinToegang(i.pleinToegang || ['openbaar']);
        setPleinNabij(i.pleinNabij);
        setPleinLoop(i.pleinLoop ?? STANDAARD_INSTELLINGEN.pleinLoop);
        setPleinSoorten(i.pleinSoorten || []);
        setPlaatsVoorrang(i.plaatsVoorrang);
        setNetGrens(i.netGrens ?? STANDAARD_INSTELLINGEN.netGrens);
        setCapexPlan({ ...STANDAARD_INSTELLINGEN.capex, ...(i.capex || {}) });
        instellingenVan.current = gemId;
      })
      .catch(e => {
        if (weg) return;
        // Zichtbaar falen via de balk bovenaan: zonder melding weet niemand dat
        // dit scherm de instellingen van een andere gemeente laat zien.
        setApiError(`De instellingen van deze gemeente konden niet worden geladen: ${e.message}`);
      });
    getInstellingenHerkomst(gemId)
      .then(r => { if (!weg) setHerkomst(r || {}); })
      // Geen melding: zonder deze regels werkt alles, er staat alleen niet bij
      // wie een uitgangspunt heeft verzet.
      .catch(e => console.error('Herkomst van de uitgangspunten ophalen mislukt:', e.message));

    return () => { weg = true; };
  }, [gemId]);

  // Bewaren zodra er iets is verzet. Het scherm wacht nergens op: de waarde
  // staat er meteen en het bewaren gebeurt een seconde later op de achtergrond,
  // zodat één sleepbeweging niet twintig keer naar de server gaat.
  useEffect(() => {
    if (!gemId || instellingenVan.current !== gemId) return;
    const nu = {
      priveStart, redundantieMarge, huidigLP,
      netcapSlim, netcapSlimWijk, netcapSlimHand, netcapBegin, netcapEind,
      pleinMinVak, pleinOmvang, pleinAandeel, pleinToegang, pleinNabij, pleinSoorten, pleinLoop,
      plaatsVoorrang, capex: capexPlan, netGrens,
    };
    const t = setTimeout(() => {
      bewaarInstellingen(gemId, nu, gezienRef.current)
        .then(() => {
          // Gelukt: vanaf nu is dit de stand waartegen de volgende opslag wordt
          // gehouden, en de herkomst is veranderd.
          gezienRef.current = { ...gezienRef.current, ...nu };
          getInstellingenHerkomst(gemId)
            .then(r => setHerkomst(r || {}))
            .catch(() => {});
        })
        .catch(e => {
          if (e.botsing) { setBotsing({ ...e.botsing, nu }); return; }
          setApiError(`Deze instelling is niet bewaard: ${e.message}`);
        });
    }, 1000);
    return () => clearTimeout(t);
  }, [gemId, priveStart, redundantieMarge, huidigLP,
      netcapSlim, netcapSlimWijk, netcapSlimHand, netcapBegin, netcapEind,
      pleinMinVak, pleinOmvang, pleinAandeel, pleinToegang, pleinNabij, pleinSoorten, pleinLoop,
      plaatsVoorrang, capexPlan, netGrens]);

  // De straten van de gemeente ophalen. Ze worden bij het onboarden eenmalig
  // door de server opgehaald en bewaard, dus dit is alleen uitlezen.
  useEffect(() => {
    if (!gemId) { setStraten([]); setStratenMelding(null); return; }
    let weg = false;
    getStraten(gemId)
      .then(r => {
        if (weg) return;
        const namen = r.namen || [];
        setStraten((r.punten || []).map(p => ({ lat: p[0], lng: p[1], naam: namen[p[2]] || '',
                                                soort: p[3] || '' })));
        setStratenMelding((r.punten || []).length ? null
          : 'De straten van deze gemeente zijn nog niet opgehaald.');
      })
      .catch(e => { if (!weg) { setStraten([]); setStratenMelding(e.message); } });
    return () => { weg = true; };
  }, [gemId]);

  // De adressen van de gemeente inlezen. Alleen uitlezen; het ophalen bij de
  // kaartdienst van Vlaanderen gebeurt met de knop hieronder.
  useEffect(() => {
    if (!gemId) { setAdressen([]); setAdressenMelding(null); return; }
    let weg = false;
    getAdressen(gemId)
      .then(r => {
        if (weg) return;
        setAdressen((r.punten || []).map(p => ({ lat: p[0], lng: p[1] })));
        setAdressenMelding((r.punten || []).length ? null
          : 'De adressen van deze gemeente zijn nog niet opgehaald.');
      })
      .catch(e => { if (!weg) { setAdressen([]); setAdressenMelding(e.message); } });
    return () => { weg = true; };
  }, [gemId]);

  const adressenOphalen = React.useCallback(async () => {
    if (!gemId || !gemeente?.naam || adressenBezig) return;
    setAdressenBezig(true);
    setAdressenMelding('Bezig met ophalen bij de kaartdienst van Vlaanderen.');
    try {
      const uit = await haalAdressenOp(gemId, gemeente.naam);
      if (!uit.gelukt) throw new Error(uit.melding || 'Het ophalen is niet gelukt.');
      const verse = await getAdressen(gemId);
      setAdressen((verse.punten || []).map(p => ({ lat: p[0], lng: p[1] })));
      setAdressenMelding(`${(uit.aantal || 0).toLocaleString('nl-BE')} adressen opgehaald `
        + `in ${Math.round((uit.duurMs || 0) / 1000)} seconden.`);
    } catch (e) {
      setAdressenMelding(e.message);
    } finally {
      setAdressenBezig(false);
    }
  }, [gemId, gemeente, adressenBezig]);

  // Voor gemeenten die al bestonden voordat deze bron er was, zijn de
  // straatnamen nooit opgehaald; dat gebeurt alleen bij het onboarden. Deze
  // knop doet het alsnog, en leest ze daarna meteen in.
  const straatnamenOphalen = React.useCallback(async () => {
    if (!gemId || !gemeente?.naam || stratenBezig) return;
    setStratenBezig(true);
    setStratenMelding(null);
    try {
      const uit = await haalStratenOp(gemId, gemeente.naam);
      if (!uit.gelukt) throw new Error(uit.melding || 'Het ophalen is niet gelukt.');
      const r = await getStraten(gemId);
      const namen = r.namen || [];
      setStraten((r.punten || []).map(p => ({ lat: p[0], lng: p[1], naam: namen[p[2]] || '' })));
    } catch (e) {
      setStratenMelding(e.message);
    } finally {
      setStratenBezig(false);
    }
  }, [gemId, gemeente, stratenBezig]);

  // Inwoners per sector ophalen. Ontbreken ze, bijvoorbeeld omdat het
  // Statbel-bestand nog niet is ingelezen, dan blijft de lijst leeg en wordt
  // het aantal laadpunten gelijk over de sectoren van een wijk verdeeld.
  useEffect(() => {
    if (!gemId) { setSectorInwoners({}); return; }
    let weg = false;
    getInwonersSectoren(gemId)
      .then(r => {
        if (weg) return;
        const kaart = {}, namen = {};
        for (const sec of (r.sectoren || [])) {
          kaart[sec.sector] = sec.inwoners || 0;
          if (sec.naam) namen[sec.sector] = sec.naam;
        }
        setSectorInwoners(kaart);
        setSectorNamen(namen);
        // De auto's per sector zijn de betere verdeelsleutel: een studentenwijk
        // telt veel inwoners en weinig auto's. Ontbreekt de bron, of ontbreekt
        // een enkele sector daarin, dan blijft de waarde leeg en valt de
        // verdeling voor die wijk terug op inwonertal.
        const auto = {};
        let gevuld = 0;
        for (const sec of (r.sectoren || [])) {
          if (sec.wagens != null) { auto[sec.sector] = sec.wagens; gevuld++; }
        }
        setSectorWagens(gevuld ? auto : {});
      })
      .catch(e => {
        if (!weg) {
          setSectorInwoners({}); setSectorWagens({}); setSectorNamen({});
          console.warn('Gegevens per sector niet opgehaald:', e.message);
        }
      });
    return () => { weg = true; };
  }, [gemId]);

  // De groei van het aantal auto's. Bij een wissel van gemeente eerst leeg, zodat
  // er nooit even met de groei van de vorige gemeente wordt gerekend.
  useEffect(() => {
    setAutoGroei(null);
    if (!gemId) return;
    let weg = false;
    getHuishoudgroei(gemId)
      .then(r => { if (!weg) setAutoGroei(r || null); })
      .catch(e => {
        if (!weg) {
          setAutoGroei(null);
          console.warn('Groei van het aantal auto\u2019s niet opgehaald:', e.message);
        }
      });
    return () => { weg = true; };
  }, [gemId]);

  // De bestelwagens volgens MOW. Ontbreekt de bron of de gemeente, dan blijft
  // het vak op tabblad Gemeente en het kader in het Word-document weg.
  useEffect(() => {
    if (!gemId) { setMowBestel(null); return; }
    let weg = false;
    getMowBestelwagens(gemId)
      .then(r => { if (!weg) setMowBestel(r || null); })
      .catch(e => {
        if (!weg) {
          setMowBestel(null);
          console.warn('Bestelwagens volgens MOW niet opgehaald:', e.message);
        }
      });
    return () => { weg = true; };
  }, [gemId]);



  // ── Kaart wijklagen ────────────────────────────────────────────────
  useEffect(() => {
    if (!mapInstance.current || !gemeente?.wijken?.length) return;
    if (wijkLayerRef.current) mapInstance.current.removeLayer(wijkLayerRef.current);
    if (projLayerRef.current) mapInstance.current.removeLayer(projLayerRef.current);

    const wg = L.layerGroup(), pg = L.layerGroup();

    // Bouw lookup van wijk-id naar berekende data
    const wijkDataMap = {};
    wijkResults.forEach(({ wijk, data }) => { wijkDataMap[wijk.id] = { wijk, data }; });

    // Het aantal bij te plaatsen laadpunten van een wijk wordt over zijn
    // sectoren verdeeld naar inwonertal. Zijn de inwoners per sector niet
    // bekend, dan wordt gelijk verdeeld over het aantal sectoren van die wijk.
    const inwPerWijk = {};
    for (const f of (sectorenRef.current?.features || [])) {
      const wid = f.properties?.WIJK_ID;
      if (!wid) continue;
      inwPerWijk[wid] = (inwPerWijk[wid] || 0) + sectorGewicht(f.properties?.NISCODE);
    }
    // Per wijk het jaardeel in HELE laadpunten over de sectoren verdelen, zo
    // dat de som per wijk exact klopt met wat op het tabblad Wijken staat.
    const perSectorLP = {};
    for (const [wid, m] of Object.entries(wijkDataMap)) {
      const eigen = (sectorenRef.current?.features || [])
        .filter(f => f.properties?.WIJK_ID === wid);
      if (!eigen.length) continue;
      const gewichten = {};
      for (const f of eigen) {
        const code = f.properties?.NISCODE;
        // Zonder bekende auto's of inwoners gelijk verdelen over de sectoren.
        gewichten[code] = (inwPerWijk[wid] || 0) > 0 ? sectorGewicht(code) : 1;
      }
      Object.assign(perSectorLP, verdeelHeel(m.data.jaardeel, gewichten));
    }
    // De kleurklassen worden op de sectorwaarden bepaald, niet op de
    // wijkwaarden. Anders valt bijna elke sector in de laagste klasse en is
    // de hele kaart één kleur.
    const sectorWaarden = Object.values(perSectorLP).filter(v => v > 0);
    const sectorGrenzen = sectorWaarden.length
      ? bepaalKlassegrenzen(sectorWaarden) : klassegrenzen;
    // De legenda moet dezelfde indeling tonen als de kleuren op de kaart.
    // Tellen gebeurt over ALLE sectoren, dus met de nullen erbij, want die
    // vormen de lichtste klasse. Alleen wegschrijven als er iets verandert,
    // anders zou dit effect zichzelf blijven aanroepen.
    const nieuweKlassen = sectorWaarden.length
      ? legendaKlassen(Object.values(perSectorLP), sectorGrenzen) : null;
    setSectorKlassen(oud => (JSON.stringify(oud) === JSON.stringify(nieuweKlassen) ? oud : nieuweKlassen));

    // Toon echte wijkpolygonen als beschikbaar, anders cirkels als fallback.
    // Elke wijk uit wijkResults moet altijd zichtbaar zijn: via een
    // gekoppelde polygoon, of anders als cirkel — nooit onzichtbaar.
    const wijkenMetPolygoon = new Set();

    if (sectorenRef.current?.features?.length > 0) {
      // CHOROPLETH: officiele wijkpolygonen, gekleurd op basis van de
      // wizard-berekening (wijkResults) van de gekoppelde wijk — niet op
      // een Statbel-oppervlaktegewicht.
      sectorenRef.current.features.forEach((feature, idx) => {
        const naam    = feature.properties?.NAAM || `Sector ${idx+1}`;
        const wijkId  = feature.properties?.WIJK_ID;
        const match   = wijkId ? wijkDataMap[wijkId] : null;

        if (match) wijkenMetPolygoon.add(match.wijk.id);

        // Kleur en hovertekst tonen het jaardeel, dus wat er IN het gekozen
        // jaar bij moet komen, maar nu per sector in plaats van per wijk.
        const sectorLP  = perSectorLP[feature.properties?.NISCODE] ?? 0;
        const fillColor = match ? kaartKleur(sectorLP, sectorGrenzen) : '#9AA4B1';
        // De hovertekst gaat over TWEE gebieden: eerst de sector waar de muis
        // op staat, met het getal waar de kleur van dit vlak bij hoort, en
        // daaronder de hele wijk. Beide krijgen hun soortnaam en staan met een
        // witregel uit elkaar, anders lijkt het wijkgetal bij de kleur te horen.
        const sCode  = feature.properties?.NISCODE;
        const sLabel = sectorNamen[sCode] && sectorNamen[sCode] !== sCode
          ? `Sector ${sCode} · ${sectorNamen[sCode]}` : `Sector ${naam}`;
        const tooltip   = match
          ? `<b>${sLabel}</b>` +
            `<br><b>${Math.round(sectorLP).toLocaleString('nl-BE')} bij te plaatsen in ${year}</b>` +
            `<br>${sectorInwoners[sCode] != null
                ? sectorInwoners[sCode].toLocaleString('nl-BE') + ' inwoners'
                : 'inwonertal onbekend'}` +
            `${sectorWagens[sCode] != null
                ? ` · ${sectorWagens[sCode].toLocaleString('nl-BE')} auto's`
                : ''}` +
            `<br><br><b>Wijk ${match.wijk.naam}</b>` +
            `<br>${match.data.bijTePlaatsen.toLocaleString('nl-BE')} bij te plaatsen tot en met ${year}` +
            (year > EERSTE_PLANJAAR
              ? `, waarvan ${match.data.jaardeel.toLocaleString('nl-BE')} in ${year}`
              : '')
          : `<b>${sLabel}</b><br>Geen wijkkoppeling`;

        try {
          // Normaliseer geometry: zorg dat coördinaten correct zijn
          const geom = feature.geometry;
          if (!geom) return;

          // Overpass geeft soms MultiPolygon met verkeerde nesting
          let normalizedFeature = { ...feature };
          if (geom.type === 'MultiPolygon' && Array.isArray(geom.coordinates[0][0]) && !Array.isArray(geom.coordinates[0][0][0])) {
            // Fix: wrap coordinates een niveau dieper
            normalizedFeature = {
              ...feature,
              geometry: { type: 'Polygon', coordinates: geom.coordinates }
            };
          }

          const poly = L.geoJSON(normalizedFeature, {
            style: () => ({
              // Witte rand tussen de wijken, zodat te zien is waar de een
              // ophoudt en de ander begint. Met een rand in dezelfde kleur
              // lopen aangrenzende wijken van dezelfde klasse in elkaar over.
              color:       '#FFFFFF',
              weight:      1.6,
              opacity:     0.9,
              fillColor:   fillColor,
              fillOpacity: match ? 0.88 : 0.4,
            })
          });

          poly.bindTooltip(tooltip, { sticky: true });
          poly.on('click', () => {
            if (match) setSelectedWijk(match.wijk.id);
          });
          poly.addTo(wg);
        } catch(e) {
          console.warn('Polygon fout:', naam, e.message);
        }
      });
    }

    // Cirkel-fallback voor elke wijk die geen gekoppelde polygoon kreeg
    // (inclusief het geval dat er helemaal geen polygonen beschikbaar zijn).
    setAantalZonderVorm(wijkResults.filter(r => !wijkenMetPolygoon.has(r.wijk.id)).length);
    wijkResults.forEach(({ wijk, data }) => {
      if (wijkenMetPolygoon.has(wijk.id)) return;
      // Streepjesrand: deze wijk kon niet aan een statistische sector worden
      // gekoppeld, dus de grenzen zijn onbekend. De cirkel staat op het
      // middelpunt.
      // Staan er WEL sectoren op de kaart, dan zijn die per sector ingekleurd
      // en deze cirkel zou een wijkwaarde tonen. Twee schalen in één beeld is
      // niet te lezen, dus dan blijft de cirkel kleurloos. Is de hele kaart
      // uit cirkels opgebouwd, dan geldt de wijkindeling en krijgt hij zijn
      // kleur gewoon.
      const gemengd = wijkenMetPolygoon.size > 0;
      const fc = gemengd ? N.ink4 : kaartKleur(data.jaardeel, klassegrenzen);
      // circleMarker in plaats van circle: de straal staat in schermpunten en
      // niet in meters, dus de cirkel houdt altijd dezelfde grootte, bij elk
      // zoomniveau en bij elk peiljaar. Alleen de kleur verandert mee. De maat
      // is gekozen zodat de wijknaam erin past.
      L.circleMarker([wijk.lat, wijk.lng], {
        radius: 34,
        color: fc, weight: 2.2, dashArray: '6 5',
        fillColor: fc, fillOpacity: gemengd ? 0 : 0.32,
      })
      .bindTooltip(`<b>${wijk.naam}</b><br><b>${data.bijTePlaatsen.toLocaleString('nl-BE')} bij te plaatsen tot en met ${year}</b>`
        + (year > EERSTE_PLANJAAR ? `<br>waarvan ${data.jaardeel.toLocaleString('nl-BE')} in ${year}` : '')
        + `<br><i>Ligging bij benadering: de grenzen van deze wijk zijn niet bekend.</i>`)
      .on('click', () => setSelectedWijk(wijk.id))
      .addTo(wg);

      // Naam midden in de cirkel. iconAnchor op de helft van de breedte en
      // hoogte zet het label precies op het middelpunt; met [0,0] zou het
      // rechtsonder de cirkel hangen. Lange namen breken over twee regels
      // zodat ze binnen de cirkel blijven.
      L.marker([wijk.lat, wijk.lng], { icon: L.divIcon({ className:'',
        html:`<div style="width:64px;text-align:center;font-size:10px;font-weight:700;line-height:1.15;color:#12161C;text-shadow:0 0 3px rgba(255,255,255,.95),0 0 3px rgba(255,255,255,.95);pointer-events:none">${wijk.naam}</div>`,
        iconSize:[64,26], iconAnchor:[32,13] }) }).addTo(wg);
    });

    // Voeg lagen toe aan kaart
    if (kaartLaag === 'behoefte') wg.addTo(mapInstance.current);
    wijkLayerRef.current = wg;
  }, [gemId, year, priveStart, redundantieMarge, trendFactor, gemeenten, sectorenGeladen,
      existingPalen, mapReady, sectorInwoners, sectorWagens, sectorNamen]);

  // ── Bestaande palen laag ───────────────────────────────────────────
  useEffect(() => {
    if (!mapInstance.current) return;
    if (existLayerRef.current) mapInstance.current.removeLayer(existLayerRef.current);
    const g = L.layerGroup();

    // Bepaal per laadpunt het type (zelfde logica als voorheen)
    const bepaalType = (t) => {
      const maxPower = parseInt(
        t['maxpower'] || t['capacity:output'] ||
        t['socket:type2_combo:output'] || t['socket:chademo:output'] ||
        t['socket:type2:output'] || '0'
      );
      if (t.mow_snelheid === 'ultrasnel')      return 'hpc';
      if (t.mow_snelheid === 'snel')           return 'dc';
      if (t.mow_snelheid === 'normaal')        return 'ac';
      const heeftCCS     = t['socket:type2_combo'] || t['socket:ccs'];
      const heeftCHAdeMO = t['socket:chademo'];
      const networkHPC   = (t['network']||'').match(/ionity|fastned|tesla|allego|porsche/i);
      if (maxPower >= 100 || networkHPC) return 'hpc';
      if (maxPower >= 22 || heeftCCS || heeftCHAdeMO) return 'dc';
      return 'ac';
    };

    // Groepeer laadpunten die exact dezelfde locatie delen (één laadstation
    // met meerdere laadpunten/connectoren), zodat ze niet onzichtbaar boven
    // op elkaar getekend worden.
    const groepen = new Map();
    existingPalen.forEach(el => {
      const lat=el.lat||el.center?.lat, lng=el.lon||el.center?.lon;
      if(!lat) return;
      const key = `${lat.toFixed(6)}_${lng.toFixed(6)}`;
      const t = el.tags||{};
      const paalType = bepaalType(t);
      const maxPower = parseInt(t['maxpower'] || '0');
      if (!groepen.has(key)) groepen.set(key, { lat, lng, punten: [] });
      groepen.get(key).punten.push({ t, paalType, vermogen: t.maxpower||maxPower });
    });

    const prioriteit = { hpc:3, dc:2, ac:1 };
    groepen.forEach(({ lat, lng, punten }) => {
      // Icoon toont het "beste" type dat op deze locatie aanwezig is
      const hoofdType = punten.reduce((best, p) =>
        prioriteit[p.paalType] > prioriteit[best] ? p.paalType : best, 'ac');

      const aantalPerType = { ac:0, dc:0, hpc:0 };
      punten.forEach(p => aantalPerType[p.paalType]++);
      const uitbaters = [...new Set(punten.map(p => p.t.operator || p.t.network).filter(Boolean))];
      const adres = punten.find(p => p.t.mow_adres)?.t.mow_adres;
      const toegankelijkheid = punten.find(p => p.t.mow_toegankelijkheid)?.t.mow_toegankelijkheid;
      const isMow = punten.some(p => p.t.mow_snelheid);

      const typeOverzicht = ['ac','dc','hpc']
        .filter(tp => aantalPerType[tp] > 0)
        .map(tp => `${aantalPerType[tp]}× ${tp.toUpperCase()}`)
        .join(' · ');

      L.marker([lat,lng], { icon: makeBestaandIcon(hoofdType, punten.length), zIndexOffset: 1000 })
       .bindPopup(`<b style="font-size:13px">${punten.length > 1 ? punten.length+' laadpunten hier' : 'Bestaande laadpaal'}</b>${toegankelijkheid ? ' · '+toegankelijkheid : ''}<br>
         <span style="font-size:12px">${typeOverzicht}</span><br>
         ${uitbaters.length ? '<span style="font-size:12px">Uitbater'+(uitbaters.length>1?'s':'')+': '+uitbaters.join(', ')+'</span><br>' : ''}
         ${adres ? '<span style="font-size:12px">'+adres+'</span><br>' : ''}
         <small style="color:#888">Bron: ${isMow ? 'MOW (Departement Mobiliteit en Openbare Werken)' : 'OpenStreetMap'}</small><br>
         <a href="https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}" target="_blank" rel="noopener" style="font-size:12px;color:#4a7fa5;text-decoration:none;display:inline-flex;align-items:center;gap:4px;margin-top:6px">
           <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0"><circle cx="12" cy="10" r="3"/><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/></svg>
           Open in Streetview
         </a>`, { maxWidth: 260 })
       .addTo(g);
    });

    if (kaartLaag === 'bestaand') g.addTo(mapInstance.current);
    existLayerRef.current = g;
  }, [existingPalen, mapReady]);

  // ── Kaartlaag omschakelen ──────────────────────────────────────────
  // Voegt de bestaande lagen toe of haalt ze eraf. De markers en polygonen
  // worden niet opnieuw opgebouwd, dus het schakelen is direct.
  useEffect(() => {
    const kaart = mapInstance.current;
    if (!kaart) return;
    const wijk = wijkLayerRef.current;
    const palen = existLayerRef.current;
    if (wijk) {
      if (kaartLaag === 'behoefte') { if (!kaart.hasLayer(wijk)) wijk.addTo(kaart); }
      else if (kaart.hasLayer(wijk)) kaart.removeLayer(wijk);
    }
    if (palen) {
      if (kaartLaag === 'bestaand') { if (!kaart.hasLayer(palen)) palen.addTo(kaart); }
      else if (kaart.hasLayer(palen)) kaart.removeLayer(palen);
    }
  }, [kaartLaag, mapReady, wijkResults, existingPalen]);

  const fmtEur = n => `€${Math.round(n/1000).toLocaleString('nl-BE')}K`;
  const fmtN   = n => Math.round(n).toLocaleString('nl-NL');
  const kom1   = n => Number(n).toFixed(1).replace('.', ',');
  const selectedResult = selectedWijk ? wijkResults.find(r=>r.wijk.id===selectedWijk) : null;

  // ── Stijlen ────────────────────────────────────────────────────────
  const st = {
    // ── Shell ──────────────────────────────────────────────────────────
    app:    { display:'flex', flexDirection:'column', height:'100vh', background:N.canvas, color:N.ink, fontFamily:"-apple-system,BlinkMacSystemFont,'Inter','Segoe UI',system-ui,sans-serif", overflow:'hidden' },

    // ── Nieuwe structuur: donkere topbar, gemeentekop, tabbladen ──────
    nTop:   { background:N.ink, height:56, display:'flex', alignItems:'center', padding:'0 28px', gap:14, flexShrink:0 },
    nBrandVak: { background:N.accent2, color:'#fff', fontSize:14, fontWeight:600, letterSpacing:'-0.01em', borderRadius:6, padding:'5px 12px', whiteSpace:'nowrap', flexShrink:0 },
    nBack:  { marginLeft:12, fontSize:12.5, color:'rgba(255,255,255,0.55)', cursor:'pointer', padding:'5px 9px', borderRadius:6, background:'none', border:'none', fontFamily:'inherit', whiteSpace:'nowrap' },
    nTbtn:  (danger, uit) => ({
      fontSize:12.5,
      color: uit ? 'rgba(255,255,255,0.3)' : (danger ? '#E8A79A' : 'rgba(255,255,255,0.72)'),
      padding:'6px 12px',
      border:`1px solid ${uit ? 'rgba(255,255,255,0.1)' : (danger ? 'rgba(232,167,154,0.28)' : 'rgba(255,255,255,0.16)')}`,
      borderRadius:7, cursor: uit ? 'not-allowed' : 'pointer', background:'transparent',
      fontFamily:'inherit', display:'flex', alignItems:'center', gap:6, whiteSpace:'nowrap',
    }),
    nHead:  { padding:'11px 28px 0', flexShrink:0, background:N.canvas },
    nNaam:  { fontSize:23, fontWeight:700, letterSpacing:'-0.028em', lineHeight:1.1, color:N.ink },
    nMeta:  { fontSize:13, color:N.ink3 },
    nTabs:  { display:'flex', gap:2, padding:'0 28px', marginTop:9, borderBottom:`1px solid ${N.line2}`, flexShrink:0, background:N.canvas },
    nTab:   (a) => ({ padding:'10px 17px', fontSize:14.5, fontWeight:600, color: a ? N.accent : N.ink3, cursor:'pointer', border:'none', background:'transparent', fontFamily:'inherit', borderBottom:`2.5px solid ${a ? N.accent : 'transparent'}`, marginBottom:-1, whiteSpace:'nowrap' }),
    nPane:  { flex:1, minHeight:0, overflowY:'auto', padding:'14px 28px 28px' },
    // Geen scroll op dit paneel: de parameters staan compact in één rij en de
    // kaart vult de rest. Zo is de kaart altijd volledig zichtbaar.
    // Tabblad Gemeente: één rij met de parameterkolom links en de kaart rechts.
    // Geen scroll op het paneel zelf, zodat de kaart altijd volledig past.
    nPaneF: { flex:1, minHeight:0, display:'flex', flexDirection:'row', padding:0, overflow:'hidden' },
    nCard:  { background:N.paper, border:`1px solid ${N.line2}`, borderRadius:12, boxShadow:'0 1px 2px rgba(18,22,28,0.05), 0 4px 14px rgba(18,22,28,0.045)', overflow:'hidden' },
    nSec:   { fontSize:11, fontWeight:700, letterSpacing:'0.09em', textTransform:'uppercase', color:N.ink4, marginBottom:7 },
    // Jaarbalk en kerncijfers, vorm uit mockup V11
    // Kerncijferbalk, altijd zichtbaar onder de tabbladen
    kern:    { display:'grid', gridTemplateColumns:'repeat(5, 1fr)', background:N.paper, borderBottom:`1px solid ${N.line2}`, boxShadow:'0 2px 6px rgba(18,22,28,0.05)', flexShrink:0 },
    kernVak: { padding:'10px 18px', borderRight:`1px solid ${N.line}` },
    kernL:   { fontSize:11.5, color:N.ink3, marginBottom:4, textTransform:'uppercase', letterSpacing:'0.05em', fontWeight:600, whiteSpace:'nowrap' },
    kernV:   (kleur) => ({ fontSize:23, fontWeight:700, lineHeight:1, letterSpacing:'-0.028em', fontVariantNumeric:'tabular-nums', color: kleur || N.ink }),
    kernS:   { fontSize:11.5, color:N.ink4, marginTop:4 },
    // Verdeelbalkje onder 'Nu aanwezig'. De labelregel is donkerder dan kernS,
    // want hij draagt betekenis; 'MWh per jaar' in de buurtegel doet dat niet.
    kernBalk:{ display:'flex', height:6, borderRadius:3, overflow:'hidden', marginTop:8, background:KERN_LICHT },
    kernDeel:(kleur, pct) => ({ display:'block', height:'100%', width:`${pct}%`, background:kleur }),
    kernLab: { display:'flex', flexWrap:'wrap', gap:'5px 14px', marginTop:6, fontSize:11.5, color:N.ink2, lineHeight:1.35 },
    kernLabI:{ display:'inline-flex', alignItems:'center', gap:6, whiteSpace:'nowrap' },
    kernStip:(kleur) => ({ width:9, height:9, borderRadius:2, flexShrink:0, background:kleur,
                           border: kleur === KERN_LICHT ? '1px solid #AFBEC4' : 'none' }),
    kernLabN:{ fontWeight:700, fontVariantNumeric:'tabular-nums' },
    // Verdeling privé en publiek
    // Parameterrij op het tabblad Gemeente
    pReset: (aan) => ({ display:'flex', alignItems:'center', justifyContent:'center', width:26, height:26, border:`1px solid ${aan ? N.line2 : 'transparent'}`, borderRadius:6, background: aan ? N.paper : 'transparent', color: aan ? N.accent2 : N.line2, cursor: aan ? 'pointer' : 'default', flexShrink:0, padding:0 }),
    gZij:   { width:310, flexShrink:0, background:N.canvas, borderRight:`1px solid ${N.line2}`, padding:12, overflowY:'auto', display:'flex', flexDirection:'column', gap:10 },
    gVak:   { background:N.paper, border:`1px solid ${N.line2}`, borderRadius:10, padding:'12px 14px', flexShrink:0 },
    gVkop:  { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 },
    // Tabel met de afzetnorm per jaar, in de smalle linkerkolom van 310 px.
    nrmTab:   { width:'100%', borderCollapse:'collapse', fontSize:12.5, marginTop:4 },
    nrmTh:    (uitl) => ({ fontSize:10.5, letterSpacing:'.04em', color:N.ink4, fontWeight:400,
                         textAlign:uitl, padding:'4px 2px', borderBottom:`1px solid ${N.line}`,
                         textTransform:'uppercase', whiteSpace:'nowrap' }),
    nrmTd:    (uitl) => ({ padding:'3px 2px', textAlign:uitl, color:N.ink }),
    nrmInp:   { width:58, fontSize:12.5, textAlign:'right', padding:'2px 5px',
              border:`1px solid ${N.line}`, borderRadius:5, fontFamily:'inherit',
              color:N.ink, background:N.paper },
    nrmKnop:  { fontSize:12, padding:'5px 10px', borderRadius:6, border:`1px solid ${N.line2}`,
              background:N.paper, color:N.ink2, fontFamily:'inherit', cursor:'pointer', width:'100%' },
    // De dichtgeklapte kopregel: de geldende norm van het gekozen jaar, met een
    // pijltje dat de tabel met alle jaren opent.
    nrmKlap:  { display:'flex', alignItems:'baseline', gap:7, width:'100%', marginTop:7,
                padding:'7px 10px', background:N.head, border:`1px solid ${N.line2}`,
                borderRadius:7, cursor:'pointer', fontFamily:'inherit', textAlign:'left' },
    nrmKlapVal: { fontSize:15, fontWeight:700, color:N.ink },
    nrmKlapJr:  { fontSize:12, color:N.ink4 },
    nrmKlapPijl: (open) => ({ marginLeft:'auto', color:N.ink3, display:'flex', alignItems:'center',
                              transform: open ? 'rotate(180deg)' : 'none', transition:'transform .15s' }),
    gLab:   { fontSize:12.5, color:N.ink3 },
    gHint:  { fontSize:11.5, color:N.ink4, lineHeight:1.5, marginTop:6 },
    gInp:   { width:'100%', boxSizing:'border-box', padding:'7px 10px', background:N.head, border:`1px solid ${N.line2}`, borderRadius:7, color:N.ink, fontSize:15, fontWeight:700, fontFamily:'inherit' },
    gBtn:   { width:'100%', background:N.accent, border:'none', borderRadius:8, padding:'9px', fontSize:13, fontWeight:700, color:'#fff', cursor:'pointer', fontFamily:'inherit', display:'flex', alignItems:'center', justifyContent:'center', gap:7 },
    // Het publieke percentage voor het gekozen jaar: het cijfer waar het plan
    // over gaat, dus groot en centraal.
    gGroot: { background:N.head, border:`1px solid ${N.line}`, borderRadius:9, padding:'11px 13px', marginTop:10, textAlign:'center' },
    gGrootL:{ fontSize:12, color:N.ink3, marginBottom:3 },
    gGrootV:{ fontSize:38, fontWeight:700, color:N.accent, lineHeight:1, letterSpacing:'-0.03em', fontVariantNumeric:'tabular-nums' },
    gGrootS:{ fontSize:12.5, color:N.ink3, marginTop:5 },
    gNoot:  { fontSize:11.5, color:N.ink4, lineHeight:1.45, marginTop:8 },
    // ── Tabblad Export ───────────────────────────────────────────────
    eGrid:  { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 },
    eKaart: { background:N.paper, border:`1px solid ${N.line2}`, borderRadius:12, padding:'17px 19px',
              display:'flex', flexDirection:'column' },
    eKop:   { display:'flex', alignItems:'center', gap:11, marginBottom:10 },
    eIcoon: { width:32, height:32, borderRadius:8, background:'#EAF1F3', color:N.accent,
              display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 },
    eNaam:  { fontSize:16, fontWeight:700, color:N.ink },
    eFmt:   { fontSize:12.5, color:N.ink4, fontWeight:600, letterSpacing:'0.04em' },
    eLijst: { fontSize:14, color:N.ink2, margin:'0 0 14px', paddingLeft:18, flex:1, lineHeight:1.5 },
    eBtn:   (vol) => ({ background: vol ? N.accent : N.paper, color: vol ? '#fff' : N.accent,
                        border: vol ? 'none' : `1px solid ${N.line2}`, borderRadius:8, padding:'9px 17px',
                        fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }),
    eHist:  { background:N.paper, border:`1px solid ${N.line2}`, borderRadius:12,
              padding:'17px 19px', marginTop:18 },
    eVersie:(nieuwste) => ({ display:'inline-block', fontSize:12.5, fontWeight:700, padding:'2px 9px',
                             borderRadius:5, background: nieuwste ? N.ok : '#EAF1F3',
                             color: nieuwste ? '#fff' : N.accent }),

    // ── Tabblad Laadinfra-mix ────────────────────────────────────────
    // Alles een slag groter dan elders in de app: deze pagina moet gelezen
    // worden, niet alleen bekeken.
    mLbl:   { fontSize:13, color:N.ink3, fontWeight:600 },
    mNum:   (kleur) => ({ fontSize:30, fontWeight:700, lineHeight:1.2, letterSpacing:'-0.02em',
                          color: kleur || N.ink, fontVariantNumeric:'tabular-nums' }),
    mSub:   { fontSize:13, color:N.ink4 },
    mUitleg:{ fontSize:14, color:N.ink3, margin:'2px 0 14px', maxWidth:'96ch', lineHeight:1.55 },
    mTbl:   { borderCollapse:'collapse', width:'100%', fontSize:14.5 },
    mTh:    (rechts) => ({ padding:'10px 12px', borderBottom:`1px solid ${N.line}`, background:N.head,
                           fontSize:13, textTransform:'uppercase', letterSpacing:'0.05em',
                           color:N.ink3, fontWeight:700, textAlign: rechts ? 'right' : 'left',
                           whiteSpace:'nowrap' }),
    mTd:    (rechts) => ({ padding:'10px 12px', borderBottom:`1px solid ${N.line}`, color:N.ink2,
                           textAlign: rechts ? 'right' : 'left',
                           fontVariantNumeric: rechts ? 'tabular-nums' : 'normal' }),
    mType:  { display:'inline-block', fontSize:12.5, padding:'2px 9px', borderRadius:5,
              background:N.head, border:`1px solid ${N.line}`, color:N.ink2, whiteSpace:'nowrap' },
    mBalk:  (breedte) => ({ display:'flex', height:12, borderRadius:4, overflow:'hidden', width:breedte }),
    mBalkTxt:{ fontSize:12.5, color:N.ink4, marginTop:3, whiteSpace:'nowrap' },
    mKnop:  (aan) => ({ border:`1px solid ${aan ? N.accent : N.line2}`, background: aan ? N.accent : N.paper,
                        color: aan ? '#fff' : N.accent, borderRadius:7, padding:'5px 12px',
                        fontSize:13.5, fontWeight:600, cursor:'pointer', fontFamily:'inherit',
                        whiteSpace:'nowrap' }),
    // De uitgeklapte kern: drie blokken naast elkaar, meer niet.
    mKernCel:{ background:'#F5F9FA', borderBottom:`2px solid ${N.line}`, padding:0 },
    mKern:  { padding:'15px 18px', display:'flex', gap:26, alignItems:'flex-start', flexWrap:'wrap' },
    mKernL: { fontSize:13, color:N.ink3, fontWeight:600, marginBottom:3 },
    mKernV: { fontSize:19, fontWeight:700, color:N.ink, fontVariantNumeric:'tabular-nums' },
    mKernS: { fontSize:13, color:N.ink4 },
    mPijl:  { alignSelf:'center', fontSize:20, color:N.ink4 },
    mKernVoet:{ padding:'0 18px 15px', fontSize:13.5, color:N.ink3, display:'flex',
                justifyContent:'space-between', alignItems:'center', gap:16, flexWrap:'wrap' },
    // De volledige rekensom, alleen zichtbaar als erom gevraagd wordt.
    mReken: { padding:'4px 18px 16px' },
    mStap:  { display:'flex', gap:14, padding:'11px 0', borderTop:`1px dashed ${N.line}` },
    mStapNr:{ width:26, height:26, borderRadius:'50%', background:N.accent, color:'#fff', fontSize:13.5,
              fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 },
    mStapT: { display:'block', fontSize:15, fontWeight:700, color:N.ink, marginBottom:2 },
    mStapR: { display:'block', fontSize:14.5, color:N.ink2 },
    mStapN: { display:'block', fontSize:13, color:N.ink4, marginTop:3 },
    mLeg:   { display:'flex', gap:20, flexWrap:'wrap', fontSize:13.5, marginTop:12, color:N.ink2 },
    mLegRij:{ display:'inline-flex', alignItems:'center', gap:7 },
    mLegBol:{ width:13, height:13, borderRadius:3, flexShrink:0 },
    mParam: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:18, marginTop:4 },
    mParamKop:{ fontSize:14.5, fontWeight:700, color:N.ink, marginBottom:7 },

    // ── Blok Laadpleinen onderaan het Dashboard ──────────────────────
    dPlein:  { background:N.paper, border:`1px solid ${N.accent2}`, borderRadius:12,
               padding:'15px 17px', marginTop:14 },
    dPleinKop:{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:3 },
    dPleinLink:{ border:'none', background:'none', color:N.accent, fontSize:12.5, fontWeight:700,
                 cursor:'pointer', fontFamily:'inherit', padding:0 },
    dPleinDrie:{ display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:14, marginTop:12 },
    // Tabblad Plaatsing: de vier stapkaarten, hun kopjes en de tabel eronder.
    pKaart:  { background:'#fff', border:`1px solid ${N.line}`, borderRadius:10,
               padding:'13px 14px', display:'flex', flexDirection:'column' },
    pStapKop:{ display:'flex', alignItems:'flex-start', gap:9, marginBottom:9 },
    pNr:     { width:20, height:20, flex:'none', borderRadius:'50%', background:N.accent,
               color:'#fff', fontSize:11.5, fontWeight:700, display:'flex',
               alignItems:'center', justifyContent:'center', marginTop:1 },
    pStapNaam:{ fontSize:14, fontWeight:700, lineHeight:1.3 },
    pStapVraag:{ fontSize:12, color:N.ink3, marginTop:2 },
    pBron:   { background:N.head, border:`1px solid ${N.line2}`, borderRadius:6,
               padding:'4px 7px', fontSize:11, lineHeight:1.3 },
    pTh:     { fontSize:13, letterSpacing:'.06em', color:N.ink3, textTransform:'uppercase',
               fontWeight:700, padding:'7px 9px', borderBottom:`1px solid ${N.line2}` },
    pTd:     { fontSize:15, padding:'7px 9px', borderBottom:`1px solid ${N.line2}`,
               fontVariantNumeric:'tabular-nums' },
    dCijfer: { background:N.head, border:`1px solid ${N.line}`, borderRadius:9, padding:'11px 13px' },
    dCijferV:(accent) => ({ fontSize:26, fontWeight:700, lineHeight:1.15,
                            color: accent ? N.accent : N.ink, fontVariantNumeric:'tabular-nums' }),
    dPleinRij:{ display:'flex', justifyContent:'space-between', fontSize:12.5, marginBottom:6, gap:12 },
    dBalk:   { height:22, borderRadius:5, background:N.head, border:`1px solid ${N.line}`,
               overflow:'hidden', display:'flex' },
    dLeg:    { display:'flex', gap:16, marginTop:7, fontSize:12, color:N.ink2, flexWrap:'wrap' },
    dLegRij: { display:'inline-flex', alignItems:'center', gap:6 },
    dVoortgang:{ display:'flex', alignItems:'center', gap:11, marginTop:13, paddingTop:12,
                 borderTop:`1px solid ${N.line}` },
    dVBalk:  { flex:1, height:7, borderRadius:4, background:N.head, overflow:'hidden' },

    // ── Tabblad Laadpleinen ──────────────────────────────────────────
    pRij:    { display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:12.5, color:N.ink2 },
    pWaarde: { fontWeight:700, color:N.ink, fontVariantNumeric:'tabular-nums' },
    pKnop:   (aan) => ({ border:`1px solid ${aan ? N.accent : N.line2}`, background: aan ? N.accent : N.paper,
                         color: aan ? '#fff' : N.ink2, borderRadius:7, padding:'5px 10px', fontSize:12.5,
                         fontWeight: aan ? 700 : 400, cursor:'pointer', fontFamily:'inherit' }),
    pSchakel:(aan) => ({ width:34, height:19, borderRadius:10, border:'none', padding:0, cursor:'pointer',
                         background: aan ? N.accent : N.line2, position:'relative', flexShrink:0 }),
    pSchakelBol:(aan) => ({ position:'absolute', top:2, left: aan ? 17 : 2, width:15, height:15,
                            borderRadius:'50%', background:'#fff', transition:'left .12s' }),
    // De lijst ligt linksboven op de kaart, de legenda rechtsboven. Rechtsonder
    // blijft leeg omdat daar de bronvermelding van de kaart staat.
    pLijst:  { position:'absolute', left:14, top:96, width:330, maxHeight:'calc(100% - 124px)', zIndex:500,
               background:'rgba(255,255,255,.97)', border:`1px solid ${N.line2}`, borderRadius:9,
               boxShadow:'0 3px 14px rgba(18,22,28,.15)', display:'flex', flexDirection:'column' },
    pLijstKop:{ padding:'10px 13px', borderBottom:`1px solid ${N.line}`, fontSize:11.5, fontWeight:700,
                textTransform:'uppercase', letterSpacing:'0.05em', color:N.ink3,
                display:'flex', justifyContent:'space-between', alignItems:'center' },
    pLijstInhoud:{ overflowY:'auto', padding:'2px 0' },
    pKaartje:(aan) => ({ padding:'8px 13px', borderBottom:`1px solid ${N.head}`, cursor:'pointer',
                         background: aan ? '#EAF1F3' : 'transparent',
                         boxShadow: aan ? `inset 3px 0 0 ${N.accent}` : 'none' }),
    pMerk:   (kleur) => ({ display:'inline-block', fontSize:11, padding:'1px 6px', borderRadius:4,
                           marginLeft:6, background:kleur, color:'#fff', verticalAlign:1 }),
    pLink:   { border:'none', background:'none', color:N.accent, fontSize:11.5, fontWeight:700, cursor:'pointer',
               fontFamily:'inherit', textTransform:'uppercase', letterSpacing:'0.05em', padding:0 },
    pLegenda:{ position:'absolute', right:14, top:96, zIndex:500, background:'rgba(255,255,255,.95)',
               border:`1px solid ${N.line2}`, borderRadius:8, padding:'10px 12px', fontSize:12,
               boxShadow:'0 2px 10px rgba(18,22,28,.14)' },
    pLegKop: { fontSize:11, textTransform:'uppercase', letterSpacing:'0.05em', color:N.ink3,
               fontWeight:700, marginBottom:7 },
    pLegRij: { display:'flex', alignItems:'center', gap:8, marginBottom:5, color:N.ink2 },
    pBol:    { width:13, height:13, borderRadius:'50%', flexShrink:0 },
    pStrook: { position:'absolute', left:14, right:14, top:14, zIndex:500, display:'flex',
               background:'rgba(255,255,255,.97)', border:`1px solid ${N.line2}`, borderRadius:9,
               boxShadow:'0 2px 10px rgba(18,22,28,.12)', overflow:'hidden' },
    pStrookVak:{ flex:1, padding:'8px 14px', borderRight:`1px solid ${N.line}` },
    // Technisch fiche per locatie
    fLink:  { fontSize:13, color:N.accent, fontWeight:600, marginTop:6, cursor:'pointer' },
    // Schermvullend sinds 26 oktober 2026 (mockup GIS netbeheerder V15, punt 4).
    fScherm:{ position:'fixed', inset:0, background:'rgba(18,22,28,0.45)', zIndex:2000,
              display:'flex', alignItems:'stretch', justifyContent:'stretch' },
    fVenster:{ width:'100vw', height:'100vh', background:N.paper,
              border:'none', borderRadius:0, display:'flex',
              flexDirection:'column', overflow:'hidden',
              boxShadow:'0 20px 60px rgba(18,22,28,0.28)' },
    fKop:   { padding:'16px 22px', borderBottom:`1px solid ${N.line}`, display:'flex',
              justifyContent:'space-between', alignItems:'center', flexShrink:0 },
    fZij:   { width:300, flexShrink:0, borderLeft:`1px solid ${N.line}`, padding:'18px 20px',
              display:'flex', flexDirection:'column', overflowY:'auto' },
    fVeldKop:{ fontSize:13.5, fontWeight:700, color:N.ink, marginBottom:8 },
    // Tabbladen A en B in de kop van het fiche (fiche V2).
    fDeel:  (a) => ({ padding:'6px 14px', fontSize:13.5, fontWeight:700, fontFamily:'inherit',
              cursor:'pointer', color: a ? N.accent : N.ink3, background:'transparent', border:'none',
              borderBottom:`3px solid ${a ? N.accent : 'transparent'}` }),
    // Melding over de aansluiting, met een lichte achtergrond in de kleur van de vlag.
    fMeld:  (kleur) => ({ fontSize:13, lineHeight:1.5, color:kleur, background:`${kleur}14`,
              border:`1px solid ${kleur}40`, borderRadius:7, padding:'8px 10px', marginTop:8 }),
    fKader: { fontSize:13, lineHeight:1.5, color:'#6B4E12', background:'#FFF7E0',
              border:'1px solid #EED9A4', borderRadius:7, padding:'8px 10px', marginTop:12 },
    fKeus:  (a, uit) => ({ display:'flex', alignItems:'center', gap:6, width:'100%', textAlign:'left',
              padding:'7px 9px', marginBottom:5, fontSize:13, fontFamily:'inherit', lineHeight:1.35,
              cursor: uit ? 'default' : 'pointer', opacity: uit ? 0.5 : 1,
              color: a ? N.ink : N.ink2, fontWeight: a ? 700 : 400,
              background: a ? '#FDEAF4' : N.paper, borderRadius:7,
              border:`1px solid ${a ? AANSLUIT_KLEUR : N.line2}` }),
    fModus: { display:'flex', flexDirection:'column', gap:5, marginBottom:14,
              paddingBottom:14, borderBottom:`1px solid ${N.line}` },
    fModusK:(a) => ({ padding:'7px 12px', fontSize:13, fontWeight:600,
              color: a ? '#fff' : N.ink2, background: a ? N.accent : N.paper,
              border:`1px solid ${a ? N.accent : N.line2}`, borderRadius:7,
              cursor:'pointer', fontFamily:'inherit', width:'100%', textAlign:'left' }),
    fRijRegel:(a) => ({ padding:'6px 10px', fontSize:13.5, borderRadius:6, cursor:'pointer',
              marginBottom:4, color: a ? N.ink : N.ink2, fontWeight: a ? 700 : 400,
              background: a ? N.head : 'transparent',
              border:`1px solid ${a ? N.line2 : 'transparent'}` }),
    fVeldRij:{ display:'flex', alignItems:'center', justifyContent:'space-between',
              gap:10, marginBottom:8 },
    fVeldLabel:{ fontSize:13.5, color:N.ink2 },
    fFout:  { fontSize:13, color:N.red, lineHeight:1.6, marginBottom:10 },
    fKnop:  (sterk) => ({ padding:'8px 14px', fontSize:13.5, fontWeight:600,
              color: sterk ? '#fff' : N.ink2, background: sterk ? N.accent : N.paper,
              border:`1px solid ${sterk ? N.accent : N.line2}`, borderRadius:7,
              cursor:'pointer', fontFamily:'inherit', width:'100%' }),
    pMelding:{ position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)', zIndex:600,
               background:N.paper, border:`1px solid ${N.line2}`, borderRadius:10, padding:'16px 20px',
               fontSize:13.5, color:N.ink2, textAlign:'center', lineHeight:1.6, maxWidth:380,
               boxShadow:'0 4px 16px rgba(18,22,28,.16)' },
    pvRij:  { display:'flex', alignItems:'center', gap:12 },
    pvVal:  { fontSize:20, fontWeight:700, minWidth:56, fontVariantNumeric:'tabular-nums', letterSpacing:'-0.02em', color:N.ink2 },
    // Tabblad Laadpleinen, opbouw volgens mockup V7 (23 oktober 2026).
    lpLinks:   { width:350, flexShrink:0, background:N.paper, borderRight:`1px solid ${N.line2}`, display:'flex', flexDirection:'column', minHeight:0 },
    lpOpgave:  { padding:'14px 16px 12px', borderBottom:`1px solid ${N.line}` },
    lpKopje:   { fontSize:12.5, letterSpacing:'.06em', color:N.ink3, textTransform:'uppercase' },
    lpGetal:   { fontSize:20, fontVariantNumeric:'tabular-nums' },
    lpBalk:    { height:7, borderRadius:4, background:N.head, overflow:'hidden', marginTop:8, border:`1px solid ${N.line}` },
    lpStatussen:{ display:'flex', flexWrap:'wrap', gap:6, padding:'10px 16px', borderBottom:`1px solid ${N.line}` },
    lpStatus:  (aan) => ({ border:`1px solid ${N.line2}`, borderRadius:16, padding:'3px 10px', fontSize:13.5, cursor:'pointer',
                           background:N.paper, opacity: aan ? 1 : 0.4, userSelect:'none' }),
    lpLijstKop:{ display:'flex', alignItems:'center', gap:8, padding:'9px 16px', fontSize:12.5, letterSpacing:'.04em',
                 color:N.ink3, textTransform:'uppercase', borderBottom:`1px solid ${N.line}`, whiteSpace:'nowrap' },
    lpItem:    (aan) => ({ display:'flex', gap:9, alignItems:'flex-start', padding:'9px 16px', cursor:'pointer',
                           borderBottom:`1px solid ${N.line}`, background: aan ? '#EEF5F6' : N.paper,
                           boxShadow: aan ? `inset 3px 0 0 ${N.accent2}` : 'none' }),
    lpKnoppen: { position:'absolute', right:14, top:14, zIndex:600, display:'flex', background:N.paper,
                 border:`1px solid ${N.line2}`, borderRadius:9, overflow:'hidden', boxShadow:'0 2px 10px rgba(18,22,28,.12)' },
    lpKnop:    (aan) => ({ padding:'8px 14px', fontSize:14, cursor:'pointer', borderRight:`1px solid ${N.line}`,
                           background: aan ? N.accent : N.paper, color: aan ? '#fff' : N.ink, userSelect:'none' }),
    lpRechts:  { width:400, flexShrink:0, background:N.paper, borderLeft:`1px solid ${N.line2}`, display:'flex', flexDirection:'column', minHeight:0 },
    lpTabs:    { display:'flex', alignItems:'center', borderBottom:`1px solid ${N.line}` },
    lpTab:     (aan) => ({ padding:'11px 14px', fontSize:14, cursor:'pointer', color: aan ? N.accent : N.ink2,
                           fontWeight: aan ? 600 : 400, borderBottom:`2px solid ${aan ? N.accent : 'transparent'}` }),
    lpSectie:  { borderTop:`1px solid ${N.line}`, marginTop:12, paddingTop:10 },
    lpSectieKop:{ display:'block', fontSize:12, letterSpacing:'.05em', textTransform:'uppercase', color:N.ink3, marginBottom:6 },
    lpRij:     { display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, fontSize:14, padding:'3px 0' },
    lpVeld:    { width:62, padding:'4px 6px', fontSize:14, border:`1px solid ${N.line2}`, borderRadius:6, textAlign:'center',
                 fontWeight:700, fontFamily:'inherit', flexShrink:0 },
    lpGroep:   { display:'block', fontSize:12, fontWeight:700, color:N.ink3, textTransform:'uppercase', letterSpacing:'.05em', margin:'14px 0 6px' },
    // De band met kerncijfers en peiljaar (23 oktober 2026).
    band:   { display:'flex', alignItems:'center', flexWrap:'wrap', gap:'8px 0', background:N.paper,
              borderBottom:`1px solid ${N.line2}`, padding:'9px 20px', flexShrink:0 },
    bandK:  { display:'inline-flex', alignItems:'baseline', gap:6, paddingRight:12, marginRight:12, whiteSpace:'nowrap' },
    jbar:   { background:N.paper, borderBottom:`1px solid ${N.line2}`, padding:'9px 28px', display:'flex', alignItems:'center', gap:11, flexWrap:'wrap', flexShrink:0 },
    jlbl:   { fontSize:11.5, fontWeight:700, letterSpacing:'0.09em', textTransform:'uppercase', color:N.ink4, whiteSpace:'nowrap' },
    jp:     (a) => ({ padding:'3px 7px', fontSize:13, fontWeight:600, color:a?'#fff':N.ink3, border:`1px solid ${a?N.accent:N.line2}`, borderRadius:7, cursor:'pointer', background:a?N.accent:N.paper, fontFamily:'inherit', fontVariantNumeric:'tabular-nums', transition:'all 0.12s' }),
    jreset: { display:'flex', alignItems:'center', justifyContent:'center', width:27, height:27, border:`1px solid ${N.line2}`, borderRadius:7, background:N.paper, cursor:'pointer', color:N.ink3, flexShrink:0, padding:0 },
    jhint:  { fontSize:13, color:N.ink3, marginLeft:6, whiteSpace:'nowrap' },
    // Vergelijkingstabel geselecteerde jaren
    // Blok om brongegevens bij te werken via de bewerkpagina
    lswitch:{ display:'flex', border:`1px solid ${N.line2}`, borderRadius:7, overflow:'hidden' },
    lsw:    (a) => ({ padding:'5px 13px', fontSize:12, fontWeight:600, color: a ? '#fff' : N.ink3, background: a ? N.accent : N.paper, border:'none', cursor:'pointer', fontFamily:'inherit', whiteSpace:'nowrap' }),
    // Wijkenpagina: alle wijken open naast elkaar te vergelijken
    wOpen:  (kleur) => ({ background:N.paper, border:`1px solid ${N.line2}`, borderLeft:`3px solid ${kleur}`, borderRadius:11, padding:'16px 19px', boxShadow:'0 1px 2px rgba(18,22,28,0.04)' }),
    wOKop:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:14 },
    wONaam: { fontSize:15, fontWeight:700, color:N.ink, letterSpacing:'-0.01em' },
    wOType: { fontSize:13, color:N.ink3, marginTop:4 },
    wOCapex:{ fontSize:12.5, fontWeight:600, color:N.ink2, whiteSpace:'nowrap' },
    wOStats:{ display:'grid', gridTemplateColumns:'repeat(5, 1fr)', gap:10, marginBottom:13 },
    wOSL:   { fontSize:11, fontWeight:600, color:N.ink3, textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:3 },
    wOSV:   (kleur) => ({ fontSize:17, fontWeight:700, color: kleur || N.ink, fontVariantNumeric:'tabular-nums', letterSpacing:'-0.015em' }),
    wOMix:  { display:'flex', height:5, borderRadius:3, overflow:'hidden', gap:1, marginBottom:6 },
    wOMixL: { display:'flex', gap:16, fontSize:12.5, color:N.ink3, fontWeight:600, marginBottom:12 },
    wODot:  { width:9, height:9, borderRadius:2, display:'inline-block', marginRight:5 },
    // Tabel met de drie laadsoorten, ingevoerd 20 augustus 2026. Vervangt de
    // balk die alleen de behoefte per soort toonde; nu staat er ook wat er al
    // is en wat er bij moet, want die drie getallen zijn per soort alleen
    // samen te begrijpen.
    wOTab:  { width:'100%', tableLayout:'fixed', borderCollapse:'collapse',
              fontSize:13.5, marginBottom:10 },
    wOTh:   { fontSize:11, letterSpacing:'.06em', color:N.ink4, fontWeight:400,
              padding:'6px 0', borderBottom:`1px solid ${N.line}`, textTransform:'uppercase' },
    wOTd:   { padding:'9px 0', color:N.ink },
    wOTdR:  { padding:'9px 0', color:N.ink, textAlign:'right' },
    wOTdB:  { padding:'9px 0', color:N.ink, textAlign:'right', fontWeight:700 },
    wOSub:  { fontSize:12, color:N.ink4, marginLeft:6 },
    wOSom:  { padding:'9px 0', fontWeight:700, borderTop:`1px solid ${N.line}` },
    wOVoet: { fontSize:12, color:N.ink4, lineHeight:1.6, marginBottom:12 },
    wOVerloop:{ borderTop:`1px solid ${N.line}`, paddingTop:12 },
    wOVLbl: { fontSize:11, fontWeight:700, color:N.ink3, textTransform:'uppercase', letterSpacing:'0.07em', marginBottom:6 },
    // Melding over iets dat nog niet werkt
    // Exportkaarten
    // Kopregel boven de wijkenlijst
    wKop:   { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 },
    wKopT:  { fontSize:13, color:N.ink3 },
    wKopB:  { padding:'8px 15px', borderRadius:8, fontSize:13, fontWeight:700, cursor:'pointer', border:'none', background:N.accent, color:'#fff', fontFamily:'inherit' },
    expGrid:{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:20 },
    expCard:{ background:N.paper, border:`1px solid ${N.line2}`, borderRadius:11, padding:'17px 19px', boxShadow:'0 1px 2px rgba(18,22,28,0.04)' },
    expIcon:{ width:34, height:34, borderRadius:9, background:'#EEF3F4', border:'1px solid #D8E4E6', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:11, color:N.accent },
    expNaam:{ fontSize:14, fontWeight:700, color:N.ink, marginBottom:5, letterSpacing:'-0.01em' },
    expTxt: { fontSize:12.5, color:N.ink3, lineHeight:1.55, marginBottom:13 },
    expBtn: { fontSize:12.5, fontWeight:700, color:'#fff', background:N.accent, border:'none', borderRadius:8, padding:'9px 15px', cursor:'pointer', fontFamily:'inherit' },
    // Wijkkaartje op het tabblad Wijken
    wKaart:  { width:'100%', height:160, borderRadius:8, border:`1px solid ${N.line}`, display:'block' },
    wKaartLeeg:{ width:'100%', height:160, borderRadius:8, border:`1px dashed ${N.line2}`, background:N.paper2, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11.5, color:N.ink4 },
    melding: { background:'#FAF4EA', border:'1px solid #E8DCC4', borderLeft:`3px solid ${N.warn}`, borderRadius:11, padding:'15px 18px', marginTop:16 },
    meldingT:{ fontSize:13, fontWeight:700, color:N.warn, marginBottom:5 },
    meldingS:{ fontSize:12.5, color:N.ink2, lineHeight:1.6 },
    cUitleg:{ fontSize:13, color:N.ink3, padding:'0 2px 8px', lineHeight:1.45 },
    vHdr:   { padding:'10px 18px', borderBottom:`1px solid ${N.line}`, display:'flex', alignItems:'center', justifyContent:'space-between', background:`linear-gradient(180deg,#FDFCFA 0%, ${N.paper} 100%)` },
    vTbl:   { width:'100%', borderCollapse:'collapse' },
    vTh:    (isJaar) => ({ fontSize: isJaar ? 12 : 10.5, fontWeight:700, letterSpacing: isJaar ? 0 : '0.08em', textTransform: isJaar ? 'none' : 'uppercase', color: isJaar ? N.ink : N.ink4, padding:'9px 16px', textAlign: isJaar ? 'right' : 'left', background:N.head, borderBottom:`1px solid ${N.line}`, fontVariantNumeric:'tabular-nums', whiteSpace:'nowrap' }),
    vTd:    (isLabel) => ({ fontSize:13.5, padding:'7px 16px', textAlign: isLabel ? 'left' : 'right', color: isLabel ? N.ink : N.ink2, fontWeight: isLabel ? 600 : 400, borderBottom:'1px solid #F1EEE8', fontVariantNumeric:'tabular-nums', whiteSpace:'nowrap' }),
    vDelta: (omhoog) => ({ display:'block', fontSize:12, fontWeight:600, marginTop:2, color: omhoog ? N.ok : N.ink4 }),
    kpis:   { display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:12, marginBottom:18 },
    kpi:    { background:N.paper, border:`1px solid ${N.line2}`, borderRadius:11, padding:'16px 18px', boxShadow:'0 1px 2px rgba(18,22,28,0.04)' },
    klbl:   { fontSize:11, color:N.ink4, marginBottom:7 },
    knum:   (kleur) => ({ fontSize:27, fontWeight:700, lineHeight:1, letterSpacing:'-0.028em', fontVariantNumeric:'tabular-nums', color: kleur || N.ink }),
    ksub:   { fontSize:11, color:N.ink4, marginTop:5 },
    sl:     { width:'100%', accentColor:N.accent2, cursor:'pointer', margin:'2px 0' },
    tog:    (on) => ({ width:36, height:20, borderRadius:10, background:on?N.accent:N.head, position:'relative', cursor:'pointer', border:`1px solid ${N.line}`, transition:'background 0.2s', flexShrink:0 }),
    tk:     (on) => ({ position:'absolute', top:2, left:on?18:2, width:14, height:14, borderRadius:'50%', background:'#fff', transition:'left 0.2s' }),
    mArea:  { flex:1, display:'flex', flexDirection:'column', position:'relative' },
    ov:     { position:'absolute', top:10, right:10, width:310, background:N.paper, border:`1px solid ${N.line}`, borderRadius:9, padding:'13px 14px', zIndex:500, boxShadow:'0 8px 24px rgba(0,0,0,0.4)' },
    dpR:    { display:'flex', justifyContent:'space-between', gap:12, fontSize:15, padding:'6px 9px', background:N.head, borderRadius:4, marginBottom:3 },
    // De regel 'waarvan in <jaar>' hoort bij de regel erboven en staat daarom
    // ingesprongen, zonder eigen vlak.
    dpSub:  { display:'flex', justifyContent:'space-between', gap:12, fontSize:14, padding:'2px 9px 5px 23px', color:N.ink3 },
    dpVoet: { fontSize:12.5, color:N.ink3, marginTop:9, lineHeight:1.45 },
    // Rechtsonder in de kaart: links zitten de zoomknoppen, boven de schakelaar.
    legB:   { position:'absolute', bottom:30, right:12, background:'rgba(255,255,255,0.94)', border:`1px solid ${N.line2}`, borderRadius:8, padding:'9px 12px', zIndex:500, boxShadow:'0 2px 8px rgba(18,22,28,0.12)', maxWidth:230 },
    legI:   { display:'flex', alignItems:'center', gap:8, fontSize:12.5, color:N.ink2, marginBottom:4 },
    legKop: { fontSize:10.5, fontWeight:700, color:N.ink3, marginBottom:7, letterSpacing:'0.05em', textTransform:'uppercase' },
    legVak: (kleur) => ({ width:16, height:11, borderRadius:2, background:kleur, border:`1px solid ${N.line2}`, flexShrink:0 }),
    legAantal:{ marginLeft:'auto', fontSize:11, color:N.ink4, fontVariantNumeric:'tabular-nums' },
    legCirkel:{ width:14, height:14, borderRadius:'50%', border:`1.5px dashed ${N.ink4}`, flexShrink:0 },
    legBenadering:{ display:'flex', alignItems:'center', gap:8, fontSize:12.5, color:N.ink3,
                    marginTop:6, paddingTop:6, borderTop:`1px solid ${N.line}` },
    legU:   { fontSize:11.5, color:N.ink4, marginTop:6, paddingTop:6, borderTop:`1px solid ${N.line}`, lineHeight:1.4 },
    // Geen vaste hoogte meer: de grafiek erin is 240 hoog en werd bij 185
    // afgeknipt, waardoor de jaartallen onder de as wegvielen.
    chart:  { background:N.paper, padding:'12px 18px 8px', flexShrink:0 },
    cTabs:  { display:'flex', gap:7, marginBottom:8 },
    cTab:   (a) => ({ fontSize:13.5, fontWeight:700, padding:'7px 15px', borderRadius:5, cursor:'pointer', border:`1px solid ${a?N.accent:N.line}`, background:a?N.accent:'transparent', color:a?'#fff':N.ink4 }),
    // ── Wijkpagina ─────────────────────────────────────────────────────
    urgBadge:(kleur) => ({ padding:'3px 10px', borderRadius:20, fontSize:12, fontWeight:600, background:`${kleur}18`, color:kleur, border:`1px solid ${kleur}44`, flexShrink:0 }),
    // ── Detail paneel (wijken) ──────────────────────────────────────────
    errBnr: { background:'rgba(224,92,92,0.1)', border:`1px solid ${N.red}`, borderRadius:5, padding:'6px 10px', fontSize:12, color:N.red, margin:'6px 16px' },
    savBnr: { background:'rgba(78,205,196,0.1)', border:`1px solid ${N.accent2}`, borderRadius:5, padding:'6px 10px', fontSize:12, color:N.accent2, margin:'6px 16px' },
    delModal:{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:3000, display:'flex', alignItems:'center', justifyContent:'center' },
    delBox:  { background:N.paper, border:`1px solid ${N.line}`, borderRadius:10, padding:'24px', width:320, boxShadow:'0 16px 48px rgba(0,0,0,0.5)' },
  };


  // ── Wijkpagina helpers ─────────────────────────────────────────────
  const urgentieKleur = (delta) => delta > 30 ? N.warn : delta > 15 ? N.accent2 : N.ok;
  const urgentieLabel = (delta) => delta > 30 ? 'Hoge prioriteit' : delta > 15 ? 'Middel prioriteit' : 'Lage prioriteit';

  // Leuven en Gent zijn vaste referentiegemeenten en kunnen niet worden verwijderd.
  // Olen is wel verwijderbaar.
  const STANDAARD_IDS = ['leuven','gent'];

  // ── Tijdlijn per wijk (2027-2035) ────────────────────────────────────
  // Berekend on-the-fly voor de geselecteerde wijk in het detailpaneel.
  const wijkTijdreeks = (wijk) => {
    if (!wijk) return [];
    return YEARS.filter(y => y >= 2027).map(yr => {
      const v5SplitJaar = heeftV5Data ? berekenPubliekSemiSplitV5(v5Gemeente, yr) : null;
      const privePctJaar = v5SplitJaar?.privePct_j != null ? v5SplitJaar.privePct_j : gemeente?.privePctBerekend;
      const p = {
        ...calcParams,
        year: yr,
        evAandeelOverride: evOverrideVoorJaar(yr),
        privePct: privePctJaar,
        privePctOverride: privePctVoorJaar(yr),
      };
      const ruwD = calcWijk(wijk, p);
      const stads = stadsVoorJaar(yr).get(wijk.id) || { dc: ruwD.totDC, hpc: ruwD.totHPC };
      const d = { ...ruwD, totDC: stads.dc, totHPC: stads.hpc,
                  totLP: ruwD.totAC + stads.dc + stads.hpc };
      const bestaand = bestaandPerWijk[wijk.id] || { AC: 0, DC: 0, HPC: 0 };
      const delta = {
        AC:  Math.max(0, d.totAC  - bestaand.AC),
        DC:  Math.max(0, d.totDC  - bestaand.DC),
        HPC: Math.max(0, d.totHPC - bestaand.HPC),
      };
      const capex = delta.AC * CAPEX_V2.AC + Math.ceil(delta.DC/2) * CAPEX_V2.DC + Math.ceil(delta.HPC/2) * CAPEX_V2.HPC;
      return {
        jaar: yr,
        totMwh: Math.round(d.mwhPubliek),
        // Cumulatief: alles wat er tussen vandaag en dit jaar bij moet.
        bijkomend: bijTePlaatsenWijk(wijk.id, yr),
        totLP: Math.ceil(d.totLP),
        capex: Math.round(capex / 1000),   // in duizenden euro, cumulatief
        // Extra velden voor de CSV-export. De grafiek gebruikt alleen de velden
        // hierboven; deze zijn puur aanvullend en veranderen niets aan de weergave.
        capexEur: Math.round(capex),
        aanwezig: +(bestaand.AC + bestaand.DC + bestaand.HPC).toFixed(1),
        // Aanwezig per soort, en de behoefte per soort. Nodig om in de export
        // te kunnen zien waarom er bij te plaatsen staat wat er staat: de
        // aftrek gebeurt PER SOORT, dus een overschot aan gewone laadpunten
        // dekt een tekort aan snelladers niet.
        aanwezigAC:  +bestaand.AC.toFixed(1),
        aanwezigDC:  +bestaand.DC.toFixed(1),
        aanwezigHPC: +bestaand.HPC.toFixed(1),
        nodigAC:  Math.ceil(d.totAC),
        nodigDC:  Math.ceil(d.totDC),
        nodigHPC: Math.ceil(d.totHPC),
        deltaAC:  Math.ceil(delta.AC),
        deltaDC:  Math.ceil(delta.DC),
        deltaHPC: Math.ceil(delta.HPC),
        privePct: privePctJaar ?? 0,
      };
    });
  };

  // ── Wijkreeks omgezet naar het jaardeel ────────────────────────────
  // Zelfde rekenwijze als op het Dashboard: het eerste jaar krijgt het volle
  // tekort omdat dan de achterstand van vandaag wordt ingelopen, elk volgend
  // jaar alleen de groei ten opzichte van het jaar ervoor. Daalt de behoefte,
  // dan wordt het nul en niet negatief, want palen worden niet weggehaald.
  // De som over alle jaren komt daardoor precies uit op het cumulatieve totaal
  // van het laatste jaar.
  const wijkTijdreeksPerJaar = (wijk) => {
    const reeks = wijkTijdreeks(wijk);
    return reeks.map((r, i) => {
      const vorige = i > 0 ? reeks[i-1] : null;
      return {
        ...r,
        nieuwDitJaar: vorige ? Math.max(0, r.bijkomend - vorige.bijkomend) : r.bijkomend,
        capexDitJaar: vorige ? Math.max(0, r.capexEur  - vorige.capexEur)  : r.capexEur,
        cumulatief:   r.bijkomend,
      };
    });
  };

  // ── Wijkkaartje als SVG ────────────────────────────────────────────
  // Tekent de vorm van één wijk uit de statistische sectoren die al voor de
  // Leaflet-kaart worden opgehaald. Bewust géén tweede Leaflet-instantie: acht
  // wijken zou acht kaarten betekenen. Dit is een gewone tekening en kost niets.
  const WijkKaartje = ({ wijkId, kleur }) => {
    const vlakken = React.useMemo(() => {
      const fc = sectorenGeo;
      if (!fc?.features?.length) return null;
      const eigen = fc.features.filter(f => f.properties?.WIJK_ID === wijkId);
      if (!eigen.length) return null;

      // Alle ringen verzamelen als lijsten van [lengtegraad, breedtegraad]
      const ringen = [];
      eigen.forEach(f => {
        const g = f.geometry;
        if (!g) return;
        if (g.type === 'Polygon') g.coordinates.forEach(r => ringen.push(r));
        else if (g.type === 'MultiPolygon') g.coordinates.forEach(p => p.forEach(r => ringen.push(r)));
      });
      if (!ringen.length) return null;

      // Uitersten bepalen om op het tekenvlak te passen
      let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
      ringen.forEach(r => r.forEach(([x, y]) => {
        if (typeof x !== 'number' || typeof y !== 'number') return;
        if (x < minX) minX = x; if (x > maxX) maxX = x;
        if (y < minY) minY = y; if (y > maxY) maxY = y;
      }));
      if (!isFinite(minX) || maxX === minX || maxY === minY) return null;

      const B = 300, H = 130, marge = 8;
      // Breedtegraden lopen op het scherm omgekeerd, en op onze breedte is een
      // graad lengte korter dan een graad breedte; die verhouding corrigeren.
      const rekX = Math.cos((minY + maxY) / 2 * Math.PI / 180);
      const brX = (maxX - minX) * rekX, brY = maxY - minY;
      const schaal = Math.min((B - marge*2) / brX, (H - marge*2) / brY);
      const dx = (B - brX * schaal) / 2, dy = (H - brY * schaal) / 2;
      const naarPunt = ([x, y]) => [
        (dx + (x - minX) * rekX * schaal).toFixed(1),
        (dy + (maxY - y) * schaal).toFixed(1),
      ];
      // Alleen punten met echte getallen. Een enkele lege of foute waarde in de
      // brondata zou anders een onbruikbaar pad opleveren dat de browser stil
      // negeert; dan is beter zichtbaar dat er niets te tekenen valt.
      const geldig = ([x, y]) => Number.isFinite(x) && Number.isFinite(y);
      const paden = ringen
        .map(r => r.filter(geldig))
        .filter(r => r.length > 2)
        .map(r => 'M' + r.map(p => naarPunt(p).join(',')).join('L') + 'Z');
      return paden.length ? paden : null;
    }, [wijkId, sectorenGeo]);

    if (!vlakken) {
      return (
        <div style={st.wKaartLeeg}>
          {sectorenGeo ? 'Geen wijkgrens beschikbaar' : 'Wijkgrenzen laden…'}
        </div>
      );
    }
    return (
      <svg viewBox="0 0 300 130" style={st.wKaart} preserveAspectRatio="xMidYMid meet">
        <rect width="300" height="130" fill="#E7E4DF"/>
        {vlakken.map((d, i) => (
          <path key={i} d={d} fill={kleur} fillOpacity="0.28" stroke={kleur} strokeWidth="1.4" strokeLinejoin="round"/>
        ))}
      </svg>
    );
  };

  // ── Export naar Excel ──────────────────────────────────────────────
  // De tabel wordt hier opgebouwd uit dezelfde wijkResults en wijkTijdreeks die
  // ook de tabellen en grafieken vullen, dus de cijfers kunnen niet afwijken.
  // De opmaak gebeurt op de server; die kent het rekenmodel niet en krijgt
  // alleen deze tabel mee.
  const [exportBezig, setExportBezig] = useState(false);
  const [exportFout,  setExportFout]  = useState(null);
  // Welke exportknop op dit moment bezig is, zodat alleen die knop dat toont.
  const [exportKnop,  setExportKnop]  = useState(null);

  // ── Gegevens die alle uitvoer deelt ────────────────────────────────
  const [historie, setHistorie] = useState([]);
  // De Highlights teaser wordt per keer aangezet in de beheeromgeving en
  // vervalt daarna vanzelf. Staat hij uit, dan is er niets te zien.
  const [teaserAan, setTeaserAan] = useState(false);
  const [teaserJaar, setTeaserJaar] = useState(2035);
  const [teaserBezig, setTeaserBezig] = useState(false);

  // De aangewezen locaties, in de vorm die de tekeningen en de bestanden
  // verwachten. Eén plek, zodat het document, het kaartbestand en de kaart
  // gegarandeerd dezelfde lijst gebruiken.
  const gekozenLocaties = React.useMemo(() => {
    const naamVan = { geschikt:'geschikt', niet:'afgevallen', later:'later', open:'nog te doen' };
    return pleinGefilterd
      .filter(r => pleinOordeel[r.id]?.status === 'geschikt')
      .map(r => {
        // Is er een opstelling ingevuld, dan telt die. Anders valt het terug op
        // de schuifknop met de standaardomvang, zodat een gemeente die nog
        // niets per locatie heeft ingevuld dezelfde uitkomst blijft zien.
        const opstelling = pleinOordeel[r.id]?.opstelling || {};
        const v = vermogenVanOpstelling(opstelling);
        const ingevuld = v.palen > 0;
        const punten = ingevuld ? v.punten : Math.min(pleinOmvang, r.vakken ?? pleinOmvang);
        return {
          id: r.id,
          naam: r.naam || `${Number(r.lat).toFixed(5)}, ${Number(r.lng).toFixed(5)}`,
          lat: Number(r.lat), lng: Number(r.lng),
          vakken: r.vakken ?? null, punten, palen: ingevuld ? v.palen : Math.ceil(punten / 2),
          ingevuld, opstelling,
          samenstelling: samenstellingTekst(opstelling),
          kvaMin: ingevuld ? v.kvaMin : null, kvaMax: ingevuld ? v.kvaMax : null,
          vlag: ingevuld ? v.vlag : 'leeg',
          groep: r.groep || '', voorziening: r.voorziening || '', voorzieningM: r.voorzieningM ?? null,
          oordeel: naamVan[oordeelVan(r)] || 'nog te doen',
          notitie: pleinOordeel[r.id]?.notitie || '',
          // Het peiljaar waarvoor deze locatie is vastgelegd. Zonder jaartal
          // telt hij overal mee.
          jaar: pleinOordeel[r.id]?.jaar ?? null,
          // Laadpunten die op deze locatie voor deelwagens zijn voorbehouden.
          // Eis 5 van de leidraad van MOW. Zitten BINNEN punten hierboven.
          deelwagens: pleinOordeel[r.id]?.deelwagens ?? null,
          // Laadpunten voor bestelwagens, { ac, dc }. Zitten ook BINNEN punten.
          bestelwagens: pleinOordeel[r.id]?.bestelwagens ?? null,
          wijk: (wijkResults.find(w => w.wijk.lat != null &&
            Math.hypot((w.wijk.lat - r.lat), (w.wijk.lng - r.lng)) < 0.05)?.wijk?.naam) || '',
        };
      });
  }, [pleinGefilterd, pleinOordeel, pleinOmvang, wijkResults]);

  // Het raster over de gemeente. Wordt alleen opgebouwd op het tabblad Dekking
  // en alleen opnieuw als de sectoren of het inwonertal veranderen, want het
  // bouwen kost het meeste tijd van de hele berekening.
  const dekRaster = React.useMemo(() => {
    // Niet aan een tabblad gebonden: de export gebruikt hetzelfde raster, en
    // die wordt vanaf het tabblad Export gemaakt. Stond hier een voorwaarde op
    // het tabblad, dan bleef het hoofdstuk Dekking uit het document.
    // De adressen erbij: daarmee worden de inwoners van een sector over de
    // vakjes verdeeld naar waar de woningen staan, in plaats van gelijkmatig.
    // Zijn er geen adressen opgehaald, dan rekent hij zoals voorheen.
    return bouwRaster(sectorenRef.current?.features || [], sectorInwoners, 50, adressen);
  }, [gemId, sectorenGeladen, sectorInwoners, adressen]);

  // Welke punten meetellen voor de dekking: de zichtbare laadpalen plus, als
  // die schakelaar aanstaat, de aangewezen laadpleinen.
  const dekZichtbaar = React.useMemo(
    () => dekPunten.filter(p => (p.semi ? dekSemi : (p.snel ? dekSnel : dekPubliek))),
    [dekPunten, dekPubliek, dekSnel, dekSemi]);

  // Alleen de laadpleinen die in het gekozen peiljaar al staan. Een locatie is
  // vastgelegd VOOR een jaar, dus vanaf dat jaar telt hij mee. Zonder jaartal
  // telt hij altijd mee.
  const dekPleinenNu = React.useMemo(
    () => gekozenLocaties.filter(l => l.jaar == null || Number(l.jaar) <= year),
    [gekozenLocaties, year]);

  // ── Tabblad Plaatsing: de rekenkant ──────────────────────────────────
  // De jaren waarover geplot wordt. Dezelfde reeks als de rest van de app.
  const plaatsJaren = React.useMemo(() => YEARS.filter(y => y >= 2027), []);

  // Een schuif geeft tijdens het slepen tientallen waarden na elkaar. Het
  // plotten van negen jaren duurt bij een grote stad een seconde of meer, dus
  // dat gebeurt pas als de schuif een halve seconde stilstaat. Het getal naast
  // de schuif volgt wel meteen, zodat het scherm niet traag aanvoelt.
  const [plaatsPvpTraag, setPlaatsPvpTraag] = useState(plaatsPvp);
  const [plaatsVoorrangTraag, setPlaatsVoorrangTraag] = useState(plaatsVoorrang);
  useEffect(() => {
    const t = setTimeout(() => setPlaatsPvpTraag(plaatsPvp), 500);
    return () => clearTimeout(t);
  }, [plaatsPvp]);
  useEffect(() => {
    const t = setTimeout(() => setPlaatsVoorrangTraag(plaatsVoorrang), 500);
    return () => clearTimeout(t);
  }, [plaatsVoorrang]);

  // De naam van een locatie zoals het locatiepaneel hem toont, voor het venster
  // Wijk impact en de regel op tabblad Wijken. gekozenLocaties zelf toont bij een
  // locatie zonder naam coördinaten; die blijven zo voor het document.
  const pleinNaamVan = React.useMemo(() => {
    const m = {};
    for (const r of pleinGefilterd) m[r.id] = pleinNaamKort(r);
    return m;
  }, [pleinGefilterd, pleinNaamKort]);
  const wijkImpactGekozen = React.useMemo(
    () => gekozenLocaties.map(l => ({ ...l, naam: pleinNaamVan[l.id] || l.naam })),
    [gekozenLocaties, pleinNaamVan]);

  // Wat er per wijk per jaar te verdelen is. Het aantal laadpunten van dat jaar
  // komt uit het rekenmodel; daar gaat eerst het deel af dat op een aangewezen
  // laadplein terechtkomt, en de rest wordt op het raster geplot.
  const plaatsOpdracht = React.useMemo(() => {
    // Het hele jaardeel gaat mee. Wat de aangewezen laadpleinen daarvan
    // opvangen wordt in de plaatsing zelf afgetrokken; het percentage op het
    // tabblad Laadpleinen is een doel en geen aftrek. Anders vielen laadpunten
    // uit het plan in een wijk waar geen plein is aangewezen.
    const jaardeel = {}, nodig = {}, pleinenPerJaar = {};
    for (const w of (gemeente?.wijken || [])) {
      jaardeel[w.id] = {}; nodig[w.id] = {};
      for (const r of wijkTijdreeksPerJaar(w)) {
        jaardeel[w.id][r.jaar] = r.nieuwDitJaar;
        nodig[w.id][r.jaar]    = r.totLP;
      }
    }
    // Een aangewezen locatie zonder jaartal telt vanaf het eerste jaar mee,
    // net als op het tabblad Dekking.
    for (const l of gekozenLocaties) {
      const j = l.jaar == null ? plaatsJaren[0] : Number(l.jaar);
      if (!plaatsJaren.includes(j)) continue;
      (pleinenPerJaar[j] = pleinenPerJaar[j] || []).push(
        { id: l.id, lat: l.lat, lng: l.lng, punten: l.punten, naam: pleinNaamVan[l.id] || l.naam });
    }
    // Dezelfde verdeelsleutel als de kaart op het tabblad Gemeente: auto's per
    // sector als die bekend zijn, anders het inwonertal.
    const gewichtPerSector = {};
    for (const f of (sectorenRef.current?.features || [])) {
      const code = f.properties?.NISCODE;
      if (code) gewichtPerSector[code] = sectorGewicht(code);
    }
    return { jaren: plaatsJaren, jaardeelPerWijkJaar: jaardeel, nodigPerWijkJaar: nodig,
             pleinenPerJaar, gewichtPerSector, straten, loopM: pleinLoop,
             // Grens voor de laadpleinen: het laatste jaar van de planperiode
             // in Parameters (besluit HL 28 oktober 2026).
             eindJaar: Math.max(netcapBegin, netcapEind),
             aandeelPvp: plaatsPvpTraag / 100, voorrang: plaatsVoorrangTraag / 100 };
  }, [gemeente, gemId, gekozenLocaties, pleinNaamVan, plaatsPvpTraag, plaatsVoorrangTraag, pleinLoop, netcapBegin, netcapEind,
      plaatsJaren, bestaandPerWijk, calcParams, sectorenGeladen, sectorGewicht, straten]);

  // De plaatsing zelf. Bewust NIET aan een tabblad gebonden: het tabblad
  // Dekking telt de geplotte palen mee en de export heeft ze later ook nodig.
  // Het is wel de zwaarste berekening van de app, negen jaren over tienduizenden
  // vakjes, dus hij draait alleen opnieuw als een van zijn invoerwaarden wijzigt.
  const plaatsResultaat = React.useMemo(() => {
    if (!dekRaster) return null;
    return plaatsPalen(dekRaster, dekPunten, plaatsOpdracht);
  }, [dekRaster, dekPunten, plaatsOpdracht]);

  // ── Venster Wijk impact ─────────────────────────────────────────────
  // De kandidaten voor de kaart in het venster, met hun wijk volgens het
  // raster. Eén keer per wijziging, anders tekent de kaart bij elke render.
  const wijkImpactKandidaten = React.useMemo(() => {
    if (!wijkImpactOpen) return [];
    const naam = {};
    for (const w of (gemeente?.wijken || [])) naam[w.id] = w.naam;
    return pleinGefilterd.filter(r => r.lat != null && r.lng != null).map(r => ({
      id: r.id, lat: Number(r.lat), lng: Number(r.lng), vakken: r.vakken ?? null,
      naam: pleinNaamVan[r.id] || `${Number(r.lat).toFixed(5)}, ${Number(r.lng).toFixed(5)}`,
      status: pleinOordeel[r.id]?.status || 'open', jaar: pleinOordeel[r.id]?.jaar ?? null,
      wijk: naam[wijkVanPunt(sectorenGeo, Number(r.lat), Number(r.lng))] || '',
    }));
  }, [wijkImpactOpen, pleinGefilterd, pleinOordeel, sectorenGeo, gemeente, pleinNaamVan]);
  const wijkImpactPlan = React.useCallback(
    (lat, lng) => (pleinHeeftPlan ? planSignalen([lat, lng], gisNet.lagen) : null),
    [pleinHeeftPlan, gisNet]);
  const wijkImpactKies = React.useCallback((id) => zetOordeel(id, 'geschikt'), [zetOordeel]);

  // De afstanden van alle geplotte losse palen, voor alle jaren tegelijk. Zo
  // zijn ze ook allemaal bewaard op het moment dat het GIS-bestand ooit wordt
  // verwijderd. Even wachten, want de plaatsing herrekent bij elke schuif.
  useEffect(() => {
    if (!gemId || !gisNet || !plaatsResultaat) return;
    const gezien = new Set();
    const punten = [];
    for (const jr of Object.keys(plaatsResultaat.perJaar || {})) {
      for (const p of plaatsResultaat.perJaar[jr]?.plekken || []) {
        if (p.soort === 'plein' || p.lat == null || p.lng == null) continue;
        const sleutel = paalSleutel(p);
        if (gezien.has(sleutel)) continue;
        gezien.add(sleutel);
        punten.push({ sleutel, lat: p.lat, lng: p.lng });
      }
    }
    if (!punten.length) return;
    let weg = false;
    const t = setTimeout(() => {
      berekenNetAfstanden(gemId, 'paal', punten)
        .then(r => {
          if (weg) return;
          const m = {};
          for (const a of r.afstanden || []) m[a.sleutel] = a;
          setNetAfstPaal(m);
        })
        .catch(e => console.error('Afstanden van de palen niet berekend:', e.message));
    }, 800);
    return () => { weg = true; clearTimeout(t); };
  }, [gemId, gisNet, plaatsResultaat]);

  // Alles wat er tot en met een jaar geplot is, als losse punten voor de kaart
  // en voor de dekkingsberekening.
  const plaatsTotEnMet = React.useCallback((tot) => {
    if (!plaatsResultaat) return [];
    return plaatsJaren.filter(j => j <= tot)
      .flatMap(j => plaatsResultaat.perJaar[j]?.plekken || []);
  }, [plaatsResultaat, plaatsJaren]);

  // De losse palen die het plan tot en met het peiljaar neerzet. Een laadplein
  // uit de plaatsing telt hier niet mee, want dat zit al in dekPleinenNu.
  const dekPlaatsingNu = React.useMemo(
    () => plaatsTotEnMet(year).filter(p => p.soort !== 'plein'),
    [plaatsTotEnMet, year]);

  // De dekking per rastervakje. Hieruit volgen zowel de getallen als het
  // gekleurde gebied op de kaart, zodat die twee nooit uit elkaar kunnen lopen.
  const dekGedekt = React.useMemo(() => {
    if (!dekRaster) return null;
    const punten = [...dekZichtbaar, ...(dekPleinen ? dekPleinenNu : []),
                    ...(dekPlaatsing ? dekPlaatsingNu : [])];
    return bepaalDekking(dekRaster, punten, 250);
  }, [dekRaster, dekZichtbaar, dekPleinenNu, dekPleinen, dekPlaatsing, dekPlaatsingNu]);

  const dekTelling = React.useMemo(
    () => (dekRaster && dekGedekt ? telDekking(dekRaster, dekGedekt) : null),
    [dekRaster, dekGedekt]);

  // Dezelfde telling ZONDER de aangewezen laadpleinen, dus de dekking van
  // vandaag. Het verschil met de telling hierboven is wat het plan oplevert.
  // Zonder het plan betekent: zonder de aangewezen laadpleinen EN zonder de
  // palen van tabblad Plaatsing tot en met het peiljaar. Alleen berekend als
  // een van die twee meetelt; anders valt er niets te vergelijken.
  const dekTellingNu = React.useMemo(() => {
    if (!dekRaster) return null;
    const heeftPlan = (dekPleinen && dekPleinenNu.length) || (dekPlaatsing && dekPlaatsingNu.length);
    if (!heeftPlan) return null;
    return telDekking(dekRaster, bepaalDekking(dekRaster, dekZichtbaar, 250));
  }, [dekRaster, dekZichtbaar, dekPleinen, dekPleinenNu, dekPlaatsing, dekPlaatsingNu]);

  // ── Tabblad Plaatsing: nabij het net ────────────────────────────────
  // Een losse AC-paal hangt altijd aan de straat, dus hier telt de straatkabel.
  const paalNetKlasse = React.useCallback(
    (p) => netKlasse(netAfstPaal[paalSleutel(p)], netGrens, false), [netAfstPaal, netGrens]);
  const plaatsHeeftNet = Object.keys(netAfstPaal).length > 0;
  // Wat er op de kaart en in de tabel van Plaatsing staat. Een laadplein blijft
  // altijd staan; het filter gaat alleen over de losse palen.
  const plaatsNetToon = React.useCallback(
    (p) => plaatsNetFilter === 'alle' || !plaatsHeeftNet || p.soort === 'plein'
      || paalNetKlasse(p) === plaatsNetFilter,
    [plaatsNetFilter, plaatsHeeftNet, paalNetKlasse]);

  // ── Tabblad Plaatsing: het vervolg van de rekenkant ─────────────────
  const plaatsDitJaar = React.useMemo(
    () => (plaatsResultaat?.perJaar[year]?.plekken || [])
      .filter(p => plaatsGebied === 'alle' || p.wijkId === plaatsGebied),
    [plaatsResultaat, year, plaatsGebied]);

  const plaatsEerder = React.useMemo(
    () => plaatsTotEnMet(year - 1)
      .filter(p => plaatsGebied === 'alle' || p.wijkId === plaatsGebied),
    [plaatsTotEnMet, year, plaatsGebied]);

  // De drie stromen van dit jaar voor het gekozen gebied.
  const plaatsVerdeling = React.useMemo(() => {
    const perWijk = plaatsResultaat?.perJaar[year]?.perWijk || {};
    const ids = Object.keys(perWijk)
      .filter(id => plaatsGebied === 'alle' || id === plaatsGebied);
    let totaal = 0, plein = 0, los = 0, teveel = 0;
    for (const id of ids) {
      const r = perWijk[id];
      totaal += r.jaardeel || 0;
      // Wat laadpleinen dit jaar in deze wijk opvangen: een plein van dit of
      // een eerder jaar in de eigen wijk, of een plein in een andere wijk
      // binnen de loopafstand (regel HL 27 oktober 2026).
      plein  += r.viaPlein ?? r.plein ?? 0;
      los    += r.losPunten || 0;
      teveel += r.teveel || 0;
    }
    const pvp   = plaatsDitJaar.filter(p => p.soort === 'pvp').length * 2;
    const nieuw = plaatsDitJaar.filter(p => p.soort === 'nieuw').length * 2;
    // Een plein kan buiten het jaardeel uitkomen; dan is het getoonde totaal de
    // som van wat er werkelijk staat, zodat de drie stromen blijven kloppen.
    return { totaal: Math.max(totaal, plein + pvp + nieuw), plein, pvp, nieuw, los, teveel };
  }, [plaatsResultaat, year, plaatsGebied, plaatsDitJaar]);

  // De dekking aan het begin en aan het eind van dit jaar, met het plan erin.
  const plaatsDekking = React.useMemo(() => {
    if (!dekRaster || !plaatsResultaat) return null;
    const meting = (tot) => telDekking(dekRaster,
      bepaalDekking(dekRaster, [...dekPunten, ...plaatsTotEnMet(tot)], 250));
    const pak = (t) => {
      if (plaatsGebied === 'alle') return t.totaal;
      return t.perWijk.find(w => w.wijkId === plaatsGebied) || t.totaal;
    };
    const voor = meting(year - 1), na = meting(year);
    return { voor: pak(voor), na: pak(na) };
  }, [dekRaster, dekPunten, plaatsResultaat, plaatsTotEnMet, year, plaatsGebied]);

  // Per sector wat er dit jaar bij komt, voor de tabel onder de kaart.
  // Eén regel per STRAAT, niet per sector. Een samenvatting als "Fonteinstraat
  // en 4 andere" verbergt precies wat een gemeente wil weten, namelijk welke
  // straten dat zijn. Plekken in dezelfde straat en dezelfde sector staan wel
  // op één regel, want dat is één straat.
  const plaatsPerStraat = React.useMemo(() => {
    const op = new Map();
    for (const p of plaatsDitJaar.filter(plaatsNetToon)) {
      const sector = p.sector || 'onbekend';
      const straat = p.straat || '';
      const sleutel = `${sector}|${straat}`;
      if (!op.has(sleutel)) {
        op.set(sleutel, { sector, straat, naam: sectorNaamVan(sector, p.sectorNaam) || 'onbekend',
                          wijkId: p.wijkId || null, punten: 0, plekken: 0,
                          soorten: new Set(), zonderDekking: 0, net: [] });
      }
      const o = op.get(sleutel);
      // De afstanden tot het net, per losse paal. Een laadplein wordt op
      // tabblad Laadpleinen beoordeeld en telt hier niet mee.
      if (p.soort !== 'plein' && netAfstPaal[paalSleutel(p)]) o.net.push(netAfstPaal[paalSleutel(p)]);
      o.punten += p.punten;
      o.plekken += 1;
      o.soorten.add(p.soort);
      o.wijkId = p.wijkId || o.wijkId;
      if (p.geenDekking) o.zonderDekking++;
    }
    const inwoners = {};
    for (const r of (dekTelling?.perSector || [])) inwoners[r.sector] = r.inwoners;
    const naam = { nieuw:'nieuwe plek', pvp:'tweede paal', plein:'laadplein' };
    const wijknaam = {};
    for (const w of (gemeente?.wijken || [])) wijknaam[w.id] = w.naam;

    const rijen = [...op.values()].map(o => ({
      ...o,
      wijk: wijknaam[o.wijkId] || 'onbekend',
      inwonersSector: inwoners[o.sector] ?? null,
      straatTekst: o.straat || '—',
      soort: [...o.soorten].map(x => naam[x]).join(' en '),
      waarom: o.soorten.has('plein') ? 'aangewezen op het tabblad Laadpleinen'
        : o.zonderDekking > 0 ? 'geen laadpunt binnen 250 meter'
        : 'veel vraag per laadpunt',
    })).sort((a, b) => a.wijk !== b.wijk ? a.wijk.localeCompare(b.wijk)
      : a.naam !== b.naam ? String(a.naam).localeCompare(String(b.naam))
      : b.punten - a.punten);

    // Het inwonertal hoort bij de SECTOR, niet bij de straat. Het staat daarom
    // alleen op de eerste regel van een sector; anders zou optellen van die
    // kolom hetzelfde aantal mensen meerdere keren tellen.
    let vorige = null;
    for (const r of rijen) {
      r.inwoners = r.sector === vorige ? null : r.inwonersSector;
      vorige = r.sector;
    }
    return rijen;
  }, [plaatsDitJaar, dekTelling, gemeente, plaatsNetToon, netAfstPaal]);

  // Het kerncijfer boven de kaart: hoeveel losse palen van dit jaar binnen de
  // grens van een 400 V-straatkabel staan. Los van het filter Nabij het net.
  const plaatsNetTelling = React.useMemo(() => {
    let totaal = 0, ok = 0;
    for (const p of plaatsDitJaar) {
      if (p.soort === 'plein' || !netAfstPaal[paalSleutel(p)]) continue;
      totaal++;
      if (paalNetKlasse(p) === '400') ok++;
    }
    return { totaal, ok };
  }, [plaatsDitJaar, netAfstPaal, paalNetKlasse]);

  // ── De Excel van Dekking en Plaatsing ────────────────────────────────
  // Alle jaren in één bestand, met de jaren als KOLOMMEN. Een blad per jaar zou
  // negen bladen geven die je naast elkaar moet leggen om iets te vergelijken,
  // en dat doet niemand. De kaart zit er niet in; die hoort in het Word-document.
  const exporteerDekkingPlaatsing = React.useCallback(async () => {
    if (!dekRaster || !plaatsResultaat) {
      setExportFout('De dekking is nog niet berekend. Open het tabblad Dekking en probeer opnieuw.');
      return;
    }
    setExportBezig(true); setExportFout(null);
    try {
      const jaren = plaatsJaren;
      const wijknaam = {};
      for (const w of (gemeente?.wijken || [])) wijknaam[w.id] = w.naam;

      // De dekking aan het eind van elk jaar, met alles wat er dan geplot is.
      // Eén meting per jaar, plus één voor de stand van vandaag.
      const meting = (tot) => telDekking(dekRaster,
        bepaalDekking(dekRaster, [...dekPunten,
          ...plaatsJaren.filter(j => j <= tot).flatMap(j => plaatsResultaat.perJaar[j]?.plekken || [])], 250));
      const nu = telDekking(dekRaster, bepaalDekking(dekRaster, dekPunten, 250));
      const perJaarMeting = {};
      for (const j of jaren) perJaarMeting[j] = meting(j);

      const alleP = jaren.flatMap(j => plaatsResultaat.perJaar[j]?.plekken || []);
      const soortNaam = { plein:'laadplein', pvp:'tweede paal', nieuw:'nieuwe plek' };

      // ── Blad Per jaar ──
      const rijenJaar = jaren.map((j, i) => {
        const p = plaatsResultaat.perJaar[j] || { plekken: [], perWijk: {} };
        const som = (soort) => p.plekken.filter(x => x.soort === soort)
          .reduce((a, x) => a + x.punten, 0);
        const voor = i === 0 ? nu : perJaarMeting[jaren[i - 1]];
        const na = perJaarMeting[j];
        return {
          jaar: String(j),
          erbij: Object.values(p.perWijk).reduce((a, w) => a + (w.jaardeel || 0), 0),
          plein: som('plein'), pvp: som('pvp'), nieuw: som('nieuw'),
          plekken: p.plekken.length,
          inwVoor: voor.totaal.inwonersGedekt, inwNa: na.totaal.inwonersGedekt,
          dekVoor: voor.totaal.deelInwoners, dekNa: na.totaal.deelInwoners,
        };
      });

      // ── Blad Per wijk ── jaren als kolommen, laadpunten en dekking
      const wijkIds = [...new Set(jaren.flatMap(j =>
        Object.keys(plaatsResultaat.perJaar[j]?.perWijk || {})))];
      const rijenWijk = wijkIds.map(id => {
        const r = { wijk: wijknaam[id] || id,
                    inwoners: Math.round(nu.perWijk.find(w => w.wijkId === id)?.inwoners ?? 0),
                    dekNu: nu.perWijk.find(w => w.wijkId === id)?.deelInwoners ?? null };
        let totaal = 0;
        for (const j of jaren) {
          const w = plaatsResultaat.perJaar[j]?.perWijk[id];
          const aantal = w ? (w.plein || 0) + (w.pvp || 0) + (w.nieuw || 0) : 0;
          r[`j${j}`] = aantal;
          totaal += aantal;
          r[`d${j}`] = perJaarMeting[j].perWijk.find(x => x.wijkId === id)?.deelInwoners ?? null;
        }
        r.totaal = totaal;
        return r;
      }).sort((a, b) => b.totaal - a.totaal);

      // ── Blad Per sector ──
      const sectorRij = new Map();
      for (const p of alleP) {
        const code = p.sector || 'onbekend';
        if (!sectorRij.has(code)) {
          sectorRij.set(code, { sector: code, naam: sectorNaamVan(code, p.sectorNaam),
                                wijk: wijknaam[p.wijkId] || '', totaal: 0 });
        }
        const r = sectorRij.get(code);
        r[`j${p.jaar}`] = (r[`j${p.jaar}`] || 0) + p.punten;
        r.totaal += p.punten;
      }
      const rijenSector = [...sectorRij.values()].map(r => {
        const nuS = nu.perSector.find(x => x.sector === r.sector);
        const eind = perJaarMeting[jaren[jaren.length - 1]].perSector.find(x => x.sector === r.sector);
        for (const j of jaren) if (r[`j${j}`] == null) r[`j${j}`] = 0;
        return { ...r, inwoners: nuS ? nuS.inwoners : null,
                 dekNu: nuS ? nuS.deelInwoners : null, dekEind: eind ? eind.deelInwoners : null };
      }).sort((a, b) => b.totaal - a.totaal);

      // ── Blad Plekken ──
      const rijenPlek = alleP.map(p => ({
        jaar: String(p.jaar), wijk: wijknaam[p.wijkId] || '', sector: sectorNaamVan(p.sector, p.sectorNaam),
        straat: p.straat || '', soort: soortNaam[p.soort] || p.soort, punten: p.punten,
        lat: p.lat != null ? Math.round(p.lat * 1e6) / 1e6 : null,
        lng: p.lng != null ? Math.round(p.lng * 1e6) / 1e6 : null,
        kaart: `https://www.google.com/maps/search/?api=1&query=${p.lat},${p.lng}`,
        // Afstanden tot het net, alleen voor losse palen en alleen met een GIS-bestand.
        ...(() => {
          const a = p.soort !== 'plein' ? netAfstPaal[paalSleutel(p)] : null;
          if (!a) return {};
          const k = netKlasse(a, netGrens, false);
          return { d400: a.d400, d230: a.d230, dkast: a.dkast, netKlasse: k ? NET_KLASSE[k].kort : '' };
        })(),
      }));
      const metNet = Object.keys(netAfstPaal).length > 0;

      // ── Blad Bestaande laadpunten ── per sector, uit dezelfde punten waarmee
      // de dekking van vandaag is gemeten.
      const bestaandRij = new Map();
      for (const p of dekPunten) {
        const kx = Math.floor(dekRaster.naarX(p.lng) / dekRaster.vakM);
        const ky = Math.floor(dekRaster.naarY(p.lat) / dekRaster.vakM);
        let code = 'buiten de gemeente', naam = 'buiten de gemeente', wijk = '';
        if (kx >= 0 && kx < dekRaster.nx && ky >= 0 && ky < dekRaster.ny) {
          const si = dekRaster.sectorVanVak[ky * dekRaster.nx + kx];
          if (si >= 0) {
            code = dekRaster.sectoren[si].code;
            naam = dekRaster.sectoren[si].naam || code;
            wijk = wijknaam[dekRaster.sectoren[si].wijkId] || '';
          }
        }
        if (!bestaandRij.has(code)) {
          bestaandRij.set(code, { sector: naam, wijk, punten: 0, gewoon: 0, snel: 0, semi: 0 });
        }
        const r = bestaandRij.get(code);
        r.punten += p.punten;
        if (p.semi) r.semi += p.punten;
        else if (p.snel) r.snel += p.punten;
        else r.gewoon += p.punten;
      }
      const rijenBestaand = [...bestaandRij.values()].sort((a, b) => b.punten - a.punten);

      const kolomJaren = (voorvoegsel, soort) => jaren.map(j =>
        ({ titel: String(j), veld: `${voorvoegsel}${j}`, breedte: 9, soort }));

      await downloadRapport({
        gemeenteId: gemId,
        gemeente: gemeente?.naam || '', onderwerp: 'dekking-en-plaatsing',
        titel: 'Strategisch Laadplan, dekking en plaatsing per jaar',
        ondertitel: `${gemeente?.naam || ''} · ${fmtN(alleP.length)} plekken over ` +
          `${jaren[0]} tot en met ${jaren[jaren.length - 1]}`,
        meta: `Opgesteld op ${new Date().toLocaleDateString('nl-BE')} · dekking binnen ` +
          `250 meter · rastervakjes van 50 bij 50 meter`,
        bladen: [
          { naam: 'Per jaar', kolommen: [
            { titel:'Jaar', veld:'jaar', breedte:8, soort:'tekst', uitleg:'Het peiljaar.' },
            { titel:'Laadpunten erbij', veld:'erbij', breedte:16, soort:'getal', uitleg:'Wat er dat jaar bij komt volgens het rekenmodel.' },
            { titel:'Op een laadplein', veld:'plein', breedte:16, soort:'getal', uitleg:'Laadpunten op de laadpleinen die voor dat jaar zijn aangewezen.' },
            { titel:'Tweede paal', veld:'pvp', breedte:13, soort:'getal', uitleg:'Laadpunten die als tweede paal op een bestaande aansluiting komen.' },
            { titel:'Nieuwe plek', veld:'nieuw', breedte:13, soort:'getal', uitleg:'Laadpunten op een plek waar nu niets staat.' },
            { titel:'Plekken op de kaart', veld:'plekken', breedte:18, soort:'getal', uitleg:'Aantal punten dat dat jaar op de kaart bij komt.' },
            { titel:'Inwoners binnen 250 meter, begin', veld:'inwVoor', breedte:28, soort:'getal', uitleg:'Aan het begin van dat jaar.' },
            { titel:'Inwoners binnen 250 meter, eind', veld:'inwNa', breedte:28, soort:'getal', uitleg:'Aan het eind van dat jaar, met de palen van dat jaar erbij.' },
            { titel:'Dekking begin', veld:'dekVoor', breedte:14, soort:'deel', uitleg:'Deel van de inwoners met een laadpunt binnen 250 meter.' },
            { titel:'Dekking eind', veld:'dekNa', breedte:14, soort:'deel', uitleg:'Zelfde, aan het eind van dat jaar.' },
          ], rijen: rijenJaar },

          { naam: 'Per wijk', kolommen: [
            { titel:'Wijk', veld:'wijk', breedte:26, soort:'tekst', uitleg:'Wijk uit de gemeentegedragen wijkindeling.' },
            { titel:'Inwoners', veld:'inwoners', breedte:11, soort:'getal', uitleg:'Inwoners van de wijk.' },
            { titel:'Dekking nu', veld:'dekNu', breedte:12, soort:'deel', uitleg:'Deel met een laadpunt binnen 250 meter vandaag.' },
            ...kolomJaren('j', 'getal'),
            { titel:'Totaal', veld:'totaal', breedte:10, soort:'getal', uitleg:'Alle laadpunten van dit plan in deze wijk.' },
            ...kolomJaren('d', 'deel'),
          ], rijen: rijenWijk },

          { naam: 'Per sector', kolommen: [
            { titel:'Sector', veld:'naam', breedte:26, soort:'tekst', uitleg:'Statistische sector.' },
            { titel:'Wijk', veld:'wijk', breedte:22, soort:'tekst', uitleg:'De wijk waar de sector bij hoort.' },
            { titel:'Inwoners', veld:'inwoners', breedte:11, soort:'getal', uitleg:'Inwoners van de sector.' },
            { titel:'Dekking nu', veld:'dekNu', breedte:12, soort:'deel', uitleg:'Deel met een laadpunt binnen 250 meter vandaag.' },
            ...kolomJaren('j', 'getal'),
            { titel:'Totaal laadpunten', veld:'totaal', breedte:18, soort:'getal', uitleg:'Alle laadpunten van dit plan in deze sector.' },
            { titel:'Dekking eind', veld:'dekEind', breedte:14, soort:'deel', uitleg:'Deel met een laadpunt binnen 250 meter na het laatste jaar.' },
          ], rijen: rijenSector },

          { naam: 'Plekken', kolommen: [
            { titel:'Jaar', veld:'jaar', breedte:8, soort:'tekst', uitleg:'Het jaar waarin deze plek aan de beurt is.' },
            { titel:'Wijk', veld:'wijk', breedte:22, soort:'tekst', uitleg:'Wijk waarin de plek ligt.' },
            { titel:'Sector', veld:'sector', breedte:22, soort:'tekst', uitleg:'Statistische sector waarin de plek ligt.' },
            { titel:'Straat', veld:'straat', breedte:28, soort:'tekst', uitleg:'De straat waarnaar de plek is getrokken. Leeg betekent dat er binnen 150 meter geen straat bekend was.' },
            { titel:'Wat voor plek', veld:'soort', breedte:16, soort:'tekst', uitleg:'Laadplein, tweede paal op een bestaande aansluiting, of een nieuwe plek.' },
            { titel:'Laadpunten', veld:'punten', breedte:12, soort:'getal', uitleg:'Aantal laadpunten op deze plek.' },
            { titel:'Breedtegraad', veld:'lat', breedte:14, soort:'tekst', uitleg:'Coördinaat van de plek.' },
            { titel:'Lengtegraad', veld:'lng', breedte:14, soort:'tekst', uitleg:'Coördinaat van de plek.' },
            { titel:'Kaart', veld:'kaart', breedte:40, soort:'link', uitleg:'Aanklikbare verwijzing die de plek op de kaart opent.' },
            ...(metNet ? [
              { titel:'Straatkabel 400 V (m)', veld:'d400', breedte:20, soort:'getal', uitleg:'Hemelsbrede afstand tot de dichtstbijzijnde straatkabel op 400 V. Leeg bij een laadplein.' },
              { titel:'Straatkabel 230 V (m)', veld:'d230', breedte:20, soort:'getal', uitleg:'Hemelsbrede afstand tot de dichtstbijzijnde straatkabel op 230 V. Leeg bij een laadplein.' },
              { titel:'Verdeelkast (m)', veld:'dkast', breedte:16, soort:'getal', uitleg:'Hemelsbrede afstand tot de dichtstbijzijnde verdeelkast. Leeg bij een laadplein.' },
              { titel:`Net binnen ${netGrens} m`, veld:'netKlasse', breedte:20, soort:'tekst', uitleg:`400 V, alleen 230 V of geen straatkabel binnen ${netGrens} m. Een laadplein wordt op tabblad Laadpleinen beoordeeld.` },
            ] : []),
          ], rijen: rijenPlek },

          { naam: 'Bestaande laadpunten', kolommen: [
            { titel:'Sector', veld:'sector', breedte:26, soort:'tekst', uitleg:'Statistische sector.' },
            { titel:'Wijk', veld:'wijk', breedte:22, soort:'tekst', uitleg:'De wijk waar de sector bij hoort.' },
            { titel:'Laadpunten nu', veld:'punten', breedte:15, soort:'getal', uitleg:'Wat er vandaag staat volgens de gegevens van MOW.' },
            { titel:'Publiek gewone paal', veld:'gewoon', breedte:20, soort:'getal', uitleg:'Publieke laadpunten tot 22 kW.' },
            { titel:'Publiek snellader', veld:'snel', breedte:18, soort:'getal', uitleg:'Publieke laadpunten van 50 kW en meer.' },
            { titel:'Semipubliek', veld:'semi', breedte:14, soort:'getal', uitleg:'Laadpunten die niet 24 uur per dag toegankelijk zijn.' },
          ], rijen: rijenBestaand },
        ],
        toelichting: [
          ['Dekking', 'Een inwoner is gedekt als er binnen 250 meter hemelsbreed een laadpunt staat.'],
          ['Ultrasnelladers', 'Tellen niet mee voor de dekking; die bedienen doorgaand verkeer en geen buurt.'],
          ['Een plek', 'Een vakje van 50 bij 50 meter, getrokken naar de dichtstbijzijnde straat. Geen adres en geen parkeervak.'],
          ['Inwoners', 'Gelijk verdeeld over de vakjes van hun statistische sector; fijner is niet bekend.'],
          ['De jaren', 'Elk jaar bouwt voort op de jaren ervoor: wat in 2028 geplot is, staat er in 2029 nog.'],
          ...(metNet ? [['Netgegevens', `Afstanden tot het net volgens de netgegevens van Fluvius, peildatum ${
            peildatumLang(Object.values(netAfstPaal)[0]?.peildatum)}. `
            + 'De netgegevens tonen waar kabels, cabines en kasten liggen. Ze zeggen niets over de vrije '
            + 'capaciteit op het net en zijn geen toezegging van de netbeheerder.']] : []),
        ],
      });
    } catch (e) {
      setExportFout(e.message);
    } finally {
      setExportBezig(false);
    }
  }, [dekRaster, plaatsResultaat, dekPunten, plaatsJaren, gemeente, gemId, netAfstPaal, netGrens]);

  // ── Tabblad Plaatsing: de kaart ──────────────────────────────────────
  useEffect(() => {
    if (tab !== 'plaatsing' || !plaatsMapRef.current) return;
    if (!plaatsMap.current) {
      plaatsMap.current = L.map(plaatsMapRef.current, {
        center: [gemeente?.wijken?.[0]?.lat ?? 50.88, gemeente?.wijken?.[0]?.lng ?? 4.70],
        zoom: 12, zoomControl: false,
      });
      L.control.zoom({ position: 'bottomleft' }).addTo(plaatsMap.current);
      L.tileLayer(KAART_ADRES, {
        attribution: '© OpenStreetMap · CARTO', maxZoom: 19,
      }).addTo(plaatsMap.current);
      plaatsLaag.current = L.layerGroup().addTo(plaatsMap.current);
      // Vaste lagen voor het stroomnet en voor de palen erbovenop.
      maakNetPanes(plaatsMap.current);
    }
    const t = setTimeout(() => plaatsMap.current?.invalidateSize(), 60);
    return () => clearTimeout(t);
  }, [tab, gemeente]);

  // Het stroomnet van Fluvius op de kaart van Plaatsing.
  useEffect(() => {
    if (tab !== 'plaatsing' || !plaatsMap.current) return;
    tekenStroomnet(plaatsMap.current, gisNet?.aanwezig ? gisNet.lagen : null, netZicht);
  }, [tab, gisNet, netZicht]);

  useEffect(() => {
    if (tab !== 'plaatsing' || !plaatsLaag.current) return;
    const laag = plaatsLaag.current;
    laag.clearLayers();

    // De sectoren, gekleurd naar de tekortscore van dit jaar. Vier vaste tinten
    // in plaats van doorzichtigheid: over een lichte ondergrond is een
    // doorzichtige laag nauwelijks te onderscheiden.
    const TINT = ['#EFF3F4', '#D2DFE2', '#A9C3C9', '#7FA7B0'];
    const tekort = plaatsResultaat?.perJaar[year]?.tekortSector || {};
    const waarden = Object.values(tekort).filter(v => v > 0).sort((a, b) => a - b);
    const grens = (deel) => waarden.length ? waarden[Math.floor(waarden.length * deel)] : 0;
    const g1 = grens(0.25), g2 = grens(0.5), g3 = grens(0.75);
    const tintVan = (code) => {
      const v = tekort[code] || 0;
      if (!(v > 0)) return TINT[0];
      return v <= g1 ? TINT[0] : v <= g2 ? TINT[1] : v <= g3 ? TINT[2] : TINT[3];
    };
    // Is er een wijk gekozen, dan houdt alleen die wijk zijn kleur en wordt de
    // rest neutraal grijs. Anders zie je wel dat de kaart inzoomt maar niet waar
    // je naar moet kijken.
    const BUITEN = '#EDEBE6';
    const vulVan = (f) => (plaatsGebied === 'alle' || f.properties?.WIJK_ID === plaatsGebied)
      ? tintVan(f.properties?.NISCODE) : BUITEN;

    const vormen = sectorenRef.current?.features || [];
    if (vormen.length) {
      L.geoJSON({ type:'FeatureCollection', features: vormen }, {
        // Half doorzichtig: de kleur geeft de tekortscore aan, maar de straten
        // van de ondergrond moeten zichtbaar blijven. Anders is een stip niet
        // aan een straat te koppelen, en daar is dit tabblad juist voor.
        style: (f) => ({ color:'#C9C4BB', weight:1, opacity:0.9,
                         fillColor: vulVan(f),
                         fillOpacity: (plaatsGebied === 'alle' ||
                                       f.properties?.WIJK_ID === plaatsGebied) ? 0.45 : 0.3 }),
        interactive: false,
      }).addTo(laag);
      L.geoJSON({ type:'FeatureCollection', features: vormen }, {
        style: { color:'#3D4652', weight:2.5, opacity:0.55, fill:false },
        interactive: false,
      }).addTo(laag);
      // De gekozen wijk met een dikke rand eromheen, zodat duidelijk is welk
      // gebied het betreft nu de buurwijken ook in beeld staan.
      if (plaatsGebied !== 'alle') {
        const eigen = vormen.filter(f => f.properties?.WIJK_ID === plaatsGebied);
        if (eigen.length) {
          L.geoJSON({ type:'FeatureCollection', features: eigen }, {
            style: { color:'#1F5C6B', weight:3.5, opacity:0.95, fill:false },
            interactive: false,
          }).addTo(laag);
        }
      }
    }
    // Bij een andere gemeente of een andere wijk de kaart opnieuw richten. Kies
    // je een wijk, dan zoomt hij in op die wijk met ruime marge, zodat je ziet
    // waar hij ligt en welke wijken eromheen liggen.
    const merk = `${gemId}|${plaatsGebied}`;
    if (vormen.length && plaatsGetoond.current !== merk) {
      try {
        const eigen = plaatsGebied === 'alle'
          ? vormen : vormen.filter(f => f.properties?.WIJK_ID === plaatsGebied);
        const rand = L.geoJSON({ type:'FeatureCollection',
          features: eigen.length ? eigen : vormen }).getBounds();
        if (rand.isValid()) {
          plaatsMap.current?.fitBounds(rand,
            { padding: plaatsGebied === 'alle' ? [24, 24] : [60, 60] });
        }
        plaatsGetoond.current = merk;
      } catch (e) {
        console.warn('Kaart niet op het gebied te zetten:', e.message);
      }
    }

    // Wat er nu al staat, klein en grijs.
    for (const p of dekPunten) {
      L.circleMarker([p.lat, p.lng], { pane: KAND_PANE, radius: 3, color:'#fff', weight: 0.8,
        fillColor: '#AAB4B7', fillOpacity: 1, interactive: false }).addTo(laag);
    }
    // Wat in eerdere jaren van dit plan is geplot.
    for (const p of plaatsEerder.filter(plaatsNetToon)) {
      const afst = p.soort !== 'plein' ? netAfstPaal[paalSleutel(p)] : null;
      L.circleMarker([p.lat, p.lng], { pane: KAND_PANE, radius: 5, color:'#fff', weight: 1.2,
        fillColor: '#7FAEBB', fillOpacity: 1 })
        .bindTooltip(`${sectorNaamVan(p.sector, p.sectorNaam)} · geplot in ${p.jaar} · ${p.punten} laadpunten`
          + (afst ? `<br>${netRegelPaal(afst)}` : ''))
        .addTo(laag);
    }
    // Dit jaar: eerst een lichte halo, dan de stip, zodat het verschil met de
    // eerdere jaren ook op een drukke kaart meteen te zien is.
    for (const p of plaatsDitJaar.filter(plaatsNetToon)) {
      const plein = p.soort === 'plein';
      const afst = !plein ? netAfstPaal[paalSleutel(p)] : null;
      if (!plein) {
        L.circleMarker([p.lat, p.lng], { pane: KAND_PANE, radius: 12, weight: 0, fillColor: '#1F5C6B',
          fillOpacity: 0.20, interactive: false }).addTo(laag);
      }
      L.circleMarker([p.lat, p.lng], {
        pane: KAND_PANE,
        radius: plein ? 8 : 7, color: '#fff', weight: 2,
        fillColor: plein ? '#B87333' : '#1F5C6B', fillOpacity: 1,
      }).bindTooltip(
        `${p.straat || sectorNaamVan(p.sector, p.sectorNaam)} · ${plein ? (p.naam || 'laadplein') :
          (p.soort === 'pvp' ? 'tweede paal op een bestaande aansluiting' : 'nieuwe plek')} · ` +
        `${p.punten} laadpunten` + (afst ? `<br>${netRegelPaal(afst)}` : '')).addTo(laag);
    }
  }, [tab, plaatsResultaat, plaatsDitJaar, plaatsEerder, dekPunten, year,
      gemId, sectorenGeladen, plaatsGebied, plaatsNetToon, netAfstPaal]);

  useEffect(() => {
    if (tab !== 'dekking' || !dekLaag.current) return;
    const laag = dekLaag.current;
    laag.clearLayers();

    // Het gebied ZONDER dekking, als één afbeelding over de kaart. Hij gaat in
    // DEZELFDE groep als de rest, en als eerste, zodat hij onderop ligt en bij
    // elke hertekening vanzelf verdwijnt met clearLayers hierboven.
    //
    // Stond hij los op de kaart met eigen opruimwerk, dan bleef er bij het
    // omzetten van een schakelaar een oude afbeelding achter. Die stapelden op
    // elkaar: de kleuren werden donkerder en gingen daarna niet meer terug.
    if (dekVlekken && dekRaster && dekGedekt) {
      const beeld = maakDekkingBeeld(dekRaster, dekGedekt);
      if (beeld) {
        L.imageOverlay(beeld.dataUrl, beeld.grenzen, {
          opacity: 1, interactive: false,
        }).addTo(laag);
      }
    }

    const K = DEK_KLEUR;
    const kleurVan = p => p.semi ? K.semi : (p.snel ? K.snel : K.publiek);

    // Eerst de gemeente zelf, anders zweven de stippen los op de ondergrond.
    // De sectorvormen worden twee keer getekend: onderaan met een dikke donkere
    // rand, daarbovenop met een dunne lichte. De buitenrand van de gemeente
    // houdt daardoor een duidelijke lijn, terwijl de grenzen binnenin fijn
    // blijven. Echte wijkgrenzen hebben we niet als vorm; de wijknamen staan
    // er daarom als label bij, ter oriëntatie.
    const vormen = sectorenRef.current?.features || [];
    if (vormen.length) {
      // GEEN vulling: die ligt over de rode laag heen en maakt hem bleek.
      // Alleen de grenzen, zodat de gemeente herkenbaar blijft.
      L.geoJSON({ type:'FeatureCollection', features: vormen }, {
        style: { color:'#3D4652', weight:2.5, opacity:0.7, fill:false },
        interactive: false,
      }).addTo(laag);
      L.geoJSON({ type:'FeatureCollection', features: vormen }, {
        style: { color:'#FFFFFF', weight:1, opacity:0.7, fill:false },
        interactive: false,
      }).addTo(laag);
    }
    // Bij een andere gemeente de kaart op die gemeente zetten. Zonder dit
    // blijft het beeld staan waar het stond en kijk je naar de vorige stad.
    if (vormen.length && dekGetoond.current !== gemId) {
      try {
        const rand = L.geoJSON({ type:'FeatureCollection', features: vormen }).getBounds();
        if (rand.isValid()) dekMap.current?.fitBounds(rand, { padding: [24, 24] });
        dekGetoond.current = gemId;
      } catch (e) {
        console.warn('Kaart niet op de gemeente te zetten:', e.message);
      }
    }

    for (const w of (gemeente?.wijken || [])) {
      if (w.lat == null || w.lng == null) continue;
      L.marker([w.lat, w.lng], {
        interactive: false,
        icon: L.divIcon({
          className: '',
          html: `<div style="font-size:12.5px;font-weight:700;color:#3D4652;white-space:nowrap;
                   text-shadow:0 0 3px #fff,0 0 3px #fff,0 0 3px #fff;transform:translate(-50%,-50%)">
                   ${w.naam}</div>`,
        }),
      }).addTo(laag);
    }
    // Eerst de cirkels, daarna de stippen, zodat de stippen bovenop liggen.
    const cirkel = (lat, lng, kleur) => L.circle([lat, lng], {
      radius: 250, color: kleur, weight: 1, opacity: 0.45,
      fillColor: kleur, fillOpacity: 0.10, interactive: false,
    }).addTo(laag);
    const stip = (lat, lng, kleur, straal, titel) => L.circleMarker([lat, lng], {
      radius: straal, color: '#fff', weight: 1.5, fillColor: kleur, fillOpacity: 1,
    }).bindTooltip(titel).addTo(laag);

    const tonen = dekZichtbaar;
    if (dekCirkels) {
      for (const p of tonen) cirkel(p.lat, p.lng, kleurVan(p));
      if (dekPleinen) for (const l of dekPleinenNu) cirkel(l.lat, l.lng, K.plein);
    }
    for (const p of tonen) {
      stip(p.lat, p.lng, kleurVan(p), 4,
        `${p.semi ? 'Semipubliek' : 'Publiek'}${p.snel ? ' · snellader' : ' · gewone paal'} · ` +
        `${p.punten} laadpunt${p.punten > 1 ? 'en' : ''}`);
    }
    if (dekPleinen) {
      for (const l of dekPleinenNu) {
        stip(l.lat, l.lng, K.plein, 7,
          `${l.naam} · ${l.punten} laadpunten` + (l.jaar ? ` · vastgelegd voor ${l.jaar}` : ''));
      }
    }
    // De palen die het tabblad Plaatsing tot en met dit jaar neerzet. Ze tellen
    // mee in het percentage, dus ze horen ook op de kaart te staan.
    if (dekPlaatsing) {
      if (dekCirkels) for (const p of dekPlaatsingNu) cirkel(p.lat, p.lng, KLEUR_PLAN);
      for (const p of dekPlaatsingNu) {
        stip(p.lat, p.lng, KLEUR_PLAN, 5,
          `Uit het plan · ${p.jaar} · ${p.punten} laadpunten`);
      }
    }
  }, [tab, dekZichtbaar, dekPleinenNu, dekPleinen, dekCirkels, dekPlaatsing, dekPlaatsingNu,
      dekVlekken, dekRaster, dekGedekt, gemeente, gemId, sectorenGeladen]);

  // De kaart voor het tabblad Netcapaciteit. Dezelfde tekenfunctie die het
  // rapport gebruikt, dus dezelfde wijkvormen en dezelfde kleurenschaal als
  // elders in de app. Gekleurd naar het gevraagde aansluitvermogen per wijk,
  // met de gekozen locaties als stip.
  // Gedeeld tussen het scherm en het rapport: het gevraagde vermogen per wijk
  // en de ruimte op het net per wijk.
  // Het getal in de wijk op de kaart volgt het slim-ladenscenario. De KLEUR
  // niet: die is de ruimte op het net volgens de netbeheerder en verandert
  // niet doordat wij het vermogen anders verdelen.
  const netcapVermogenVanWijk = useCallback((w) => {
    const rs = (netcapUit?.regels || []).filter(r =>
      r.binnenPeriode && r.gebiedId === w.id &&
      (netcapWijkJaar === '' || r.jaar === Number(netcapWijkJaar)));
    const slim = rs.some(r => (r.slimAandeel || 0) > 0);
    return rs.reduce((a, r) => a + ((slim ? r.kvaSlimMax : r.kvaMax) || 0), 0);
  }, [netcapUit, netcapWijkJaar]);
  // Het gevraagde vermogen per sector: het wijkgetal maal het aandeel van die
  // sector in het inwonertal van zijn wijk. Zijn de inwoners niet bekend, dan
  // wordt gelijk verdeeld over de sectoren van die wijk.
  const netcapKvaPerSector = React.useMemo(() => {
    const uit = {};
    const kenmerken = sectorenRef.current?.features || [];
    if (!kenmerken.length) return uit;
    const perWijk = {};
    for (const f of kenmerken) {
      const wid = f.properties?.WIJK_ID;
      if (!wid) continue;
      (perWijk[wid] = perWijk[wid] || []).push(f);
    }
    for (const [wid, eigen] of Object.entries(perWijk)) {
      const totaal = eigen.reduce((a, f) => a + sectorGewicht(f.properties?.NISCODE), 0);
      const gewichten = {};
      for (const f of eigen) {
        const code = f.properties?.NISCODE;
        gewichten[code] = totaal > 0 ? sectorGewicht(code) : 1;
      }
      // In hele kVA verdelen, zodat de optelling van de sectoren exact het
      // wijkgetal geeft dat elders in de app staat.
      Object.assign(uit, verdeelHeel(netcapVermogenVanWijk({ id: wid }), gewichten));
    }
    return uit;
  }, [netcapVermogenVanWijk, sectorInwoners, sectorWagens, sectorenGeladen, sectorGewicht]);

  // Voor het Word-document en de Excel: dezelfde kaart, maar ZONDER het getal
  // per sector. Met 134 sectoren naast 24 wijkgetallen is dat op papier niet
  // te lezen, en anders dan op het scherm kun je er niet op inzoomen of met de
  // muis overheen gaan. De kleur per sector blijft, want die draagt het verhaal.
  const netcapKaartOptiesRapport = React.useMemo(() => ({
    netruimteVan: netcapUit?.netruimte ? (w) => netcapUit.netruimte[w.id]?.ruimte : null,
    netruimtePerSector: netcapUit?.netruimteSector || null,
    // GEEN opschriften op de kaart in het rapport. Sinds de wijkindeling van de
    // gemeente wordt gebruikt zijn er veel meer en veel kleinere wijken; bij
    // Leuven vierentwintig, waarvan de meeste dicht bij elkaar in het centrum.
    // De getallen liepen daardoor over elkaar heen en zelfs over de legenda.
    // Het vermogen per wijk staat in de tabel eronder, met de ruimte op het
    // net erbij; de kaart laat alleen zien WAAR het net krap is.
  }), [netcapUit]);

  const netcapKaartOpties = React.useMemo(() => ({
    netruimteVan: netcapUit?.netruimte ? (w) => netcapUit.netruimte[w.id]?.ruimte : null,
    // De ruimte op het net wordt per statistische sector gemeten. De kaart
    // kleurt daarom die sectoren, niet de wijken.
    netruimtePerSector: netcapUit?.netruimteSector || null,
    // Het gevraagde vermogen staat zowel per sector als per wijk in beeld. Het
    // wijkgetal wordt over de sectoren verdeeld naar inwonertal, dezelfde
    // regel als op het tabblad Gemeente.
    labelPerSector: (code) => {
      const k = netcapKvaPerSector[code];
      return k >= 1 ? `${Math.round(k).toLocaleString('nl-BE')}` : '';
    },
    titelPerSector: (code) => {
      const f = (sectorenRef.current?.features || [])
        .find(x => x.properties?.NISCODE === code);
      const naam = f?.properties?.NAAM || code;
      const wijk = (gemeente?.wijken || []).find(w => w.id === f?.properties?.WIJK_ID);
      const kva = Math.round(netcapKvaPerSector[code] || 0).toLocaleString('nl-BE');
      const inw = sectorInwoners[code];
      const ruimte = netcapUit?.netruimteSector?.[code];
      return `${naam}` +
        (wijk ? ` (${wijk.naam})` : '') +
        ` · ${kva} kVA` +
        (inw != null ? ` · ${inw.toLocaleString('nl-BE')} inwoners` : '') +
        (ruimte ? ` · net ${ruimte}` : '');
    },
    labelVan: (w) => {
      const k = netcapVermogenVanWijk(w);
      return k ? `${Math.round(k).toLocaleString('nl-BE')} kVA` : '';
    },
  }), [netcapUit, netcapVermogenVanWijk, netcapKvaPerSector, sectorInwoners, gemeente, sectorenGeladen]);

  // De kaart op het tabblad Netcapaciteit: aanmaken en tekenen in EEN blok.
  // Stonden die apart, dan kon het tekenen stilletjes overslaan omdat de kaart
  // nog niet bestond, en zag je een leeg vlak zonder melding.
  useEffect(() => {
    if (tab !== 'netcapaciteit') return;
    if (!netcapMapRef.current) {
      console.warn('Netcapaciteit: de plek voor de kaart bestaat nog niet.');
      return;
    }
    if (!netcapMap.current) {
      netcapMap.current = L.map(netcapMapRef.current, {
        center: [gemeente?.wijken?.[0]?.lat ?? 50.88, gemeente?.wijken?.[0]?.lng ?? 4.70],
        zoom: 12, zoomControl: false,
      });
      L.control.zoom({ position: 'bottomleft' }).addTo(netcapMap.current);
      L.tileLayer(KAART_ADRES, {
        attribution: '\u00a9 OpenStreetMap \u00b7 CARTO', maxZoom: 19,
      }).addTo(netcapMap.current);
      netcapLaag.current = L.layerGroup().addTo(netcapMap.current);
    }
    // Na het tonen van een verborgen paneel weet Leaflet zijn afmetingen niet.
    const tijd = setTimeout(() => netcapMap.current?.invalidateSize(), 60);

    const laag = netcapLaag.current;
    laag.clearLayers();
    const vormen = sectorenRef.current?.features || [];
    // Geen vormen betekent alleen: nog niets te tekenen. De kaart zelf staat er
    // dan al, met de ondergrond, en vult zich zodra de sectoren binnen zijn.
    if (!vormen.length) return () => clearTimeout(tijd);

    // Elke sector krijgt de kleur die de netbeheerder voor die sector meet.
    for (const f of vormen) {
      const code = f.properties?.NISCODE;
      const ruimte = netcapUit?.netruimteSector?.[code];
      const kleur = NET_RUIMTE_KLEUR[ruimte] || '#E7E4DF';
      const wijk = (gemeente?.wijken || []).find(w => w.id === f.properties?.WIJK_ID);
      const kva = Math.round(netcapKvaPerSector[code] || 0);
      L.geoJSON(f, {
        style: { color:'#FFFFFF', weight:1, opacity:0.9, fillColor:kleur, fillOpacity:0.75 },
      })
        .bindTooltip(`<b>${sectorNaam(code)}</b>` +
          (wijk ? `<br>${wijk.naam}` : '') +
          `<br>${kva.toLocaleString('nl-BE')} kVA` +
          (ruimte ? `<br>Ruimte op het net: ${ruimte}` : ''), { sticky: true })
        .addTo(laag);
    }

    // Het vermogen per sector klein, het wijktotaal groot erbovenop.
    for (const f of vormen) {
      const kva = Math.round(netcapKvaPerSector[f.properties?.NISCODE] || 0);
      if (kva < 1) continue;
      const punt = middelpuntVanVorm(f.geometry);
      if (!punt) continue;
      L.marker([punt.lat, punt.lng], { interactive: false, icon: L.divIcon({ className: '',
        html: `<div style="font-size:11px;font-weight:600;color:#12161C;white-space:nowrap;`
            + `text-shadow:0 0 3px #fff,0 0 3px #fff,0 0 3px #fff;transform:translate(-50%,-50%)">`
            + `${kva.toLocaleString('nl-BE')}</div>` }) }).addTo(laag);
    }
    for (const w of (gemeente?.wijken || [])) {
      if (w.lat == null || w.lng == null) continue;
      const kva = Math.round(netcapVermogenVanWijk(w) || 0);
      if (kva < 1) continue;
      L.marker([w.lat, w.lng], { interactive: false, icon: L.divIcon({ className: '',
        html: `<div style="font-size:14px;font-weight:700;color:#12161C;white-space:nowrap;`
            + `text-shadow:0 0 4px #fff,0 0 4px #fff,0 0 4px #fff;transform:translate(-50%,-50%)">`
            + `${kva.toLocaleString('nl-BE')} kVA</div>` }) }).addTo(laag);
    }

    for (const l of gekozenLocaties) {
      L.circleMarker([l.lat, l.lng], { radius: 7, color: '#fff', weight: 2,
        fillColor: '#1F5C6B', fillOpacity: 1 })
        .bindTooltip(`${l.naam} \u00b7 ${l.punten} laadpunten`).addTo(laag);
    }

    if (netcapGetoond.current !== gemId) {
      try {
        const rand = L.geoJSON({ type:'FeatureCollection', features: vormen }).getBounds();
        if (rand.isValid()) netcapMap.current?.fitBounds(rand, { padding: [24, 24] });
        netcapGetoond.current = gemId;
      } catch (e) {
        console.warn('Kaart netcapaciteit niet op de gemeente te zetten:', e.message);
      }
    }
    return () => clearTimeout(tijd);
  }, [tab, gemId, sectorenGeladen, gemeente, netcapUit, netcapKvaPerSector,
      netcapVermogenVanWijk, gekozenLocaties, sectorNaam, sectorNaamVan]);



  // Historie ophalen zodra het tabblad Export in beeld komt.
  useEffect(() => {
    if (tab !== 'export' || !gemId) return;
    let weg = false;
    getExportHistorie(gemId)
      .then(a => { if (!weg) setHistorie(a.historie || []); })
      .catch(() => { if (!weg) setHistorie([]); });
    return () => { weg = true; };
  }, [tab, gemId, exportBezig]);

  // Staat de Highlights teaser aan voor deze gemeente en dit account. Bij een
  // fout of een oudere server blijft het antwoord nee, en dan is er niets te
  // zien op het tabblad Export.
  useEffect(() => {
    if (!gemId) { setTeaserAan(false); return; }
    let weg = false;
    getTeaserStatus(gemId)
      .then(a => { if (!weg) setTeaserAan(!!a?.aan); })
      .catch(() => { if (!weg) setTeaserAan(false); });
    return () => { weg = true; };
  }, [gemId, tab]);

  // ── De Highlights teaser ───────────────────────────────────────────
  // Drie verhoudingen tussen het eerste planjaar en het gekozen eindjaar, uit
  // hetzelfde rekenmodel als de schermen. Het aansluitvermogen haalt de server
  // zelf uit wat er bij het doorrekenen van de netcapaciteit is bewaard.
  const maakTeaser = async () => {
    setExportFout(null);
    setTeaserBezig(true);
    try {
      const basis = tijdreeks.find(t => t.jaar === EERSTE_PLANJAAR);
      const eind  = tijdreeks.find(t => t.jaar === teaserJaar);
      if (!basis || !eind) throw new Error('Voor dit jaar zijn geen cijfers berekend.');

      const evBasis = evAandeelGemeente(EERSTE_PLANJAAR, evOverrideVoorJaar(EERSTE_PLANJAAR));
      const evEind  = evAandeelGemeente(teaserJaar,      evOverrideVoorJaar(teaserJaar));
      const nodigEind = Math.round(eind['Laadpunten nodig']);

      if (!basis['MWh'] || !evBasis || !aanwezigTotaal) {
        throw new Error('Er is geen vertrekpunt om mee te vergelijken: ' +
                        'de laadvraag, het EV-aandeel of het aantal bestaande laadpunten is nul.');
      }
      await downloadTeaser(gemId, {
        eindjaar:     teaserJaar,
        groeiEv:      evEind / evBasis,
        groeiVraag:   eind['MWh'] / basis['MWh'],
        groeiPunten:  nodigEind / aanwezigTotaal,
      }, `Highlights teaser ${gemeente?.naam || 'gemeente'} ${teaserJaar}.pptx`);
    } catch (e) {
      setExportFout(e.message);
    } finally {
      setTeaserBezig(false);
    }
  };

  // ── Het Word-document van het strategisch laadplan ─────────────────
  // De inhoud wordt hier opgebouwd uit dezelfde cijfers die op het scherm
  // staan, en als blokken naar de server gestuurd. Die doet alleen de opmaak,
  // zodat het document nooit iets anders kan zeggen dan de app.
  const exporteerLaadplan = async () => {
    setExportBezig(true); setExportFout(null);
    try {
      const nu = new Date().toLocaleDateString('nl-BE', { day:'numeric', month:'long', year:'numeric' });
      const jaren = YEARS.filter(y => y >= 2027);
      const eersteJaar = jaren[0], laatsteJaar = jaren[jaren.length - 1];
      const evPct = (wijkResults[0]?.data.evPct || 0) * 100;

      // ── De tekeningen, in de browser omgezet naar afbeeldingen ──
      // Blijft het omzetten van een tekening hangen, dan hangt de hele download.
      // Daarom een tijdslimiet: na tien seconden gaat het document verder zonder
      // die afbeelding, met een melding in de logboekregel van de browser.
      const png = async (svg, breedte, bg) => {
        if (!svg) return null;
        try {
          return await Promise.race([
            svgNaarPng(svg, breedte, bg),
            new Promise((_, mislukt) => setTimeout(() => mislukt(new Error('tijd verstreken')), 10000)),
          ]);
        } catch (e) {
          console.error('Afbeelding overgeslagen:', e.message);
          return null;
        }
      };
      // De vorm wordt in wit getekend en komt op het petrol vlak van de omslag
      // te staan, dus de afbeelding moet diezelfde achtergrondkleur krijgen.
      const omslag = await png(omslagSvg(sectorenGeo, 620, 620), 700, EK.accent);
      const stadskaart = await png(
        // Het hoofdstuk Prognose per wijk toont de opgave, dus de kleurenschaal
        // naar bij te plaatsen laadpunten. De kaart met de kleuren van de
        // netbeheerder hoort in het hoofdstuk Netcapaciteit.
        stadskaartSvg(sectorenGeo, (gemeente?.wijken || []), (w) => {
          const r = wijkResults.find(x => x.wijk.id === w.id);
          return r ? Math.max(0, r.data.deltaTotaal) : 0;
        }, gekozenLocaties), 1200);
      // De kaart met de kleuren van de netbeheerder, voor het hoofdstuk
      // Netcapaciteit. Dezelfde tekening als op het tabblad.
      const netkaart = netcapUit?.netruimte
        ? await png(stadskaartSvg(sectorenGeo, (gemeente?.wijken || []), netcapVermogenVanWijk,
            gekozenLocaties, 620, 430, netcapKaartOptiesRapport), 1200)
        : null;
      const grafiek = await png(grafiekSvg(
        tijdreeksPerJaar.map(r => r.jaar),
        tijdreeksPerJaar.map(r => Math.round(r['Nieuw dit jaar'] ?? 0)),
        tijdreeksPerJaar.map(r => Math.round(r['Tot en met dat jaar'] ?? 0))), 1200);

      // ── De hoofdstukken. Per hoofdstuk staat vast hoeveel pagina's het
      //    beslaat, zodat de inhoudsopgave vooraf kloppend te maken is. ──
      const H = [];
      const add = (titel, blokken, paginas = 1) => H.push({ titel, blokken, paginas });
      const paginasVoorTabel = (rijen) => Math.max(1, Math.ceil(rijen / 26));
      // Bestelwagens volgens MOW, als kader onder de prognose per wijk. Alleen de
      // twee getallen uit het bestand; niet opgeteld bij de laadpunten. Telt
      // voor zes tabelregels mee in de paginering, zodat de inhoudsopgave klopt.
      const mowBestelKader = (Number.isFinite(mowBestel?.kw2028) && Number.isFinite(mowBestel?.kw2030))
        ? (() => {
            const p28 = bestelVermogenTot(gekozenLocaties, 2028, EERSTE_PLANJAAR);
            const p30 = bestelVermogenTot(gekozenLocaties, 2030, EERSTE_PLANJAAR);
            const groei = mowBestel.kw2028 > 0
              ? `, een groei met factor ${(mowBestel.kw2030 / mowBestel.kw2028).toLocaleString('nl-NL',
                  { minimumFractionDigits:2, maximumFractionDigits:2 })}. `
              : '. ';
            const norm = `Volgens MOW moet in ${gemeente?.naam} voor bestelwagens minimaal ` +
              `${fmtN(mowBestel.kw2028)} kW laadvermogen beschikbaar zijn in 2028 en ${fmtN(mowBestel.kw2030)} kW in 2030` + groei;
            const plan = (p28.punten || p30.punten)
              ? `Op de gekozen laadpleinen is voor bestelwagens ${fmtN(p28.kw)} kW beschikbaar in 2028 en ` +
                `${fmtN(p30.kw)} kW in 2030. AC telt voor 11 kW per laadpunt, DC voor 25 kW per laadpunt. ` +
                `Het minimum van MOW geldt voor de hele gemeente, dus ook voor laadpunten buiten de laadpleinen.`
              : 'Op de gekozen laadpleinen zijn nog geen laadpunten voor bestelwagens voorbehouden.';
            return { soort:'kader', titel:'Bestelwagens volgens MOW', tekst: norm + plan };
          })()
        : null;
      // Dezelfde verdeling per deelgemeente als op tabblad Dashboard, hier
      // uitgeschreven. Alleen als de deelgemeenten met hun vorm zijn ingelezen.
      const mowBestelTabel = (mowBestelKader && (mowBestel.deelgemeenten || []).length)
        ? (() => {
            const dg = mowBestel.deelgemeenten;
            const p28 = bestelPerDeelgemeente(gekozenLocaties, dg, 2028, EERSTE_PLANJAAR);
            const p30 = bestelPerDeelgemeente(gekozenLocaties, dg, 2030, EERSTE_PLANJAAR);
            const verschil = (plan, mow) => {
              const v = Math.round(plan) - Math.round(mow || 0);
              return `${v > 0 ? '+' : v < 0 ? '\u2212' : ''}${fmtN(Math.abs(v))} kW`;
            };
            const g28 = bestelVermogenTot(gekozenLocaties, 2028, EERSTE_PLANJAAR).kw;
            const g30 = bestelVermogenTot(gekozenLocaties, 2030, EERSTE_PLANJAAR).kw;
            return { soort:'tabel',
              kolommen:[{titel:'Deelgemeente'},
                {titel:'Pleinen 2028',rechts:true},{titel:'MOW 2028',rechts:true},{titel:'Verschil 2028',rechts:true},
                {titel:'Pleinen 2030',rechts:true},{titel:'MOW 2030',rechts:true},{titel:'Verschil 2030',rechts:true}],
              rijen: [
                ...dg.map(d => {
                  const a = p28.get(d.code) || 0, b = p30.get(d.code) || 0;
                  return [`${d.naam || d.code} (${d.code})`,
                    `${fmtN(a)} kW`, `${fmtN(d.kw2028 || 0)} kW`, verschil(a, d.kw2028),
                    `${fmtN(b)} kW`, `${fmtN(d.kw2030 || 0)} kW`, verschil(b, d.kw2030)];
                }),
                ['Gemeente', `${fmtN(g28)} kW`, `${fmtN(mowBestel.kw2028)} kW`, verschil(g28, mowBestel.kw2028),
                             `${fmtN(g30)} kW`, `${fmtN(mowBestel.kw2030)} kW`, verschil(g30, mowBestel.kw2030)],
              ] };
          })()
        : null;

      add('Samenvatting', [
        { soort:'kerncijfers', cijfers:[
          { label:'Laadpunten nodig',  waarde:fmtN(Math.round(totLP)),     sub:`publiek, peiljaar ${year}` },
          { label:'Bij te plaatsen',   waarde:fmtN(Math.round(bijkomend)), sub:'ten opzichte van vandaag' },
          { label:'Nu aanwezig',       waarde:fmtN(aanwezigTotaal),        sub:'gewogen' },
          { label:'Investering',       waarde:fmtEur(capexBijkomend),      sub:`tot en met ${year}` },
          { label:'Laadvraag',         waarde:fmtN(Math.round(totMwhPubliek)), sub:'MWh publiek per jaar' } ] },
        { soort:'alinea', tekst:
          `${gemeente?.naam} heeft in ${year} naar verwachting ${fmtN(Math.round(totLP))} publieke laadpunten ` +
          `nodig. Daarvan is er nu ${fmtN(aanwezigTotaal)} aanwezig, zodat er ${fmtN(Math.round(bijkomend))} ` +
          `bij moeten komen. De bijbehorende investering bedraagt ${fmtEur(capexBijkomend)}. Dit plan laat ` +
          `zien hoeveel laadpunten er per wijk en per jaar nodig zijn, waar ze kunnen komen en wat dat kost.` },
        { soort:'kader', titel:'Gevraagd besluit', tekst:
          `Instemmen met dit strategisch laadplan als kader voor de uitrol van publieke laadinfrastructuur ` +
          `tot en met ${laatsteJaar}` +
          (gekozenLocaties.length ? `, en met de ${fmtN(gekozenLocaties.length)} aangewezen locaties voor laadpleinen.` : '.') },
      ]);

      add('Aanleiding en werkwijze', [
        { soort:'alinea', tekst:
          `Het aantal elektrische voertuigen groeit, en daarmee de behoefte aan publieke laadinfrastructuur. ` +
          `Dit strategisch laadplan brengt die behoefte in beeld tot en met ${laatsteJaar} en vertaalt die ` +
          `naar een uitvoerbaar programma per wijk en per jaar.` },
        { soort:'kop', tekst:'Hoe de raming werkt', niveau:2 },
        { soort:'alinea', tekst:
          'De raming werkt van onderop. Per wijk wordt bepaald hoeveel elektrische voertuigen er rijden, ' +
          'hoeveel energie die per jaar nodig hebben, en welk deel daarvan thuis of op eigen terrein wordt ' +
          'geladen. Wat overblijft is de publieke laadvraag. Die wordt verdeeld over normaal, snel en ' +
          'ultrasnel laden op basis van het wijktype, en vervolgens gedeeld door wat één laadpunt per jaar aankan.' },
        { soort:'lijst', punten:[
          `Peiljaren ${eersteJaar} tot en met ${laatsteJaar}, met ${year} als jaar waarop dit plan is toegespitst.`,
          `Privé-aandeel in ${year}: ${Math.round(privePctVoorJaar(year) * 100)} procent, dalend met twee procentpunt per jaar.`,
          `Aandeel elektrische voertuigen in ${year}: ${evPct.toFixed(1)} procent van het wagenpark.`,
          `Reserve op de capaciteit: ${Math.round(redundantieMarge * 100)} procent, zodat uitval en pieken opgevangen worden.` ] },
      ]);

      add('Huidige situatie', [
        { soort:'alinea', tekst:
          `In ${gemeente?.naam} staan op dit moment ${fmtN(existingPalen.length)} laadpunten die uit de open ` +
          `gegevens van het departement Mobiliteit en Openbare Werken bekend zijn. Semipublieke laadpunten ` +
          `tellen voor de helft mee, omdat ze niet altijd toegankelijk zijn; gewogen komt dat neer op ` +
          `${fmtN(aanwezigTotaal)} laadpunten.` },
        { soort:'tabel', kolommen:[{titel:'Wijk'},{titel:'Aanwezig',rechts:true},{titel:`Nodig in ${year}`,rechts:true}],
          rijen: wijkResults.map(({ wijk, data }) => {
            const a = deelAfronding([data.totAC, data.totDC, data.totHPC]);
            const aanw = (data.bestaand?.AC ?? 0) + (data.bestaand?.DC ?? 0) + (data.bestaand?.HPC ?? 0);
            return [wijk.naam, fmtN(Math.round(aanw)), fmtN(a.totaal)];
          }) },
      ], paginasVoorTabel(wijkResults.length + 6));

      add('Prognose per wijk', [
        ...(stadskaart ? [
          { soort:'alinea', tekst:
            `De kaart toont per wijk hoeveel laadpunten er in ${year} bij moeten komen. Hoe donkerder, hoe ` +
            `groter de opgave. De stippen zijn de voorziene locaties.` },
          { soort:'afbeelding', png:stadskaart, breedte:620, hoogte:430,
            onderschrift:`Bij te plaatsen laadpunten per wijk in ${year}.` },
          { soort:'nieuwe-pagina' },
        ] : []),
        { soort:'tabel',
          kolommen:[{titel:'Wijk'},{titel:'Type'},{titel:`Nodig in ${year}`,rechts:true},
            {titel:'Aanwezig',rechts:true},{titel:'Bij te plaatsen',rechts:true},{titel:'AC',rechts:true},
            {titel:'DC',rechts:true},{titel:'HPC',rechts:true},{titel:'Investering',rechts:true}],
          rijen: wijkResults.map(({ wijk, data }) => {
            const a = deelAfronding([data.totAC, data.totDC, data.totHPC]);
            const aanw = (data.bestaand?.AC ?? 0) + (data.bestaand?.DC ?? 0) + (data.bestaand?.HPC ?? 0);
            return [wijk.naam,
              (Array.isArray(wijk.wijktype) ? wijk.wijktype : [wijk.wijktype]).filter(Boolean).join(' + ') || '—',
              fmtN(a.totaal), fmtN(Math.round(aanw)), fmtN(data.bijTePlaatsen),
              fmtN(a.delen[0]), fmtN(a.delen[1]), fmtN(a.delen[2]), fmtEur(data.capex)];
          }) },
        ...(mowBestelKader ? [mowBestelKader] : []),
        ...(mowBestelTabel ? [mowBestelTabel] : []),
      ], (stadskaart ? 1 : 0) + paginasVoorTabel(wijkResults.length + 4 + (mowBestelKader ? 6 : 0)
                                                  + (mowBestelTabel ? mowBestelTabel.rijen.length + 2 : 0)));

      add('Spreiding in de tijd', [
        { soort:'alinea', tekst:
          'In het eerste planjaar wordt de bestaande achterstand ingelopen; daarna komt er per jaar alleen ' +
          'de groei bij. Palen worden niet weggehaald, dus het aantal loopt nooit terug.' },
        ...(grafiek ? [{ soort:'afbeelding', png:grafiek, breedte:620, hoogte:300,
          onderschrift:'Staven: wat er dat jaar bij moet komen. Lijn: het totaal tot en met dat jaar.' }] : []),
        { soort:'tabel',
          kolommen:[{titel:'Jaar'},{titel:'Bij te plaatsen dat jaar',rechts:true},
            {titel:'Tot en met dat jaar',rechts:true},{titel:'Laadvraag MWh',rechts:true},
            {titel:'Investering dat jaar',rechts:true}],
          rijen: tijdreeksPerJaar.map(r => [String(r.jaar),
            fmtN(Math.round(r['Nieuw dit jaar'] ?? 0)), fmtN(Math.round(r['Tot en met dat jaar'] ?? 0)),
            fmtN(Math.round(r['MWh'] ?? 0)), `€${fmtN(Math.round(r['CAPEX dit jaar'] ?? 0))}K`]) },
      ]);

      // ── Laadpleinen: aanpak, criteria, resultaat ──
      const soortNaam = { openbaar:'openbaar', semipubliek:'semipubliek', gesloten:'gesloten' };
      add('Laadpleinen', [
        { soort:'alinea', tekst:
          'Niet elk laadpunt komt als losse paal in de straat. Waar de ruimte het toelaat worden laadpalen ' +
          'geclusterd tot een laadplein: aaneengesloten parkeervakken met één netaansluiting, waarover het ' +
          'beschikbare vermogen dynamisch wordt verdeeld.' },
        { soort:'kop', tekst:'Waarom clusteren', niveau:2 },
        { soort:'lijst', punten:[
          'Eén netaansluiting voor meerdere palen vraagt fors minder aansluitvermogen dan dezelfde palen los.',
          'De straat hoeft maar één keer open en er is één verkeersbesluit nodig in plaats van meerdere.',
          'Een plein biedt laadzekerheid: de kans op een vrije plek is groter dan bij een enkele paal.',
          'Boven tienduizend kWh per jaar valt de aansluiting in een gunstiger staffel voor de energiebelasting.' ] },
        { soort:'kop', tekst:'Criteria voor een locatie', niveau:2 },
        { soort:'tabel', kolommen:[{titel:'Criterium'},{titel:'Toegepast als'}], rijen:[
          ['Ruimte', `Minstens ${pleinMinVak} parkeervakken, goed voor ${pleinOmvang} laadpunten.`],
          ['Parkeervakken', 'Openbaar domein, want alleen daar is de gemeente wegbeheerder.'],
          ['Nabijheid van een voorziening',
           `Binnen ${pleinNabij} meter van een winkel, sportcentrum, school, station of zorginstelling.`] ] },
        { soort:'kop', tekst:'Resultaat van de toets', niveau:2 },
        { soort:'tabel', kolommen:[{titel:'Stap'},{titel:'Aantal',rechts:true}], rijen:[
          ['Parkeerterreinen in de gemeente', fmtN(pleinAlles.length)],
          ['Voldoen aan ruimte en toegang', fmtN(pleinGefilterd.length)],
          ['Geschikt bevonden door de gemeente', fmtN(gekozenLocaties.length)],
          [pleinRuimteBestel > 0 ? 'Laadpunten die daarop passen, zonder die voor bestelwagens'
                                 : 'Laadpunten die daarop passen', fmtN(pleinRuimte)] ] },
      ], 2);

      // ── Voorziene locaties, met een kaart per wijk ──
      // Laadpunten voor deelwagens, geteld over de locaties die in het
      // document staan. Niet over pleinGeschikt, want dat is dezelfde lijst
      // maar via een andere weg, en dan kunnen tabel en zin uiteenlopen.
      const deelLocaties = gekozenLocaties.filter(l => (l.deelwagens ?? 0) > 0);
      const deelPunten = deelLocaties.reduce((s2, l) => s2 + (l.deelwagens ?? 0), 0);
      const locBlokken = [];
      if (gekozenLocaties.length) {
        locBlokken.push({ soort:'alinea', tekst:
          `Samen met de gemeente zijn ${fmtN(gekozenLocaties.length)} locaties aangewezen. Per locatie staan ` +
          `hieronder de coördinaten, het aantal parkeervakken, het voorziene aantal laadpalen en de ` +
          `het aansluitvermogen. De nummers komen terug op de kaart per wijk.` });
        locBlokken.push({ soort:'alinea', tekst:
          `Het aansluitvermogen wordt per laadpaal berekend en niet per laadpunt, omdat één paal twee ` +
          `laadpunten voedt vanaf dezelfde aansluiting. Een gewone paal vraagt 24,2 kVA, een snellader ` +
          `55,4 kVA en een ultrasnellader 150 tot 250 kVA. Onder ${KVA_STUDIE} kVA komt de aansluiting op ` +
          `laagspanning. Tussen ${KVA_STUDIE} en ${KVA_CABINE} kVA beslist Fluvius na een studie of de ` +
          `aansluiting op laagspanning of op middenspanning komt. Boven ${KVA_CABINE} kVA is een eigen ` +
          `elektriciteitscabine op middenspanning nodig. Een wijktotaal is geen aanvraag voor één aansluiting, want losse ` +
          `palen in een straat hangen aan verschillende cabines. Peildatum ${VERMOGEN_PEILDATUM}.` });
        locBlokken.push({ soort:'tabel',
          kolommen:[{titel:'Nr',rechts:true},{titel:'Locatie'},{titel:'Vakken',rechts:true},
            {titel:'Palen',rechts:true},{titel:'Punten',rechts:true},{titel:'Opstelling'},
            {titel:'Punten deelwagens',rechts:true},
            {titel:'kVA',rechts:true},{titel:'Voorziening'},
            {titel:'Coördinaten'},{titel:'Opmerking'}],
          rijen: gekozenLocaties.map((l, i) => [String(i + 1), l.naam, l.vakken == null ? 'onbekend' : fmtN(l.vakken),
            String(l.palen), String(l.punten),
            l.samenstelling || 'nog niet ingevuld',
            (l.deelwagens ?? 0) > 0 ? String(l.deelwagens) : '—',
            l.kvaMax == null ? '—' : (l.kvaMin !== l.kvaMax ? `${l.kvaMin} tot ${l.kvaMax}` : String(l.kvaMax)),
            l.voorziening ? `${l.voorziening}${l.voorzieningM != null ? ` op ${l.voorzieningM} m` : ''}` : '—',
            `${l.lat.toFixed(6)}, ${l.lng.toFixed(6)}`, l.notitie]) });

        // Eis 5 van de leidraad. Alleen als er ergens deelwagenpunten staan;
        // anders zou er een zin over nul locaties in het document komen.
        if (deelLocaties.length) {
          locBlokken.push({ soort:'alinea', tekst:
            `Op ${fmtN(deelLocaties.length)} van de ${fmtN(gekozenLocaties.length)} locaties zijn samen ` +
            `${fmtN(deelPunten)} laadpunten voorbehouden voor deelwagens. Die laadpunten zitten binnen de ` +
            `opstelling van de locatie en komen er niet bovenop.` });
        }

        // Per wijk een kaart met de locaties die daarbinnen vallen.
        for (const { wijk } of wijkResults) {
          const eigen = gekozenLocaties.filter(l => l.wijk === wijk.naam);
          if (!eigen.length) continue;
          const kaart = await png(wijkkaartSvg(sectorenGeo, wijk.id, gemeente?.wijken || [], eigen), 1200);
          if (!kaart) continue;
          locBlokken.push({ soort:'nieuwe-pagina' });
          locBlokken.push({ soort:'kop', tekst:wijk.naam, niveau:2 });
          locBlokken.push({ soort:'afbeelding', png:kaart, breedte:620, hoogte:320,
            onderschrift:'De genummerde stippen verwijzen naar de tabel hierboven.' });
        }
      } else {
        locBlokken.push({ soort:'alinea', tekst:
          'Er zijn nog geen locaties aangewezen. Op het tabblad Laadpleinen staan de kandidaatlocaties klaar ' +
          'om samen met de gemeente te beoordelen; zodra dat gebeurd is, verschijnen ze hier met hun ' +
          'coördinaten en het voorziene aantal laadpalen.' });
      }
      add('Voorziene locaties', locBlokken,
        gekozenLocaties.length ? paginasVoorTabel(gekozenLocaties.length + 4) +
          wijkResults.filter(({ wijk }) => gekozenLocaties.some(l => l.wijk === wijk.naam)).length : 1);

      // ── Overzicht per wijk ──
      const wijkBlokken = [{ soort:'alinea', tekst:
        'Per wijk de kerncijfers, de doelgroepenmix die de verdeling over de laadtypes bepaalt, en de ' +
        'daaruit volgende verdeling in laadpunten.' }];
      for (let i = 0; i < wijkResults.length; i++) {
        const { wijk, data } = wijkResults[i];
        const a = deelAfronding([data.totAC, data.totDC, data.totHPC]);
        const types = (Array.isArray(wijk.wijktype) ? wijk.wijktype : [wijk.wijktype]).filter(Boolean);
        const m = types.map(t2 => WIJKTYPE_MIX?.[t2]).filter(Boolean);
        const mix = m.length
          ? { bew:m.reduce((x,y)=>x+y.bew,0)/m.length, bez:m.reduce((x,y)=>x+y.bez,0)/m.length,
              log:m.reduce((x,y)=>x+y.log,0)/m.length }
          : null;
        const aanw = (data.bestaand?.AC ?? 0) + (data.bestaand?.DC ?? 0) + (data.bestaand?.HPC ?? 0);
        wijkBlokken.push({ soort:'kop', tekst:wijk.naam, niveau:2 });
        wijkBlokken.push({ soort:'kerncijfers', cijfers:[
          { label:`Nodig in ${year}`, waarde:fmtN(a.totaal), sub:'publieke laadpunten' },
          { label:'Bij te plaatsen', waarde:fmtN(data.bijTePlaatsen),
            sub:`er staan er nu ${fmtN(Math.round(aanw))}` },
          { label:'Publieke laadvraag', waarde:fmtN(Math.round(data.mwhPubliek)), sub:'MWh per jaar' },
          { label:'Investering', waarde:fmtEur(data.capex), sub:`tot en met ${year}` } ] });
        if (mix) {
          const b1 = await png(balkSvg([mix.bew, mix.bez, mix.log], [EK.bew, EK.bez, EK.log],
            [`${Math.round(mix.bew*100)}% bewoners`, `${Math.round(mix.bez*100)}% bezoekers`,
             `${Math.round(mix.log*100)}% logistiek`]), 1200);
          if (b1) wijkBlokken.push({ soort:'afbeelding', png:b1, breedte:620, hoogte:78,
            onderschrift:'Voor wie er in deze wijk geladen wordt.' });
        }
        const b2 = await png(balkSvg([data.totAC, data.totDC, data.totHPC], [EK.ac, EK.dc, EK.hpc],
          [`${a.delen[0]} AC`, `${a.delen[1]} DC`, `${a.delen[2]} HPC`]), 1200);
        if (b2) wijkBlokken.push({ soort:'afbeelding', png:b2, breedte:620, hoogte:78,
          onderschrift:'De verdeling over de laadtypes die daaruit volgt.' });
        if (i < wijkResults.length - 1) wijkBlokken.push({ soort:'nieuwe-pagina' });
      }
      add('Overzicht per wijk', wijkBlokken, Math.max(1, Math.ceil(wijkResults.length / 2)));

      // ── Netcapaciteit: wat het plan bij de netbeheerder vraagt ──────
      const netRegels = (netcapUit?.regels || []).filter(r => r.binnenPeriode);
      const netSom = (rs, veld) => rs.reduce((a2, r) => a2 + (r[veld] || 0), 0);
      const netPalen = (rs) => rs.reduce((a2, r) => a2 + r.palen.ac + r.palen.dc + r.palen.hpc, 0);
      const netWijken = [...new Set(netRegels.map(r => r.gebiedNaam))]
        .map(naam => ({ naam, rs: netRegels.filter(r => r.gebiedNaam === naam) }))
        .sort((a2, b2) => netSom(b2.rs, 'kvaMax') - netSom(a2.rs, 'kvaMax'));
      const netJaren = [...new Set(netRegels.map(r => r.jaar))].sort();
      const netKrap = netWijken.filter(w => {
        const id = netRegels.find(r => r.gebiedNaam === w.naam)?.gebiedId;
        return netcapUit?.netruimte?.[id]?.ruimte === 'krap';
      });

      if (netRegels.length) {
        add('Netcapaciteit', [
          { soort:'alinea', tekst:
            `Het laadplan vraagt ${fmtN(netPalen(netRegels))} laadpalen met samen ` +
            `${fmtN(netSom(netRegels, 'kvaMax'))} kVA aan aansluitvermogen. Elke locatie krijgt een eigen ` +
            `aansluiting, dus dit is de optelsom van losse aansluitingen en geen aanvraag voor één grote ` +
            `aansluiting. Een gewone paal vraagt ${String(PAAL_VERMOGEN.ac.kvaMax).replace('.', ',')} kVA, ` +
            `een snellader ${String(PAAL_VERMOGEN.dc.kvaMax).replace('.', ',')} kVA en een ultrasnellader ` +
            `${PAAL_VERMOGEN.hpc.kvaMin} tot ${PAAL_VERMOGEN.hpc.kvaMax} kVA. Boven ${KVA_CABINE} kVA op één ` +
            `locatie is een eigen elektriciteitscabine nodig; dat geldt voor ` +
            `${fmtN(netSom(netRegels, 'cabines'))} locaties.` },
          ...(netkaart ? [
            { soort:'alinea', tekst:
              'De kleur is de ruimte op het net volgens de netbeheerder, per statistische sector. De ' +
              'stippen zijn de gekozen laadpleinen. Het aansluitvermogen dat het laadplan per wijk ' +
              'vraagt staat in de tabel hieronder.' },
            { soort:'afbeelding', png:netkaart, breedte:620, hoogte:430,
              onderschrift:'Ruimte op het net volgens de netbeheerder, per statistische sector' +
                (netcapUit?.netruimtePeildatum ? `, kaart van de netbeheerder van ${netcapUit.netruimtePeildatum}` : '') + '.' },
            { soort:'nieuwe-pagina' },
          ] : []),
          { soort:'tabel',
            kolommen:[{titel:'Jaar'},{titel:'Gewone paal',rechts:true},{titel:'Snellader',rechts:true},
              {titel:'Ultrasnellader',rechts:true},{titel:'Samen',rechts:true},{titel:'Aansluitvermogen (kVA)',rechts:true}],
            rijen: [...netJaren.map(j => {
              const rs = netRegels.filter(r => r.jaar === j);
              return [String(j), fmtN(rs.reduce((a2, r) => a2 + r.palen.ac, 0)),
                fmtN(rs.reduce((a2, r) => a2 + r.palen.dc, 0)),
                fmtN(rs.reduce((a2, r) => a2 + r.palen.hpc, 0)),
                fmtN(netPalen(rs)), fmtN(netSom(rs, 'kvaMax'))];
            }), ['Samen',
              fmtN(netRegels.reduce((a2, r) => a2 + r.palen.ac, 0)),
              fmtN(netRegels.reduce((a2, r) => a2 + r.palen.dc, 0)),
              fmtN(netRegels.reduce((a2, r) => a2 + r.palen.hpc, 0)),
              fmtN(netPalen(netRegels)), fmtN(netSom(netRegels, 'kvaMax'))]] },
          { soort:'tabel',
            kolommen:[{titel:'Wijk'},{titel:'Palen',rechts:true},{titel:'Op een laadplein',rechts:true},
              {titel:'Aansluitvermogen (kVA)',rechts:true},{titel:'Ruimte op het net'}],
            rijen: netWijken.map(w => {
              const id = netRegels.find(r => r.gebiedNaam === w.naam)?.gebiedId;
              const ruimte = netcapUit?.netruimte?.[id]?.ruimte;
              return [w.naam, fmtN(netPalen(w.rs)),
                fmtN(netPalen(w.rs) - netSom(w.rs, 'palenZonderLocatie')),
                fmtN(netSom(w.rs, 'kvaMax')), ruimte || 'nog niet bepaald'];
            }) },
          ...(netKrap.length ? [{ soort:'kader', titel:'Ruimte op het net', tekst:
            `In ${fmtN(netKrap.length)} van de ${fmtN(netWijken.length)} wijken is het net krap. De ` +
            `netbeheerder staat daar alleen flexibele aansluitingen toe. Die indeling komt uit de ` +
            `aansluitingskaart van de netbeheerder` +
            (netcapUit?.netruimtePeildatum ? ` van ${netcapUit.netruimtePeildatum}` : '') +
            `, die laat zien welke ruimte er in 2035 nog over is.` }] : []),
        ], (netkaart ? 1 : 0) + paginasVoorTabel(netJaren.length + netWijken.length + 10));
      }

      // ...... Dekking binnen 250 meter ......
      // Eis 2 van de leidraad: de bestaande laadpunten en de toekomstige
      // dekking met cirkels. Wat het document toont is precies wat er op het
      // tabblad Dekking staat, met dezelfde afbeelding en dezelfde getallen.
      if (dekTelling && dekRaster && dekGedekt) {
        const beeld = maakDekkingBeeld(dekRaster, dekGedekt);
        const dekKaart = await png(dekkingskaartSvg(sectorenGeo, {
          beeldPng: beeld?.dataUrl, beeldGrenzen: beeld?.grenzen,
          punten: dekZichtbaar, pleinen: dekPleinen ? dekPleinenNu : [], straalM: 250,
          plaatsing: dekPlaatsing ? dekPlaatsingNu : [], kleuren: DEK_KLEUR, jaar: year,
        }, 620, 560), 1400);

        const buiten = dekTelling.totaal.inwonersZonder;
        const deel = Math.round((1 - dekTelling.totaal.deelInwoners) * 100);
        const wijkRijen = dekTelling.perWijk
          .filter(w => w.inwoners > 0)
          .sort((a2, b2) => b2.inwonersZonder - a2.inwonersZonder);
        const slechte = dekTelling.perSector
          .filter(x => x.deelInwoners < 0.5 && x.inwonersZonder >= 50)
          .sort((a2, b2) => a2.deelInwoners - b2.deelInwoners);
        const naamVanWijk = (id) => (gemeente?.wijken || []).find(w => w.id === id)?.naam || id;

        add('Dekking binnen 250 meter', [
          { soort:'alinea', tekst:
            `Rond elke bestaande laadpaal ligt een cirkel van 250 meter. Wat daarbuiten valt heeft geen ` +
            `laadpunt op loopafstand. Van de ${fmtN(dekTelling.totaal.inwoners)} inwoners van ` +
            `${gemeente?.naam} zijn dat er ${fmtN(buiten)}, oftewel ${deel} procent.` },
          { soort:'alinea', tekst:
            `De afstand is hemelsbreed gemeten en niet als looproute, dus het beeld is aan de gunstige ` +
            `kant. Gewone laadpalen en snelladers tellen mee; ultrasnelladers niet, want die staan er ` +
            `voor wie onderweg is en bedienen geen buurt. De berekening gebeurt op een raster van vijftig ` +
            `meter, waarbij de inwoners van een statistische sector gelijk over die sector zijn verdeeld.` },
          ...(dekKaart ? [{ soort:'afbeelding', png:dekKaart, breedte:620, hoogte:560,
            onderschrift:`Rood is het gebied zonder laadpunt binnen 250 meter. Peiljaar ${year}.` },
            { soort:'nieuwe-pagina' }] : []),
          { soort:'kop', tekst:'Per wijk', niveau:2 },
          { soort:'tabel',
            kolommen:[{titel:'Wijk'},{titel:'Inwoners',rechts:true},
              {titel:'Buiten de dekking',rechts:true},{titel:'Gedekt',rechts:true}],
            rijen: [...wijkRijen.map(w => [naamVanWijk(w.wijkId), fmtN(w.inwoners),
                fmtN(w.inwonersZonder), `${fmtN(Math.round(w.deelInwoners * 100))}%`]),
              ['Samen', fmtN(dekTelling.totaal.inwoners), fmtN(buiten),
                `${fmtN(Math.round(dekTelling.totaal.deelInwoners * 100))}%`]] },
          ...(slechte.length ? [
            { soort:'kop', tekst:'Sectoren met slechte of geen dekking', niveau:2 },
            { soort:'alinea', tekst:
              `In ${fmtN(slechte.length)} statistische sectoren heeft minder dan de helft van de inwoners ` +
              `een laadpunt binnen 250 meter. Samen wonen daar ` +
              `${fmtN(slechte.reduce((a2, x) => a2 + x.inwonersZonder, 0))} van de ${fmtN(buiten)} ` +
              `inwoners zonder laadpunt op loopafstand. Sectoren met minder dan vijftig inwoners buiten ` +
              `de dekking staan er niet bij.` },
            { soort:'tabel',
              kolommen:[{titel:'Statistische sector'},{titel:'Code'},{titel:'Ligt in wijk'},
                {titel:'Inwoners',rechts:true},{titel:'Buiten de dekking',rechts:true},{titel:'Gedekt',rechts:true}],
              rijen: slechte.map(x => [sectorNaam(x.sector), x.sector, naamVanWijk(x.wijkId),
                fmtN(x.inwoners), fmtN(x.inwonersZonder),
                `${fmtN(Math.round(x.deelInwoners * 100))}%`]) },
          ] : []),
          ...(dekTellingNu ? [{ soort:'kader', titel:'Wat het plan oplevert', tekst:
            `Zonder de nieuwe laadpunten uit het plan tot en met ${year} zouden ` +
            `${fmtN(dekTellingNu.totaal.inwonersZonder)} inwoners ` +
            `buiten de dekking vallen. Het plan brengt er ` +
            `${fmtN(dekTellingNu.totaal.inwonersZonder - buiten)} binnen bereik.` }] : []),
        ], (dekKaart ? 1 : 0) + paginasVoorTabel(wijkRijen.length + slechte.length + 12));
      }

      add('Investering', [
        { soort:'alinea', tekst:
          `De totale investering tot en met ${year} bedraagt ${fmtEur(capexBijkomend)}. Dat bedrag omvat de ` +
          `laadpaal, de netaansluiting en de installatie. Snelladers en ultrasnelladers worden per laadpaal ` +
          `gerekend, niet per laadpunt, omdat één paal twee voertuigen bedient.` },
        { soort:'tabel', kolommen:[{titel:'Onderdeel'},{titel:'Per eenheid',rechts:true},{titel:'Aantal',rechts:true}],
          rijen:[
            ['AC-laadpunt', fmtEur(CAPEX_V2.AC), fmtN(wijkResults.reduce((x,r)=>x+r.data.totAC,0))],
            ['DC-laadpaal', fmtEur(CAPEX_V2.DC), fmtN(Math.ceil(wijkResults.reduce((x,r)=>x+r.data.totDC,0)/2))],
            ['HPC-laadpaal', fmtEur(CAPEX_V2.HPC), fmtN(Math.ceil(wijkResults.reduce((x,r)=>x+r.data.totHPC,0)/2))] ] },
      ]);

      add('Verantwoording bij de eisen', [
        { soort:'alinea', tekst:
          'Het departement Mobiliteit en Openbare Werken stelt zeven eisen aan een strategisch laadplan. ' +
          'Hieronder staat per eis waar die in dit plan is ingevuld.' },
        { soort:'tabel', kolommen:[{titel:'Eis'},{titel:'Waar in dit plan'}], rijen:[
          ['Plan op kaart met voorziene locaties en legende',
           stadskaart ? 'Prognose per wijk en Voorziene locaties' : 'Nog aan te vullen'],
          ['Bestaande laadpunten en toekomstige dekking',
           dekTelling ? 'Dekking binnen 250 meter' : 'Nog aan te vullen'],
          ['Coördinaten of adressen per locatie', gekozenLocaties.length ? 'Voorziene locaties' : 'Nog aan te vullen'],
          ['Aantal laadpalen per locatie', gekozenLocaties.length ? 'Voorziene locaties' : 'Nog aan te vullen'],
          ['Aanduiding laadpunten voor deelwagens',
           deelLocaties.length ? 'Voorziene locaties' : 'Nog aan te vullen'],
          ['Timing met realistische spreiding', 'Spreiding in de tijd'],
          ['Beschrijvende tekst ter motivering', 'Aanleiding en Prognose'] ] },
        ...(dekTelling && deelLocaties.length ? [] : [{ soort:'kader', titel:'Wat nog aangevuld moet worden', tekst:
          (dekTelling
            ? 'De aanduiding van laadpunten voor deelwagens is nog niet in dit plan opgenomen. '
            : deelLocaties.length
              ? 'De dekkingscirkels op de kaart zijn nog niet in dit plan opgenomen. '
              : 'De dekkingscirkels op de kaart en de aanduiding van laadpunten voor deelwagens zijn nog niet ' +
                'in dit plan opgenomen. ') +
          'Dat wordt aangevuld voordat het plan wordt ingediend.' }]),
      ]);

      add('Bijlage: verantwoording en bronnen', [
        { soort:'kop', tekst:'Werkwijze in stappen', niveau:2 },
        { soort:'tabel', kolommen:[{titel:'Stap'},{titel:'Wat er gebeurt'}], rijen:[
          ['1 · Voertuigen','Het aantal auto\u0027s per wijk komt uit het huishoudbestand van Statbel, opgeteld uit de statistische sectoren die bij de wijk horen.'],
          ['2 · Elektrisch aandeel','Het aandeel elektrische voertuigen per peiljaar, uit lokale cijfers waar beschikbaar, anders uit de landelijke groeicurve.'],
          ['3 · Energievraag',`Per elektrisch voertuig ${fmtN(JAARKM)} km per jaar maal ${String(VERBRUIK_PER_KM).replace('.', ',')} kWh per kilometer, maal een stadsfactor van ${String(STADSFACTOR).replace('.', ',')}.`],
          ['4 · Privé versus publiek','Het deel dat thuis of op eigen terrein laadt gaat eraf, op basis van de geregistreerde privé-laadpunten bij Fluvius.'],
          ['5 · Verdeling over laadtypes','De publieke vraag wordt verdeeld over normaal, snel en ultrasnel op basis van het wijktype.'],
          ['6 · Naar laadpunten','De energie per laadtype gedeeld door wat één laadpunt per jaar aankan, plus een reserve.'] ] },
        { soort:'kop', tekst:'Kernratio\u0027s', niveau:2 },
        { soort:'tabel', kolommen:[{titel:'Ratio'},{titel:'Waarde',rechts:true},{titel:'Toelichting'}], rijen:[
          ['Jaarkilometrage per voertuig', `${fmtN(JAARKM)} km`, 'Gemiddelde afstand per elektrisch voertuig per jaar'],
          ['Verbruik per kilometer', `${String(VERBRUIK_PER_KM).replace('.', ',')} kWh`, 'Inclusief laadverliezen'],
          ['Stadsfactor', `${String(STADSFACTOR).replace('.', ',')}`, 'Correctie omdat stedelijke ritten korter zijn'],
          ['Aandeel elektrisch', `${evPct.toFixed(1)} %`, `In het peiljaar ${year}`],
          ['Correctie privé-laadpunten', `${FLUVIUS_KAPPA.toFixed(4).replace('.', ',')}`, 'Niet elke privé-laadpaal is bij Fluvius aangemeld'],
          ['Privé-aandeel', `${Math.round(privePctVoorJaar(year) * 100)} %`, 'Daalt met twee procentpunt per jaar'],
          ['Weging semipubliek', '0,5', 'Een semipubliek punt telt voor de helft mee'],
          ['Afzet per AC laadpunt per jaar', `${fmtN(acNormKwh(year, normPerJaar))} kWh/jaar`,
           `${Math.round(100*acNormKwh(year, normPerJaar)/MOW_DREMPEL_BIJPLAATSING_KWH)} procent van de MOW-drempel bijplaatsing van ${fmtN(MOW_DREMPEL_BIJPLAATSING_KWH)} kWh. In te stellen per jaar op tabblad Gemeente`],
          ['Gemeten bezettingsgraad van deze gemeente',
           bezetting.gemeten ? `${bezetting.bezetting} %` : `${bezetting.bezetting} % (geschat)`,
           bezetting.gemeten
             ? 'Vierde kwartaal 2025. Bron: Vlaams Parlement, vraag 1093 van 17 maart 2026. Meet TIJD, niet energie: geen invoer voor de afzet, wel een tweede toets'
             : 'Geen eigen cijfer bekend; dit is de mediaan van gemeenten met evenveel inwoners'],
          ['Reserve op de capaciteit', `${Math.round(redundantieMarge * 100)} %`, 'Dekt uitval en pieken'],
          ['Kosten AC', fmtEur(CAPEX_V2.AC), 'Per laadpunt, inclusief aansluiting en plaatsing'],
          ['Kosten DC', fmtEur(CAPEX_V2.DC), 'Per laadpaal van twee punten'],
          ['Kosten HPC', fmtEur(CAPEX_V2.HPC), 'Per laadpaal van twee punten'] ] },
        { soort:'kop', tekst:'Geraadpleegde bronnen', niveau:2 },
        { soort:'tabel', kolommen:[{titel:'Bron'},{titel:'Waarvoor'}], rijen:[
          ['Departement Mobiliteit en Openbare Werken','Bestaande publieke en semipublieke laadpunten'],
          ['Fluvius','Privé-laadpunten per postcode'],
          ['Rijksregister','Inwonertal per gemeente'],
          ['FOD Mobiliteit','Wagenpark per gemeente en brandstofsoort'],
          ['Statbel','Statistische sectoren als wijkindeling'],
          ['OpenStreetMap','Parkeerterreinen als kandidaatlocaties'] ] },
      ], 2);

      // ── Inhoudsopgave: pagina 1 is het titelblad, pagina 2 de inhoud ──
      let pagina = 3;
      const regels = H.map(h => {
        const r = { tekst:h.titel, pagina:String(pagina), niveau:1 };
        pagina += h.paginas;
        return r;
      });

      const blokken = [{ soort:'inhoudsopgave', regels }];
      H.forEach((h, i) => {
        blokken.push({ soort:'kop', tekst:h.titel, niveau:1 });
        blokken.push(...h.blokken);
        if (i < H.length - 1) blokken.push({ soort:'nieuwe-pagina' });
      });

      await downloadRapport({
        gemeenteId: gemId, gemeente: gemeente?.naam || '', onderwerp: 'strategisch-laadplan',
        titel: 'Strategisch Laadplan', omslag,
        merkregel: 'Publieke laadinfrastructuur',
        planhorizon: `${eersteJaar} – ${laatsteJaar}`,
        ondertitel: `Met ${year} als peiljaar · ${fmtN(gemeente?.inwoners || 0)} inwoners · ` +
                    `${(gemeente?.wijken || []).length} wijken`,
        meta: `Opgesteld op ${nu}`,
        meta2: { peiljaar: year, bijkomend: Math.round(bijkomend), locaties: gekozenLocaties.length },
        blokken,
      }, 'docx');
    } catch (e) {
      setExportFout(e.message);
    } finally {
      setExportBezig(false);
    }
  };

  // ── De voorziene locaties als kaartbestand ─────────────────────────
  const exporteerLocaties = async (soort) => {
    setExportBezig(true); setExportFout(null);
    try {
      if (!gekozenLocaties.length) throw new Error('Er zijn nog geen locaties aangewezen.');
      const geo = soort === 'kml';
      const inhoud = geo ? kmlVan(gekozenLocaties, gemeente?.naam, year)
                         : geojsonVan(gekozenLocaties, gemeente?.naam, year);
      const naam = exportNaam(gemeente?.naam, 'voorziene-locaties', geo ? 'kml' : 'geojson');
      bewaarAls(naam, inhoud, geo ? 'application/vnd.google-earth.kml+xml' : 'application/geo+json');
      await bewaarExport({ gemeenteId: gemId, soort: geo ? 'locaties-kml' : 'locaties-geojson',
        naam, mimetype: geo ? 'application/vnd.google-earth.kml+xml' : 'application/geo+json',
        inhoud: btoa(unescape(encodeURIComponent(inhoud))),
        meta: { peiljaar: year, locaties: gekozenLocaties.length } }).catch(() => {});
    } catch (e) {
      setExportFout(e.message);
    } finally {
      setExportBezig(false);
    }
  };

  // ── De kaarten als losse afbeeldingen ──────────────────────────────
  const exporteerKaarten = async () => {
    setExportBezig(true); setExportFout(null);
    try {
      const bestanden = [];
      const stad = stadskaartSvg(sectorenGeo, (gemeente?.wijken || []), (w) => {
        const r = wijkResults.find(x => x.wijk.id === w.id);
        return r ? Math.max(0, r.data.deltaTotaal) : 0;
      }, gekozenLocaties);
      if (stad) bestanden.push({ naam:`stadskaart-${year}.png`,
        inhoud: Uint8Array.from(atob(await svgNaarPng(stad, 1600)), c => c.charCodeAt(0)) });

      for (const { wijk } of wijkResults) {
        const eigen = gekozenLocaties.filter(l => l.wijk === wijk.naam);
        const svg = wijkkaartSvg(sectorenGeo, wijk.id, gemeente?.wijken || [], eigen);
        if (!svg) continue;
        const veilig = String(wijk.naam).normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '');
        bestanden.push({ naam:`wijk-${veilig}.png`,
          inhoud: Uint8Array.from(atob(await svgNaarPng(svg, 1600)), c => c.charCodeAt(0)) });
      }
      if (!bestanden.length) throw new Error('Er zijn geen wijkvormen beschikbaar om te tekenen.');

      const zip = maakZip(bestanden);
      const naam = exportNaam(gemeente?.naam, 'kaarten', 'zip');
      bewaarAls(naam, zip, 'application/zip');
      let base64 = '';
      for (let i = 0; i < zip.length; i += 8192) {
        base64 += String.fromCharCode.apply(null, zip.subarray(i, i + 8192));
      }
      await bewaarExport({ gemeenteId: gemId, soort:'kaarten', naam, mimetype:'application/zip',
        inhoud: btoa(base64), meta:{ peiljaar: year, kaarten: bestanden.length } }).catch(() => {});
    } catch (e) {
      setExportFout(e.message);
    } finally {
      setExportBezig(false);
    }
  };

  const exporteerPrognose = async () => {
    setExportBezig(true); setExportFout(null);
    try {
      // Het aantal auto's per wijk, opgeteld uit de sectoren. Dit is de sleutel
      // waarmee de behoefte van een wijk over haar sectoren wordt verdeeld, dus
      // hij hoort in het bestand te staan om te kunnen narekenen.
      const wijkAutos = {};
      for (const f of (sectorenRef.current?.features || [])) {
        const wid = f.properties?.WIJK_ID;
        const w = sectorWagens[f.properties?.NISCODE];
        if (wid && w != null) wijkAutos[wid] = (wijkAutos[wid] || 0) + w;
      }

      const rijen = [];
      wijkResults.forEach(({ wijk }) => {
        wijkTijdreeksPerJaar(wijk).forEach(r => rijen.push({
          wijk: wijk.naam,
          wijktype: Array.isArray(wijk.wijktype) ? wijk.wijktype.join(' + ') : (wijk.wijktype || ''),
          jaar: r.jaar,
          inwoners: wijk.inwoners ?? null,
          autos: wijkAutos[wijk.id] ?? null,
          nodig: Math.ceil(r.totLP ?? 0),
          nodigAC: r.nodigAC ?? 0,
          nodigDC: r.nodigDC ?? 0,
          nodigHPC: r.nodigHPC ?? 0,
          aanwezig: r.aanwezig ?? 0,
          aanwezigAC: r.aanwezigAC ?? 0,
          aanwezigDC: r.aanwezigDC ?? 0,
          aanwezigHPC: r.aanwezigHPC ?? 0,
          ditJaar: Math.ceil(r.nieuwDitJaar ?? 0),
          cumulatief: Math.ceil(r.cumulatief ?? 0),
          ac: Math.ceil(r.deltaAC ?? 0),
          dc: Math.ceil(r.deltaDC ?? 0),
          hpc: Math.ceil(r.deltaHPC ?? 0),
          prive: Math.round((r.privePct ?? 0) * 100),
          mwh: Math.round(r.totMwh ?? 0),
          capexJaar: Math.round(r.capexDitJaar ?? 0),
          capexCum: Math.round(r.capexEur ?? 0),
        }));
      });
      // ── Twee extra bladen ────────────────────────────────────────────
      // Per sector: de gegevens waarop alles sinds augustus 2026 verdeeld
      // wordt. Dekking: hoeveel inwoners er buiten de 250 meter vallen.
      const naamVanWijk = (id) => (gemeente?.wijken || []).find(w => w.id === id)?.naam || '';
      const sectorRijen = (sectorenRef.current?.features || []).map(f => {
        const code = f.properties?.NISCODE;
        const dek = dekTelling?.perSector.find(x => x.sector === code);
        return {
          sector: sectorNaam(code),
          code,
          wijk: naamVanWijk(f.properties?.WIJK_ID),
          inwoners: sectorInwoners[code] ?? null,
          autos: sectorWagens[code] ?? null,
          buiten: dek ? dek.inwonersZonder : null,
          gedekt: dek && dek.inwoners > 0 ? Math.round(dek.deelInwoners * 100) : null,
        };
      }).sort((a2, b2) => (a2.wijk || '').localeCompare(b2.wijk || '')
        || (b2.inwoners || 0) - (a2.inwoners || 0));

      const dekWijkRijen = (dekTelling?.perWijk || [])
        .filter(w => w.inwoners > 0)
        .sort((a2, b2) => b2.inwonersZonder - a2.inwonersZonder)
        .map(w => ({
          wijk: naamVanWijk(w.wijkId),
          inwoners: w.inwoners,
          buiten: w.inwonersZonder,
          gedekt: Math.round(w.deelInwoners * 100),
        }));
      if (dekWijkRijen.length && dekTelling) {
        dekWijkRijen.push({ wijk: 'Samen', inwoners: dekTelling.totaal.inwoners,
          buiten: dekTelling.totaal.inwonersZonder,
          gedekt: Math.round(dekTelling.totaal.deelInwoners * 100) });
      }

      const extraBladen = [
        ...(sectorRijen.length ? [{ naam:'Per sector',
          kolommen:[
            { titel:'Statistische sector', veld:'sector', breedte:30, soort:'tekst',
              uitleg:'Naam van de sector volgens Statbel. Let op: die naam is vaak gelijk aan de wijknaam.' },
            { titel:'Code', veld:'code', breedte:13, soort:'tekst', uitleg:'De officiële sectorcode.' },
            { titel:'Wijk', veld:'wijk', breedte:26, soort:'tekst',
              uitleg:'De wijk waar deze sector bij hoort, volgens de gemeentegedragen wijkindeling.' },
            { titel:'Inwoners', veld:'inwoners', breedte:11, soort:'getal', uitleg:'Inwoners van de sector volgens Statbel.' },
            { titel:'Auto\u2019s', veld:'autos', breedte:11, soort:'getal',
              uitleg:'Auto\u2019s in de sector volgens Statbel. Hiermee wordt de behoefte van de wijk over haar sectoren verdeeld.' },
            { titel:'Buiten de dekking', veld:'buiten', breedte:17, soort:'getal',
              uitleg:'Inwoners van deze sector zonder laadpunt binnen 250 meter.' },
            { titel:'Gedekt %', veld:'gedekt', breedte:11, soort:'getal',
              uitleg:'Deel van de inwoners met een laadpunt binnen 250 meter.' },
          ], rijen: sectorRijen }] : []),
        ...(dekWijkRijen.length ? [{ naam:'Dekking per wijk',
          kolommen:[
            { titel:'Wijk', veld:'wijk', breedte:28, soort:'tekst', uitleg:'Naam van de wijk.' },
            { titel:'Inwoners', veld:'inwoners', breedte:12, soort:'getal', uitleg:'Inwoners van de wijk, opgeteld uit de sectoren.' },
            { titel:'Buiten de dekking', veld:'buiten', breedte:18, soort:'getal',
              uitleg:'Inwoners zonder laadpunt binnen 250 meter, hemelsbreed gemeten.' },
            { titel:'Gedekt %', veld:'gedekt', breedte:11, soort:'getal',
              uitleg:'Deel van de inwoners met een laadpunt binnen 250 meter.' },
          ], rijen: dekWijkRijen }] : []),
      ];

      const hoofdKolommen = [
          { titel:'Wijk',        veld:'wijk',      breedte:22, soort:'tekst', uitleg:'Naam van de wijk zoals in de app.' },
          { titel:'Wijktype',    veld:'wijktype',  breedte:20, soort:'tekst', uitleg:'Binnenstad, woonwijk of bedrijventerrein; bepaalt de doelgroepenmix.' },
          { titel:'Jaar',        veld:'jaar',      breedte:8,  soort:'getal', uitleg:'Peiljaar.' },
          { titel:'Inwoners',    veld:'inwoners',  breedte:11, soort:'getal',
            uitleg:'Inwoners van de wijk, opgeteld uit de statistische sectoren.' },
          { titel:'Auto\u2019s',     veld:'autos',     breedte:11, soort:'getal',
            uitleg:'Auto\u2019s in de wijk, opgeteld uit de statistische sectoren. Dit is de sleutel waarmee de behoefte van een wijk over haar sectoren wordt verdeeld.' },
          { titel:'Nodig',       veld:'nodig',     breedte:11, soort:'getal', uitleg:'Publieke laadpunten die dat jaar nodig zijn, alle soorten samen.' },
          { titel:'Nodig gewoon',   veld:'nodigAC',   breedte:13, soort:'getal', uitleg:'Daarvan het deel normaal laden, AC 11 kW.' },
          { titel:'Nodig snel',     veld:'nodigDC',   breedte:12, soort:'getal', uitleg:'Daarvan het deel snelladen, DC 50 kW. Voor de hele gemeente opgeteld en naar hele palen van twee afgerond, en pas daarna over de wijken verdeeld.' },
          { titel:'Nodig ultrasnel',veld:'nodigHPC',  breedte:15, soort:'getal', uitleg:'Daarvan het deel ultrasnel laden, HPC 150 kW. Op dezelfde manier per gemeente afgerond. Komt alleen voor bij een bedrijventerrein.' },
          { titel:'Aanwezig',    veld:'aanwezig',  breedte:11, soort:'getal', uitleg:'Bestaande laadpunten die meetellen voor die behoefte, GEWOGEN: een semipubliek laadpunt telt voor de helft. Vandaar de halve getallen.' },
          { titel:'Aanwezig gewoon',   veld:'aanwezigAC',  breedte:15, soort:'getal', uitleg:'Daarvan het deel normaal laden, gewogen.' },
          { titel:'Aanwezig snel',     veld:'aanwezigDC',  breedte:14, soort:'getal', uitleg:'Daarvan het deel snelladen, gewogen.' },
          { titel:'Aanwezig ultrasnel',veld:'aanwezigHPC', breedte:17, soort:'getal', uitleg:'Daarvan het deel ultrasnel laden, gewogen.' },
          { titel:'Bij dat jaar',veld:'ditJaar',   breedte:13, soort:'getal', uitleg:'Wat er in dat ene jaar bij moet komen.' },
          { titel:'Cumulatief',  veld:'cumulatief',breedte:12, soort:'getal', uitleg:'Alles bij elkaar tot en met dat jaar.' },
          { titel:'Bij te plaatsen gewoon', veld:'ac',      breedte:19, soort:'getal',
            uitleg:'Van het CUMULATIEVE aantal, het deel normaal laden dat nog bij moet komen. De aftrek gebeurt PER SOORT: een overschot aan gewone laadpunten dekt een tekort aan snelladers niet.' },
          { titel:'Bij te plaatsen snel', veld:'dc',      breedte:17, soort:'getal',
            uitleg:'Van het cumulatieve aantal, het deel snelladen dat nog bij moet komen.' },
          { titel:'Bij te plaatsen ultrasnel',veld:'hpc',      breedte:20, soort:'getal',
            uitleg:'Van het cumulatieve aantal, het deel ultrasnel laden dat nog bij moet komen.' },
          { titel:'Privé %',     veld:'prive',     breedte:10, soort:'getal', uitleg:'Aandeel dat thuis of op eigen terrein laadt.' },
          { titel:'MWh',         veld:'mwh',       breedte:11, soort:'getal', uitleg:'Publieke laadvraag per jaar.' },
          { titel:'CAPEX jaar',  veld:'capexJaar', breedte:14, soort:'bedrag',uitleg:'Investering in dat ene jaar.' },
          { titel:'CAPEX totaal',veld:'capexCum',  breedte:14, soort:'bedrag',uitleg:'Investering tot en met dat jaar.' },
      ];

      await downloadRapport({
        gemeenteId: gemId, gemeente: gemeente?.naam || '', onderwerp: 'prognose',
        meta2: { peiljaar: year, bijkomend: Math.round(bijkomend) },
        titel: 'Strategisch Laadplan, prognose per wijk',
        ondertitel: `${gemeente?.naam || ''} · ${(gemeente?.wijken || []).length} wijken · ` +
                    `${fmtN(wijkResults.reduce((x, r) => x + (r.wijk.inwoners || 0), 0))} inwoners ` +
                    `in de wijken · peiljaren ${EERSTE_PLANJAAR} tot en met ${YEARS[YEARS.length - 1]}`,
        meta: `Opgesteld op ${new Date().toLocaleDateString('nl-BE')} · privé-aandeel startpunt ` +
              `${Math.round(priveStartActief * 100)}% · buffer ${Math.round(redundantieMarge * 100)}%`,
        tabblad: 'Per wijk per jaar',
        // LET OP: worden er bladen meegestuurd, dan negeert de server de losse
        // kolommen en rijen hieronder. Het hoofdblad staat daarom als EERSTE
        // blad in de lijst, en deze kolommen blijven staan voor de opbouw van
        // het toelichtingsblad.
        kolommen: hoofdKolommen,
        rijen,
        bladen: [{ naam: 'Per wijk per jaar', kolommen: hoofdKolommen, rijen }, ...extraBladen],
        toelichting: [
          ['Herkomst', 'Bestaande laadpunten uit de open gegevens van MOW; privé-laadpunten via Fluvius. ' +
            'Inwoners en auto\u2019s per sector komen van Statbel en worden per wijk opgeteld; het aantal ' +
            'voertuigen van de gemeente komt uit het voertuigenpark en wordt over de wijken verdeeld naar ' +
            'het aantal auto\u2019s.'],
          ['Eerste jaar', 'In het eerste planjaar wordt de volledige achterstand ingelopen, daarna komt er per jaar alleen de groei bij.'],
          ['Kosten', 'AC rekent 4.500 euro per laadpunt; DC en HPC rekenen per laadpaal van twee punten.'],
          ['Privé-aandeel', 'Het startpunt geldt voor 2026 en daalt daarna met twee punten per jaar.'],
        ],
      });
    } catch (e) {
      setExportFout(e.message);
    } finally {
      setExportBezig(false);
    }
  };

  // ── Jaarbalk ───────────────────────────────────────────────────────
  // Staat op Dashboard, Gemeente, Wijken en Laadinfra-mix en werkt overal op
  // dezelfde selectie, zodat een jaar dat je op het ene tabblad kiest ook op de
  // andere geldt.
  // Het peiljaar, rechts in de band met kerncijfers. De zin per tabblad staat
  // in de uitleg bij "Peiljaar". Op Dashboard met meer jaren gekozen blijft die
  // zin zichtbaar, want anders is niet te zien voor welk jaar de cijfers gelden.
  const JaarBalk = ({ hint }) => (
    <div style={{ display:'flex', alignItems:'center', gap:4, flexWrap:'wrap', marginLeft:'auto' }}>
      <Uitleg tekst={hint} ikoon={false} style={{ ...st.jlbl, borderBottom:`1px dotted ${N.ink4}`, marginRight:2 }}>Peiljaar</Uitleg>
      {[2027,2028,2029,2030,2031,2032,2033,2034,2035].map(y => (
        <button key={y} style={st.jp(jaren.includes(y))} onClick={() => wisselJaar(y)}>{y}</button>
      ))}
      <button style={st.jreset}
        onClick={() => setJaren(meerdereJarenToegestaan ? JAREN_DEFAULT : [2030])}
        title={meerdereJarenToegestaan ? 'Terug naar 2027 en 2030' : 'Terug naar 2030'}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
          <path d="M21 12a9 9 0 11-3.5-7.1"/><path d="M21 3v6h-6"/>
        </svg>
      </button>
      {tab === 'dashboard' && jaren.length > 1 && <span style={st.jhint}>{hint}</span>}
    </div>
  );

  // "3 minuten geleden" leest prettiger dan een tijdstip in een melding die
  // over iets van zojuist gaat.
  const geledenInWoorden = (wanneer) => {
    if (!wanneer) return 'zojuist';
    const min = Math.round((Date.now() - new Date(wanneer).getTime()) / 60000);
    if (min < 1) return 'zojuist';
    if (min === 1) return '1 minuut geleden';
    if (min < 60) return `${min} minuten geleden`;
    const uur = Math.round(min / 60);
    return uur === 1 ? '1 uur geleden' : `${uur} uur geleden`;
  };

  // Geen enkele gemeente aan dit account gekoppeld. Dan heeft de rest van het
  // scherm niets om te tonen en zou het rekenmodel op niets rekenen.
  if (geenToegang) {
    return (
      <div style={{ minHeight:'100vh', background:N.canvas, display:'flex',
                    alignItems:'center', justifyContent:'center', padding:24,
                    fontFamily:'inherit' }}>
        <div style={{ maxWidth:460, background:N.paper, border:`1px solid ${N.line2}`,
                      borderRadius:12, padding:'28px 30px' }}>
          <div style={{ fontSize:17, fontWeight:700, color:N.ink, marginBottom:10,
                        letterSpacing:'-0.015em' }}>
            Geen gemeente gekoppeld
          </div>
          <div style={{ fontSize:14, color:N.ink2, lineHeight:1.65 }}>
            Er is op dit moment geen gemeente aan dit account gekoppeld.
            Neem contact op met de beheerder.
          </div>
        </div>
      </div>
    );
  }

  // Iemand anders heeft ondertussen hetzelfde uitgangspunt verzet. In plaats
  // van stil overschrijven komt hier de keuze: opnieuw laden, of de eigen
  // wijziging alsnog doorzetten.
  const botsingBalk = botsing ? (
    <div style={{ background:'#FDF4E7', borderBottom:`1px solid ${N.line2}`,
                  padding:'12px 22px', display:'flex', alignItems:'center',
                  gap:14, flexWrap:'wrap' }}>
      <div style={{ fontSize:14, color:N.ink, lineHeight:1.5, flex:1, minWidth:280 }}>
        {botsing.door
          ? `${botsing.door} heeft dit ${geledenInWoorden(botsing.wanneer)} gewijzigd.`
          : 'Iemand anders heeft dit ondertussen gewijzigd.'}
        {' '}Opnieuw laden om de laatste versie te zien, of de eigen wijziging alsnog opslaan.
      </div>
      <button
        onClick={() => { setBotsing(null); window.location.reload(); }}
        style={{ padding:'8px 14px', borderRadius:8, border:`1px solid ${N.line2}`,
                 background:N.paper, color:N.ink, fontSize:13, fontWeight:600,
                 cursor:'pointer', fontFamily:'inherit' }}
      >
        Opnieuw laden
      </button>
      <button
        onClick={() => {
          const nu = botsing.nu;
          setBotsing(null);
          // Zonder de meegestuurde stand slaat de server zonder controle op.
          bewaarInstellingen(gemId, nu)
            .then(() => {
              gezienRef.current = { ...gezienRef.current, ...nu };
              return getInstellingenHerkomst(gemId).then(r => setHerkomst(r || {}));
            })
            .catch(e => setApiError(`Deze instelling is niet bewaard: ${e.message}`));
        }}
        style={{ padding:'8px 14px', borderRadius:8, border:'none',
                 background:N.accent, color:'#fff', fontSize:13, fontWeight:600,
                 cursor:'pointer', fontFamily:'inherit' }}
      >
        Toch opslaan
      </button>
    </div>
  ) : null;

  return (
    <>
      {botsingBalk}
      {showDashboard && (
        <Dashboard
          gemeenten={gemeenten}
          dbStatus={dbStatus}
          gebruiker={getIngelogdeGebruiker()}
          onHoofdmenu={onHoofdmenu}
          onOpenBronnen={() => setShowBronnen(true)}
          onSelectGemeente={(id) => {
            setGemId(id);
            setShowDashboard(false);
          }}
          onStartOnboarding={(gemeenteMatch) => {
            setOnboardingInit(gemeenteMatch || null);
            setShowDashboard(false);
            setShowOnboarding(true);
          }}
        />
      )}
      <div style={{...st.app, display: showDashboard ? 'none' : 'flex'}}>
      <style>{`
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
        *{scrollbar-width:auto;scrollbar-color:rgba(18,22,28,0.24) transparent}
        ::-webkit-scrollbar{width:12px;height:12px}
        ::-webkit-scrollbar-track{background:transparent}
        ::-webkit-scrollbar-thumb{background:rgba(18,22,28,0.24);border-radius:6px;border:2px solid transparent;background-clip:padding-box}
        ::-webkit-scrollbar-thumb:hover{background:rgba(18,22,28,0.4);background-clip:padding-box;border:2px solid transparent}
        .kaart-tooltip { background: white; border: 1px solid #ddd; border-radius: 8px; padding: 8px 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
        .kaart-tooltip::before { display: none; }
        .leaflet-tooltip.kaart-tooltip { white-space: normal; }
      `}</style>

      {showOnboarding && (
        <GemeenteOnboarding
          initialGemeente={onboardingInit}
          onComplete={voegGemeenteToe}
          onClose={() => { setShowOnboarding(false); setOnboardingInit(null); }}
          saving={saving} />
      )}

      {/* Beheer van de gegevensbestanden. Vult het scherm, net als het
          gemeentenoverzicht, en is alleen vanaf dat overzicht te openen. */}
      {/* De parameters staan in een eigen bestand. Dit venster geeft alleen de
          waarden mee die HIER leven: de instellingen van dit plan en de
          aansluitwaarden van het scherm, zodat de pop-up kan laten zien of die
          laatste afwijken van wat de server gebruikt. */}
      <WijkImpact
        open={wijkImpactOpen} onClose={() => setWijkImpactOpen(false)} kaartAdres={KAART_ADRES}
        wijken={gemeente?.wijken || []} sectorenGeo={sectorenGeo} raster={dekRaster}
        jaren={plaatsJaren} startJaar={Math.min(Math.max(year, plaatsJaren[0]), plaatsJaren[plaatsJaren.length - 1])}
        jaardeel={plaatsOpdracht.jaardeelPerWijkJaar} plaatsResultaat={plaatsResultaat}
        gekozen={wijkImpactGekozen} kandidaten={wijkImpactKandidaten} pleinKleur={PLEIN_KLEUR}
        pleinOmvang={pleinOmvang} loopM={pleinLoop} zetLoopM={setPleinLoop} onKies={wijkImpactKies}
        beginJaar={Math.min(netcapBegin, netcapEind)} eindJaar={Math.max(netcapBegin, netcapEind)}
        planVoor={pleinHeeftPlan ? wijkImpactPlan : null} planMeta={gisNet?.samenvatting?.plan || null} />

      {showParams && (
        <Parameters
          onClose={() => setShowParams(false)}
          plan={{ minVak: pleinMinVak, pleinOmvang, pleinAandeel, nabij: pleinNabij, pleinLoop, capex: CAPEX_V2,
                  priveStart, redundantieMarge, huidigLP, plaatsVoorrang, netGrens, gisAanwezig: !!gisNet?.aanwezig }}
          net={{ PAAL_VERMOGEN, PUNTEN_PER_PAAL, KVA_STUDIE, KVA_CABINE, VERMOGEN_PEILDATUM }}
          herkomst={herkomst}
          gemeenteNaam={gemeente?.naam || ''}
          // De groei van het aantal auto's voor het uitlegblok, met het aantal
          // auto's van de telling erbij.
          autoGroei={autoGroei}
          voertuigen={gemeente?.voertuigen ?? null}
          // Het overzicht Instellingen: de huidige waarden plus dezelfde setters
          // en bewaarfuncties als de tabbladen. Niets hier bewaart zelf.
          instellingen={gemeente ? {
            standaard: STANDAARD_INSTELLINGEN, soorten: PLEIN_SOORTEN,
            priveStart, setPriveStart, priveBerekend: priveStartBerekend,
            redundantieMarge, setRedundantieMarge, huidigLP, setHuidigLP,
            evEigen: Object.keys(gemeente?.evAandeelOverride || {}).length > 0,
            normPerJaar, normMelding,
            bewaarNorm: (jr, w) => bewaarNormWaarde(jr, begrensNorm(w, jr)),
            pvpNormPct: gemeente?.pvpNormPct ?? null, bewaarPvp: bewaarPvpWaarde,
            pleinMinVak, setPleinMinVak, pleinOmvang, setPleinOmvang, pleinAandeel, setPleinAandeel,
            pleinToegang, setPleinToegang, pleinNabij, setPleinNabij, pleinSoorten, setPleinSoorten,
            pleinLoop, setPleinLoop,
            plaatsVoorrang, setPlaatsVoorrang, netGrens, setNetGrens, gisAanwezig: !!gisNet?.aanwezig,
            netcapSlim, setNetcapSlim, netcapBegin, setNetcapBegin, netcapEind, setNetcapEind,
            capex: capexPlan, setCapex: setCapexPlan,
            stad: { inwoners: gemeente?.inwoners, voertuigen: gemeente?.voertuigen,
                    wijken: (gemeente?.wijken || []).length, mow: existingPalen.length },
          } : null}
        />
      )}

      {showBronnen && (
        <div style={{ position:'fixed', inset:0, zIndex:1500, overflowY:'auto', background:N.canvas }}>
          <DataBronnen onClose={() => setShowBronnen(false)} />
        </div>
      )}

      {/* ── TOPBAR ─────────────────────────────────────────────────── */}
      <div style={st.nTop}>
        <div style={st.nBrandVak}>LaadAtlas</div>
        {/* Alleen voor de beheerder: terug naar de startpagina met de modules. */}
        {onHoofdmenu && (
          <button style={st.nTbtn(false)} onClick={onHoofdmenu}>Hoofdmenu</button>
        )}
        <button style={st.nBack} onClick={() => setShowDashboard(true)}>← Alle gemeenten</button>
        <div style={{ marginLeft:'auto', display:'flex', gap:8, alignItems:'center' }}>
          <button style={st.nTbtn(false)} onClick={() => setShowParams(true)}>
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
              <circle cx="8" cy="8" r="2.4"/>
              <path d="M8 1.4v2M8 12.6v2M14.6 8h-2M3.4 8h-2M12.7 3.3l-1.4 1.4M4.7 11.3l-1.4 1.4M12.7 12.7l-1.4-1.4M4.7 4.7L3.3 3.3"/>
            </svg>
            Parameters
          </button>
          <button style={st.nTbtn(false)} onClick={() => setShowEditor(true)}>
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
              <path d="M11 2l3 3-8 8H3v-3l8-8z"/>
            </svg>
            Bewerken
          </button>
          {/* Altijd zichtbaar. Voor de vaste referentiegemeenten Leuven en Gent
              staat de knop uit, met uitleg bij het aanwijzen. */}
          <button
            style={st.nTbtn(true, STANDAARD_IDS.includes(gemId))}
            disabled={STANDAARD_IDS.includes(gemId)}
            title={STANDAARD_IDS.includes(gemId)
              ? `${gemeente?.naam} is een vaste referentiegemeente en kan niet worden verwijderd`
              : `${gemeente?.naam} verwijderen`}
            onClick={() => setShowDelete(true)}>
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
              <polyline points="3 6 13 6"/><path d="M5 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><rect x="3" y="6" width="10" height="9" rx="1"/>
            </svg>
            Verwijderen
          </button>
        </div>
      </div>

      {showOverzicht && (
        <div style={{position:'fixed',inset:0,background:'rgba(18,22,28,0.45)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center'}}
          onClick={e=>e.target===e.currentTarget&&setShowOverzicht(false)}>
          <div style={{width:'min(1100px, 94vw)',maxHeight:'85vh',background:N.paper,border:`1px solid ${N.line}`,borderRadius:12,display:'flex',flexDirection:'column',overflow:'hidden',boxShadow:'0 20px 60px rgba(18,22,28,0.28)'}}>
            <div style={{padding:'16px 22px',borderBottom:`1px solid ${N.line}`,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontSize:15,fontWeight:800,color:N.ink}}>{gemeente?.naam}, Wijkoverzicht {year}</div>
              <span style={{cursor:'pointer',color:N.ink4,fontSize:20}} onClick={()=>setShowOverzicht(false)}>×</span>
            </div>
            <div style={{overflowY:'auto',flex:1}}>
              {/* Dezelfde kolommen en dezelfde getallen als de wijkkaarten
                  eronder, met de drie laadsoorten erbij en een totaalregel.
                  Tot 20 augustus 2026 stonden hier andere kolommen en werd
                  de prioriteit met gekleurde bolletjes aangeduid. */}
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
                <thead>
                  <tr style={{background:N.head,position:'sticky',top:0}}>
                    {[['Wijk','left'],['Nodig','right'],['Aanwezig','right'],
                      ['Gewoon','right'],['Snel','right'],['Ultrasnel','right'],
                      ['Bij te plaatsen','right'],['Privé-aandeel','right'],
                      ['Laadvraag MWh','right'],
                      ['Investering','right'],['Prioriteit','left']].map(([h,uitl])=>(
                      <th key={h} style={{padding:'10px 12px',textAlign:uitl,color:N.ink2,fontWeight:700,
                                          borderBottom:`1px solid ${N.line}`,whiteSpace:'nowrap'}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const rijen = wijkResults.map(({wijk,data})=>({
                      naam: wijk.naam,
                      nodig: data.totLP,
                      aanwezig: data.bestaand.AC + data.bestaand.DC + data.bestaand.HPC,
                      ac: data.delta.AC, dc: data.delta.DC, hpc: data.delta.HPC,
                      lp: data.bijTePlaatsen,
                      prive: data.privePct || 0,
                      mwh: Math.round(data.mwhPubliek),
                      capex: data.capex,
                    })).sort((a,b)=>b.lp-a.lp);
                    const som = rijen.reduce((a,r)=>({
                      nodig:a.nodig+r.nodig, aanwezig:a.aanwezig+r.aanwezig,
                      ac:a.ac+r.ac, dc:a.dc+r.dc, hpc:a.hpc+r.hpc,
                      lp:a.lp+r.lp, mwh:a.mwh+r.mwh, capex:a.capex+r.capex,
                    }), {nodig:0,aanwezig:0,ac:0,dc:0,hpc:0,lp:0,mwh:0,capex:0});
                    const cel = { padding:'8px 12px', textAlign:'right', color:N.ink2 };
                    const getal = (x) => x % 1 === 0 ? x : x.toFixed(1);
                    return (
                      <>
                        {rijen.map((r,i)=>(
                          <tr key={i} style={{borderBottom:`1px solid ${N.line}`,background:i%2===0?N.paper2:N.paper}}>
                            <td style={{padding:'8px 12px',color:N.ink,fontWeight:500}}>{r.naam}</td>
                            <td style={cel}>{Math.ceil(r.nodig)}</td>
                            <td style={cel}>{getal(r.aanwezig)}</td>
                            <td style={cel}>{Math.ceil(r.ac)}</td>
                            <td style={cel}>{Math.ceil(r.dc)}</td>
                            <td style={cel}>{Math.ceil(r.hpc)}</td>
                            <td style={{...cel,color:N.accent2,fontWeight:700}}>{Math.ceil(r.lp)}</td>
                            <td style={cel}>{Math.round(r.prive*100)}%</td>
                            <td style={cel}>{r.mwh.toLocaleString('nl-BE')}</td>
                            <td style={cel}>{fmtEur(r.capex)}</td>
                            <td style={{padding:'8px 12px',color:urgentieKleur(r.lp),whiteSpace:'nowrap'}}>
                              {urgentieLabel(r.lp)}</td>
                          </tr>
                        ))}
                        <tr style={{background:N.head,fontWeight:700}}>
                          <td style={{padding:'10px 12px',color:N.ink}}>Samen</td>
                          <td style={{...cel,color:N.ink,fontWeight:700}}>{Math.ceil(som.nodig)}</td>
                          <td style={{...cel,color:N.ink,fontWeight:700}}>{getal(som.aanwezig)}</td>
                          <td style={{...cel,color:N.ink,fontWeight:700}}>{Math.ceil(som.ac)}</td>
                          <td style={{...cel,color:N.ink,fontWeight:700}}>{Math.ceil(som.dc)}</td>
                          <td style={{...cel,color:N.ink,fontWeight:700}}>{Math.ceil(som.hpc)}</td>
                          <td style={{...cel,color:N.accent2,fontWeight:700}}>{Math.ceil(som.lp)}</td>
                          <td/>
                          <td style={{...cel,color:N.ink,fontWeight:700}}>{som.mwh.toLocaleString('nl-BE')}</td>
                          <td style={{...cel,color:N.ink,fontWeight:700}}>{fmtEur(som.capex)}</td>
                          <td/>
                        </tr>
                      </>
                    );
                  })()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {showEditor && gemeente && (
        <GemeenteEditor
          gemeente={gemeenteVolledig}
          capex={capexPlan}
          onCapex={setCapexPlan}
          onSave={slaEditorOp}
          onGisGewijzigd={() => setGisVersie(v => v + 1)}
          onClose={() => setShowEditor(false)} />
      )}

      {/* Verwijder bevestiging */}
      {showDelete && (
        <div style={st.delModal}>
          <div style={st.delBox}>
            <div style={{ fontSize:16, fontWeight:700, marginBottom:8, color:N.ink, letterSpacing:'-0.015em' }}>
              {gemeente?.naam} verwijderen?
            </div>
            <div style={{ fontSize:13, color:N.ink2, marginBottom:20, lineHeight:1.6 }}>
              De gemeente en alle bijbehorende wijkdata worden definitief uit de database
              verwijderd. Dit kan niet ongedaan worden gemaakt.
            </div>
            <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
              <button style={{ padding:'9px 18px', borderRadius:8, border:`1px solid ${N.line2}`, background:N.paper, color:N.ink2, cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'inherit' }}
                onClick={() => setShowDelete(false)}>Nee, annuleren</button>
              <button style={{ padding:'9px 18px', borderRadius:8, border:'none', background:N.red, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:700, fontFamily:'inherit' }}
                onClick={() => verwijder(gemId)}>Ja, verwijderen</button>
            </div>
          </div>
        </div>
      )}

      {apiError && <div style={st.errBnr}>⚠ {apiError}</div>}
      {saving   && <div style={st.savBnr}>Opslaan in database…</div>}

      {/* ── GEMEENTEKOP ────────────────────────────────────────────── */}
      <div style={st.nHead}>
        <div style={{ display:'flex', alignItems:'baseline', gap:14, flexWrap:'wrap' }}>
        <div style={st.nNaam}>{gemeente?.naam}</div>
        <div style={st.nMeta}>
          {gemeente?.inwoners?.toLocaleString('nl-BE')} inwoners
          {' · '}{gemeente?.wijken?.length || '…'} wijken
          {' · '}{loadingPalen
            ? 'laadpunten laden…'
            : `${existingPalen.length} bestaande laadpunten (MOW), ${(bestaandTotaalPerType.AC+bestaandTotaalPerType.DC+bestaandTotaalPerType.HPC).toFixed(0)} gewogen`}
          {ongematcht > 0 && <span style={{ color:N.warn }}>{' · '}{ongematcht} zonder wijkkoppeling</span>}
        </div>
        </div>
      </div>

      {/* ── TABBLADEN ──────────────────────────────────────────────── */}
      <div style={st.nTabs}>
        {[['dashboard','Dashboard'],['gemeente','Gemeente'],
          ...(bezettingZichtbaar ? [['bezetting','Bezetting']] : []),
          ['wijken','Wijken'],
          ['mix','Laadinfra-mix'],['pleinen','Laadpleinen'],['plaatsing','Plaatsing'],['dekking','Dekking'],['netcapaciteit','Netcapaciteit'],
          ['export','Export']].map(([id, label]) => (
          <button key={id} style={st.nTab(tab === id)} onClick={() => {
            // Buiten het Dashboard geldt er maar één jaar; houd het laatst
            // gekozen jaar aan zodat de gebruiker niets kwijtraakt.
            if (id !== 'dashboard') setJaren(hs => hs.length > 1 ? [hs[hs.length - 1]] : hs);
            setTab(id);
          }}>{label}</button>
        ))}
      </div>

      {/* ── KERNCIJFERS EN PEILJAAR, één smalle band ─────────────────── */}
      {/* Staat op elk tabblad, zodat het effect van een aangepaste parameter
          meteen zichtbaar is. Behalve op Bezetting: daar gaat het om gemeten
          gebruik, niet om het plan (HL, 14 oktober 2026).
          Sinds 23 oktober 2026 (mockup Laadpleinen V7) één regel in plaats van
          twee hoge stroken: de kleine regels onder de getallen staan nu in de
          uitleg bij aanwijzen. De jaren lopen door op een tweede regel als de
          breedte op is, zodat ze nooit uit beeld vallen. */}
      {tab !== 'bezetting' && (() => {
        const normKwh = acNormKwh(year, normPerJaar);
        const evPct = wijkResults[0]?.data.evPct || 0;
        const evTeHoog = evAandeelTeHoog(year, wijkResults[0]?.data.evPct);
        const evHerkomst = gemeente?.evAandeelOverride?.[year] != null ? 'handmatig ingevuld'
          : evOverrideVoorJaar(year) != null ? 'afgeleid uit de ingevulde jaren' : 'Vlaams gemiddelde';
        const cijfers = [
          [fmtN(totLP), `laadpunten nodig in ${year}`, N.accent,
            `Publieke laadpunten die in ${year} nodig zijn in de hele gemeente.`],
          [fmtN(bijkomend), 'bij te plaatsen', null,
            `Laadpunten die er tot ${year} bij moeten komen, bovenop wat er al staat en gepland is. Opgeteld per wijk. Een overschot in de ene wijk vult geen tekort in een andere wijk.`],
          [fmtN(normKwh), 'kWh per laadpunt per jaar', null,
            `De norm: wat één publiek laadpunt per jaar levert. Dat is ${Math.round(100 * normKwh / MOW_DREMPEL_BIJPLAATSING_KWH)}% van de MOW-drempel van ${fmtN(MOW_DREMPEL_BIJPLAATSING_KWH)} kWh.`],
          [fmtN(Math.round(totMwhPubliek)), 'MWh publiek per jaar', null,
            `Wat er per jaar aan publieke laadpunten wordt geladen. Daarnaast laadt ${fmtN(Math.round(totMwhPrive))} MWh thuis of op het werk.`],
          [fmtN(aanwezigTotaal), 'laadpunten nu', null,
            aanwezigTotaal > 0
              ? `Telt mee in de berekening: ${fmtN(aanwezigPubliek)} publiek en ${fmtN(aanwezigSemi)} semipubliek. Semipubliek telt voor de helft. Publiek is dag en nacht open, semipubliek minstens 10 uur per dag. Bron: Vlaamse overheid.`
              : `Gewogen, van ${fmtN(existingPalen.length)} punten.`],
          [`${(evPct * 100).toFixed(1).replace('.', ',')}%`, `elektrisch in ${year}`, evTeHoog ? N.red : null,
            <>Deel van de personenwagens dat in {year} volledig elektrisch rijdt: {evHerkomst}.
              {evTeHoog && <><br/><span style={{ color:'#FFB4A6' }}>Dit is meer dan {String(EV_AANDEEL_GRENS).replace('.', ',')} keer
              het Vlaams gemiddelde van dit jaar. Een cijfer uit een gemeentelijke statistiek bevat ook de
              geregistreerde voertuigen van een leasemaatschappij en hoort hier niet ingevuld te worden.</span></>}</>],
        ];
        const hint = (tab === 'dashboard'
          ? (jaren.length > 1
              ? `${jaren.length} jaren geselecteerd, kerncijfers gelden voor ${year}`
              : 'Klik meerdere jaren om ze te vergelijken')
        : tab === 'gemeente' ? 'Parameters en kaart gelden voor het laatst gekozen jaar'
        : tab === 'wijken'   ? 'Alle wijken bij het laatst gekozen jaar'
        : tab === 'mix'      ? 'Verdeling bij het laatst gekozen jaar'
        : tab === 'netcapaciteit' ? 'Gevraagd aansluitvermogen per jaar en per wijk'
        : tab === 'pleinen'  ? 'Kandidaatlocaties; het benodigde aantal geldt voor het laatst gekozen jaar'
        : tab === 'plaatsing' ? 'Waar de nieuwe laadpunten van dit jaar terechtkomen'
        : tab === 'dekking'  ? 'Laadpunten met een cirkel van 250 meter eromheen'
        : 'Export gebruikt alle jaren van 2027 tot 2035');
        return (
          <div style={st.band}>
            {cijfers.map(([waarde, label, kleur, uitleg], i) => (
              // In de band zonder het rondje met de i, anders past de regel niet
              // naast de jaren. Een stippellijn onder het woord toont de uitleg.
              <Uitleg key={label} tekst={uitleg} ikoon={false}
                style={{ ...st.bandK, borderRight: i < cijfers.length - 1 ? `1px solid ${N.line}` : 'none' }}>
                <b style={{ fontSize:18, fontWeight:700, color: kleur || N.ink, fontVariantNumeric:'tabular-nums' }}>{waarde}</b>
                <span style={{ fontSize:12.5, color:N.ink3, borderBottom:`1px dotted ${N.ink4}` }}>{label}</span>
              </Uitleg>
            ))}
            {JaarBalk({ hint })}
          </div>
        );
      })()}

      {/* ── TABBLAD: DASHBOARD ─────────────────────────────────────── */}
      {/* Kerncijfers en de prognosegrafiek, verhuisd uit de oude zijbalk
          en het oude kaartgebied. */}
      <div style={{ ...st.nPane, display: tab === 'dashboard' ? 'block' : 'none' }}>

        <div style={st.nCard}>
          {/* Grafiek. Laadpunten en CAPEX tonen het jaardeel, niet het
              cumulatieve totaal. Dat totaal staat in de kerncijfers bovenaan
              en, voor CAPEX, als lijn over de staven heen. */}
          <div style={st.chart}>
            <div style={st.cTabs}>
              {[['lp','Laadpunten'],['mwh','MWh'],['capex','CAPEX']].map(([id,l])=>(
                <div key={id} style={st.cTab(chartTab===id)} onClick={()=>setChartTab(id)}>{l}</div>
              ))}
            </div>
            <div style={st.cUitleg}>
              {chartTab==='lp'   && 'Staven: wat er dat jaar bij moet komen. Lijn: het totaal tot en met dat jaar.'}
              {chartTab==='mwh'  && 'Publieke laadvraag in dat jaar.'}
              {chartTab==='capex'&& 'Staven: investering in dat jaar. Lijn: totaal vanaf 2027 tot en met dat jaar.'}
            </div>
            <ResponsiveContainer width="100%" height={210}>
              {chartTab==='mwh' ? (
                <LineChart data={tijdreeksPerJaar} margin={{top:8,right:12,left:-14,bottom:4}}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#E8E4DC"/>
                  <XAxis dataKey="jaar" tick={{fill:N.ink2,fontSize:12.5,fontWeight:600}} height={30} tickMargin={8} interval={0} axisLine={{stroke:N.line2}} tickLine={false}/>
                  <YAxis tick={{fill:N.ink3,fontSize:12}} width={58}/>
                  <Tooltip
                    contentStyle={{background:N.paper,border:`1px solid ${N.line2}`,borderRadius:8,fontSize:13.5,padding:"10px 13px",boxShadow:'0 4px 14px rgba(18,22,28,0.12)'}}
                    labelStyle={{color:N.ink,fontWeight:700}}
                    formatter={(v,naam)=>[`${Math.round(v).toLocaleString('nl-BE')} MWh`, naam]}/>
                  <Line dataKey="MWh" name="Laadvraag dat jaar" stroke={N.ok} strokeWidth={2.4} dot={{r:3}}/>
                </LineChart>

              ) : chartTab==='capex' ? (
                <ComposedChart data={tijdreeksPerJaar} margin={{top:8,right:2,left:-14,bottom:4}}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#E8E4DC"/>
                  <XAxis dataKey="jaar" tick={{fill:N.ink2,fontSize:12.5,fontWeight:600}} height={30} tickMargin={8} interval={0} axisLine={{stroke:N.line2}} tickLine={false}/>
                  {/* Twee assen: het jaarbedrag is veel kleiner dan het totaal, dus
                      op één as zouden de staven onzichtbaar plat worden. */}
                  <YAxis yAxisId="jaar"  tick={{fill:N.warn,fontSize:12}} width={58} axisLine={false} tickLine={false}/>
                  <YAxis yAxisId="totaal" orientation="right" tick={{fill:N.accent,fontSize:12}} width={58} axisLine={false} tickLine={false}/>
                  <Tooltip
                    contentStyle={{background:N.paper,border:`1px solid ${N.line2}`,borderRadius:8,fontSize:13.5,padding:"10px 13px",boxShadow:'0 4px 14px rgba(18,22,28,0.12)'}}
                    labelStyle={{color:N.ink,fontWeight:700}}
                    formatter={(v,naam)=>[`€${Math.round(v).toLocaleString('nl-BE')}K`, naam]}
                    cursor={{ fill:'transparent' }}/>
                  <Legend wrapperStyle={{fontSize:13,paddingTop:10}} iconType="square" iconSize={11}/>
                  <Bar  yAxisId="jaar"   dataKey="CAPEX dit jaar"   name="Investering dat jaar (as links)" fill={N.warn} radius={[3,3,0,0]} maxBarSize={30}/>
                  <Line yAxisId="totaal" dataKey="CAPEX cumulatief" name="Totaal vanaf 2027 (as rechts)"  stroke={N.accent} strokeWidth={2.4} dot={{r:3}}/>
                </ComposedChart>

              ) : (
                /* Eén staaf met het jaardeel, en de totale behoefte als lijn
                   erover. Bewust geen gestapelde staaf meer: het onderste deel
                   was een restpost (behoefte min jaardeel) die niet gelijk is
                   aan het kerncijfer 'nu aanwezig', omdat overschot in een wijk
                   die al genoeg heeft per wijk op nul wordt geknipt. Twee
                   getallen die op hetzelfde lijken maar verschillen, leest als
                   een fout. Eén as, zodat de staaf zichtbaar een deel van de
                   lijn is en niet even hoog lijkt. */
                <ComposedChart data={tijdreeksPerJaar} margin={{top:8,right:12,left:-14,bottom:4}}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#E8E4DC"/>
                  <XAxis dataKey="jaar" tick={{fill:N.ink2,fontSize:12.5,fontWeight:600}} height={30} tickMargin={8} interval={0} axisLine={{stroke:N.line2}} tickLine={false}/>
                  <YAxis tick={{fill:N.ink3,fontSize:12}} width={58}/>
                  {/* De hovertekst krijgt per reeks de kleur van de reeks zelf,
                      expliciet gezet en niet overgelaten aan de standaardstijl,
                      zodat naam en getal altijd bij de juiste vorm horen. */}
                  <Tooltip
                    contentStyle={{background:N.paper,border:`1px solid ${N.line2}`,borderRadius:8,fontSize:13.5,padding:"10px 13px",boxShadow:'0 4px 14px rgba(18,22,28,0.12)'}}
                    labelStyle={{color:N.ink,fontWeight:700}}
                    formatter={(v,naam,p)=>[
                      <span key="v" style={{color:p?.color||N.ink2,fontWeight:700}}>{Math.round(v).toLocaleString('nl-BE')}</span>,
                      <span key="n" style={{color:p?.color||N.ink2}}>{naam}</span>,
                    ]}
                    cursor={{ fill:'transparent' }}/>
                  <Legend wrapperStyle={{fontSize:13,paddingTop:10}} iconType="square" iconSize={11}/>
                  {/* Staaf in petrol, lijn in oker. Bewust twee kleurfamilies:
                      twee tinten petrol waren op het scherm niet uit elkaar te
                      houden, waardoor staaf en lijn hetzelfde leken. */}
                  <Bar  dataKey="Nieuw dit jaar" name="Bij te plaatsen dat jaar" fill={N.accent2} radius={[3,3,0,0]} maxBarSize={34}/>
                  <Line dataKey="Tot en met dat jaar" name="Tot en met dat jaar" stroke={N.warn} strokeWidth={2.4} dot={{r:3,fill:N.warn}}/>
                </ComposedChart>
              )}
            </ResponsiveContainer>
            {chartTab==='lp' && (
              <div style={{ ...st.cUitleg, marginTop:6, marginBottom:0 }}>
                De lijn toont wat er tot en met dat jaar in totaal bij moet komen. In het gekozen
                jaar komt hij precies uit op het kerncijfer &laquo;bij te plaatsen&raquo; bovenaan.
              </div>
            )}
          </div>
        </div>

        {/* Vergelijking van de geselecteerde jaren. Gevuld uit tijdreeksPerJaar,
            dus exact dezelfde cijfers als de grafiek erboven. De rijen die 'dat
            jaar' heten tonen het JAARDEEL, niet het cumulatieve totaal; dat
            laatste staat in de vaste kerncijferbalk bovenaan. Verschijnt alleen
            als er meer dan één jaar is aangeklikt. */}
        {jaren.length > 1 && (() => {
          const rijen = [
            ['Laadpunten nodig publiek', 'Totaal nodig',   v => fmtN(v)],
            ['Bij te plaatsen dat jaar', 'Nieuw dit jaar', v => fmtN(v)],
            ['CAPEX dat jaar',           'CAPEX dit jaar', v => `€${Math.round(v).toLocaleString('nl-BE')}K`],
            ['Laadvolume MWh per jaar',  'MWh',            v => fmtN(v)],
          ];
          const perJaar = jaren.map(j => tijdreeksPerJaar.find(t => t.jaar === j)).filter(Boolean);
          if (perJaar.length < 2) return null;
          return (
            <div style={{ ...st.nCard, marginBottom:18 }}>
              <div style={st.vHdr}>
                <div style={{ fontSize:14, fontWeight:700, color:N.ink }}>Vergelijking geselecteerde jaren</div>
                <div style={{ fontSize:11.5, color:N.ink4 }}>verschil ten opzichte van het vorige geselecteerde jaar</div>
              </div>
              <div style={{ overflowX:'auto' }}>
                <table style={st.vTbl}>
                  <thead>
                    <tr>
                      <th style={st.vTh(false)}>Indicator</th>
                      {perJaar.map(p => <th key={p.jaar} style={st.vTh(true)}>{p.jaar}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {rijen.map(([label, sleutel, opmaak]) => (
                      <tr key={label}>
                        <td style={st.vTd(true)}>{label}</td>
                        {perJaar.map((p, i) => {
                          const waarde = p[sleutel] || 0;
                          let verschil = null;
                          if (i > 0) {
                            const vorige = perJaar[i-1][sleutel] || 0;
                            if (vorige > 0) {
                              const pct = Math.round((waarde - vorige) / vorige * 100);
                              verschil = (pct >= 0 ? '+' : '') + pct + '%';
                            }
                          }
                          return (
                            <td key={p.jaar} style={st.vTd(false)}>
                              {opmaak(waarde)}
                              {verschil && <span style={st.vDelta(verschil.startsWith('+'))}>{verschil}</span>}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })()}

        {/* ── Kerninzichten van het tabblad Laadpleinen ─────────────── */}
        {/* Staat onderaan het Dashboard, na de vergelijking van de jaren, en
            rekent mee met het gekozen peiljaar. Bewust een toevoeging: aan het
            bestaande Dashboard verandert niets. */}
        <div style={st.dPlein}>
          <div style={st.dPleinKop}>
            <span style={{ fontSize:14, fontWeight:700, color:N.ink }}>Laadpleinen</span>
            <button style={st.dPleinLink} onClick={() => setTab('pleinen')}>
              Naar het tabblad Laadpleinen →
            </button>
          </div>

          {pleinRijen === null ? (
            <div style={st.cUitleg}>Kandidaatlocaties laden…</div>
          ) : !pleinAlles.length ? (
            <>
              <div style={st.cUitleg}>
                Voor {gemeente?.naam} zijn nog geen parkeerterreinen opgehaald, dus er is nog geen
                zicht op waar de laadpunten terecht kunnen.
              </div>
              <button style={{ ...st.gBtn, width:'auto', marginTop:10, padding:'8px 16px' }}
                onClick={opnieuwOphalen} disabled={pleinBezig}>
                {pleinBezig ? 'Bezig met ophalen…' : 'Nu ophalen'}
              </button>
            </>
          ) : (
            <>
              <div style={st.cUitleg}>
                Waar de laadpunten van {year} terecht kunnen, en hoever de gemeente is met het
                aanwijzen van locaties.
              </div>

              <div style={st.dPleinDrie}>
                {[['Laadpleinen nodig', fmtN(pleinNodig),
                   `${pleinAandeel}% van ${fmtN(bijkomend)} laadpunten, ${pleinOmvang} per plein`, true],
                  ['Kandidaatlocaties', fmtN(pleinGefilterd.length),
                   'openbaar, groot genoeg, bij een voorziening', false],
                  ['Geschikt bevonden', fmtN(pleinGeschikt.length),
                   pleinRuimteBestel > 0
                     ? `samen ruimte voor ${fmtN(pleinRuimte)} laadpunten, zonder de ${fmtN(pleinRuimteBestel)} voor bestelwagens`
                     : `samen ruimte voor ${fmtN(pleinRuimte)} laadpunten`, false],
                  ['Laadpunten deelwagens', fmtN(pleinDeelTotaal),
                   `op ${fmtN(pleinDeelLocaties.length)} van de ${fmtN(pleinGeschikt.length)} gekozen locaties`, true],
                ].map(([label, waarde, sub, accent]) => (
                  <div key={label} style={st.dCijfer}>
                    <div style={st.kernL}>{label}</div>
                    <div style={st.dCijferV(accent)}>{waarde}</div>
                    <div style={st.kernS}>{sub}</div>
                  </div>
                ))}
              </div>

              {/* De verdeelbalk: het antwoord op de vraag of er plek is. */}
              <div style={{ marginTop:14 }}>
                <div style={st.dPleinRij}>
                  <span><b>{fmtN(puntenMetPlek)}</b> van de {fmtN(bijkomend)} bij te plaatsen
                    laadpunten heeft een concrete plek</span>
                  <span style={{ color:N.ink3 }}>
                    {pleinAandeel}% op een plein, {100 - pleinAandeel}% als losse paal</span>
                </div>
                <div style={st.dBalk}>
                  {[[puntenMetPlek, N.ok], [puntenZonderPlek, N.accent2], [puntenLossePaal, KERN_LICHT]]
                    .map(([deel, kleur], i) => (
                    <span key={i} style={{ display:'block', height:'100%', background:kleur,
                      width: `${bijkomend > 0 ? (deel / bijkomend) * 100 : 0}%` }}/>
                  ))}
                </div>
                <div style={st.dLeg}>
                  {[[N.ok, `${fmtN(puntenMetPlek)} op geschikt bevonden pleinen`],
                    [N.accent2, `${fmtN(puntenZonderPlek)} nog een plein voor te kiezen`],
                    [KERN_LICHT, `${fmtN(puntenLossePaal)} als losse paal in de straat`],
                  ].map(([kleur, tekst]) => (
                    <span key={tekst} style={st.dLegRij}>
                      <span style={{ ...st.pBol, borderRadius:3, background:kleur }}/>{tekst}
                    </span>
                  ))}
                </div>
              </div>

              {/* Wat de gekozen locaties dekken: wat het model per laadsoort
                  vraagt naast wat er is aangewezen. De regels over gedekte
                  laadvraag, over bewoners en over de netaansluiting stonden
                  hier tot 9 september 2026. Die rekenden in megawattuur en
                  procenten, en dat las als een oordeel dat het niet was. */}
              {pleinIngevuldeLocaties.length > 0 && (
                <div style={{ marginTop:14, paddingTop:12, borderTop:`1px solid ${N.line2}` }}>
                  <div style={{ fontSize:14, fontWeight:700, color:N.ink }}>Wat de gekozen locaties dekken</div>
                  <div style={{ fontSize:12.5, color:N.ink3, marginBottom:10 }}>
                    Peiljaar {year} · Norm is: {pleinAandeel}% van de laadpunten staan op een laadplein</div>

                  <table style={{ width:'100%', fontSize:12.5, borderCollapse:'collapse' }}><tbody>
                    <tr>
                      <td style={{ color:N.ink4, paddingBottom:5 }}>Soort</td>
                      <td style={{ color:N.ink4, textAlign:'right', paddingBottom:5 }}>Volgens het model</td>
                      <td style={{ color:N.ink4, textAlign:'right', paddingBottom:5 }}>Ingevuld</td>
                    </tr>
                    {[['AC 11 kW','ac'],['DC 50 kW','dc'],['HPC 150 kW','hpc']].map(([label, sleutel]) => (
                      <tr key={sleutel} style={{ borderTop:`1px solid ${N.line}` }}>
                        <td style={{ padding:'5px 0' }}>{label}</td>
                        <td style={{ textAlign:'right', color:N.ink3 }}>{fmtN(pleinDekking.nodig[sleutel])}</td>
                        <td style={{ textAlign:'right', fontWeight:700 }}>{fmtN(pleinDekking.ingevuld[sleutel])}</td>
                      </tr>
                    ))}
                  </tbody></table>
                  {pleinRuimteBestel > 0 && (
                    <div style={{ fontSize:12.5, color:N.ink4, marginTop:6 }}>
                      Laadpunten voor bestelwagens tellen hier niet mee.
                    </div>
                  )}
                </div>
              )}

              <div style={st.dVoortgang}>
                <span style={{ fontSize:12.5, whiteSpace:'nowrap' }}>Beoordeeld</span>
                <span style={st.dVBalk}>
                  <span style={{ display:'block', height:'100%', background:N.accent,
                    width:`${pleinGefilterd.length ? (pleinBeoordeeldTotaal / pleinGefilterd.length) * 100 : 0}%` }}/>
                </span>
                <span style={{ fontSize:12.5, fontWeight:700, whiteSpace:'nowrap' }}>
                  {fmtN(pleinBeoordeeldTotaal)} van {fmtN(pleinGefilterd.length)}</span>
                <span style={{ fontSize:12.5, color:N.ink3, whiteSpace:'nowrap' }}>
                  · {fmtN(pleinGeschikt.length)} geschikt, {fmtN(pleinAfgevallen)} afgevallen</span>
              </div>
            </>
          )}
        </div>

        {/* ── Bestelwagens ───────────────────────────────────────────────
            Het laadvermogen voor bestelwagens op de gekozen laadpleinen naast
            het minimum dat MOW voor de hele gemeente raamt. Verandert niet mee
            met de jaarbalk, want MOW publiceert alleen 2028 en 2030. Zonder
            MOW-gegevens voor deze gemeente geen blok. */}
        {Number.isFinite(mowBestel?.kw2028) && Number.isFinite(mowBestel?.kw2030) && (() => {
          const rijen = [[2028, mowBestel.kw2028], [2030, mowBestel.kw2030]].map(([j, mow]) => {
            const plan = bestelVermogenTot(gekozenLocaties, j, EERSTE_PLANJAAR);
            return { j, mow, punten: plan.punten, kw: plan.kw, verschil: Math.round(plan.kw) - Math.round(mow) };
          });
          const th = (rechts) => ({ fontSize:13, fontWeight:400, color:N.ink4, textAlign: rechts ? 'right' : 'left',
            padding:'5px 6px', borderBottom:`1px solid ${N.line}`, textTransform:'uppercase',
            letterSpacing:'.04em', whiteSpace:'nowrap' });
          const td = (extra = {}) => ({ fontSize:15, padding:'8px 6px', borderBottom:`1px solid ${N.line}`,
            textAlign:'right', fontVariantNumeric:'tabular-nums', whiteSpace:'nowrap', color:N.ink, ...extra });
          return (
            <div style={{ ...st.dPlein, marginTop:16 }}>
              <div style={{ fontSize:14, fontWeight:700, color:N.ink, marginBottom:4 }}>Bestelwagens</div>
              <div style={st.cUitleg}>
                Laadvermogen voor bestelwagens op de gekozen laadpleinen, naast het minimum dat MOW
                voor de hele gemeente raamt.
              </div>
              <table style={{ width:'100%', borderCollapse:'collapse', marginTop:10 }}>
                <thead><tr>
                  <th style={th(false)}>Jaar</th>
                  <th style={th(true)}>Laadpunten</th>
                  <th style={th(true)}>Op de gekozen laadpleinen</th>
                  <th style={th(true)}>Minimum volgens MOW</th>
                  <th style={th(true)}>Verschil</th>
                </tr></thead>
                <tbody>
                  {rijen.map(r => (
                    <tr key={r.j}>
                      <td style={td({ textAlign:'left' })}>{r.j}</td>
                      <td style={td()}>{fmtN(r.punten)}</td>
                      <td style={td({ fontWeight:700 })}>{fmtN(r.kw)} kW</td>
                      <td style={td()}>{fmtN(r.mow)} kW</td>
                      <td style={td({ fontWeight:700,
                                      color: r.verschil < 0 ? N.red : r.verschil > 0 ? N.ok : N.ink })}>
                        {r.verschil > 0 ? '+' : r.verschil < 0 ? '\u2212' : ''}{fmtN(Math.abs(r.verschil))} kW
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* De verdeling per deelgemeente, uitklapbaar. Alleen als de
                  deelgemeenten met hun vorm zijn ingelezen. */}
              {(mowBestel.deelgemeenten || []).length > 0 && (() => {
                const dg = mowBestel.deelgemeenten;
                const p28 = bestelPerDeelgemeente(gekozenLocaties, dg, 2028, EERSTE_PLANJAAR);
                const p30 = bestelPerDeelgemeente(gekozenLocaties, dg, 2030, EERSTE_PLANJAAR);
                const scheid = { borderLeft:`1px solid ${N.line2}` };
                const verschil = (plan, mow) => {
                  const v = Math.round(plan) - Math.round(mow || 0);
                  return { tekst: `${v > 0 ? '+' : v < 0 ? '\u2212' : ''}${fmtN(Math.abs(v))} kW`,
                           kleur: v < 0 ? N.red : v > 0 ? N.ok : N.ink };
                };
                const cellen = (plan, mow, vet) => {
                  const v = verschil(plan, mow);
                  return [
                    <td key="p" style={td({ ...scheid, fontWeight:700 })}>{fmtN(plan)} kW</td>,
                    <td key="m" style={td({ fontWeight:vet ? 700 : 400 })}>{fmtN(mow || 0)} kW</td>,
                    <td key="v" style={td({ fontWeight:700, color:v.kleur })}>{v.tekst}</td>,
                  ];
                };
                const tot = rijen;
                return (
                  <>
                    <button onClick={() => setBestelDgOpen(o => !o)}
                      style={{ display:'flex', alignItems:'center', gap:8, width:'100%', marginTop:16,
                               padding:'9px 12px', background:N.head, border:`1px solid ${N.line2}`,
                               borderRadius:7, cursor:'pointer', fontFamily:'inherit', fontSize:14,
                               fontWeight:700, color:N.ink, textAlign:'left' }}>
                      Per deelgemeente
                      <span style={{ marginLeft:'auto', color:N.ink3, display:'flex', alignItems:'center',
                                     transform: bestelDgOpen ? 'rotate(180deg)' : 'none', transition:'transform .15s' }}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6"/></svg>
                      </span>
                    </button>
                    {bestelDgOpen && (
                      <table style={{ width:'100%', borderCollapse:'collapse', marginTop:8 }}>
                        <thead>
                          <tr>
                            <th style={th(false)}></th>
                            <th colSpan={3} style={{ ...th(false), ...scheid, textAlign:'center', color:N.ink2, fontWeight:700 }}>2028</th>
                            <th colSpan={3} style={{ ...th(false), ...scheid, textAlign:'center', color:N.ink2, fontWeight:700 }}>2030</th>
                          </tr>
                          <tr>
                            <th style={th(false)}>Deelgemeente</th>
                            <th style={{ ...th(true), ...scheid }}>Pleinen</th><th style={th(true)}>MOW</th><th style={th(true)}>Verschil</th>
                            <th style={{ ...th(true), ...scheid }}>Pleinen</th><th style={th(true)}>MOW</th><th style={th(true)}>Verschil</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dg.map(d => (
                            <tr key={d.code}>
                              <td style={td({ textAlign:'left', whiteSpace:'normal' })}>
                                {d.naam || d.code}
                                <span style={{ fontSize:12.5, color:N.ink4, marginLeft:6 }}>{d.code}</span>
                              </td>
                              {cellen(p28.get(d.code) || 0, d.kw2028, false)}
                              {cellen(p30.get(d.code) || 0, d.kw2030, false)}
                            </tr>
                          ))}
                          <tr>
                            <td style={td({ textAlign:'left', fontWeight:700, borderTop:`1.5px solid ${N.ink3}`, borderBottom:'none' })}>Gemeente</td>
                            {[tot[0], tot[1]].map(r => {
                              const v = verschil(r.kw, r.mow);
                              return [
                                <td key={`p${r.j}`} style={td({ ...scheid, fontWeight:700, borderTop:`1.5px solid ${N.ink3}`, borderBottom:'none' })}>{fmtN(r.kw)} kW</td>,
                                <td key={`m${r.j}`} style={td({ fontWeight:700, borderTop:`1.5px solid ${N.ink3}`, borderBottom:'none' })}>{fmtN(r.mow)} kW</td>,
                                <td key={`v${r.j}`} style={td({ fontWeight:700, color:v.kleur, borderTop:`1.5px solid ${N.ink3}`, borderBottom:'none' })}>{v.tekst}</td>,
                              ];
                            })}
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </>
                );
              })()}
              <div style={{ fontSize:12.5, color:N.ink4, lineHeight:1.5, marginTop:10 }}>
                Locaties die uiterlijk in dat jaar gerealiseerd zijn. AC telt voor 11 kW per laadpunt,
                DC voor 25 kW per laadpunt, omdat twee laadpunten de 50 kW van een snellader delen. Het
                minimum van MOW geldt voor de hele gemeente, dus ook voor laadpunten buiten de laadpleinen.
              </div>
            </div>
          );
        })()}
      </div>

      {/* ── TABBLAD: GEMEENTE ──────────────────────────────────────── */}
      {/* Parameters uit de oude zijbalk, plus de kaart. De kaart-div blijft
          altijd in de DOM staan; dit paneel wordt alleen verborgen met
          display:none, nooit uit de boom gehaald. */}
      <div style={{ ...st.nPaneF, display: tab === 'gemeente' ? 'flex' : 'none' }}>
        {/* Parameters in een smalle kolom links, kaart rechts. De kaart vult
            alles wat overblijft en is daardoor altijd volledig zichtbaar,
            ongeacht de schermhoogte. Alleen de linkerkolom kan scrollen. */}
        <div style={st.gZij}>

          {/* Verdeling privé en publiek. De schuifbalk verzet het STARTPUNT in
              2026; het model trekt daar per jaar twee punten vanaf. Het cijfer
              dat telt is het publieke deel in het gekozen jaar, dus dat staat
              groot in beeld. */}
          <div style={st.gVak}>
            {(() => {
              const startPct    = Math.round(priveStartActief * 100);
              const berekendPct = Math.round(priveStartBerekend * 100);
              const ditJaarPct  = Math.round(privePctVoorJaar(year) * 100);
              return (
                <>
                  <div style={st.gVkop}>
                    <span style={st.gLab}>Aandeel privé, startpunt 2026</span>
                    <button
                      style={st.pReset(priveStart != null)}
                      title={`Terug naar het berekende startpunt van ${berekendPct}%`}
                      onClick={() => setPriveStart(null)}
                      disabled={priveStart == null}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                        <path d="M21 12a9 9 0 11-3.5-7.1"/><path d="M21 3v6h-6"/>
                      </svg>
                    </button>
                  </div>
                  <div style={st.pvRij}>
                    <span style={st.pvVal}>{startPct}%</span>
                    <input type="range" style={st.sl} min={0} max={100} step={1}
                      value={startPct}
                      onChange={e=>setPriveStart(+e.target.value/100)}/>
                  </div>
                  <div style={st.gGroot}>
                    <div style={st.gGrootL}>Publiek en semipubliek in {year}</div>
                    <div style={st.gGrootV}>{100 - ditJaarPct}%</div>
                    <div style={st.gGrootS}>privé is dan <strong style={{color:N.ink2}}>{ditJaarPct}%</strong></div>
                  </div>
                  <div style={st.gNoot}>
                    Het privé-aandeel daalt 2 punten per jaar. Je stelt hier het startpunt in;
                    die daling blijft.
                  </div>
                </>
              );
            })()}
          </div>

          {/* ── De afzetnorm per jaar ──────────────────────────────────
              De knop waarmee een gemeente stuurt: hoeveel stroom er per
              gewoon laadpunt per jaar doorheen gaat. Het model deelt de
              publieke laadvraag hierdoor.

              Twee invoervelden die hetzelfde getal zijn in een andere
              gedaante: kWh per laadpunt, en het aantal elektrische auto's
              zonder eigen laadpunt dat er één deelt. Wie de ene aanpast,
              ziet de andere meebewegen. */}
          <div style={st.gVak}>
            <div style={st.gVkop}>
              <span style={st.gLab}>Hoeveel stroom per laadpunt</span>
              <button style={st.pReset(!!normPerJaar)}
                      title="Terug naar de standaardreeks"
                      onClick={resetNorm} disabled={!normPerJaar}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                  <path d="M21 12a9 9 0 11-3.5-7.1"/><path d="M21 3v6h-6"/>
                </svg>
              </button>
            </div>

            {/* Dichtgeklapt staat hier alleen de norm van het gekozen jaar. De
                tabel met alle jaren maakte het paneel zo lang dat de vakken
                eronder buiten beeld vielen. */}
            <button onClick={() => setNormOpen(o => !o)} style={st.nrmKlap}>
              <span style={st.nrmKlapVal}>{fmtN(acNormKwh(year, normPerJaar))} kWh</span>
              <span style={st.nrmKlapJr}>in {year}</span>
              <span style={st.nrmKlapPijl(normOpen)}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </span>
            </button>

            {normOpen && (<>
            <div style={st.gHint}>
              De MOW-drempel bijplaatsing ligt op {fmtN(MOW_DREMPEL_BIJPLAATSING_KWH)} kWh
              per laadpunt per jaar. Dat is meteen de hoogste waarde die hier
              ingevuld kan worden, want daarboven plaatst de concessiehouder een
              laadpunt bij. Sturen op deze norm beïnvloedt het aantal bij te
              plaatsen laadpunten.
            </div>

            <table style={st.nrmTab}>
              <thead>
                <tr>
                  <th style={st.nrmTh('left')}>Jaar</th>
                  <th style={st.nrmTh('right')}>Norm kWh</th>
                  <th style={st.nrmTh('right')}>Van drempel</th>
                  <th style={st.nrmTh('right')}>EV per punt</th>
                </tr>
              </thead>
              <tbody>
                {NORM_JAREN.map(jr => {
                  const n = acNormKwh(jr, normPerJaar);
                  const r = normReeks[jr] || {};
                  return (
                    <tr key={jr} style={jr === year ? { background: N.head } : undefined}>
                      <td style={st.nrmTd('left')}>{jr}</td>
                      <td style={st.nrmTd('right')}>
                        {/* Toont de waarde die GELDT, ook als er niets is
                            ingevuld. Anders begint een klik op het pijltje bij
                            nul in plaats van bij de huidige waarde. */}
                        <input type="number" min={NORM_MIN_KWH} max={MOW_DREMPEL_BIJPLAATSING_KWH} step={100}
                          value={normInvoer[jr] ?? n}
                          onChange={e => setNormInvoer(v => ({ ...v, [jr]: e.target.value }))}
                          onBlur={() => bewaarNorm(jr)}
                          onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); }}
                          style={st.nrmInp} />
                      </td>
                      <td style={st.nrmTd('right')}>
                        {Math.round(100 * n / MOW_DREMPEL_BIJPLAATSING_KWH)}%
                      </td>
                      <td style={st.nrmTd('right')}>
                        <input type="number" min={0.5} max={20} step={0.1}
                          value={evInvoer[jr] ?? (r.evPerPunt != null ? r.evPerPunt.toFixed(1) : '')}
                          onChange={e => setEvInvoer(v => ({ ...v, [jr]: e.target.value }))}
                          onBlur={() => bewaarNormViaEv(jr)}
                          onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); }}
                          style={st.nrmInp} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {normMelding && (
              <div style={{ fontSize:12.5, lineHeight:1.5, marginTop:8, padding:'8px 10px',
                            background:N.warnBg, border:`1px solid ${N.warnBd}`,
                            borderRadius:7, color:N.ink2 }}>
                {normMelding}
              </div>
            )}

            <div style={{ display:'flex', gap:8, marginTop:8 }}>
              <button style={st.nrmKnop} onClick={() => trekNormDoor(year)}>
                {year} doortrekken naar de latere jaren
              </button>
            </div>

            <div style={st.gHint}>
              Beide vakjes zijn in te vullen en horen bij elkaar: wie de kWh
              aanpast, ziet de EV's per laadpunt meebewegen, en omgekeerd.
              Leeg laten betekent de standaardreeks, die van {fmtN(acNormBasis(2027))} kWh
              in 2027 oploopt naar {fmtN(acNormBasis(2035))} in 2035.
            </div>
            </>)}
          </div>

          <div style={st.gVak}>
            <div style={st.gLab}>Buffer voor pieken en storingen</div>
            <div style={{ ...st.pvRij, marginTop:7 }}>
              <span style={st.pvVal}>{Math.round(redundantieMarge*100)}%</span>
              <input type="range" style={st.sl} min={0} max={30} step={1}
                value={Math.round(redundantieMarge*100)}
                onChange={e=>setRedundantieMarge(+e.target.value/100)}/>
            </div>
            <div style={{ ...st.gLab, marginTop:13, marginBottom:6 }}>Gepland te installeren, AC</div>
            <input
              type="number" min={0}
              value={huidigLP === 0 ? '' : huidigLP}
              placeholder="0"
              onChange={e => setHuidigLP(e.target.value === '' ? 0 : Math.max(0, +e.target.value))}
              style={st.gInp}
            />
          </div>

          <div style={st.gVak}>
            <div style={{ ...st.gLab, marginBottom:8 }}>Brongegevens</div>
            <button style={st.gBtn} onClick={() => setShowEditor(true)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                <path d="M21 12a9 9 0 11-3.5-7.1"/><path d="M21 3v6h-6"/>
              </svg>
              Inwoners en Fluvius bijwerken
            </button>
            {dbStatus === 'offline' && (
              <div style={{ fontSize:12, color:N.warn, marginTop:8 }}>Lokale modus</div>
            )}
          </div>



        </div>

        <div style={{ ...st.mArea, minWidth:0 }}>
          {/* Kop boven de kaart. Bewerken en Verwijderen staan alleen in de topbar
              rechtsboven, niet meer hier. */}
          <div style={{height:46,background:N.head,borderBottom:`1px solid ${N.line}`,display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 20px',flexShrink:0}}>
            {/* Schakelaar tussen de twee kaartweergaven */}
            <div style={st.lswitch}>
              {[['bestaand','Bestaand'],['behoefte','Behoefte ' + year]].map(([id,label]) => (
                <button key={id} style={st.lsw(kaartLaag === id)} onClick={() => setKaartLaag(id)}>{label}</button>
              ))}
            </div>
            <div style={{fontSize:12,color:N.ink3,display:'flex',alignItems:'center',gap:14}}>
              <span style={{display:'flex',alignItems:'center',gap:6}}>
                <span style={{width:7,height:7,borderRadius:'50%',background:N.ok,display:'inline-block',animation:loadingPalen?'pulse 2s infinite':'none'}}/>
                {loadingPalen?'Laden…':`${existingPalen.length} laadpunten (MOW)`}
              </span>
              <strong style={{color:N.accent}}>{(bestaandTotaalPerType.AC+bestaandTotaalPerType.DC+bestaandTotaalPerType.HPC).toFixed(0)} gewogen</strong>
              <button onClick={() => setShowOverzicht(true)} style={{padding:'5px 13px',borderRadius:7,fontSize:12,fontWeight:700,cursor:'pointer',border:'none',background:N.accent,color:'#fff',fontFamily:'inherit'}}>
                Wijkoverzicht
              </button>
              {ongematcht > 0 && <span style={{color:N.warn}}>{ongematcht} zonder koppeling</span>}
            </div>
          </div>
          <div style={{flex:1}} ref={mapRef}/>
          {/* Wijk detail. Eén venster met drie getallen die op elkaar aansluiten:
              wat er in het peiljaar nodig is, wat er nu staat, en het verschil.
              De uitsplitsing naar gewoon, snel en ultrasnel staat op tabblad
              Wijken en wordt hier bewust niet herhaald. */}
          {selectedResult && (() => {
            const d   = selectedResult.data;
            const afg = deelAfronding([d.totAC, d.totDC, d.totHPC]);
            const aanwezig = d.bestaand.AC + d.bestaand.DC + d.bestaand.HPC;
            const bijTePlaatsen = d.bijTePlaatsen;
            // In het eerste planjaar wordt de hele achterstand ingelopen, dus
            // dan zegt 'waarvan in dit jaar' hetzelfde als de regel erboven.
            const toonJaardeel = year > EERSTE_PLANJAAR;
            return (
            <div style={st.ov}>
              <span style={{float:'right',cursor:'pointer',color:N.ink4,fontSize:18}} onClick={()=>setSelectedWijk(null)}>×</span>
              <div style={{fontSize:15,fontWeight:800,marginBottom:2}}>{selectedResult.wijk.naam}</div>
              <div style={{fontSize:13,color:N.ink3,marginBottom:11}}>
                <span style={{color:urgentieKleur(d.deltaTotaal),fontWeight:700}}>
                  {urgentieLabel(d.deltaTotaal)}</span> · {year}
              </div>

              {[
                [`Nodig tot en met ${year}`, fmtN(afg.totaal)],
                ['Nu aanwezig',              fmtN(aanwezig)],
                [`Bij te plaatsen tot en met ${year}`, fmtN(bijTePlaatsen), urgentieKleur(d.deltaTotaal)],
              ].map(([l,v,kl])=>(
                <div key={l} style={st.dpR}>
                  <span style={{color:N.ink2}}>{l}</span>
                  <span style={{fontWeight:700,whiteSpace:'nowrap',color:kl||undefined}}>{v}</span>
                </div>
              ))}

              {toonJaardeel && (
                <div style={st.dpSub}>
                  <span>waarvan in {year}</span>
                  <span style={{fontWeight:700,color:N.ink2}}>{fmtN(d.jaardeel)}</span>
                </div>
              )}

              <div style={{height:1,background:N.line,margin:'10px 0 6px'}}/>

              {[
                [`Publieke laadvraag ${year}`, `${fmtN(d.mwhPubliek)} MWh`],
                ['Investering', `€${fmtN(Math.round(d.capex/1000)*1000)}`],
              ].map(([l,v])=>(
                <div key={l} style={st.dpR}>
                  <span style={{color:N.ink2}}>{l}</span>
                  <span style={{fontWeight:700,whiteSpace:'nowrap'}}>{v}</span>
                </div>
              ))}

              <div style={st.dpVoet}>Verdeling over gewoon, snel en ultrasnel: tabblad Wijken</div>
            </div>
            );
          })()}
          {/* Legenda, alleen die van de actieve kaartlaag. Rechtsonder in de
              kaart, zodat de zoomknoppen links en de schakelaar boven vrij blijven.
              Staat er een wijk open, dan gaat de legenda weg: het detailvenster is
              lang en liep er anders overheen, waardoor de onderste regels (DC, HPC,
              MWh en CAPEX) onleesbaar werden. */}
          {!selectedResult && (
          <div style={st.legB}>
            {kaartLaag === 'bestaand' ? (
              <>
                {[['#27ae60','AC'], ['#e74c3c','DC'], ['#9b59b6','HPC']].map(([kleur, l]) => (
                  <div key={l} style={st.legI}>
                    <div style={{width:12,height:12,borderRadius:'50%',background:kleur,border:'2px solid white',outline:`1px solid ${N.line2}`,flexShrink:0}}/>
                    Bestaande {l}-paal
                  </div>
                ))}
                <div style={st.legU}>Klik een punt voor details en Streetview</div>
              </>
            ) : (
              <>
                {/* De kaart kleurt per statistische sector zodra die vormen er
                    zijn. De legenda toont dan dezelfde indeling en telt
                    sectoren; anders geldt de wijkindeling en tellen wijken. */}
                <div style={st.legKop}>
                  Bij te plaatsen {sectorKlassen ? 'per sector ' : ''}in {year}
                </div>
                {(sectorKlassen || kaartKlassen).map((k, i) => (
                  <div key={i} style={st.legI}>
                    <div style={st.legVak(k.kleur)}/>
                    <span>
                      {k.aantal === 0 ? '\u2014'
                        : k.laag === k.hoog ? Math.round(k.laag)
                        : `${Math.round(k.laag)} tot ${Math.round(k.hoog)}`}
                    </span>
                    <span style={st.legAantal}>{k.aantal}</span>
                  </div>
                ))}
                {/* Wijken waarvan de begrenzing niet bekend is, staan als cirkel
                    op de kaart. Kleurt de kaart per sector, dan blijft die
                    cirkel kleurloos, want hij toont een wijkwaarde. */}
                {aantalZonderVorm > 0 && (
                  <div style={st.legBenadering}>
                    <div style={st.legCirkel}/>
                    {sectorKlassen ? 'wijk zonder bekende grenzen, geen kleur' : 'ligging bij benadering'}
                    <span style={st.legAantal}>{aantalZonderVorm}</span>
                  </div>
                )}
              </>
            )}
          </div>
          )}
        </div>
      </div>

      {/* ── TABBLAD: WIJKEN ───────────────────────────────────────── */}
      <div style={{ ...st.nPane, display: tab === 'wijken' ? 'block' : 'none' }}>
        {/* Zelfde knop als op het tabblad Gemeente: opent het overzicht van alle
            wijken naast elkaar, handig om te tonen tijdens een gesprek. */}
        <div style={st.wKop}>
          <div style={st.wKopT}>
            {wijkResults.length} wijken, gesorteerd op wat er nog moet gebeuren
          </div>
          <button style={st.wKopB} onClick={() => setShowOverzicht(true)}>Wijkoverzicht</button>
        </div>
        {/* Alle wijken staan open, zodat ze naast elkaar te vergelijken zijn
            zonder heen en weer te klikken. Per wijk de kerncijfers, de mix over
            AC, DC en HPC, en het verloop tot 2035. */}
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {wijkResults
            .slice()
            .sort((a,b) => b.data.deltaTotaal - a.data.deltaTotaal)
            .map(({wijk, data}) => {
              const kleur = urgentieKleur(data.deltaTotaal);
              const reeks = wijkTijdreeksPerJaar(wijk);
              // Zo afgerond dat AC plus DC plus HPC precies het totaal geeft.
              const afg = deelAfronding([data.totAC, data.totDC, data.totHPC]);
              const aanwezig = data.bestaand.AC + data.bestaand.DC + data.bestaand.HPC;
              // Bij te plaatsen per laadsoort, zo verdeeld dat de drie regels
              // precies optellen tot het getal in de somregel eronder.
              const bijAfg = verdeelHeel(data.bijTePlaatsen,
                { AC: data.delta.AC, DC: data.delta.DC, HPC: data.delta.HPC });
              // Ongewogen aantallen per wijk, gescheiden naar publiek en
              // semipubliek. Nodig om onder Aanwezig te kunnen tonen hoe het
              // gewogen getal is opgebouwd: 20 publiek plus 10 semi geeft 25.
              const v5Wijk = bestaandV5PerWijk[wijk.id] || null;
              return (
                <div key={wijk.id} style={st.wOpen(kleur)}>

                  {/* Kop */}
                  <div style={st.wOKop}>
                    <div>
                      <div style={st.wONaam}>{wijk.naam}</div>
                      <div style={st.wOType}>
                        {Array.isArray(wijk.wijktype) ? wijk.wijktype.join(' en ') : wijk.wijktype || 'woonwijk'}
                        {wijk.inwoners ? ` · ${wijk.inwoners.toLocaleString('nl-BE')} inwoners` : ''}
                      </div>
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={st.wOCapex}>{fmtEur(data.capex)} CAPEX</div>
                      <div style={st.urgBadge(kleur)}>{urgentieLabel(data.deltaTotaal)}</div>
                    </div>
                  </div>

                  {/* Kerncijfers, inclusief het privé-aandeel */}
                  <div style={st.wOStats}>
                    {[
                      ['Nodig t/m ' + year,  afg.totaal,                   null],
                      ['Al aanwezig',        aanwezig.toFixed(0),          null],
                      ['Bij te plaatsen',    data.bijTePlaatsen,  data.deltaTotaal > 0 ? kleur : N.accent2],
                      ['Privé-aandeel',      `${Math.round((data.privePct||0)*100)}%`, null],
                      ['Publieke laadvraag', `${Math.round(data.mwhPubliek).toLocaleString('nl-BE')} MWh`, null],
                    ].map(([label, waarde, kl]) => (
                      <div key={label}>
                        <div style={st.wOSL}>{label}</div>
                        <div style={st.wOSV(kl)}>{waarde}</div>
                      </div>
                    ))}
                  </div>

                  {/* Welke laadpleinen in deze wijk liggen (mockup Wijk impact V8). */}
                  {(() => {
                    const pl = (plaatsResultaat?.pleinImpact?.pleinen || []).filter(l => l.wijkId === wijk.id);
                    if (!pl.length) return null;
                    return (
                      <div style={{ fontSize:14.5, color:N.ink2, margin:'2px 0 10px', lineHeight:1.45 }}>
                        Via laadpleinen: {pl.map(l => `${fmtN(l.punten)} laadpunten op ${l.naam} (${l.jaar})`).join('; ')}.
                      </div>
                    );
                  })()}

                  {/* De drie laadsoorten apart. Nodig, aanwezig en bij te
                      plaatsen worden PER SOORT tegen elkaar weggestreept: een
                      gewoon laadpunt vervangt geen snellader, dus een overschot
                      aan de ene soort dekt een tekort aan de andere niet. Zolang
                      hier alleen de som stond, leek 56 min 48,5 gelijk aan 32. */}
                  <table style={st.wOTab}>
                    <thead>
                      <tr>
                        <th style={{...st.wOTh, width:'38%', textAlign:'left'}}>Laadsoort</th>
                        <th style={{...st.wOTh, width:'14%', textAlign:'right'}}>Nodig</th>
                        <th style={{...st.wOTh, width:'30%', textAlign:'right'}}>Aanwezig</th>
                        <th style={{...st.wOTh, width:'18%', textAlign:'right'}}>Bij te plaatsen</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ['Gewoon laden',   'AC 11 kW',   'AC',  N.accent2, data.totAC,  afg.delen[0]],
                        ['Snelladen',      'DC 50 kW',   'DC',  N.ok,      data.totDC,  afg.delen[1]],
                        ['Ultrasnelladen', 'HPC 150 kW', 'HPC', N.warn,    data.totHPC, afg.delen[2]],
                      ].map(([naam, verm, sleutel, kl, nodigRuw, nodigAfg]) => {
                        const pub  = v5Wijk ? (v5Wijk['Qp_' + sleutel] || 0) : 0;
                        const semi = v5Wijk ? (v5Wijk['Qs_' + sleutel] || 0) : 0;
                        const aanw = data.bestaand[sleutel] || 0;
                        return (
                          <tr key={sleutel}>
                            <td style={st.wOTd}>
                              <span style={{...st.wODot, background:kl, borderRadius:'50%'}}/>
                              {naam}<span style={st.wOSub}>{verm}</span>
                            </td>
                            <td style={st.wOTdR}>{nodigAfg}</td>
                            <td style={st.wOTdR}>
                              {aanw % 1 === 0 ? aanw : aanw.toFixed(1)}
                              <span style={st.wOSub}>
                                {pub} publiek + {(semi / 2) % 1 === 0 ? semi / 2 : (semi / 2).toFixed(1)} semipubliek*
                                {semi > 0 ? ` (op ${semi} laadpunten)` : ''}
                              </span>
                            </td>
                            <td style={st.wOTdB}>{bijAfg[sleutel] || 0}</td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td style={{...st.wOSom, textAlign:'left'}}>Samen</td>
                        <td style={{...st.wOSom, textAlign:'right'}}>{afg.totaal}</td>
                        <td style={{...st.wOSom, textAlign:'right'}}>{aanwezig % 1 === 0 ? aanwezig : aanwezig.toFixed(1)}</td>
                        <td style={{...st.wOSom, textAlign:'right'}}>{data.bijTePlaatsen}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={st.wOVoet}>
                    De laadinfra-mix is afgestemd op de kenmerken van de wijk.<br/>
                    * Een semipubliek laadpunt telt voor de helft mee, omdat het niet altijd toegankelijk is.
                  </div>

                  {/* Kaartje en verloop naast elkaar, zoals in het ontwerp */}
                  <div style={st.wOVerloop}>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>

                      <div>
                        <div style={st.wOVLbl}>Ligging in de gemeente</div>
                        <WijkKaartje wijkId={wijk.id} kleur={kleur} />
                      </div>

                      <div>
                        <div style={st.wOVLbl}>Bij te plaatsen per jaar</div>
                        <ResponsiveContainer width="100%" height={160}>
                      <BarChart data={reeks} margin={{top:4,right:6,left:-24,bottom:0}}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#EDEAE4"/>
                        <XAxis dataKey="jaar" tick={{fill:N.ink2,fontSize:12,fontWeight:600}} height={26} tickMargin={5} interval={0} axisLine={{stroke:N.line2}} tickLine={false}/>
                        <YAxis tick={{fill:N.ink3,fontSize:11.5}} width={46}/>
                        <Tooltip
                          contentStyle={{background:N.paper,border:`1px solid ${N.line2}`,borderRadius:8,fontSize:13.5,padding:"10px 13px",boxShadow:'0 4px 14px rgba(18,22,28,0.12)'}}
                          labelStyle={{color:N.ink,fontWeight:700}}
                          formatter={(v,naam)=>[Math.round(v).toLocaleString('nl-BE'), naam]}
                    cursor={{ fill:'transparent' }}/>
                          <Bar dataKey="nieuwDitJaar" name="Bij te plaatsen dat jaar" fill={kleur} radius={[3,3,0,0]} maxBarSize={22}/>
                        </BarChart>
                        </ResponsiveContainer>
                      </div>

                    </div>
                  </div>

                </div>
              );
            })}
        </div>
      </div>

      {/* ── TABBLAD: LAADINFRA-MIX ────────────────────────────────── */}
      {/* Toont de verdeling over AC, DC en HPC die het model per wijk berekent
          op basis van de doelgroepenmix van het wijktype. De vier
          beleidsscenario's zijn nog niet actief: die vragen een aanpassing in
          gemeenteData.js zodat een gekozen mix de doelgroepenberekening
          overschrijft. Zie de melding onder de tabel. */}
      <div style={{ ...st.nPane, display: tab === 'mix' ? 'block' : 'none' }}>
        <div style={st.nSec}>Verdeling over de laadtypes</div>
        {(() => {
          const tot = wijkResults.reduce((a, r) => ({
            AC:  a.AC  + r.data.totAC,
            DC:  a.DC  + r.data.totDC,
            HPC: a.HPC + r.data.totHPC,
            LP:  a.LP  + r.data.totLP,
            capex: a.capex + r.data.capex,
          }), { AC:0, DC:0, HPC:0, LP:0, capex:0 });
          const som = tot.AC + tot.DC + tot.HPC || 1;
          const totAfg = deelAfronding([tot.AC, tot.DC, tot.HPC]);

          // Nederlandse namen voor de wijktypes en de doelgroepen, en de
          // volgorde waarin ze in de tabellen en de balken staan.
          const TYPENAAM  = { binnenstad:'Binnenstad', woonwijk:'Woonwijk', bedrijventerrein:'Bedrijventerrein' };
          const GROEPNAAM = { bew:'Bewoners', bez:'Bezoekers', log:'Logistiek', ov:'Openbaar vervoer' };
          const pct = (x) => `${Math.round((x ?? 0) * 100)}%`;

          // De doelgroepenmix van een wijk. Bij meerdere types het gemiddelde,
          // net zoals de rekenkern dat doet.
          const mixVan = (wijk) => {
            const types = Array.isArray(wijk.wijktype) ? wijk.wijktype : [wijk.wijktype].filter(Boolean);
            const geldig = types.filter(t => WIJKTYPE_MIX?.[t]);
            if (!geldig.length) return null;
            const uit = { bew:0, bez:0, log:0 };
            geldig.forEach(t => { uit.bew += WIJKTYPE_MIX[t].bew; uit.bez += WIJKTYPE_MIX[t].bez; uit.log += WIJKTYPE_MIX[t].log; });
            return { bew: uit.bew/geldig.length, bez: uit.bez/geldig.length, log: uit.log/geldig.length };
          };

          return (
            <>
              <div style={st.kpis}>
                {[['AC normaal laden', totAfg.delen[0], tot.AC, MIX_AC],
                  ['DC snel laden', totAfg.delen[1], tot.DC, MIX_DC],
                  ['HPC ultrasnel', totAfg.delen[2], tot.HPC, MIX_HPC],
                  [`Nodig t/m ${year}`, totAfg.totaal, tot.LP, null]
                ].map(([label, waarde, ruw, kleur]) => (
                  <div key={label} style={st.kpi}>
                    <div style={st.mLbl}>{label}</div>
                    <div style={st.mNum(kleur)}>{waarde.toLocaleString('nl-BE')}</div>
                    <div style={st.mSub}>
                      {label.startsWith('Nodig')
                        ? `waarvan ${fmtN(Math.round(bijkomend))} nog bij te plaatsen`
                        : `${Math.round(ruw/som*100)}% van de laadpunten`}
                    </div>
                  </div>
                ))}
              </div>

              <div style={st.nCard}>
                <div style={st.vHdr}>
                  <div style={{ fontSize:16.5, fontWeight:700, color:N.ink }}>Verdeling per wijk</div>
                </div>
                <div style={st.mUitleg}>
                  Het wijktype bepaalt voor wie er geladen wordt, en dat bepaalt de mix. De verdeling
                  over AC, DC en HPC hoort bij het TOTAAL dat in {year} nodig is; de laatste kolom
                  laat zien wat daarvan nog bij moet komen, en dat is hetzelfde getal als op tabblad
                  Wijken. Klik op een wijk om te zien hoe die mix tot stand komt.
                </div>
                <div style={{ overflowX:'auto' }}>
                  <table style={st.mTbl}>
                    <thead>
                      <tr>
                        <th style={st.mTh(false)}>Wijk</th>
                        <th style={st.mTh(false)}>Wijktype</th>
                        <th style={st.mTh(false)}>Voor wie</th>
                        <th style={st.mTh(true)}>AC</th>
                        <th style={st.mTh(true)}>DC</th>
                        <th style={st.mTh(true)}>HPC</th>
                        <th style={st.mTh(true)}>Nodig t/m {year}</th>
                        <th style={st.mTh(true)}>Bij te plaatsen</th>
                        <th style={st.mTh(true)}>CAPEX</th>
                        <th style={st.mTh(true)}/>
                      </tr>
                    </thead>
                    <tbody>
                      {wijkResults.map(({ wijk, data }) => {
                        const mix = mixVan(wijk);
                        const open = mixOpen === wijk.id;
                        const types = (Array.isArray(wijk.wijktype) ? wijk.wijktype : [wijk.wijktype])
                          .filter(Boolean).map(t => TYPENAAM[t] || t).join(' + ');
                        const lpSom = data.totAC + data.totDC + data.totHPC || 1;
                        const afg = deelAfronding([data.totAC, data.totDC, data.totHPC]);
                        return (
                          <React.Fragment key={wijk.id}>
                            <tr>
                              <td style={{ ...st.mTd(false), fontWeight:700, color:N.ink }}>{wijk.naam}</td>
                              <td style={st.mTd(false)}><span style={st.mType}>{types || 'onbekend'}</span></td>
                              <td style={st.mTd(false)}>
                                {mix ? (
                                  <>
                                    <div style={st.mBalk(140)}>
                                      <span style={{ width:`${mix.bew*100}%`, background:MIX_BEW }}/>
                                      <span style={{ width:`${mix.bez*100}%`, background:MIX_BEZ }}/>
                                      <span style={{ width:`${mix.log*100}%`, background:MIX_LOG }}/>
                                    </div>
                                    <div style={st.mBalkTxt}>
                                      {Math.round(mix.bew*100)} · {Math.round(mix.bez*100)} · {Math.round(mix.log*100)}
                                    </div>
                                  </>
                                ) : <span style={{ color:N.ink4 }}>geen wijktype</span>}
                              </td>
                              <td style={st.mTd(true)}>{afg.delen[0]}</td>
                              <td style={st.mTd(true)}>{afg.delen[1]}</td>
                              <td style={st.mTd(true)}>{afg.delen[2]}</td>
                              <td style={{ ...st.mTd(true), fontWeight:700, color:N.ink }}>{afg.totaal}</td>
                              <td style={{ ...st.mTd(true), fontWeight:700, color:N.accent }}>
                                {data.bijTePlaatsen}</td>
                              <td style={st.mTd(true)}>{fmtEur(data.capex)}</td>
                              <td style={st.mTd(true)}>
                                <button style={st.mKnop(open)} onClick={() => setMixOpen(open ? null : wijk.id)}>
                                  {open ? 'Sluiten' : 'Uitleg'}
                                </button>
                              </td>
                            </tr>

                            {/* Alleen de kern: waar de vraag vandaan komt, voor wie,
                                en wat het in laadpunten wordt. De hele rekensom zit
                                achter een aparte knop, want vier stappen met alle
                                getallen erbij is te veel om zomaar te tonen. */}
                            {open && (
                              <tr>
                                <td colSpan={10} style={st.mKernCel}>
                                  <div style={st.mKern}>
                                    <div style={{ minWidth:200 }}>
                                      <div style={st.mKernL}>Publieke laadvraag</div>
                                      <div style={st.mKernV}>{Math.round(data.mwhPubliek).toLocaleString('nl-BE')} MWh</div>
                                      <div style={st.mKernS}>per jaar in {wijk.naam}</div>
                                    </div>
                                    <span style={st.mPijl}>→</span>
                                    <div style={{ minWidth:250 }}>
                                      <div style={st.mKernL}>
                                        {types || 'geen wijktype'}{mix ? ', dus vooral ' +
                                          (mix.bew >= mix.bez && mix.bew >= mix.log ? 'bewoners'
                                            : mix.bez >= mix.log ? 'bezoekers' : 'logistiek') : ''}
                                      </div>
                                      {mix && (
                                        <div style={{ ...st.mBalk(190), margin:'3px 0 4px' }}>
                                          <span style={{ width:`${mix.bew*100}%`, background:MIX_BEW }}/>
                                          <span style={{ width:`${mix.bez*100}%`, background:MIX_BEZ }}/>
                                          <span style={{ width:`${mix.log*100}%`, background:MIX_LOG }}/>
                                        </div>
                                      )}
                                      <div style={st.mKernS}>
                                        {(() => {
                                          // Per wijktype de reden waarom de verdeling over
                                          // gewoon, snel en ultrasnel eruitziet zoals hij
                                          // eruitziet. Bij meerdere types het zwaarste type.
                                          const t = Array.isArray(wijk.wijktype) ? wijk.wijktype : [wijk.wijktype];
                                          if (t.includes('bedrijventerrein'))
                                            return 'logistieke voertuigen worden vaker en langer ingezet, dus is snel laden ook vereist';
                                          if (t.includes('binnenstad'))
                                            return 'een binnenstad heeft meer bezoekers, daardoor ook nood aan sneller laden';
                                          return 'in een woonwijk wordt hoofdzakelijk normaal geladen';
                                        })()}
                                      </div>
                                    </div>
                                    <span style={st.mPijl}>→</span>
                                    <div style={{ minWidth:250 }}>
                                      <div style={st.mKernL}>Wordt in laadpunten</div>
                                      <div style={{ ...st.mBalk(190), margin:'3px 0 4px' }}>
                                        <span style={{ width:`${data.totAC/lpSom*100}%`,  background:MIX_AC }}/>
                                        <span style={{ width:`${data.totDC/lpSom*100}%`,  background:MIX_DC }}/>
                                        <span style={{ width:`${data.totHPC/lpSom*100}%`, background:MIX_HPC }}/>
                                      </div>
                                      <div style={{ ...st.mKernV, fontSize:17 }}>
                                        {afg.delen[0]} · {afg.delen[1]} · {afg.delen[2]}
                                      </div>
                                    </div>
                                  </div>

                                  <div style={st.mKernVoet}>
                                    <span>
                                      {(() => {
                                        // Alleen de laadsoorten tonen die in deze wijk voorkomen.
                                        const mSom = data.mwhAC + data.mwhDC + data.mwhHPC || 1;
                                        const soorten = [['AC', data.mwhAC, data.totAC],
                                                         ['DC', data.mwhDC, data.totDC],
                                                         ['HPC', data.mwhHPC, data.totHPC]]
                                          .filter(([, mw]) => mw > 0.5);
                                        const energie = soorten.map(([, mw]) => Math.round(mw/mSom*100)).join(' · ');
                                        const punten  = soorten.map(([, , lp]) => Math.round(lp/lpSom*100)).join(' · ');
                                        return `In energie is de verdeling ${energie}, in laadpunten ${punten}.` +
                                          (data.totDC > 0.5 ? ' Eén snellader verzet namelijk veel meer energie dan één gewone paal.' : '');
                                      })()}
                                    </span>
                                    <button style={st.mKnop(mixReken === wijk.id)}
                                      onClick={() => setMixReken(mixReken === wijk.id ? null : wijk.id)}>
                                      {mixReken === wijk.id ? 'Berekening verbergen' : 'Volledige berekening'}
                                    </button>
                                  </div>

                                  {mixReken === wijk.id && mix && (
                                    <div style={st.mReken}>
                                      {[
                                        ['1', 'Publieke laadvraag',
                                         `${Math.round(data.mwhPubliek).toLocaleString('nl-BE')} MWh per jaar in ${year}`,
                                         'Wat er in deze wijk publiek geladen wordt, na aftrek van het deel dat thuis of op eigen terrein laadt.'],
                                        // Alleen de groepen die in deze wijk voorkomen. Een
                                        // woonwijk heeft sinds 20 augustus 2026 geen logistiek
                                        // meer, en "logistiek 0 MWh" tonen leidt af.
                                        ['2', `Verdeeld over de groepen, ` +
                                         [['bewoners',mix.bew],['bezoekers',mix.bez],['logistiek',mix.log]]
                                           .filter(([, a]) => a > 0).map(([, a]) => Math.round(a*100)).join(' · '),
                                         [['bewoners',mix.bew],['bezoekers',mix.bez],['logistiek',mix.log]]
                                           .filter(([, a]) => a > 0)
                                           .map(([nm, a]) => `${nm} ${Math.round(data.mwhPubliek*a).toLocaleString('nl-BE')} MWh`)
                                           .join(' · '),
                                         'Deze verdeling hoort bij het wijktype en staat in de tabel onderaan de pagina.'],
                                        ['3', 'Elke groep naar zijn eigen laadtype',
                                         [['AC',data.mwhAC],['DC',data.mwhDC],['HPC',data.mwhHPC]]
                                           .filter(([, v]) => v > 0.5)
                                           .map(([nm, v]) => `${nm} ${Math.round(v).toLocaleString('nl-BE')} MWh`)
                                           .join(' · '),
                                         'AC = ' + [['bewoners',mix.bew,DOELGROEP_LAADTYPE.bew.ac],
                                                    ['bezoekers',mix.bez,DOELGROEP_LAADTYPE.bez.ac],
                                                    ['logistiek',mix.log,DOELGROEP_LAADTYPE.log.ac]]
                                           .filter(([, a]) => a > 0)
                                           .map(([nm, , f]) => `${nm} × ${pct(f)}`).join(' + ') + '.'],
                                        ['4', 'Van energie naar laadpunten',
                                         `AC: ${Math.round(data.mwhAC).toLocaleString('nl-BE')} ÷ ${acUtilisatieMwhJaarV5(year, normPerJaar).toFixed(1)} MWh per punt ` +
                                         `× ${(1 + redundantieMarge).toFixed(2)} buffer = ${afg.delen[0]} punten`,
                                         data.totDC > 0.5
                                           ? `Een snellaadpunt verzet ${(dcUtilisatieMwhMaand(year)*12).toFixed(0)} MWh per jaar, een gewoon laadpunt ${acUtilisatieMwhJaarV5(year, normPerJaar).toFixed(1)}. Daarom levert dezelfde hoeveelheid energie veel minder snellaadpunten op.`
                                           : ''],
                                      ].map(([nr, titel, reken, noot]) => (
                                        <div key={nr} style={st.mStap}>
                                          <span style={st.mStapNr}>{nr}</span>
                                          <span>
                                            <span style={st.mStapT}>{titel}</span>
                                            <span style={st.mStapR}>{reken}</span>
                                            <span style={st.mStapN}>{noot}</span>
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })}
                      <tr>
                        <td style={{ ...st.mTd(false), background:N.head, borderBottom:'none', fontWeight:700, color:N.ink }}>Totaal</td>
                        <td style={{ ...st.mTd(false), background:N.head, borderBottom:'none' }}/>
                        <td style={{ ...st.mTd(false), background:N.head, borderBottom:'none' }}/>
                        {[...totAfg.delen, totAfg.totaal].map((w, i) => (
                          <td key={i} style={{ ...st.mTd(true), background:N.head, borderBottom:'none', fontWeight:700, color:N.ink }}>
                            {w}</td>
                        ))}
                        <td style={{ ...st.mTd(true), background:N.head, borderBottom:'none', fontWeight:700, color:N.accent }}>
                          {fmtN(Math.round(bijkomend))}</td>
                        <td style={{ ...st.mTd(true), background:N.head, borderBottom:'none', fontWeight:700, color:N.ink }}>{fmtEur(tot.capex)}</td>
                        <td style={{ ...st.mTd(true), background:N.head, borderBottom:'none' }}/>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div style={st.mLeg}>
                  {[[MIX_BEW,'bewoners'],[MIX_BEZ,'bezoekers'],[MIX_LOG,'logistiek']].map(([k, t]) => (
                    <span key={t} style={st.mLegRij}><span style={{ ...st.mLegBol, background:k }}/>{t}</span>
                  ))}
                  <span style={{ color:N.line2 }}>|</span>
                  {[[MIX_AC,'AC'],[MIX_DC,'DC'],[MIX_HPC,'HPC']].map(([k, t]) => (
                    <span key={t} style={st.mLegRij}><span style={{ ...st.mLegBol, background:k }}/>{t}</span>
                  ))}
                </div>
              </div>

              {/* De twee tabellen die samen de mix bepalen. Dit zijn de echte
                  waarden uit de rekenkern, niet een navertelling ervan. */}
              <div style={st.nCard}>
                <div style={st.vHdr}>
                  <div style={{ fontSize:16.5, fontWeight:700, color:N.ink }}>De gebruikte verhoudingen</div>
                  <button style={st.mKnop(false)} onClick={() => setMixParams(!mixParams)}>
                    {mixParams ? 'Verbergen' : 'Tonen'}
                  </button>
                </div>
                <div style={st.mUitleg}>
                  Deze twee tabellen bepalen samen de mix. Het zijn de waarden waarmee het model werkelijk rekent.
                </div>
                {mixParams && (
                  <div style={st.mParam}>
                    <div>
                      <div style={st.mParamKop}>Voor wie wordt er geladen</div>
                      <table style={st.mTbl}>
                        <thead><tr>
                          <th style={st.mTh(false)}>Wijktype</th>
                          <th style={st.mTh(true)}>Bewoners</th>
                          <th style={st.mTh(true)}>Bezoekers</th>
                          <th style={st.mTh(true)}>Logistiek</th>
                        </tr></thead>
                        <tbody>
                          {Object.entries(WIJKTYPE_MIX || {}).map(([type, m]) => (
                            <tr key={type}>
                              <td style={st.mTd(false)}>{TYPENAAM[type] || type}</td>
                              <td style={st.mTd(true)}>{pct(m.bew)}</td>
                              <td style={st.mTd(true)}>{pct(m.bez)}</td>
                              <td style={st.mTd(true)}>{pct(m.log)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <div style={st.mParamKop}>Hoe elke groep laadt</div>
                      <table style={st.mTbl}>
                        <thead><tr>
                          <th style={st.mTh(false)}>Groep</th>
                          <th style={st.mTh(true)}>AC</th>
                          <th style={st.mTh(true)}>DC</th>
                          <th style={st.mTh(true)}>HPC</th>
                        </tr></thead>
                        <tbody>
                          {Object.entries(DOELGROEP_LAADTYPE || {}).map(([groep, t]) => (
                            <tr key={groep}>
                              <td style={st.mTd(false)}>{GROEPNAAM[groep] || groep}</td>
                              <td style={st.mTd(true)}>{pct(t.ac)}</td>
                              <td style={st.mTd(true)}>{pct(t.dc)}</td>
                              <td style={st.mTd(true)}>{pct(t.hpc)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div style={{ gridColumn:'1 / -1' }}>
                      <div style={st.mParamKop}>Wat dat samen oplevert per soort wijk</div>
                      <table style={st.mTbl}>
                        <thead><tr>
                          <th style={st.mTh(false)}>Wijktype</th>
                          <th style={st.mTh(true)}>Gewoon</th>
                          <th style={st.mTh(true)}>Snel</th>
                          <th style={st.mTh(true)}>Ultrasnel</th>
                        </tr></thead>
                        <tbody>
                          {Object.entries(WIJKTYPE_MIX || {}).map(([type, m]) => {
                            const D = DOELGROEP_LAADTYPE || {};
                            const deel = (soort) => (['bew','bez','log'])
                              .reduce((som, g) => som + (m[g] || 0) * ((D[g] || {})[soort] || 0), 0);
                            return (
                              <tr key={type}>
                                <td style={st.mTd(false)}>{TYPENAAM[type] || type}</td>
                                <td style={st.mTd(true)}>{pct(deel('ac'))}</td>
                                <td style={st.mTd(true)}>{pct(deel('dc'))}</td>
                                <td style={st.mTd(true)}>{pct(deel('hpc'))}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                <div style={{ ...st.mUitleg, marginTop:12, marginBottom:0 }}>
                  Een bewoner staat 's nachts stil en laadt dus vrijwel altijd normaal; logistiek wil juist
                  snel weer weg. Daarom is de mix op een bedrijventerrein zo anders dan in een woonwijk.
                </div>
              </div>

              {/* De melding over beleidsscenario's is op 15 oktober 2026 weggehaald: HL
                  besliste dat de AC/DC/HPC-mix per wijktype niet per gemeente wordt
                  ingevuld, omdat dat te veel ingrijpt in het rekenmodel. */}
            </>
          );
        })()}
      </div>

      {/* ── TABBLAD: EXPORT ───────────────────────────────────────── */}
      {/* De CSV wordt hier in de browser opgebouwd uit dezelfde cijfers als de
          grafiek en de tabellen, dus zonder backend. Word, Excel en de
          kaartexport vragen wel een backend-endpoint; die zijn er nog niet. */}
      {/* ── TABBLAD LAADPLEINEN ─────────────────────────────────────── */}
      {/* Filters links, kaart rechts, net als op Gemeente. De lijst ligt over
          de kaart linksboven; de legenda rechtsboven, zodat de bronvermelding
          van de kaart rechtsonder vrij blijft. */}
      {/* ── TABBLAD: PLAATSING ────────────────────────────────────────
          Vier stappen naast elkaar boven de kaart, zodat het effect van een
          jaar of een schuif meteen te zien is zonder te schuiven met de pagina. */}
      <div style={{ ...st.nPaneF, flexDirection:'column', overflowY:'auto', overflowX:'hidden',
                    display: tab === 'plaatsing' ? 'flex' : 'none' }}>

        <div style={{ display:'flex', alignItems:'center', gap:14, flexWrap:'wrap',
                      padding:'12px 20px', borderBottom:`1px solid ${N.line}`, background:N.paper2,
                      position:'sticky', top:0, zIndex:600, flexShrink:0 }}>
          <span style={{ fontSize:13, color:N.ink3, letterSpacing:'.04em' }}>GEBIED</span>
          <select value={plaatsGebied} onChange={e => setPlaatsGebied(e.target.value)}
                  style={{ ...st.gInp, width:230, fontSize:14, padding:'6px 8px' }}>
            <option value="alle">Hele gemeente</option>
            {(gemeente?.wijken || []).map(w => (
              <option key={w.id} value={w.id}>{w.naam}</option>
            ))}
          </select>
          {plaatsHeeftNet && (<>
            <span style={{ fontSize:13, color:N.ink3, letterSpacing:'.04em' }}>NABIJ HET NET</span>
            <select value={plaatsNetFilter} onChange={e => setPlaatsNetFilter(e.target.value)}
                    style={{ ...st.gInp, width:230, fontSize:14, padding:'6px 8px' }}>
              <option value="alle">alle</option>
              {['400', '230', 'geen'].map(k => (
                <option key={k} value={k}>{NET_KLASSE[k].label(netGrens)}</option>))}
            </select>
          </>)}
          <span style={{ fontSize:13, color:N.ink4 }}>
            Peiljaar {year}. Elk jaar bouwt voort op de jaren ervoor.
          </span>
          {/* De knop bleef eerder weg zodra de straten er eenmaal waren. Daardoor
              was er geen manier meer om ze te verversen, bijvoorbeeld nadat de
              wegsoort eraan is toegevoegd. Nu staat hij er altijd; alleen de
              tekst verschilt. */}
          <span style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:10 }}>
            {!straten.length && (
              <span style={{ fontSize:13, color:N.warn }}>Straatnamen zijn nog niet opgehaald</span>
            )}
            {/* De adressen zijn er voor de volgende stap: de vraag per vakje
                gaan verdelen naar waar mensen wonen. Nu alleen ophalen en
                tellen, zodat te zien is of de aantallen kloppen. */}
            <span style={{ fontSize:13, color: adressen.length ? N.ink3 : N.warn }}>
              {adressen.length
                ? `${adressen.length.toLocaleString('nl-BE')} adressen`
                : 'Geen adressen'}
            </span>
            <button onClick={adressenOphalen} disabled={adressenBezig}
              style={{ background: adressen.length ? N.paper : N.accent,
                       border: adressen.length ? `1px solid ${N.line2}` : 'none',
                       borderRadius:7, padding:'6px 12px',
                       fontSize:13, fontWeight:700,
                       color: adressen.length ? N.ink2 : '#fff', fontFamily:'inherit',
                       cursor: adressenBezig ? 'default' : 'pointer', opacity: adressenBezig ? 0.6 : 1 }}>
              {adressenBezig ? 'Bezig met ophalen'
                : adressen.length ? 'Adressen opnieuw ophalen' : 'Adressen ophalen'}
            </button>
            <button onClick={straatnamenOphalen} disabled={stratenBezig}
              style={{ background: straten.length ? N.paper : N.accent,
                       border: straten.length ? `1px solid ${N.line2}` : 'none',
                       borderRadius:7, padding:'6px 12px',
                       fontSize:13, fontWeight:700,
                       color: straten.length ? N.ink2 : '#fff', fontFamily:'inherit',
                       cursor: stratenBezig ? 'default' : 'pointer', opacity: stratenBezig ? 0.6 : 1 }}>
              {stratenBezig ? 'Bezig met ophalen'
                : straten.length ? 'Straatnamen opnieuw ophalen' : 'Straatnamen ophalen'}
            </button>
          </span>
        </div>
        {adressenMelding && (
          <div style={{ padding:'8px 20px', fontSize:13, color:N.ink3, flexShrink:0 }}>
            {adressenMelding}
          </div>
        )}
        {stratenMelding && (
          <div style={{ padding:'8px 20px', fontSize:13, color:N.red, flexShrink:0 }}>
            {stratenMelding}
          </div>
        )}

        {/* De vier stappen */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:14,
                      padding:'16px 20px 0', alignItems:'stretch', flexShrink:0 }}>

          {/* 1 */}
          <div style={st.pKaart}>
            <div style={st.pStapKop}>
              <span style={st.pNr}>1</span>
              <span>
                <div style={st.pStapNaam}>Hoeveel laadpunten komen erbij</div>
                <div style={st.pStapVraag}>Komt uit het rekenmodel, niet uit dit scherm</div>
              </span>
            </div>
            <div style={{ fontSize:28, fontWeight:700, lineHeight:1.1, fontVariantNumeric:'tabular-nums' }}>
              {fmtN(plaatsVerdeling.totaal)}
            </div>
            <div style={{ fontSize:12.5, color:N.ink3, marginTop:2 }}>
              laadpunten erbij in {year}, in {plaatsGebied === 'alle' ? 'de hele gemeente'
                : ((gemeente?.wijken || []).find(w => w.id === plaatsGebied)?.naam || 'deze wijk')}
            </div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginTop:'auto', paddingTop:10 }}>
              {[[fmtN(plaatsGebied === 'alle' ? (gemeente?.inwoners || 0)
                    : Math.round(dekTelling?.perWijk.find(w => w.wijkId === plaatsGebied)?.inwoners || 0)),
                 'inwoners', 'tabblad Gemeente'],
                [(gemeente?.inwoners ? ((gemeente?.voertuigen || 0) / gemeente.inwoners) : 0)
                   .toFixed(2).replace('.', ','), 'auto per inwoner', 'voertuigenpark'],
                [Math.round(evAandeelGemeente(year, evOverrideVoorJaar(year)) * 100) + '%',
                 'elektrisch', 'tabblad Gemeente'],
                [fmtN(plaatsVerdeling.totaal), 'laadpunten', 'tabblad Wijken'],
              ].map(([groot, klein, bron]) => (
                <div key={klein} style={st.pBron}>
                  <b style={{ display:'block', fontSize:12.5, fontVariantNumeric:'tabular-nums' }}>{groot}</b>
                  {klein}<br/><span style={{ color:N.ink4 }}>{bron}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 2 */}
          <div style={st.pKaart}>
            <div style={st.pStapKop}>
              <span style={st.pNr}>2</span>
              <span>
                <div style={st.pStapNaam}>Wat voor plek</div>
                <div style={st.pStapVraag}>Een laadplein, een tweede paal, of een nieuwe plek</div>
              </span>
            </div>
            <div style={{ display:'flex', height:10, borderRadius:5, overflow:'hidden',
                          background:N.line2, margin:'0 0 9px' }}>
              {[['#B87333', plaatsVerdeling.plein], ['#7FAEBB', plaatsVerdeling.pvp],
                [N.accent, plaatsVerdeling.nieuw]].map(([kl, n], i) => (
                <div key={i} style={{ width: plaatsVerdeling.totaal > 0
                  ? `${(n / plaatsVerdeling.totaal) * 100}%` : '0%', background: kl }} />
              ))}
            </div>
            {[['Op een laadplein', '#B87333', plaatsVerdeling.plein],
              ['Tweede paal, waar er al een staat', '#7FAEBB', plaatsVerdeling.pvp],
              ['Nieuwe plek', N.accent, plaatsVerdeling.nieuw]].map(([label, kl, n]) => (
              <div key={label} style={{ display:'flex', alignItems:'center', gap:8,
                                        fontSize:12.5, marginBottom:5 }}>
                <span style={{ width:10, height:10, borderRadius:'50%', background:kl, flex:'none' }} />
                {label}
                <b style={{ marginLeft:'auto', fontVariantNumeric:'tabular-nums' }}>{fmtN(n)}</b>
              </div>
            ))}
            <div style={{ marginTop:8, paddingTop:8, borderTop:`1px solid ${N.line2}`,
                          fontSize:11.5, color:N.ink4, lineHeight:1.45 }}>
              {plaatsVerdeling.plein === 0
                ? 'Geen laadpleinen in dit jaar geselecteerd. Alle laadpunten ingevuld via afzonderlijke laadpalen.'
                : plaatsVerdeling.los === 0
                  ? 'De aangewezen laadpleinen dekken alle laadpunten af. Er komen dit jaar geen losse laadpalen bij.'
                  : 'Laadpleinen komen uit de keuzes op tabblad Laadpleinen.'}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:9, marginTop:'auto', paddingTop:10 }}>
              <label style={{ fontSize:12, color:N.ink2, flex:1 }}>
                Laadpunten die de bijplaatsnorm halen</label>
              <input type="number" min={0} max={100} step={1} value={pvpInvoer}
                     onChange={e => setPvpInvoer(e.target.value)}
                     onBlur={bewaarPvpNorm}
                     onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); }}
                     placeholder="leeg"
                     style={{ width:56, fontSize:12.5, fontWeight:700, textAlign:'right',
                              padding:'3px 6px', border:`1px solid ${N.line}`, borderRadius:5,
                              fontFamily:'inherit', color:N.ink, background:N.paper }} />
              <span style={{ fontSize:12.5, color:N.ink3 }}>%</span>
            </div>
            <div style={{ fontSize:11, color: pvpOnbekend ? N.warn : N.ink4, marginTop:6, lineHeight:1.45 }}>
              {pvpOnbekend
                ? 'Nog niet ingevuld. Het gaat om het deel van de gewone laadpunten dat drie maanden achtereen meer dan 1.000 kWh per maand levert, of gemiddeld meer dan 65 procent van de tijd bezet is. Zolang dit leeg is, krijgt elk nieuw laadpunt een eigen aansluiting.'
                : `${plaatsPvp} procent van de gewone laadpunten die er aan het begin van ${year} stonden haalt de bijplaatsnorm. Daarvan komen er ${fmtN(plaatsVerdeling.pvp)} als tweede paal op een aansluiting die er al ligt.`}
            </div>
          </div>

          {/* 3 */}
          <div style={st.pKaart}>
            <div style={st.pStapKop}>
              <span style={st.pNr}>3</span>
              <span>
                <div style={st.pStapNaam}>Waar precies</div>
                <div style={st.pStapVraag}>De tekortscore kiest, vakje voor vakje</div>
              </span>
            </div>
            <div style={{ fontSize:12.5, lineHeight:1.5, color:N.ink2 }}>
              Elke plek krijgt een score: wat de mensen binnen 250 meter nodig hebben, min wat
              er al staat. De paal gaat naar de hoogste score. Daar staat dan iets, dus de
              volgende paal komt verderop.
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:9, marginTop:'auto', paddingTop:10 }}>
              <label style={{ fontSize:12, color:N.ink2, flex:1, lineHeight:1.3 }}>
                Voorrang voor plekken zonder laadpunt binnen 250 meter</label>
              <input type="range" min={100} max={250} step={10} value={plaatsVoorrang}
                     onChange={e => setPlaatsVoorrang(+e.target.value)} style={{ width:96 }} />
              <span style={{ fontSize:12.5, fontWeight:700, width:36, textAlign:'right' }}>
                {(plaatsVoorrang / 100).toFixed(1).replace('.', ',')}</span>
            </div>
            <div style={{ fontSize:11, color:N.ink4, marginTop:6, lineHeight:1.45 }}>
              {plaatsVoorrang <= 105
                ? 'Uit. De palen gaan naar de grootste vraag, ook waar al laadpunten staan.'
                : `Een plek zonder laadpunt binnen 250 meter telt ${(plaatsVoorrang/100).toFixed(1).replace('.', ',')} keer zo zwaar. ` +
                  'Daar mag de gemeente een aanvraag niet weigeren.'}
            </div>
          </div>

          {/* 4 */}
          <div style={st.pKaart}>
            <div style={st.pStapKop}>
              <span style={st.pNr}>4</span>
              <span>
                <div style={st.pStapNaam}>Hoeveel inwoners hebben een laadpunt binnen 250 meter</div>
                <div style={st.pStapVraag}>Voor en na dit jaar</div>
              </span>
            </div>
            <div style={{ display:'flex', alignItems:'flex-end', gap:12 }}>
              <div>
                <div style={{ fontSize:28, fontWeight:700, lineHeight:1.1 }}>
                  {plaatsDekking ? Math.round(plaatsDekking.voor.deelInwoners * 100) + '%' : '—'}
                </div>
                <div style={{ fontSize:12.5, color:N.ink3 }}>begin {year}</div>
              </div>
              <div style={{ fontSize:19, color:N.ink4, paddingBottom:7 }}>→</div>
              <div>
                <div style={{ fontSize:28, fontWeight:700, lineHeight:1.1, color:N.accent }}>
                  {plaatsDekking ? Math.round(plaatsDekking.na.deelInwoners * 100) + '%' : '—'}
                </div>
                <div style={{ fontSize:12.5, color:N.ink3 }}>eind {year}</div>
              </div>
            </div>
            <div style={{ fontSize:11, color:N.ink4, marginTop:6, lineHeight:1.45 }}>
              {plaatsDekking
                ? `${fmtN(Math.max(0, plaatsDekking.na.inwonersGedekt - plaatsDekking.voor.inwonersGedekt))} ` +
                  'inwoners komen dit jaar binnen 250 meter van een laadpunt. Een tweede paal ' +
                  'verandert de dekking niet.'
                : 'Nog geen dekking berekend.'}
            </div>
            <div style={{ marginTop:'auto', paddingTop:10 }}>
              <div style={{ background:'#F0F5F2', border:'1px solid #CFE0D6', borderRadius:7,
                            padding:'7px 9px', fontSize:11.5, color:'#2C5741', lineHeight:1.45 }}>
                Alle {fmtN(plaatsVerdeling.totaal)} laadpunten van {year} hebben een plek:{' '}
                {fmtN(plaatsVerdeling.plein)} op een laadplein, {fmtN(plaatsVerdeling.pvp)} als
                tweede paal, {fmtN(plaatsVerdeling.nieuw)} op een nieuwe plek.
              </div>
            </div>
          </div>
        </div>

        {/* Het kerncijfer over het net. Alleen met een GIS-bestand. */}
        {plaatsHeeftNet && plaatsNetTelling.totaal > 0 && (
          <div style={{ display:'flex', alignItems:'baseline', gap:10, flexWrap:'wrap', margin:'14px 20px 0',
                        background:N.paper, border:`1px solid ${N.line}`, borderRadius:10, padding:'10px 14px' }}>
            <span style={{ fontSize:13, color:N.ink2 }}>Binnen {netGrens} m van een 400 V-straatkabel</span>
            <b style={{ fontSize:22, fontVariantNumeric:'tabular-nums', color:NET_KLASSE['400'].kleur }}>
              {fmtN(plaatsNetTelling.ok)}</b>
            <span style={{ fontSize:13, color:N.ink3 }}>
              van {fmtN(plaatsNetTelling.totaal)} losse laadpalen in {year}</span>
          </div>
        )}

        {/* De kaart */}
        <div style={{ height:720, flexShrink:0, position:'relative', margin:'14px 20px 0',
                      border:`1px solid ${N.line}`, borderRadius:10, overflow:'hidden' }}>
          <div ref={plaatsMapRef} style={{ width:'100%', height:'100%' }} />
          <div style={{ position:'absolute', top:12, right:12, zIndex:500,
                        background:'rgba(255,255,255,0.96)', border:`1px solid ${N.line2}`,
                        borderRadius:8, padding:'10px 12px', fontSize:12.5 }}>
            {[['staat er nu', '#AAB4B7', 9], ['geplot in voorgaande jaren', '#7FAEBB', 12],
              ['dit jaar, losse laadpunten', N.accent, 15], ['dit jaar, laadplein', '#B87333', 15]]
              .map(([label, kl, maat]) => (
              <div key={label} style={{ display:'flex', alignItems:'center', gap:9, margin:'5px 0' }}>
                <span style={{ width:maat, height:maat, borderRadius:'50%', background:kl, flex:'none' }} />
                {label}
              </div>
            ))}
            <div style={{ display:'flex', alignItems:'center', gap:4, marginTop:9, paddingTop:8,
                          borderTop:`1px solid ${N.line2}`, color:N.ink4, fontSize:11 }}>
              <span>tekortscore laag</span>
              {['#EFF3F4','#D2DFE2','#A9C3C9','#7FA7B0'].map(k => (
                <span key={k} style={{ width:17, height:10, borderRadius:2, background:k }} />
              ))}
              <span>hoog</span>
            </div>
            <StroomnetUitklap gis={gisNet} zicht={netZicht} onZicht={setNetZicht} />
          </div>
        </div>

        {/* De tabel per sector */}
        <div style={{ padding:'14px 20px 30px' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr>
                {['Wijk', 'Sector', 'Straat', 'Inwoners in de sector', 'Laadpunten dit jaar', 'Wat voor plek', 'Waarom hier',
                  ...(plaatsHeeftNet ? ['Straatkabel 400 V (m)', 'Verdeelkast (m)', `Net binnen ${netGrens} m`] : [])]
                  .map((k, i) => (
                  <th key={k} style={{ ...st.pTh, textAlign: i === 3 || i === 4 || i === 7 || i === 8 ? 'right' : 'left' }}>{k}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {plaatsPerStraat.map(r => (
                <tr key={`${r.sector}|${r.straat}`}>
                  <td style={st.pTd}>{r.wijk}</td>
                  <td style={st.pTd}>{r.naam}</td>
                  <td style={st.pTd}>{r.straatTekst}</td>
                  <td style={{ ...st.pTd, textAlign:'right' }}>
                    {r.inwoners == null ? '' : fmtN(r.inwoners)}</td>
                  <td style={{ ...st.pTd, textAlign:'right' }}>{fmtN(r.punten)}</td>
                  <td style={st.pTd}>{r.soort}</td>
                  <td style={{ ...st.pTd, color:N.ink3 }}>{r.waarom}</td>
                  {plaatsHeeftNet && (<>
                    <td style={{ ...st.pTd, textAlign:'right', whiteSpace:'nowrap' }}>{netBereik(r.net, 'd400')}</td>
                    <td style={{ ...st.pTd, textAlign:'right', whiteSpace:'nowrap' }}>{netBereik(r.net, 'dkast')}</td>
                    <td style={st.pTd}><NetStraat lijst={r.net} grens={netGrens} /></td>
                  </>)}
                </tr>
              ))}
              {!plaatsPerStraat.length && (
                <tr><td colSpan={plaatsHeeftNet ? 10 : 7} style={{ ...st.pTd, color:N.ink4 }}>
                  {plaatsNetFilter !== 'alle' && plaatsHeeftNet
                    ? `Voor ${year} staat er in dit gebied geen losse laadpaal met ${NET_KLASSE[plaatsNetFilter].label(netGrens)}.`
                    : `Voor ${year} komt er in dit gebied niets bij.`}</td></tr>
              )}
            </tbody>
          </table>
          <div style={{ fontSize:11.5, color:N.ink4, marginTop:10, lineHeight:1.5 }}>
            {straten.length
              ? 'Een plek ligt in de aangegeven straat, op het punt dat het dichtst bij de berekende plek ligt. Het is geen adres en geen parkeervak.'
              : 'Zonder straatnamen staat elke plek op het midden van een vakje van 50 bij 50 meter.'}
          </div>
        </div>
      </div>

      {/* ── TABBLAD: BEZETTING ────────────────────────────────────────
          Hoe druk de bestaande laadpunten gebruikt worden, elk uur gemeten.
          De inhoud staat in Bezetting.js. Alleen in beeld als de server het
          toestaat, zie bezettingZichtbaar. */}
      {bezettingZichtbaar && (
        <div style={{ ...st.nPane, padding:0, display: tab === 'bezetting' ? 'block' : 'none' }}>
          <Bezetting actief={tab === 'bezetting'} gemeente={gemeente} wijkResults={wijkResults}
                     existingPalen={existingPalen} sectorenGeo={sectorenGeo} />
        </div>
      )}

      {/* ── TABBLAD: DEKKING ──────────────────────────────────────────
          Elke laadpaal met een cirkel van 250 meter eromheen, zodat zichtbaar
          wordt welk deel van de gemeente binnen die afstand ligt. */}
      <div style={{ ...st.nPaneF, flexDirection:'column', overflowY:'auto', overflowX:'hidden',
                    display: tab === 'dekking' ? 'flex' : 'none' }}>
        <div style={{ display:'flex', alignItems:'center', gap:22, flexWrap:'wrap',
                      padding:'14px 20px', borderBottom:`1px solid ${N.line}`, background:N.paper2,
                      position:'sticky', top:0, zIndex:600, flexShrink:0 }}>
          <span style={{ fontSize:13, color:N.ink3, letterSpacing:'.04em' }}>TONEN</span>
          {[['Publiek gewone paal', dekPubliek, setDekPubliek, DEK_KLEUR.publiek],
            ['Publiek snellader', dekSnel, setDekSnel, DEK_KLEUR.snel],
            ['Semipubliek', dekSemi, setDekSemi, DEK_KLEUR.semi],
            ['Aangewezen laadpleinen', dekPleinen, setDekPleinen, DEK_KLEUR.plein],
            ['Plaatsing tot en met dit jaar', dekPlaatsing, setDekPlaatsing, KLEUR_PLAN]].map(([label, aan, zet, kleur]) => (
            <label key={label} style={{ display:'flex', alignItems:'center', gap:7, fontSize:15, cursor:'pointer' }}>
              <input type="checkbox" checked={aan} onChange={() => zet(v => !v)} />
              <span style={{ display:'inline-block', width:11, height:11, borderRadius:'50%', background:kleur }} />
              {label}
            </label>
          ))}
          <span style={{ width:1, height:22, background:N.line }} />
          <label style={{ display:'flex', alignItems:'center', gap:7, fontSize:15, cursor:'pointer' }}>
            <input type="checkbox" checked={dekCirkels} onChange={() => setDekCirkels(v => !v)} />
            Cirkels van 250 m
          </label>
          <label style={{ display:'flex', alignItems:'center', gap:7, fontSize:15, cursor:'pointer' }}>
            <input type="checkbox" checked={dekVlekken} onChange={() => setDekVlekken(v => !v)} />
            <span style={{ display:'inline-block', width:11, height:11, borderRadius:2,
                           background:DEK_KLEUR.rood, opacity:0.85 }} />
            Zonder laadpunt binnen 250 m
          </label>
          <span style={{ flex:1 }} />
          <span style={{ fontSize:17, color: dekZichtbaar.length ? N.ink : N.warn, fontWeight:700 }}>
            {fmtN(dekZichtbaar.length)} locaties
            <span style={{ fontSize:15, color:N.ink3, fontWeight:400, marginLeft:8 }}>
              met een of meerdere laadpalen
            </span>
          </span>
          {dekTelling && (
            <span style={{ fontSize:14, color:N.ink3 }}>
              · {fmtN(Math.round(dekTelling.totaal.deelInwoners * 100))}% van de inwoners
              heeft een laadpunt binnen 250 m
            </span>
          )}
          {!dekZichtbaar.length && (
            <span style={{ fontSize:14, color:N.warn, background:'#FBF3E2',
                           border:`1px solid #E4D2A8`, borderRadius:7, padding:'5px 10px' }}>
              Er staat geen enkel laadpunt aan, dus alles is ongedekt. Zet hierboven minstens
              één soort laadpunt aan.
            </span>
          )}
          <span style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:12 }}>
            {exportFout && <span style={{ fontSize:13, color:N.red }}>{exportFout}</span>}
            <button style={st.pLink} disabled={exportBezig} onClick={exporteerDekkingPlaatsing}>
              {exportBezig ? 'Bezig…' : 'Downloaden'}
            </button>
          </span>
        </div>

        <div style={{ height:620, flexShrink:0, position:'relative' }}>
          <div ref={dekMapRef} style={{ width:'100%', height:'100%' }} />
          <div style={{ position:'absolute', top:12, right:12, zIndex:500, width:290 }}>
            {dekTelling && (
              <div style={{ background:'rgba(255,255,255,0.96)', border:`1px solid ${N.line2}`,
                            borderRadius:8, padding:'14px 15px', marginBottom:10 }}>
                <div style={{ fontSize:13, color:N.ink3, letterSpacing:'.04em', marginBottom:6 }}>
                  BUITEN DE DEKKING
                  <span style={{ display:'inline-block', width:10, height:10, borderRadius:2,
                                 background:'#B4442F', opacity:0.7, marginLeft:7 }} />
                  <span style={{ marginLeft:5 }}>(ROOD)</span>
                </div>
                <div style={{ fontSize:34, fontWeight:700, lineHeight:1.05, color:N.warn }}>
                  {fmtN(dekTelling.totaal.inwonersZonder)}
                </div>
                <div style={{ fontSize:14, color:N.ink2, marginTop:3 }}>
                  van de {fmtN(dekTelling.totaal.inwoners)} inwoners
                </div>
                <div style={{ fontSize:13.5, color:N.ink3, marginTop:8, lineHeight:1.5 }}>
                  Zij wonen verder dan 250 meter van een laadpunt.
                  Dat is {fmtN(Math.round((1 - dekTelling.totaal.deelInwoners) * 100))}% van de inwoners.
                </div>
                {dekTellingNu && (
                  <div style={{ marginTop:10, paddingTop:10, borderTop:`1px solid ${N.line}`,
                                fontSize:13.5, color:N.ink2, lineHeight:1.5 }}>
                    Zonder de nieuwe laadpunten uit het plan tot en met {year} zijn dat er
                    {' '}<b>{fmtN(dekTellingNu.totaal.inwonersZonder)}</b>.
                    {' '}Het plan brengt er dus
                    {' '}<b>{fmtN(dekTellingNu.totaal.inwonersZonder
                                  - dekTelling.totaal.inwonersZonder)}</b>
                    {' '}binnen bereik.
                  </div>
                )}
              </div>
            )}
            <div style={{ background:'rgba(255,255,255,0.94)', border:`1px solid ${N.line2}`,
                          borderRadius:8, padding:'10px 13px',
                          fontSize:13.5, color:N.ink2, lineHeight:1.6 }}>
              <div style={{ fontWeight:700, marginBottom:5, color:N.ink }}>Wat je ziet</div>
              {/* Legenda: alleen wat aan staat en er ook werkelijk is. */}
              <div style={{ marginBottom:8 }}>
                {[[dekPubliek, 'Publiek gewone paal', DEK_KLEUR.publiek, 'rond'],
                  [dekSnel, 'Publiek snellader', DEK_KLEUR.snel, 'rond'],
                  [dekSemi, 'Semipubliek', DEK_KLEUR.semi, 'rond'],
                  [dekPleinen && dekPleinenNu.length > 0, 'Aangewezen laadplein', DEK_KLEUR.plein, 'rond'],
                  [dekPlaatsing && dekPlaatsingNu.length > 0,
                   `Nieuw tot en met ${year}`, DEK_KLEUR.plan, 'rond'],
                  [dekVlekken, 'Bewoond, geen laadpunt binnen 250 m', DEK_KLEUR.rood, 'vierkant'],
                ].filter(r => r[0]).map(([, tekst, kleur, vorm]) => (
                  <div key={tekst} style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ display:'inline-block', width:11, height:11, flexShrink:0,
                                   borderRadius: vorm === 'rond' ? '50%' : 2, background:kleur,
                                   opacity: vorm === 'rond' ? 1 : 0.85 }} />
                    {tekst}
                  </div>
                ))}
              </div>
              Cirkel: 250 meter hemelsbreed. Ultrasnelladers tellen niet mee.
            </div>
          </div>
        </div>

        {/* Onder de kaart: per wijk hoeveel inwoners er buiten de 250 meter
            wonen. Zelfde telling als het getal rechtsboven op de kaart, dus die
            twee kunnen niet uit elkaar lopen. */}
        {dekTelling && dekTelling.perWijk.length > 0 && (() => {
          const naamVan = (id) => (gemeente?.wijken || []).find(w => w.id === id)?.naam || id;
          const rijen = dekTelling.perWijk
            .filter(w => w.inwoners > 0)
            .sort((a, b) => b.inwonersZonder - a.inwonersZonder);
          const kol = 'minmax(0,1fr) 120px 150px 110px';
          return (
            <div style={{ borderTop:`1px solid ${N.line}`, padding:'16px 20px 28px',
                          background:N.paper2, flexShrink:0 }}>
              <div style={{ marginBottom:12 }}>
                <div style={{ fontSize:15, fontWeight:700 }}>Per wijk</div>
                <div style={{ fontSize:13.5, color:N.ink3, marginTop:3 }}>
                  Optelsom van alle statistische sectoren in die wijk.
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:kol, gap:10, fontSize:13,
                            color:N.ink3, paddingBottom:8, borderBottom:`1px solid ${N.line}` }}>
                <div>Wijk</div>
                <div style={{ textAlign:'right' }}>Inwoners</div>
                <div style={{ textAlign:'right' }}>Buiten de dekking</div>
                <div style={{ textAlign:'right' }}>Gedekt</div>
              </div>
              {rijen.map(w => (
                <div key={w.wijkId} style={{ display:'grid', gridTemplateColumns:kol, gap:10,
                      fontSize:15, padding:'8px 0', borderBottom:`1px solid ${N.line}` }}>
                  <div>{naamVan(w.wijkId)}</div>
                  <div style={{ textAlign:'right' }}>{fmtN(w.inwoners)}</div>
                  <div style={{ textAlign:'right', fontWeight: w.inwonersZonder > 0 ? 700 : 400,
                                color: w.inwonersZonder > 0 ? N.warn : N.ink3 }}>
                    {fmtN(w.inwonersZonder)}</div>
                  <div style={{ textAlign:'right', color:N.ink3 }}>
                    {fmtN(Math.round(w.deelInwoners * 100))}%</div>
                </div>
              ))}
              <div style={{ display:'grid', gridTemplateColumns:kol, gap:10, fontSize:15,
                            padding:'10px 0', fontWeight:700 }}>
                <div>Samen</div>
                <div style={{ textAlign:'right' }}>{fmtN(dekTelling.totaal.inwoners)}</div>
                <div style={{ textAlign:'right' }}>{fmtN(dekTelling.totaal.inwonersZonder)}</div>
                <div style={{ textAlign:'right' }}>
                  {fmtN(Math.round(dekTelling.totaal.deelInwoners * 100))}%</div>
              </div>
            </div>
          );
        })()}

        {/* Waar die inwoners precies wonen: per statistische sector, de
            slechtst gedekte bovenaan. Een wijk zegt in welke hoek van de stad
            het knelt, een sector zegt welke straten. */}
        {dekTelling && dekTelling.perSector.length > 0 && (() => {
          const naamVan = (id) => (gemeente?.wijken || []).find(w => w.id === id)?.naam || '';
          // De grens: minder dan de helft van de inwoners van die sector heeft
          // een laadpunt binnen 250 meter. In de gegevens zit geen natuurlijke
          // grens, dus dit is een keuze; hij is gekozen omdat hij in één zin
          // uit te leggen is. De ondergrens van vijftig inwoners houdt kleine
          // sectoren met een handvol mensen uit de kop van de lijst.
          const GRENS = 0.5, MIN_INWONERS = 50;
          const alle = dekTelling.perSector
            .filter(x => x.inwonersZonder > 0)
            .sort((a, b) => a.deelInwoners - b.deelInwoners);
          const slecht = alle.filter(x => x.deelInwoners < GRENS && x.inwonersZonder >= MIN_INWONERS);
          const rijen = dekAlleSectoren ? alle : slecht;
          const toon = rijen;
          const kol = 'minmax(0,1fr) 150px 110px 140px 100px';
          return (
            <div style={{ borderTop:`1px solid ${N.line}`, padding:'16px 20px 28px',
                          background:N.paper, flexShrink:0 }}>
              <div style={{ marginBottom:12 }}>
                <div style={{ fontSize:15, fontWeight:700 }}>
                  {dekAlleSectoren ? 'Alle sectoren met inwoners zonder laadpunt'
                    : 'Sectoren met slechte of geen dekking'}
                </div>
                <div style={{ fontSize:13.5, color:N.ink3, marginTop:3 }}>
                  {dekAlleSectoren
                    ? `${fmtN(alle.length)} sectoren, van laagste naar hoogste dekking.`
                    : `${fmtN(slecht.length)} sectoren waar minder dan de helft van de inwoners `
                      + `een laadpunt binnen 250 meter heeft, van laag naar hoog. `
                      + `Sectoren met minder dan ${MIN_INWONERS} inwoners buiten de dekking `
                      + `staan er niet bij.`}
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:kol, gap:10, fontSize:13,
                            color:N.ink3, paddingBottom:8, borderBottom:`1px solid ${N.line}` }}>
                <div>Statistische sector</div>
                <div>Ligt in wijk</div>
                <div style={{ textAlign:'right' }}>Inwoners</div>
                <div style={{ textAlign:'right' }}>Buiten de dekking</div>
                <div style={{ textAlign:'right' }}>Gedekt</div>
              </div>
              {toon.map(x => (
                <div key={x.sector} style={{ display:'grid', gridTemplateColumns:kol, gap:10,
                      fontSize:15, padding:'8px 0', borderBottom:`1px solid ${N.line}` }}>
                  <div>
                    {sectorNaam(x.sector)}
                    <span style={{ color:N.ink4, fontSize:12.5, marginLeft:7 }}>{x.sector}</span>
                  </div>
                  <div style={{ color:N.ink3, fontSize:14 }}>{naamVan(x.wijkId)}</div>
                  <div style={{ textAlign:'right' }}>{fmtN(x.inwoners)}</div>
                  <div style={{ textAlign:'right', fontWeight:700, color:N.warn }}>
                    {fmtN(x.inwonersZonder)}</div>
                  <div style={{ textAlign:'right', color:N.ink3 }}>
                    {fmtN(Math.round(x.deelInwoners * 100))}%</div>
                </div>
              ))}
              {!toon.length && (
                <div style={{ fontSize:15, color:N.ink3, padding:'12px 0' }}>
                  In geen enkele sector is minder dan de helft van de inwoners gedekt.
                </div>
              )}
              {alle.length > slecht.length && (
                <button style={{ ...st.pLink, marginTop:10, fontSize:14 }}
                  onClick={() => setDekAlleSectoren(v => !v)}>
                  {dekAlleSectoren ? 'Toon alleen de slecht gedekte sectoren'
                    : `Toon alle ${fmtN(alle.length)} sectoren met inwoners zonder laadpunt`}
                </button>
              )}
            </div>
          );
        })()}
      </div>

      {/* ── TABBLAD NETCAPACITEIT ──────────────────────────────────── */}
      <div style={{ ...st.nPane, display: tab === 'netcapaciteit' ? 'block' : 'none' }}>
        {(() => {
          const regels = netcapUit?.regels || [];
          const binnen = regels.filter(r => r.binnenPeriode);
          const nadien = regels.filter(r => !r.binnenPeriode);
          const som   = (rs, veld) => rs.reduce((a, r) => a + (r[veld] || 0), 0);
          const soort = (rs, s) => rs.reduce((a, r) => a + (r.palen[s] || 0), 0);
          const palen = rs => soort(rs,'ac') + soort(rs,'dc') + soort(rs,'hpc');
          // Palen die op een gekozen laadplein staan: het totaal min de palen
          // waarvan de locatie nog niet gekozen is.
          const opPlein = rs => palen(rs) - som(rs,'palenZonderLocatie');
          const GRID_WIJK = 'minmax(0,1fr) 76px 116px 132px 104px 128px';
          const jaarLijst = [...new Set(binnen.map(r => r.jaar))].sort();
          // De wijktabel toont de hele periode, of één jaar daaruit.
          const wijkBron = netcapWijkJaar === '' ? binnen
            : binnen.filter(r => r.jaar === Number(netcapWijkJaar));
          const wijkLijst = [...new Set(binnen.map(r => r.gebiedNaam))]
            .map(naam => ({ naam, rs: wijkBron.filter(r => r.gebiedNaam === naam) }))
            .sort((a, b) => som(b.rs,'kvaMax') - som(a.rs,'kvaMax'));
          // De ruimte op het net komt uit de kaart van de netbeheerder, per wijk
          // opgeteld uit de statistische sectoren die eronder vallen.
          const netruimte = netcapUit?.netruimte || {};
          const RUIMTE_KLEUR = { krap:'#E08A2E', beperkt:'#E8DE2A', ruim:'#8CC63F' };
          const wijkIdVan = (naam) => (binnen.find(r => r.gebiedNaam === naam)?.gebiedId) ?? null;
          const krappe = wijkLijst.filter(w => netruimte[wijkIdVan(w.naam)]?.ruimte === 'krap');
          // Slim laden staat aan zodra er ergens een percentage boven nul staat,
          // stadsbreed of in een enkele wijk.
          const slimVanWijk = (naam) => {
            const id = wijkIdVan(naam);
            return netcapSlimHand[id] ? (netcapSlimWijk[id] ?? 0) : netcapSlim;
          };
          const wijkenMetSlim = wijkLijst.filter(w => slimVanWijk(w.naam) > 0).length;
          const slimAan = wijkenMetSlim > 0;
          // Volgt uit de twee vermogens, zodat het getal nooit los kan gaan lopen
          // van de waarden waarmee gerekend wordt. Bij 11 en 6 kW is dat 45 procent,
          // binnen de 35 tot 49 procent die het E-Laad-onderzoek noemt.
          const kwNom  = netcapUit?.slim?.kwPerPuntNominaal || 11;
          const kwSlim = netcapUit?.slim?.kwPerPuntSlim || SOCKET_KW_SLIM;
          const piekReductiePct = Math.round((1 - kwSlim / kwNom) * 100);
          const begin = Math.min(netcapBegin, netcapEind), eind = Math.max(netcapBegin, netcapEind);
          const mva = k => (k / 1000).toFixed(1).replace('.', ',');
          // De drie soorten krijgen een vaste, smalle breedte zodat ze naast
          // elkaar blijven staan; de kolom Jaar vangt de rek op.
          const kol = 'minmax(0,1fr) 104px 104px 104px 92px 132px';
          const rijStijl = { display:'grid', gridTemplateColumns:kol, gap:10, fontSize:15, padding:'10px 0' };
          const Rij = ({ label, rs, vet, grijs, streep }) => (
            <div style={{ ...rijStijl, fontWeight: vet ? 700 : 400,
                          color: grijs ? N.ink3 : N.ink,
                          borderBottom: `1px solid ${streep || N.line}` }}>
              <div>{label}</div>
              <div style={{ textAlign:'right' }}>{fmtN(soort(rs,'ac'))}</div>
              <div style={{ textAlign:'right' }}>{fmtN(soort(rs,'dc'))}</div>
              <div style={{ textAlign:'right' }}>{fmtN(soort(rs,'hpc'))}</div>
              <div style={{ textAlign:'right' }}>{fmtN(palen(rs))}</div>
              <div style={{ textAlign:'right' }}>{fmtN(som(rs, slimAan ? 'kvaSlimMax' : 'kvaMax'))} kVA</div>
            </div>
          );

          return (
            <>
              <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap', marginBottom:14 }}>
                {/* De planperiode wordt alleen in Parameters gekozen (besluit HL
                    29 oktober 2026); hij geldt ook voor het venster Wijk impact. */}
                <span style={{ fontSize:13, color:N.ink3, letterSpacing:'.04em' }}>PERIODE</span>
                <span style={{ fontSize:15, color:N.ink }}>{begin} tot en met {eind}, in te stellen in Parameters</span>
                <span style={{ fontSize:13, color:N.ink3, letterSpacing:'.04em', marginLeft:10 }}>SLIM LADEN</span>
                <input type="number" min={0} max={100} step={5} value={netcapSlim}
                  onChange={e => setNetcapSlim(Math.min(100, Math.max(0, Number(e.target.value) || 0)))}
                  style={{ ...st.gInp, width:74, fontSize:15, padding:'6px 9px', textAlign:'right' }} />
                <span style={{ fontSize:14, color:N.ink3 }}>% van de laadpalen</span>
                <button style={{ ...st.pLink, fontSize:13 }}
                  onClick={() => { setNetcapSlimHand({}); setNetcapSlimWijk({}); }}>
                  alle wijken op dit percentage</button>
                <span style={{ flex:1 }} />
                <button style={st.pLink} disabled={netcapBezig || !binnen.length}
                  onClick={() => exporteerNetcapaciteit(regels, binnen, nadien, begin, eind, slimAan)}>
                  Exporteren naar Excel</button>
              </div>

              {netcapBezig && <div style={{ fontSize:14, color:N.ink3, marginBottom:10 }}>Bezig met doorrekenen…</div>}
              {netcapFout && <div style={{ fontSize:14, color:N.red, marginBottom:10 }}>{netcapFout}</div>}

              {!binnen.length && !netcapBezig ? (
                <div style={{ fontSize:15, color:N.ink3 }}>
                  Nog niets om te tonen. Kies een periode en zorg dat er wijken bekend zijn.
                </div>
              ) : (
                <>
                  <div style={{ background:N.paper2, border:`1px solid ${N.line}`, borderRadius:10, padding:'18px 20px', marginBottom:12 }}>
                    <div style={{ fontSize:14, color:N.ink3, marginBottom:14 }}>
                      Aan te vragen bij de netbeheerder, {begin} tot en met {eind}</div>
                    <div style={{ display:'flex', gap:56, flexWrap:'wrap', marginBottom:22 }}>
                      {[[fmtN(palen(binnen)), 'laadpalen', null],
                        [`${mva(som(binnen, slimAan ? 'kvaSlimMax' : 'kvaMax'))} MVA`, 'aansluitvermogen',
                         slimAan ? `zonder slim laden ${mva(som(binnen,'kvaMax'))} MVA` : null],
                        [fmtN(som(binnen,'cabines')), 'locaties met een eigen cabine', null]].map(([groot, klein, onder]) => (
                        <div key={klein}>
                          <div style={{ fontSize:40, fontWeight:700, lineHeight:1.05 }}>{groot}</div>
                          <div style={{ fontSize:15, color:N.ink3, marginTop:3 }}>{klein}</div>
                          {onder && <div style={{ fontSize:13, color:N.ink3, marginTop:2 }}>{onder}</div>}
                        </div>
                      ))}
                    </div>

                    {slimAan && (
                      <div style={{ background:N.head, border:`1px solid ${N.line}`, borderRadius:8,
                                    padding:'12px 14px', marginBottom:18, fontSize:14, lineHeight:1.55 }}>
                        <div style={{ fontWeight:700, marginBottom:4 }}>
                          Met slim laden in {fmtN(wijkenMetSlim)} van de {fmtN(wijkLijst.length)} wijken
                        </div>
                        <div>
                          Elk laadpunt houdt {netcapUit?.slim?.kwPerPuntSlim || SOCKET_KW_SLIM} kW gegarandeerd
                          in plaats van {netcapUit?.slim?.kwPerPuntNominaal || 11}, een piekreductie van{' '}
                          <b>{piekReductiePct} procent</b>. Op een aansluiting voor een gewone paal passen dan{' '}
                          {netcapUit?.slim?.puntenPerAansluiting || 4} laadpunten in plaats van {PUNTEN_PER_PAAL}.
                        </div>
                        <div style={{ marginTop:8 }}>
                          Dat kan op twee manieren worden benut, en die zijn niet bij elkaar op te tellen:
                          het gevraagde aansluitvermogen daalt naar{' '}
                          <b>{mva(som(binnen,'kvaSlimMax'))} MVA</b>{' '}
                          (nu {mva(som(binnen,'kvaMax'))}), <i>of</i> er kunnen{' '}
                          <b>{fmtN(som(binnen,'extraPalenSlim'))} laadpalen</b> extra bij zonder dat er
                          één aansluiting verzwaard wordt.
                        </div>
                      </div>
                    )}

                    <div style={{ display:'grid', gridTemplateColumns:kol, gap:10, fontSize:13, color:N.ink3,
                                  paddingBottom:8, borderBottom:`1px solid ${N.line}` }}>
                      <div>Jaar</div>
                      <div style={{ textAlign:'right' }}>Gewone paal</div>
                      <div style={{ textAlign:'right' }}>Snellader</div>
                      <div style={{ textAlign:'right' }}>Ultrasnellader</div>
                      <div style={{ textAlign:'right' }}>Samen</div>
                      <div style={{ textAlign:'right' }}>Aansluitvermogen</div>
                    </div>
                    {jaarLijst.map((j, i) => (
                      <Rij key={j} label={String(j)} rs={binnen.filter(r => r.jaar === j)}
                        streep={i === jaarLijst.length - 1 ? N.line2 : N.line} />
                    ))}
                    <Rij label={`Samen ${begin}–${eind}`} rs={binnen} vet />
                    {nadien.length > 0 && (
                      <>
                        <Rij label={`${eind + 1} t/m 2035`} rs={nadien} grijs streep={N.line2} />
                        <Rij label="Samen tot 2035" rs={regels} vet streep="transparent" />
                      </>
                    )}

                    {nadien.length > 0 && (
                      <div style={{ fontSize:14, marginTop:14, lineHeight:1.55 }}>
                        Voor {eind + 1} tot en met 2035 zijn nog geen locaties gekozen. Volgens het model
                        komen er dan nog {fmtN(pleinenNodig(palen(nadien) * 2, pleinAandeel, pleinOmvang))} laadpleinen bij.
                      </div>
                    )}
                    <div style={{ fontSize:12.5, color:N.ink3, marginTop:8, lineHeight:1.5 }}>
                      Een gewone paal vraagt {String(PAAL_VERMOGEN.ac.kvaMax).replace('.', ',')} kVA,
                      een snellader {String(PAAL_VERMOGEN.dc.kvaMax).replace('.', ',')} kVA en
                      een ultrasnellader {PAAL_VERMOGEN.hpc.kvaMin} tot {PAAL_VERMOGEN.hpc.kvaMax} kVA.
                      Peildatum {netcapUit?.peildatum || VERMOGEN_PEILDATUM}.
                    </div>
                  </div>

                  <div style={{ background:N.paper2, border:`1px solid ${N.line}`, borderRadius:10, padding:'18px 20px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap', marginBottom:14 }}>
                      <span style={{ fontSize:15, fontWeight:700 }}>
                        Aansluitkaart netcongestie en gevraagd aansluitvermogen</span>
                      <span style={{ flex:1 }} />
                      <span style={{ fontSize:14, color:N.ink3 }}>Toon</span>
                      <select value={netcapWijkJaar} onChange={e => setNetcapWijkJaar(e.target.value)}
                        style={{ ...st.gInp, width:170, fontSize:14, padding:'5px 8px', fontWeight:400 }}>
                        <option value="">de hele periode</option>
                        {jaarLijst.map(j => <option key={j} value={j}>alleen {j}</option>)}
                      </select>
                    </div>
                    <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr)', gap:22 }}>
                      {/* Dezelfde kaart als in het rapport en op de andere tabbladen, dus
                          dezelfde wijkvormen en dezelfde kleurenschaal. Gekleurd naar het
                          gevraagde vermogen, met de gekozen locaties als stip. */}
                      <div>
                        {sectorenGeo
                          ? <>
                              <div style={{ position:'relative' }}>
                                <div ref={netcapMapRef} style={{ width:'100%', height:620 }} />
                                <div style={{ position:'absolute', bottom:12, right:12, zIndex:500,
                                              background:'rgba(255,255,255,0.94)', border:`1px solid ${N.line2}`,
                                              borderRadius:8, padding:'9px 12px', fontSize:13.5, color:N.ink2,
                                              display:'flex', gap:14, alignItems:'center', flexWrap:'wrap' }}>
                                  {[['krap','#E08A2E'],['beperkt','#E8DE2A'],['ruim','#8CC63F']].map(([naam, kleur]) => (
                                    <span key={naam} style={{ display:'flex', alignItems:'center', gap:6 }}>
                                      <span style={{ width:12, height:12, borderRadius:3, background:kleur,
                                                     border:`1px solid ${N.line2}` }} />{naam}
                                    </span>
                                  ))}
                                  <span style={{ display:'flex', alignItems:'center', gap:6 }}>
                                    <span style={{ width:12, height:12, borderRadius:'50%', background:'#1F5C6B' }} />
                                    laadplein
                                  </span>
                                </div>
                              </div>
                              <div style={{ fontSize:14, color:N.ink2, marginTop:8, lineHeight:1.55 }}>
                                De kleur is de ruimte op het net volgens de netbeheerder, per statistische
                                sector. Het kleine getal is het aansluitvermogen van die sector, het grote
                                getal dat van de hele wijk. De stippen zijn de laadpleinen die op geschikt staan.
                              </div>
                              <div style={{ fontSize:14, color:N.ink3, marginTop:6, lineHeight:1.55 }}>
                                Bron: aansluitingskaart van de netbeheerder
                                {netcapUit?.netruimtePeildatum ? ` van ${netcapUit.netruimtePeildatum}` : ''},
                                die laat zien welke ruimte er in 2035 nog over is.
                              </div>
                            </>
                          : <div style={{ fontSize:14, color:N.ink3, padding:'24px 0' }}>
                              Geen wijkgrenzen beschikbaar voor deze gemeente.</div>}
                      </div>
                      <div>
                        {/* Dezelfde jaarkeuze als boven de kaart, zodat je hem ook
                            hier bij de hand hebt zonder omhoog te scrollen. */}
                        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12 }}>
                          <span style={{ fontSize:15, fontWeight:700 }}>Per wijk</span>
                          <span style={{ flex:1 }} />
                          <span style={{ fontSize:14, color:N.ink3 }}>Toon</span>
                          <select value={netcapWijkJaar} onChange={e => setNetcapWijkJaar(e.target.value)}
                            style={{ ...st.gInp, width:170, fontSize:14, padding:'5px 8px', fontWeight:400 }}>
                            <option value="">de hele periode</option>
                            {jaarLijst.map(j => <option key={j} value={j}>alleen {j}</option>)}
                          </select>
                        </div>
                        <div style={{ display:'grid', gridTemplateColumns:GRID_WIJK, gap:10,
                                      fontSize:13, color:N.ink3, paddingBottom:8, borderBottom:`1px solid ${N.line}` }}>
                          <div>Wijk</div>
                          <div style={{ textAlign:'right' }}>Palen</div>
                          <div style={{ textAlign:'right' }}>Op een laadplein</div>
                          <div>Ruimte op het net</div>
                          <div style={{ textAlign:'right' }}>Slim laden</div>
                          <div style={{ textAlign:'right' }}>Vermogen</div>
                        </div>
                        {wijkLijst.map(w => (
                          <div key={w.naam} style={{ display:'grid', gridTemplateColumns:GRID_WIJK,
                            gap:10, fontSize:15, padding:'9px 0', borderBottom:`1px solid ${N.line}` }}>
                            <div>{w.naam}</div>
                            <div style={{ textAlign:'right' }}>{fmtN(palen(w.rs))}</div>
                            <div style={{ textAlign:'right' }}>{fmtN(opPlein(w.rs))}</div>
                            {(() => {
                              const r = netruimte[wijkIdVan(w.naam)];
                              if (!r) return <div style={{ color:N.ink3 }}>nog niet bepaald</div>;
                              return (
                                <div>
                                  <span style={{ display:'inline-block', width:10, height:10, borderRadius:2,
                                    background: RUIMTE_KLEUR[r.ruimte] || N.line, marginRight:7 }} />
                                  {r.ruimte}
                                </div>
                              );
                            })()}
                            {/* Het percentage per wijk. Zodra je hier iets invult, volgt deze
                                wijk het stadspercentage niet meer, tot je hem terugzet. */}
                            <div style={{ textAlign:'right', whiteSpace:'nowrap' }}>
                              <input type="number" min={0} max={100} step={5}
                                value={slimVanWijk(w.naam)}
                                onChange={e => {
                                  const id = wijkIdVan(w.naam);
                                  const v = Math.min(100, Math.max(0, Number(e.target.value) || 0));
                                  setNetcapSlimWijk(o => ({ ...o, [id]: v }));
                                  setNetcapSlimHand(o => ({ ...o, [id]: true }));
                                }}
                                style={{ ...st.gInp, width:58, fontSize:14, padding:'3px 6px',
                                         textAlign:'right', fontWeight:400 }} />
                              <span style={{ fontSize:13, color:N.ink3, marginLeft:4 }}>%</span>
                              {netcapSlimHand[wijkIdVan(w.naam)] && (
                                <button
                                  title="terug naar het stadspercentage"
                                  onClick={() => {
                                    const id = wijkIdVan(w.naam);
                                    setNetcapSlimHand(o => { const n2 = { ...o }; delete n2[id]; return n2; });
                                    setNetcapSlimWijk(o => { const n2 = { ...o }; delete n2[id]; return n2; });
                                  }}
                                  style={{ marginLeft:6, fontSize:11, color:N.warn, background:'#FBF3E2',
                                           border:'1px solid #E4D2A8', borderRadius:20, padding:'1px 7px',
                                           fontFamily:'inherit', cursor:'pointer' }}>handmatig ×</button>
                              )}
                            </div>
                            <div style={{ textAlign:'right' }}>
                              {fmtN(som(w.rs, slimAan ? 'kvaSlimMax' : 'kvaMax'))} kVA
                              {slimAan && slimVanWijk(w.naam) > 0 && (
                                <div style={{ fontSize:12.5, color:N.ink3 }}>
                                  was {fmtN(som(w.rs,'kvaMax'))}
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                        <div style={{ display:'grid', gridTemplateColumns:GRID_WIJK,
                          gap:10, fontSize:15, fontWeight:700, padding:'10px 0' }}>
                          <div>{netcapWijkJaar === '' ? 'Samen' : `Samen ${netcapWijkJaar}`}</div>
                          <div style={{ textAlign:'right' }}>{fmtN(palen(wijkBron))}</div>
                          <div style={{ textAlign:'right' }}>{fmtN(opPlein(wijkBron))}</div>
                          <div />
                          <div />
                          <div style={{ textAlign:'right' }}>
                            {fmtN(som(wijkBron, slimAan ? 'kvaSlimMax' : 'kvaMax'))} kVA</div>
                        </div>
                        {Object.keys(netruimte).length ? (
                          <>
                            {krappe.length > 0 && (
                              <div style={{ fontSize:14, marginTop:14, lineHeight:1.55 }}>
                                In {fmtN(krappe.length)} van de {fmtN(wijkLijst.length)} wijken is het net krap.
                                De netbeheerder staat daar alleen flexibele aansluitingen toe.
                              </div>
                            )}

                          </>
                        ) : (
                          <div style={{ fontSize:14, color:N.ink3, marginTop:12, lineHeight:1.55 }}>
                            De ruimte op het net is voor deze gemeente niet te bepalen
                            {netcapUit?.netruimteReden ? `: ${netcapUit.netruimteReden}` : '.'}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          );
        })()}
      </div>

      {/* ── TABBLAD LAADPLEINEN, opbouw volgens mockup V7 (23 oktober 2026) ──
          Links het overzicht (opgave, beoordeling als legenda, lijst), in het
          midden de kaart, rechts een vaste kolom met Locatie, Filters en Lagen.
          Niets ligt over de kaart behalve twee knoppen en de zoomknoppen. */}
      <div style={{ ...st.nPaneF, display: tab === 'pleinen' ? 'flex' : 'none' }}>

        {/* ── Links: overzicht ── */}
        <div style={st.lpLinks}>
          <div style={st.lpOpgave}>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <Uitleg tekst={`Nodig: ${pleinAandeel}% van de ${fmtN(bijkomend)} bij te plaatsen laadpunten komt op een laadplein, ${pleinOmvang} laadpunten per plein. Vastgelegd: locaties op geschikt, vastgelegd voor ${year} of eerder of zonder jaar. Nog te kiezen: het verschil. Aandeel en omvang staan in Parameters.`}
                style={st.lpKopje}>Laadpleinen voor {year}</Uitleg>
              {/* Het venster Wijk impact (mockup V8, akkoord HL 27 oktober 2026). */}
              <button onClick={() => setWijkImpactOpen(true)}
                style={{ marginLeft:'auto', fontSize:13.5, fontWeight:600, padding:'4px 10px',
                         border:`1px solid ${N.accent2}`, borderRadius:6, background:N.paper, color:N.accent2,
                         cursor:'pointer', fontFamily:'inherit', whiteSpace:'nowrap' }}>Wijk impact</button>
            </div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:'2px 14px', fontSize:14.5, marginTop:4, color:N.ink }}>
              {[[pleinNodig, 'nodig'], [pleinVastgelegd, 'vastgelegd'], [pleinTeKiezen, 'nog te kiezen']].map(([n, w]) => (
                <span key={w} style={{ whiteSpace:'nowrap' }}><b style={st.lpGetal}>{fmtN(n)}</b> {w}</span>
              ))}
            </div>
            <div style={st.lpBalk}>
              <span style={{ display:'block', height:'100%', background:N.ok,
                width:`${pleinNodig > 0 ? Math.min(100, (pleinVastgelegd / pleinNodig) * 100) : 100}%` }}/>
            </div>
          </div>

          <div style={st.lpStatussen}>
            {PLEIN_STATUSSEN.map(([id, label]) => (
              <Uitleg key={id} ikoon={false} tekst="Klik om deze locaties op de kaart en in de lijst te tonen of te verbergen."
                style={st.lpStatus(pleinZicht[id])}>
                <span onClick={() => setPleinZicht(z => ({ ...z, [id]: !z[id] }))}
                  style={{ display:'inline-flex', alignItems:'center', gap:6 }}>
                  <span style={{ width:10, height:10, borderRadius:'50%', background:PLEIN_KLEUR[id] }}/>
                  {label} <b>{fmtN(pleinVoorStatus.filter(r => oordeelVan(r) === id).length)}</b>
                </span>
              </Uitleg>
            ))}
          </div>

          <div style={st.lpLijstKop}>
            <Uitleg tekst="Parkeerterreinen die aan de filters voldoen. De grootte van de bol op de kaart volgt het aantal vakken.">
              {fmtN(pleinGefilterd.length)} kandidaten · {fmtN(pleinVakkenTotaal)} vakken</Uitleg>
            <Uitleg tekst="Excel met alle kandidaten uit de lijst: kenmerken, samenstelling, beoordeling en netgegevens."
              style={{ marginLeft:'auto' }}>
              <button style={{ ...st.pLink, fontSize:13.5, textTransform:'none', letterSpacing:0 }} disabled={exportBezig} onClick={downloadPleinen}>
                {exportBezig ? 'Bezig…' : 'Downloaden'}</button>
            </Uitleg>
          </div>

          <div style={{ overflowY:'auto', flex:1 }}>
            {pleinGefilterd.slice(0, 300).map(r => {
              const status = oordeelVan(r);
              return (
                <div key={r.id} style={st.lpItem(r.id === pleinGekozen)}
                  onClick={() => { setPleinGekozen(r.id); setPleinRechts('loc');
                    if (r.lat != null) pleinMap.current?.panTo([r.lat, r.lng]); }}>
                  <span style={{ width:10, height:10, borderRadius:'50%', background:PLEIN_KLEUR[status],
                                 marginTop:6, flexShrink:0 }}/>
                  <div style={{ minWidth:0 }}>
                    <div style={{ fontSize:15, fontWeight:600, color:N.ink }}>{pleinNaamKort(r)}</div>
                    <div style={{ fontSize:13, color:N.ink3, lineHeight:1.4 }}>
                      {pleinVakkenTekst(r)} · {(r.laadpunten ?? 0) > 0 ? `${r.laadpunten} laadpunten nu` : 'nog geen laadpunt'}
                      {r.voorziening ? <><br/>{r.voorziening}</> : null}
                    </div>
                  </div>
                </div>
              );
            })}
            {pleinGefilterd.length > 300 && (
              <div style={{ padding:'9px 16px', fontSize:12.5, color:N.ink4 }}>
                Alleen de eerste 300 worden getoond. Zet het minimum aantal vakken hoger.
              </div>
            )}
            {pleinRijen !== null && !pleinGefilterd.length && !!pleinAlles.length && (
              <div style={{ padding:'12px 16px', fontSize:13.5, color:N.ink3 }}>
                Geen kandidaten met deze filters en beoordelingen.
              </div>
            )}
          </div>
        </div>

        {/* ── Midden: de kaart ── */}
        <div style={{ flex:1, minWidth:0, position:'relative' }}>
          <div style={{ position:'absolute', inset:0 }} ref={pleinMapRef}/>

          {pleinRijen === null ? (
            <div style={st.pMelding}>Parkeerterreinen laden…</div>
          ) : pleinFout ? (
            <div style={st.pMelding}>{pleinFout}</div>
          ) : !pleinAlles.length ? (
            <div style={st.pMelding}>
              {pleinOphaal && !pleinOphaal.gelukt
                ? <>Het ophalen van de parkeerterreinen voor {gemeente?.naam} is niet gelukt.<br/>
                    <span style={{ color:N.ink4, fontSize:12.5 }}>{pleinOphaal.melding}</span></>
                : <>Er zijn nog geen parkeerterreinen voor {gemeente?.naam}.</>}
              <br/>
              <button style={{ ...st.gBtn, width:'auto', margin:'12px auto 0', padding:'8px 16px' }}
                onClick={opnieuwOphalen} disabled={pleinBezig}>
                {pleinBezig ? 'Bezig met ophalen…' : 'Nu ophalen'}
              </button>
            </div>
          ) : null}

          <div style={st.lpKnoppen}>
            {[['flt','Filters'],['lag','Lagen']].map(([id, label]) => (
              <span key={id} style={st.lpKnop(pleinRechts === id)}
                onClick={() => setPleinRechts(r => r === id ? null : id)}>{label}</span>
            ))}
          </div>
        </div>

        {/* ── Rechts: Locatie, Filters, Lagen ── */}
        {pleinRechts && (
          <div style={st.lpRechts}>
            <div style={st.lpTabs}>
              {[['loc','Locatie'],['flt','Filters'],['lag','Lagen']].map(([id, label]) => (
                <span key={id} style={st.lpTab(pleinRechts === id)} onClick={() => setPleinRechts(id)}>{label}</span>
              ))}
              <span style={{ marginLeft:'auto', padding:'11px 14px', cursor:'pointer', color:N.ink3, fontSize:16 }}
                title="Sluiten" onClick={() => { setPleinRechts(null); setPleinGekozen(null); }}>✕</span>
            </div>
            <div style={{ overflowY:'auto', flex:1, padding:'14px 18px 22px' }}>

              {pleinRechts === 'loc' && (() => {
                const gekozen = pleinAlles.find(r => r.id === pleinGekozen);
                if (!gekozen) return (
                  <div style={{ fontSize:14, color:N.ink3, lineHeight:1.5, marginTop:6 }}>
                    Klik een locatie op de kaart of in de lijst. Hier staan dan de kenmerken en de
                    samenstelling van het laadplein.
                  </div>
                );
                const status = oordeelVan(gekozen);
                const opst = pleinOordeel[gekozen.id]?.opstelling || {};
                const v = vermogenVanOpstelling(opst);
                const kleurVan = { cabine:N.red, studie:N.warn, geen:N.ok, leeg:N.ink4 }[v.vlag];
                const zet = (type, waarde) => {
                  const n = Math.max(0, Math.min(999, Math.floor(Number(waarde) || 0)));
                  zetOpstelling(gekozen.id, { ...opst, [type]: n });
                };
                const deel = pleinOordeel[gekozen.id]?.deelwagens;
                const teveel = v.punten > 0 && (deel ?? 0) > v.punten;
                const b = pleinOordeel[gekozen.id]?.bestelwagens || {};
                const maxB = { ac: (Number(opst.ac) || 0) * PUNTEN_PER_PAAL, dc: (Number(opst.dc) || 0) * PUNTEN_PER_PAAL };
                const knop = (id, tekst, kleur) => (
                  <button key={id} onClick={() => zetOordeel(gekozen.id, status === id ? 'open' : id)}
                    style={{ flex:1, padding:'8px 0', fontSize:13.5, fontWeight:700, cursor:'pointer',
                             fontFamily:'inherit', borderRadius:7,
                             border:`1px solid ${status === id ? kleur : N.line2}`,
                             background: status === id ? kleur : N.paper,
                             color: status === id ? '#fff' : N.ink2 }}>{tekst}</button>
                );
                const rij = (label, uitleg, waarde) => (
                  <div style={st.lpRij}>
                    <Uitleg tekst={uitleg} style={{ color:N.ink3, whiteSpace:'nowrap' }}>{label}</Uitleg>
                    <b style={{ textAlign:'right' }}>{waarde}</b>
                  </div>
                );
                const veld = (waarde, onZet) => (
                  <input type="number" min={0} max={999} step={1} value={waarde ?? 0}
                    onChange={e => onZet(e.target.value)} style={st.lpVeld}/>
                );
                const fiche = pleinOordeel[gekozen.id]?.fiche;
                const ficheRijen = fiche?.rijen || [];
                const ficheVakken = ficheRijen.reduce((s2, x) => s2 + (x.aantal || 0), 0);
                return (
                  <div key={gekozen.id}>
                    <div style={{ fontSize:19, fontWeight:700, color:N.ink }}>{pleinNaamKort(gekozen)}</div>
                    <div style={{ fontSize:13.5, color:N.ink3, marginTop:2 }}>
                      {gekozen.soort === 'garage' || gekozen.soort === 'strook'
                        ? (gekozen.groep === 'openbaar' ? 'openbare ' : 'semipublieke ') +
                          (gekozen.soort === 'garage' ? 'parkeergarage' : 'parkeerstrook langs de straat')
                        : (gekozen.groep === 'openbaar' ? 'openbaar parkeerterrein' : 'semipubliek parkeerterrein')}
                    </div>

                    <div style={st.lpSectie}>
                      <div style={st.lpSectieKop}>Kenmerken</div>
                      {rij('Parkeervakken', 'Uit OpenStreetMap als het aantal daar staat. Anders geschat op 25 m² per vak.',
                        gekozen.vakken == null ? 'onbekend' : <>{gekozen.vakken}{' '}
                          <span style={{ color:N.ink4, fontWeight:400, fontSize:13 }}>
                            {gekozen.capBron === 'ja' ? '(uit de bron)' : '(geschat)'}</span></>)}
                      {rij('Laadpunten nu', 'Laadpunten die nu al op dit terrein staan, volgens de gegevens van MOW.',
                        (gekozen.laadpunten ?? 0) > 0 ? gekozen.laadpunten : 'geen')}
                      {rij('Past een plein van', 'De omvang van een laadplein, ingesteld in Parameters.', `${pleinOmvang} laadpunten`)}
                      {gekozen.voorziening && rij('Voorziening',
                        'De dichtstbijzijnde voorziening waar bezoekers voor parkeren, hemelsbreed gemeten vanaf het midden van het terrein.',
                        `${gekozen.voorziening}${gekozen.voorzieningM != null ? `, ${fmtN(gekozen.voorzieningM)} m` : ''}`)}
                    </div>

                    {netAfstPlein[String(gekozen.id)] && (
                      <div style={st.lpSectie}>
                        <Uitleg tekst="Hemelsbrede afstand vanaf het midden van het terrein, volgens de netgegevens van Fluvius. Zegt niets over de vrije capaciteit op het net."
                          style={st.lpSectieKop}>Netgegevens</Uitleg>
                        <div style={{ fontSize:14, color:N.ink2, lineHeight:1.5 }}>
                          {netRegelPlein(netAfstPlein[String(gekozen.id)], v.vlag === 'cabine')}</div>
                      </div>
                    )}
                    {/* Het blok Plan van Fluvius staat sinds 27 oktober 2026 in
                        het venster Wijk impact, per plein (mockup V8). */}

                    <div style={st.lpSectie}>
                      <Uitleg tekst="Het aantal palen per soort. Elke paal heeft twee laadpunten." style={st.lpSectieKop}>
                        Laadplein samenstellen</Uitleg>
                      {Object.entries(PAAL_VERMOGEN).map(([type, g]) => (
                        <div key={type} style={st.lpRij}>
                          <span style={{ color:N.ink }}>{g.naam} <span style={{ color:N.ink4, fontSize:13 }}>· {g.aansluiting}</span></span>
                          {veld(opst[type], w => zet(type, w))}
                        </div>
                      ))}
                      <div style={{ ...st.lpRij, borderTop:`1px dashed ${N.line}`, marginTop:6, paddingTop:7 }}>
                        <span style={{ color:N.ink3 }}>Palen en laadpunten</span><b>{v.palen} · {v.punten}</b></div>
                      {rij('Aansluitvermogen',
                        `AC 24,2 kVA per paal, DC 55,4 kVA, HPC 150 tot 250 kVA. Onder ${KVA_STUDIE} kVA laagspanning. Tussen ${KVA_STUDIE} en ${KVA_CABINE} kVA beslist Fluvius na een studie: laagspanning of middenspanning. Boven ${KVA_CABINE} kVA een eigen cabine op middenspanning. Peildatum ${VERMOGEN_PEILDATUM}.`,
                        `${v.bandbreedte ? `${fmtN(v.kvaMin)} tot ${fmtN(v.kvaMax)}` : fmtN(v.kvaMax)} kVA`)}
                      <div style={{ fontSize:13, color:kleurVan, marginTop:3, lineHeight:1.45 }}>{vermogenMelding(v.vlag)}</div>

                      {/* Eis 5 van MOW. Dit veld telt LAADPUNTEN, de velden
                          hierboven tellen PALEN. */}
                      <div style={{ ...st.lpRij, marginTop:9 }}>
                        <Uitleg tekst="Laadpunten die voor deelwagens worden voorbehouden. Ze tellen mee binnen de palen hierboven."
                          style={{ color:N.ink }}>Laadpunten deelwagens</Uitleg>
                        {veld(deel, w => zetDeelwagens(gekozen.id, Math.max(0, Math.min(999, Math.floor(Number(w) || 0)))))}
                      </div>
                      {teveel && <div style={{ fontSize:12.5, color:N.red, lineHeight:1.45 }}>
                        Meer dan de {v.punten} laadpunten van deze locatie.</div>}
                      {[['ac','AC'],['dc','DC']].map(([soort, label]) => (
                        <React.Fragment key={soort}>
                          <div style={st.lpRij}>
                            <Uitleg tekst="Laadpunten voor bestelwagens, AC en DC apart. Ze tellen mee binnen de palen hierboven."
                              style={{ color:N.ink }}>Laadpunten bestelwagens, {label}</Uitleg>
                            {veld(b[soort], w => zetBestelwagens(gekozen.id, soort, Math.max(0, Math.min(999, Math.floor(Number(w) || 0)))))}
                          </div>
                          {(b[soort] || 0) > maxB[soort] && <div style={{ fontSize:12.5, color:N.red, lineHeight:1.45 }}>
                            Meer dan de {maxB[soort]} {label}-laadpunten van deze locatie.</div>}
                        </React.Fragment>
                      ))}
                    </div>

                    <div style={st.lpSectie}>
                      <Uitleg tekst="Sneltoetsen: G geschikt, N niet geschikt, L later beslissen, O ongedaan maken."
                        style={st.lpSectieKop}>Beoordeling</Uitleg>
                      <div style={{ display:'flex', gap:6 }}>
                        {knop('geschikt','Geschikt',N.ok)}{knop('niet','Niet',N.ink4)}{knop('later','Later',N.warn)}
                      </div>
                      {status === 'geschikt' && (
                        <div style={{ ...st.lpRij, marginTop:10 }}>
                          <Uitleg tekst="Het peiljaar waarvoor deze locatie is vastgelegd. Vanaf dat jaar telt ze mee als vastgelegd."
                            style={{ color:N.ink }}>Vastgelegd voor</Uitleg>
                          <select value={pleinOordeel[gekozen.id]?.jaar ?? ''}
                            onChange={(e) => zetPleinJaar(gekozen.id, e.target.value === '' ? null : Number(e.target.value))}
                            style={{ ...st.gInp, width:170, fontSize:14, padding:'5px 7px', fontWeight:400 }}>
                            <option value="">nog niet vastgelegd</option>
                            {/* Vanaf 2027, het eerste planjaar. Een eerder bewaard
                                jaar blijft zichtbaar, anders zou het leeg lijken. */}
                            {YEARS.filter(j => j >= 2027 || j === pleinOordeel[gekozen.id]?.jaar)
                              .map(j => <option key={j} value={j}>{j}</option>)}
                          </select>
                        </div>
                      )}
                      <input style={{ ...st.gInp, fontSize:14, fontWeight:400, marginTop:9, width:'100%', boxSizing:'border-box' }}
                        placeholder="Notitie, bijvoorbeeld: eerst herinrichting afwachten"
                        defaultValue={pleinOordeel[gekozen.id]?.notitie || ''}
                        key={`n${gekozen.id}`}
                        onBlur={e => zetOordeel(gekozen.id, status || 'later', e.target.value)}/>
                    </div>

                    <div style={{ display:'flex', gap:16, flexWrap:'wrap', marginTop:12, fontSize:14 }}>
                      {status === 'geschikt' && (
                        <Uitleg tekst="Opent het fiche van deze locatie, met luchtfoto en indeling van de parkeervakken.">
                          <span style={{ color:N.accent, fontWeight:600, cursor:'pointer' }} onClick={() => openFiche(gekozen)}>
                            Technisch fiche{ficheRijen.length ? ` · ${fmtN(ficheVakken)} ${ficheVakken === 1 ? 'vak' : 'vakken'}` : ''}</span>
                        </Uitleg>
                      )}
                      <a href={`https://www.google.com/maps/search/?api=1&query=${gekozen.lat},${gekozen.lng}`}
                         target="_blank" rel="noreferrer" style={{ color:N.accent, fontWeight:600 }}>Google Maps</a>
                      <a href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${gekozen.lat},${gekozen.lng}`}
                         target="_blank" rel="noreferrer" style={{ color:N.accent, fontWeight:600 }}>Street View</a>
                    </div>
                  </div>
                );
              })()}

              {pleinRechts === 'flt' && (
                <div>
                  <Uitleg tekst="Kleinere terreinen vallen weg uit de lijst en van de kaart." style={st.lpGroep}>
                    Minimaal aantal parkeervakken</Uitleg>
                  <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <input type="range" style={{ ...st.sl, flex:1 }} min={6} max={100} value={pleinMinVak}
                      onChange={e => setPleinMinVak(Number(e.target.value))}/>
                    <b style={{ width:36, textAlign:'right' }}>{pleinMinVak}</b>
                  </div>
                  <Uitleg tekst="Openbaar: vrij toegankelijk volgens OpenStreetMap. Semipubliek: winkel- of bedrijfsparking."
                    style={st.lpGroep}>Parkeervakken</Uitleg>
                  <div style={{ display:'flex', gap:6 }}>
                    {[['openbaar','Openbaar'],['semipubliek','Semipubliek']].map(([id, label]) => (
                      <button key={id} style={st.pKnop(pleinToegang.includes(id))}
                        onClick={() => setPleinToegang(h => h.includes(id) ? h.filter(x => x !== id) : [...h, id])}>
                        {label}</button>
                    ))}
                  </div>
                  <Uitleg tekst="Alleen terreinen binnen de gekozen afstand van een gekozen soort voorziening."
                    style={st.lpGroep}>Voorziening in de buurt</Uitleg>
                  <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                    {PLEIN_SOORTEN.map(([id, label]) => (
                      <button key={id} style={st.pKnop(pleinSoorten.includes(id))}
                        onClick={() => setPleinSoorten(h => h.includes(id) ? h.filter(x => x !== id) : [...h, id])}>
                        {label}</button>
                    ))}
                  </div>
                  <div style={{ ...st.pRij, marginTop:8 }}><span>Binnen</span><span style={st.pWaarde}>{pleinNabij} m</span></div>
                  <input type="range" style={st.sl} min={50} max={800} step={25} value={pleinNabij}
                    onChange={e => setPleinNabij(Number(e.target.value))}/>
                  <div style={st.gNoot}>Zonder keuze telt de afstand niet mee.</div>
                  <div style={{ ...st.pRij, marginTop:14 }}>
                    <span>Alleen parkings met een laadpunt</span>
                    <button onClick={() => setPleinMetLp(!pleinMetLp)} style={st.pSchakel(pleinMetLp)}>
                      <span style={st.pSchakelBol(pleinMetLp)}/>
                    </button>
                  </div>
                  <div style={{ borderTop:`1px solid ${N.line}`, marginTop:16, paddingTop:12, fontSize:13, color:N.ink3, lineHeight:1.5 }}>
                    Parkeerterreinen uit OpenStreetMap
                    {pleinOphaal?.wanneer
                      ? `, opgehaald op ${new Date(pleinOphaal.wanneer).toLocaleDateString('nl-BE')}` +
                        (pleinOphaal.gelukt ? '.' : '. De laatste poging is mislukt.')
                      : ', nog niet opgehaald.'}
                    {' '}
                    <button style={{ ...st.pLink, fontSize:13 }} onClick={opnieuwOphalen} disabled={pleinBezig}>
                      {pleinBezig ? 'Bezig met ophalen…' : 'Opnieuw ophalen'}</button>
                    {pleinFout && <div style={{ fontSize:12.5, color:N.red, marginTop:6 }}>{pleinFout}</div>}
                  </div>
                </div>
              )}

              {pleinRechts === 'lag' && (
                <div>
                  <div style={{ ...st.lpGroep, marginTop:0 }}>Kaart</div>
                  {[['Luchtfoto', 'Luchtfoto van Digitaal Vlaanderen.', pleinLucht, setPleinLucht],
                    ['Bestaande laadpunten', 'Publieke en semipublieke laadpunten volgens de gegevens van MOW.', pleinPunten, setPleinPunten]]
                    .map(([label, uitleg, aan, zet]) => (
                    <label key={label} style={{ display:'flex', alignItems:'center', gap:8, padding:'3px 0', fontSize:14, cursor:'pointer' }}>
                      <input type="checkbox" checked={aan} onChange={e => zet(e.target.checked)}/>
                      <Uitleg tekst={uitleg}>{label}</Uitleg>
                    </label>
                  ))}
                  <StroomnetUitklap gis={gisNet} zicht={pleinNetZicht} onZicht={setPleinNetZicht} vast />
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <div style={{ ...st.nPane, display: tab === 'export' ? 'block' : 'none' }}>

        <div style={st.eGrid}>
          {[
            { id:'plan', naam:'Strategisch Laadplan', formaat:'DOCX',
              icoon:<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                       <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></>,
              punten:['Titelpagina en inhoudsopgave met paginanummers',
                      'Samenvatting, aanleiding en huidige situatie',
                      'Prognose per wijk en spreiding per jaar',
                      'Stadskaart en een kaart per wijk',
                      'Voorziene locaties met coördinaten en aantal palen',
                      'Investering, verantwoording bij de eisen, bronnen en aannames'],
              knoppen:[['Downloaden', exporteerLaadplan, true]] },
            { id:'dekking', naam:'Dekking en plaatsing per jaar', formaat:'XLSX',
              icoon:<><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/></>,
              punten:['Per jaar: erbij, op een laadplein, tweede paal, nieuwe plek',
                      'Per wijk en per sector, met de jaren als kolommen',
                      'Elke plek apart, met wijk, sector en straat',
                      'Dekking binnen 250 meter, nu en per jaar',
                      'Bestaande laadpunten per sector'],
              knoppen:[['Downloaden', exporteerDekkingPlaatsing, true]] },
            { id:'prognose', naam:'Prognose per wijk en per jaar', formaat:'XLSX',
              icoon:<><path d="M3 3v18h18"/><path d="M18 17V9M13 17V5M8 17v-3"/></>,
              punten:['Per wijk per jaar: nodig, aanwezig, bij te plaatsen',
                      'Verdeling over normaal, snel en ultrasnel laden',
                      'Laadvraag in MWh en investering per jaar',
                      'Filter op elke kolom',
                      'Tweede tabblad met de betekenis van elke kolom'],
              knoppen:[['Downloaden', exporteerPrognose, true]] },
            { id:'locaties', naam:'Voorziene locaties', formaat:'GEOJSON · KML',
              icoon:<><path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/><path d="M8 2v16M16 6v16"/></>,
              punten:['Eén punt per aangewezen locatie',
                      'Naam, aantal laadpalen en laadpunten, parkeervakken',
                      'Dichtstbijzijnde voorziening met afstand',
                      'Beoordeling en notitie',
                      'Coördinaten in WGS84'],
              knoppen:[['GeoJSON', () => exporteerLocaties('geojson'), true],
                       ['KML', () => exporteerLocaties('kml'), false]] },
            { id:'kaarten', naam:'Kaarten', formaat:'PNG in een ZIP',
              icoon:<><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
                       <path d="M21 15l-5-5L5 21"/></>,
              punten:['Stadskaart met de behoefte per wijk',
                      'Eén kaart per wijk met genummerde locaties',
                      'Legende, schaalbalk en noordpijl',
                      'Zelfde kaarten als in het Word-document'],
              knoppen:[['Downloaden', exporteerKaarten, true]] },
          ].map(k => (
            <div key={k.id} style={st.eKaart}>
              <div style={st.eKop}>
                <span style={st.eIcoon}>
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    {k.icoon}
                  </svg>
                </span>
                <span>
                  <span style={st.eNaam}>{k.naam}</span><br/>
                  <span style={st.eFmt}>{k.formaat}</span>
                </span>
              </div>
              <ul style={st.eLijst}>
                {k.punten.map(p => <li key={p} style={{ marginBottom:4 }}>{p}</li>)}
              </ul>
              <div style={{ display:'flex', gap:9, flexWrap:'wrap' }}>
                {k.knoppen.map(([label, actie, vol]) => {
                  // Alleen de aangeklikte knop toont Bezig; de andere worden
                  // wel uitgeschakeld maar houden hun eigen opschrift.
                  const sleutel = `${k.id}|${label}`;
                  return (
                    <button key={label} style={st.eBtn(vol)} disabled={exportBezig}
                      onClick={async () => {
                        setExportKnop(sleutel);
                        try { await actie(); } finally { setExportKnop(null); }
                      }}>
                      {exportKnop === sleutel ? 'Bezig…' : label}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* De Highlights teaser. Alleen zichtbaar zolang hij in de
            beheeromgeving is aangezet; daarna verdwijnt hij vanzelf. */}
        {teaserAan && (
          <div style={{ ...st.melding, borderLeftColor:N.accent2, marginTop:16,
                        display:'flex', alignItems:'center', gap:14, flexWrap:'wrap' }}>
            <div style={{ flex:'1 1 340px' }}>
              <div style={st.meldingT}>Highlights teaser</div>
              <div style={st.meldingS}>
                Een korte presentatie voor het college met de groei tot het gekozen jaar.
                Zonder aantallen, bedragen of wijknamen.
              </div>
            </div>
            <select value={teaserJaar} onChange={e => setTeaserJaar(+e.target.value)}
                    style={{ ...st.gInp, width:110 }}>
              {tijdreeks.map(t => <option key={t.jaar} value={t.jaar}>{t.jaar}</option>)}
            </select>
            <button style={st.eBtn(true)} disabled={teaserBezig} onClick={maakTeaser}>
              {teaserBezig ? 'Bezig…' : 'Downloaden'}
            </button>
          </div>
        )}

        {exportFout && (
          <div style={{ ...st.melding, borderLeftColor:N.red, marginTop:16 }}>
            <div style={st.meldingT}>Het is niet gelukt</div>
            <div style={st.meldingS}>{exportFout}</div>
          </div>
        )}

        {/* ── Historie ─────────────────────────────────────────────── */}
        <div style={st.eHist}>
          <div style={st.vHdr}>
            <div style={{ fontSize:16, fontWeight:700, color:N.ink }}>Eerder opgeleverd</div>
          </div>
          {!historie.length ? (
            <div style={st.mUitleg}>Er is voor {gemeente?.naam} nog niets opgeleverd.</div>
          ) : (
            <div style={{ overflowX:'auto' }}>
              <table style={st.mTbl}>
                <thead>
                  <tr>
                    <th style={st.mTh(false)}>Versie</th>
                    <th style={st.mTh(false)}>Bestand</th>
                    <th style={st.mTh(false)}>Gemaakt op</th>
                    <th style={st.mTh(true)}>Peiljaar</th>
                    <th style={st.mTh(true)}>Bij te plaatsen</th>
                    <th style={st.mTh(true)}>Locaties</th>
                    <th style={st.mTh(true)}/>
                  </tr>
                </thead>
                <tbody>
                  {historie.map((h, i) => (
                    <tr key={h.id}>
                      <td style={st.mTd(false)}><span style={st.eVersie(i === 0)}>{h.versie}</span></td>
                      <td style={st.mTd(false)}>{h.bestandsnaam}</td>
                      <td style={st.mTd(false)}>
                        {new Date(h.gemaakt_op).toLocaleDateString('nl-BE', { day:'numeric', month:'long', year:'numeric' })}</td>
                      <td style={st.mTd(true)}>{h.meta?.peiljaar ?? '—'}</td>
                      <td style={st.mTd(true)}>{h.meta?.bijkomend != null ? fmtN(h.meta.bijkomend) : '—'}</td>
                      <td style={st.mTd(true)}>{h.meta?.locaties ?? '—'}</td>
                      <td style={st.mTd(true)}>
                        <button style={st.pLink} onClick={() => downloadHistorie(h.id).catch(e => setExportFout(e.message))}>
                          Downloaden
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

    {/* ── Technisch fiche per locatie ─────────────────────────────────── */}
    {ficheOpen && (() => {
      const locatie = (pleinAlles || []).find(r => r.id === ficheOpen);
      const straat = locatie ? straatBij(locatie.lat, locatie.lng) : '';
      const noemer = straat || locatie?.naam || 'parkeerterrein';
      const rijen = ficheWerk?.rijen || [];
      const rij = rijen[ficheRijNr] || null;
      const maat = rij ? maatVanRij(rij) : null;
      const vakkenTotaal = rijen.reduce((n, r) => n + (r.aantal || 0), 0);
      const paalTelling = telPalen(ficheWerk?.palen);
      // De opstelling die bij deze locatie is ingevuld, in palen per soort.
      // Wijkt de tekening daarvan af, dan zegt het scherm dat, want die twee
      // horen hetzelfde te vertellen.
      const opstelling = pleinOordeel[ficheOpen]?.opstelling || {};
      const opTelling = { ac: opstelling.ac || 0, dc: opstelling.dc || 0, hpc: opstelling.hpc || 0 };
      const opTotaal = opTelling.ac + opTelling.dc + opTelling.hpc;
      const paalAfwijking = (opTotaal > 0 || (ficheWerk?.palen?.length || 0) > 0)
        && (opTelling.ac !== paalTelling.ac || opTelling.dc !== paalTelling.dc
            || opTelling.hpc !== paalTelling.hpc)
        ? palenTekst(opTelling) : null;
      // Vakken voor deelwagens en bestelwagens tegenover de laadpunten die bij
      // de locatie zijn ingevuld. Zelfde gedachte als bij de palen.
      const aangewezenF = new Set(ficheWerk?.vakken || []);
      const telDoelF = (doel) => Object.entries(ficheWerk?.doelen || {})
        .filter(([sleutel, d]) => d === doel && aangewezenF.has(sleutel)).length;
      const vakDeel = telDoelF('deel'), vakBestel = telDoelF('bestel');
      const locDeel = pleinOordeel[ficheOpen]?.deelwagens || 0;
      const locBestelO = pleinOordeel[ficheOpen]?.bestelwagens || {};
      const locBestel = (locBestelO.ac || 0) + (locBestelO.dc || 0);
      const meervoudVak = (x) => `${fmtN(x)} ${x === 1 ? 'vak' : 'vakken'}`;
      const doelAfwijkingen = [
        ...((locDeel || vakDeel) && locDeel !== vakDeel
          ? [`Dit wijkt af van de locatie: daar staan ${fmtN(locDeel)} laadpunten voor deelwagens, hier ${meervoudVak(vakDeel)}.`] : []),
        ...((locBestel || vakBestel) && locBestel !== vakBestel
          ? [`Dit wijkt af van de locatie: daar staan ${fmtN(locBestel)} laadpunten voor bestelwagens, hier ${meervoudVak(vakBestel)}.`] : []),
      ];
      return (
        <div style={st.fScherm} onClick={e => e.target === e.currentTarget && sluitFiche()}>
          <div style={st.fVenster}>
            <div style={st.fKop}>
              <div style={{ display:'flex', alignItems:'center', gap:22, minWidth:0 }}>
                <div style={{ fontSize:15, fontWeight:800, color:N.ink }}>
                  {gemeente?.naam}, Technisch fiche {noemer}
                </div>
                <div style={{ display:'flex', gap:4 }}>
                  {[['A', 'A. Inrichting'], ['B', 'B. Aansluiting op het net']].map(([id, label]) => (
                    <button key={id} style={st.fDeel(ficheDeel === id)} onClick={() => setFicheDeel(id)}>{label}</button>
                  ))}
                </div>
              </div>
              <span style={{ cursor:'pointer', color:N.ink4, fontSize:20 }}
                    onClick={sluitFiche}>×</span>
            </div>
            <div style={{ display:'flex', flex:1, minHeight:0 }}>
              <div style={{ flex:1, position:'relative', minWidth:0 }}>
                <div ref={ficheMapRef} style={{ position:'absolute', inset:0 }}/>
                {/* Het stroomnet als uitklapmenu rechtsboven, binnen één vak,
                    zodat er nooit twee legenda's over de kaart liggen. */}
                {gisNet?.aanwezig && (
                  <div style={{ position:'absolute', right:10, top:10, zIndex:500, background:N.paper,
                                border:`1px solid ${N.line2}`, borderRadius:8, padding:'8px 12px',
                                maxWidth:300, maxHeight:'calc(100% - 70px)', overflowY:'auto',
                                boxShadow:'0 2px 10px rgba(18,22,28,.14)' }}>
                    <StroomnetUitklap gis={gisNet} zicht={ficheNetZicht} onZicht={setFicheNetZicht} los
                      bestaand={existingPalen.length} />
                  </div>
                )}
                {/* Legenda van de vakken, linksonder op de kaart. */}
                <div style={{ position:'absolute', left:10, bottom:10, zIndex:500, background:N.paper,
                              border:`1px solid ${N.line2}`, borderRadius:7, padding:'6px 10px',
                              display:'flex', gap:12, flexWrap:'wrap', fontSize:12.5, color:N.ink2 }}>
                  {ficheDeel === 'B' ? (<>
                    <span style={{ display:'flex', alignItems:'center', gap:5 }}>
                      <span style={{ width:12, height:12, background:N.accent }}/>dit laadplein
                    </span>
                    <span style={{ display:'flex', alignItems:'center', gap:5 }}>
                      <span style={{ width:20, height:0, borderTop:`4px dashed ${AANSLUIT_KLEUR}` }}/>aansluiting op het net
                    </span>
                  </>) : (<>
                  {[['laden', 'laden'], ['deel', 'D deelwagen'], ['bestel', 'B bestelwagen']].map(([k, t]) => (
                    <span key={k} style={{ display:'flex', alignItems:'center', gap:5 }}>
                      <span style={{ width:13, height:13, borderRadius:3, background:VAK_KLEUR[k] }}/>{t}
                    </span>
                  ))}
                  <span style={{ display:'flex', alignItems:'center', gap:5 }}>
                    <span style={{ width:13, height:13, borderRadius:3, background:'rgba(45,127,146,.25)',
                                   border:`1px solid ${N.accent2}` }}/>vrij
                  </span>
                  {/* De laadpalen, als vierkantje met witte rand zoals op de kaart. */}
                  {[['ac', 'AC'], ['dc', 'DC'], ['hpc', 'HPC']].map(([k, t]) => (
                    <span key={k} style={{ display:'flex', alignItems:'center', gap:5 }}>
                      <span style={{ width:13, height:13, boxSizing:'border-box', borderRadius:3,
                                     background:PAAL_KLEUR[k], border:'2px solid #fff',
                                     boxShadow:'0 0 0 1px rgba(18,22,28,.35)' }}/>{t}
                    </span>
                  ))}
                  </>)}
                  {existingPalen.length > 0 && ficheNetZicht.best !== false && (
                    <span style={{ display:'flex', alignItems:'center', gap:3 }}>
                      <BestaandTeken/>bestaand laadpunt
                    </span>
                  )}
                </div>
              </div>
              <div style={st.fZij}>
                {ficheDeel === 'B' && (() => {
                  const vt = vermogenVanOpstelling(paalTelling);
                  const kleurVlag = { cabine:N.red, studie:N.warn, geen:N.ok, leeg:N.ink4 }[vt.vlag];
                  const metNet = !!gisNet?.aanwezig;
                  // Het planbestand van Fluvius kent geen verdeelkasten, middenspanningskabels
                  // en MS-cabines van bedrijven; die keuzes vallen dan weg.
                  const plan = gisNet?.samenvatting?.soort === 'plan';
                  const keuzes = !metNet ? AANSLUIT_SOORTEN.filter(([k]) => k === 'vrij')
                    : plan ? AANSLUIT_SOORTEN.filter(([k]) => !['vk', 'ms', 'kc'].includes(k)) : AANSLUIT_SOORTEN;
                  return (<>
                    <div style={st.fVeldKop}>Aansluitvermogen</div>
                    <div style={st.fVeldRij}>
                      <span style={st.fVeldLabel}>Laadpalen</span>
                      <b style={{ fontSize:13.5, textAlign:'right' }}>{(ficheWerk?.palen?.length || 0) ? palenTekst(paalTelling) : 'nog geen palen'}</b>
                    </div>
                    {vt.palen > 0 && (
                      <div style={st.fVeldRij}>
                        <span style={st.fVeldLabel}>Totaal</span>
                        <b style={{ fontSize:13.5 }}>{vt.bandbreedte ? `${fmtN(vt.kvaMin)} tot ${fmtN(vt.kvaMax)}` : fmtN(vt.kvaMax)} kVA</b>
                      </div>
                    )}
                    {vt.vlag !== 'leeg' && <div style={st.fMeld(kleurVlag)}>{vermogenMelding(vt.vlag)}</div>}

                    <div style={{ ...st.fVeldKop, marginTop:16 }}>Aansluiten op</div>
                    {!metNet && (
                      <div style={{ fontSize:13, color:N.ink3, lineHeight:1.5, marginBottom:8 }}>
                        Voor deze gemeente is geen netbestand van Fluvius ingelezen. Een punt op de kaart aanwijzen kan wel.
                      </div>
                    )}
                    {keuzes.map(([k, naam]) => {
                      const uit = k === 'ms' && !ficheMsMag;
                      const p = k === 'vrij' ? null : ficheNetPunten[k];
                      const gekozen = ficheAansluiting?.soort === k;
                      const extra = uit ? 'alleen boven 25 kVA'
                        : k === 'vrij' ? (gekozen && !ficheAansluiting.leeg ? `${fmtN(ficheAansluiting.d)} m` : 'klik op de kaart')
                        : p ? `${fmtN(p.d)} m` : 'niet gevonden';
                      return (
                        <button key={k} style={st.fKeus(gekozen, uit || (k !== 'vrij' && !p))}
                                onClick={() => { if (!uit && (k === 'vrij' || p)) kiesAansluiting(k); }}>
                          <span style={{ width:24, display:'flex', justifyContent:'center', flexShrink:0 }}><AansluitTeken soort={k}/></span>
                          <span style={{ flex:1 }}>{naam}</span>
                          <span style={{ fontSize:12.5, color:N.ink3, fontWeight:400, textAlign:'right',
                                         whiteSpace: uit ? 'normal' : 'nowrap', maxWidth:92 }}>{extra}</span>
                        </button>
                      );
                    })}
                    <div style={{ fontSize:12.5, color:N.ink3, lineHeight:1.5, marginTop:4 }}>
                      De lijn loopt naar het dichtstbijzijnde punt van die soort, of naar het punt dat op de kaart is aangeklikt. Hemelsbreed gemeten; de kabel volgt in werkelijkheid de straat.
                    </div>
                    <div style={st.fKader}>
                      Schets ter illustratie en voor overleg. Waar en hoe de aansluiting komt, bepaalt de netbeheerder na een studie. Aan deze schets kunnen geen rechten worden ontleend.
                    </div>
                  </>);
                })()}
                {ficheDeel === 'A' && (<>
                <div style={st.fModus}>
                  {[['rijen','Rijen tekenen'],['vakken','Vakken aanwijzen'],
                    ['palen','Palen plaatsen']].map(([id, label]) => (
                    <button key={id} style={st.fModusK(ficheModus === id)}
                            onClick={() => setFicheModus(id)}>{label}</button>
                  ))}
                </div>

                {ficheModus === 'rijen' && (<>
                  <div style={st.fVeldKop}>Rijen parkeervakken</div>
                  {!rijen.length && (
                    <div style={{ fontSize:13.5, color:N.ink3, lineHeight:1.6, marginBottom:10 }}>
                      Er is nog niets ingetekend op deze locatie.
                    </div>
                  )}
                  {rijen.map((r, i) => (
                    <div key={i} style={st.fRijRegel(i === ficheRijNr)}
                         onClick={() => setFicheRijNr(i)}>
                      Rij {i + 1} · {r.aantal} {r.aantal === 1 ? 'vak' : 'vakken'}
                    </div>
                  ))}
                  <div style={{ display:'flex', gap:8, margin:'10px 0 4px' }}>
                    <button style={st.fKnop(false)} onClick={rijToevoegen}>Rij toevoegen</button>
                    {!!rijen[ficheRijNr] && (
                      <button style={st.fKnop(false)}
                              onClick={() => rijVerwijderen(ficheRijNr)}>Rij verwijderen</button>
                    )}
                  </div>
                  {!!rij && (<>
                    <div style={{ fontSize:13, color:N.ink3, lineHeight:1.6, margin:'10px 0 10px' }}>
                      Sleep de rij naar de parkeervakken. Aan de randen maak je hem
                      langer of dieper, met de greep erboven draai je hem.
                    </div>
                    {[['aantal', 'Aantal vakken', rij.aantal, 1, 1],
                      ['breedte', 'Breedte in meter', maat.breedte.toFixed(1), 0.1, 0.1],
                      ['diepte', 'Diepte in meter', maat.diepte.toFixed(1), 0.1, 0.1],
                      ['schuinte', 'Schuinte in graden', rij.schuinte ?? 0, 5, -60],
                    ].map(([veld, label, waarde, stap, laagste]) => (
                      <div key={veld} style={st.fVeldRij}>
                        <span style={st.fVeldLabel}>{label}</span>
                        <input type="number" step={stap} min={laagste}
                          max={veld === 'schuinte' ? 60 : undefined} value={waarde}
                          onChange={e => zetFicheVeld(veld, Number(e.target.value))}
                          style={{ ...st.gInp, width:86, fontSize:13.5, padding:'5px 8px',
                                   textAlign:'right', fontVariantNumeric:'tabular-nums' }}/>
                      </div>
                    ))}
                    <div style={{ fontSize:13, color:N.ink3, marginTop:2, lineHeight:1.6 }}>
                      0 is haaks parkeren. Een minwaarde kantelt de vakken de andere kant op.
                    </div>
                    <div style={{ fontSize:13, color:N.ink3, marginTop:10, lineHeight:1.6 }}>
                      De rij is {meterTekst(maat.lengte)} meter lang.
                    </div>
                  </>)}
                </>)}

                {ficheModus === 'vakken' && (<>
                  <div style={st.fVeldKop}>Vakken aanwijzen</div>
                  <div style={{ fontSize:13, color:N.ink3, lineHeight:1.6 }}>
                    Kies waarvoor een vak wordt voorbehouden en klik het vak aan. Nog een
                    keer klikken maakt het weer vrij.
                  </div>
                  <div style={{ display:'flex', flexDirection:'column', gap:6, marginTop:10 }}>
                    {VAK_DOELEN.map(([id, label]) => (
                      <button key={id} style={{ ...st.fKnop(ficheDoel === id),
                                display:'flex', alignItems:'center', gap:8 }}
                              onClick={() => setFicheDoel(id)}>
                        <span style={{ width:14, height:14, borderRadius:3, background:VAK_KLEUR[id],
                                       border: ficheDoel === id ? '1px solid #fff' : 'none', flexShrink:0 }}/>
                        {label}
                      </button>
                    ))}
                  </div>
                  <div style={{ fontSize:13.5, color:N.ink2, fontWeight:600, marginTop:10, lineHeight:1.5 }}>
                    {fmtN(ficheWerk?.vakken?.length || 0)} van de {fmtN(vakkenTotaal)} vakken aangewezen
                    {(vakDeel > 0 || vakBestel > 0) &&
                      `, waarvan ${fmtN(vakDeel)} voor deelwagens en ${fmtN(vakBestel)} voor bestelwagens`}
                  </div>
                  {doelAfwijkingen.map(t => (
                    <div key={t} style={{ fontSize:13, color:N.warn, marginTop:8, lineHeight:1.6 }}>{t}</div>
                  ))}
                </>)}

                {ficheModus === 'palen' && (<>
                  <div style={st.fVeldKop}>Palen plaatsen</div>
                  <div style={{ fontSize:13, color:N.ink3, lineHeight:1.6, marginBottom:10 }}>
                    Klik op een scheiding tussen twee vakken. Een paal bedient de twee
                    vakken ernaast.
                  </div>
                  <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                    {PAAL_SOORTEN.map(([id, label]) => (
                      <button key={id} style={st.fKnop(fichePaal === id)}
                              onClick={() => setFichePaal(id)}>{label}</button>
                    ))}
                  </div>
                  <div style={{ fontSize:13.5, color:N.ink2, marginTop:10, lineHeight:1.6 }}>
                    Ingetekend: {palenTekst(paalTelling)}.
                    {(ficheWerk?.palen?.length || 0) > 0 &&
                      ` Samen ${fmtN(ficheWerk.palen.length)} palen en ${fmtN(ficheWerk.palen.length * 2)} laadpunten.`}
                  </div>
                  {paalAfwijking && (
                    <div style={{ fontSize:13, color:N.warn, marginTop:8, lineHeight:1.6 }}>
                      Dit wijkt af van de opstelling van deze locatie: {paalAfwijking}.
                    </div>
                  )}
                  {(() => {
                    const vt = vermogenVanOpstelling(paalTelling);
                    if (!vt.palen) return null;
                    const kleurVlag = { cabine:N.red, studie:N.warn, geen:N.ok, leeg:N.ink4 }[vt.vlag];
                    return (<>
                      <div style={{ ...st.fVeldRij, marginTop:10, marginBottom:0 }}>
                        <span style={st.fVeldLabel}>Aansluitvermogen</span>
                        <b style={{ fontSize:13.5 }}>{vt.bandbreedte ? `${fmtN(vt.kvaMin)} tot ${fmtN(vt.kvaMax)}` : fmtN(vt.kvaMax)} kVA</b>
                      </div>
                      <div style={st.fMeld(kleurVlag)}>{vermogenMelding(vt.vlag)}</div>
                    </>);
                  })()}
                  {(ficheMsMag || ficheWerk?.cabine) && (
                  <div style={{ marginTop:14, paddingTop:14, borderTop:`1px solid ${N.line}` }}>
                    <button style={st.fKnop(false)} onClick={wisselCabine}>
                      {ficheWerk?.cabine ? 'Cabine verwijderen' : 'Cabine plaatsen'}
                    </button>
                    {ficheWerk?.cabine && (
                      <div style={{ fontSize:13, color:N.ink3, marginTop:8, lineHeight:1.6 }}>
                        De cabine staat bij de snelladers. Sleep hem om hem te verzetten.
                      </div>
                    )}
                    {ficheWerk?.cabine && (ficheWerk?.palen?.length || 0) > 0 && (
                      <div style={{ fontSize:13, color:N.ink3, marginTop:6, lineHeight:1.6 }}>
                        De kabels lopen langs de rij naar de cabine.
                      </div>
                    )}
                  </div>
                  )}
                </>)}

                </>)}

                {/* Netgegevens van deze locatie (mockup V15, punt 4), in beide
                    delen. Gemeten vanaf het midden van de ingetekende rijen,
                    hetzelfde punt als de lijn in deel B. Zonder rijen vanaf het
                    midden van het terrein, zoals in de Excel. De
                    middenspanningskabel alleen vanaf 25 kVA. De opmerking over
                    de netgegevens staat alleen in het uitklapmenu Stroomnet
                    (besluit HL 26 oktober 2026). */}
                {(() => {
                  const np = ficheNetPunten;
                  const b2 = locatie ? netAfstPlein[String(locatie.id)] : null;
                  // Met netgegevens alleen wat het bestand zelf kent: het planbestand van
                  // Fluvius heeft geen verdeelkasten, dan blijft die regel weg.
                  const d = (k, oud) => (np[k] ? np[k].d : (!gisNet?.aanwezig && b2 ? b2[oud] : null));
                  if (!gisNet?.aanwezig && !b2) return null;
                  const regels = [['Straatkabel 400 V', d('v400', 'd400')], ['MS-cabine Fluvius', d('dc', 'dcabine')],
                    ['Verdeelkast', d('vk', 'dkast')], ...(ficheMsMag ? [['Middenspanningskabel', d('ms', 'dms')]] : [])]
                    .filter(([, x]) => x != null);
                  if (!regels.length) return null;
                  const peil = peildatumLang(gisNet?.peildatum || b2?.peildatum);
                  return (
                    <div style={{ marginTop:16, paddingTop:14, borderTop:`1px solid ${N.line}` }}>
                      <div style={st.fVeldKop}>Netgegevens</div>
                      {regels.map(([label, x]) => (
                        <div key={label} style={st.fVeldRij}>
                          <span style={st.fVeldLabel}>{label}</span>
                          <b style={{ fontSize:13.5 }}>{fmtN(x)} m</b>
                        </div>
                      ))}
                      <div style={{ fontSize:12.5, color:N.ink3, marginTop:6, lineHeight:1.5 }}>
                        Bron netgegevens: Fluvius{gisNet?.bestandsnaam ? `, ${gisNet.bestandsnaam}` : ''}{peil ? `, peildatum ${peil}` : ''}
                      </div>
                    </div>
                  );
                })()}
                {/* Plan van Fluvius, onder de netgegevens (mockup Plan van Fluvius V1). */}
                <PlanBlok signalen={fichePlan} plan={gisNet?.samenvatting?.plan} kopStijl={{ ...st.fVeldKop, marginTop:16 }} />

                <div style={{ marginTop:'auto', paddingTop:16 }}>
                  {ficheFout && <div style={st.fFout}>{ficheFout}</div>}
                  <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                    <button style={st.fKnop(true)} disabled={ficheBezig} onClick={bewaarFiche}>
                      {ficheBezig ? 'Bezig met bewaren' : ficheBewaard ? 'Bewaard' : 'Bewaren'}
                    </button>
                    {!!rijen.length && (
                      <button style={st.fKnop(false)} disabled={fichePdfBezig} onClick={ficheAlsPdf}>
                        {fichePdfBezig ? 'Bezig met maken' : 'Fiche als PDF'}
                      </button>
                    )}
                    <button style={st.fKnop(false)} onClick={sluitFiche}>Sluiten</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    })()}

    </div>{/* app */}
    </>
  );
}
